import { FeatureCollection } from "geojson";

export const regionsData: FeatureCollection = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: { market_to_: "ABE" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.86131999999998, 41.498870000000025],
            [-74.84642999999997, 41.255099999999956],
            [-74.96782999999996, 41.09585999999997],
            [-74.73673, 40.846639999999994],
            [-74.82499999999999, 40.37036],
            [-74.93593999999999, 40.29990999999997],
            [-75.26361999999997, 40.286109999999994],
            [-75.37228999999999, 40.21375000000002],
            [-75.64332999999996, 40.30756000000001],
            [-75.6797, 40.152180000000016],
            [-76.01308, 40.20799999999997],
            [-76.06123999999997, 40.49081],
            [-76.27196999999992, 40.51751],
            [-76.38517999999996, 40.70662],
            [-76.21541999999997, 41.00533000000003],
            [-76.00884999999997, 41.10076000000004],
            [-75.89213999999996, 41.412240000000004],
            [-75.63073, 41.36081999999996],
            [-75.47049999999999, 41.51205999999998],
            [-75.23488000000003, 41.48331],
            [-75.16112999999999, 41.57530000000004],
            [-74.86131999999998, 41.498870000000025],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ABI" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-98.57568999999997, 32.86892000000003],
            [-98.56266999999995, 32.38389000000001],
            [-98.47515000000001, 32.386050000000026],
            [-98.49989000000002, 32.02676000000001],
            [-98.38153000000001, 31.726170000000035],
            [-98.73037999999997, 31.42947000000004],
            [-98.86854, 31.209180000000007],
            [-99.09171999999997, 31.188410000000026],
            [-99.09092000000003, 31.387850000000032],
            [-98.95720999999996, 31.443479999999983],
            [-99.23791999999997, 31.483050000000016],
            [-99.31336999999999, 31.409790000000008],
            [-99.72161999999999, 31.56271000000003],
            [-99.71944999999994, 31.70245999999998],
            [-99.89875999999998, 31.83417999999997],
            [-100.06186999999998, 31.849870000000006],
            [-100.16159000000003, 32.082530000000006],
            [-100.28973999999997, 32.000790000000016],
            [-100.42259000000001, 32.08232000000004],
            [-101.18358999999998, 32.08691000000003],
            [-101.18157, 32.19931000000002],
            [-101.01910000000002, 32.28419000000002],
            [-101.17452999999998, 32.584459999999986],
            [-101.31663999999996, 32.72618999999998],
            [-101.17411999999997, 32.76571999999999],
            [-101.03877999999996, 32.97018000000004],
            [-101.03876, 33.24904000000001],
            [-100.65326000000002, 33.199079999999974],
            [-100.59463000000001, 33.12930999999998],
            [-100.78825999999998, 33.02009999999997],
            [-100.52663000000001, 32.96337999999998],
            [-100.51757, 33.13576999999998],
            [-100.33563999999998, 33.397520000000014],
            [-99.99094999999997, 33.39718999999998],
            [-99.99262000000003, 33.540499999999966],
            [-99.83524999999996, 33.49305999999998],
            [-99.57831, 33.57839],
            [-99.53712999999999, 33.39882999999996],
            [-99.10609999999997, 33.39813000000004],
            [-99.07711000000002, 33.204249999999995],
            [-98.95296000000003, 33.217470000000034],
            [-98.95077000000002, 32.95691000000004],
            [-98.65498000000001, 32.95567999999997],
            [-98.57568999999997, 32.86892000000003],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ABQ" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-106.37266000000002, 33.47980000000001],
            [-108.00057999999999, 33.47804999999998],
            [-108.38360000000002, 33.61707000000002],
            [-108.46122, 33.90427000000002],
            [-108.35383000000002, 34.012659999999954],
            [-108.59137000000003, 33.94149000000003],
            [-108.91978000000003, 34.12835999999996],
            [-109.04681999999995, 34.066080000000014],
            [-109.04562999999999, 34.791289999999975],
            [-109.04592999999994, 34.95977000000003],
            [-108.4693, 34.95907000000002],
            [-108.46858000000003, 35.30664000000003],
            [-107.30613999999997, 35.30224999999997],
            [-107.30866000000002, 35.99851999999996],
            [-107.62645999999995, 36.000250000000015],
            [-107.62423, 36.219819999999984],
            [-107.31033, 36.216600000000014],
            [-107.30651000000003, 36.08017000000005],
            [-107.14675999999996, 35.992620000000024],
            [-106.88622999999995, 36.12146000000002],
            [-106.88521000000003, 35.999059999999965],
            [-106.24725999999998, 36.00158000000002],
            [-106.39942, 35.96000000000003],
            [-106.26596000000002, 35.77960000000004],
            [-106.41459, 35.67917000000004],
            [-106.32864999999997, 35.13885999999999],
            [-106.4823, 34.94407999999999],
            [-106.46954000000001, 34.52125999999999],
            [-106.41592999999995, 34.25973000000003],
            [-105.9238, 34.259989999999966],
            [-105.92469999999994, 33.82554999999998],
            [-106.05272999999998, 33.82543],
            [-106.05268000000002, 33.65026000000002],
            [-106.37354, 33.66053000000004],
            [-106.37266000000002, 33.47980000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ABR" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-96.20003, 45.412310000000026],
            [-96.22920999999994, 45.21836999999999],
            [-96.34591, 45.05933000000004],
            [-96.43492000000003, 45.133470000000024],
            [-96.70945999999998, 44.980579999999996],
            [-96.73878999999997, 45.04837999999997],
            [-97.08645999999999, 45.10775000000002],
            [-97.21243000000004, 44.964419999999976],
            [-97.38395, 44.971109999999996],
            [-97.98167000000001, 45.15327999999998],
            [-97.98243999999995, 45.00855000000001],
            [-98.31112, 45.01366000000004],
            [-98.55325999999994, 44.93479000000002],
            [-98.76548, 44.987810000000025],
            [-98.86642999999994, 44.722210000000025],
            [-99.08914999999995, 44.77932000000004],
            [-99.31198, 44.74366999999999],
            [-99.31174999999998, 44.89720999999997],
            [-99.67513, 44.90669],
            [-99.72715999999998, 45.371839999999956],
            [-99.93497999999995, 45.31910000000003],
            [-99.95579999999998, 45.593739999999976],
            [-100.06113999999998, 45.61520999999997],
            [-99.88234999999997, 45.65159000000003],
            [-99.91286000000001, 45.90167999999996],
            [-99.67437, 45.94092999999999],
            [-99.74070000000003, 46.108909999999966],
            [-99.45787000000003, 46.156069999999964],
            [-99.29516, 46.08476000000001],
            [-98.88818999999994, 46.10599999999997],
            [-98.61435999999996, 46.282810000000026],
            [-98.36959999999996, 46.262290000000036],
            [-97.84637000000002, 46.31135999999997],
            [-97.61099999999996, 46.26858],
            [-97.48193999999998, 46.10947999999996],
            [-97.29420999999994, 46.17323999999998],
            [-97.30149000000003, 45.93509999999998],
            [-97.09265999999997, 45.93533],
            [-96.97122999999996, 45.69612000000002],
            [-96.79962999999998, 45.783389999999976],
            [-96.61753000000002, 45.70205000000004],
            [-96.61687000000003, 45.55889999999997],
            [-96.43136000000001, 45.485400000000006],
            [-96.26135000000002, 45.53843999999997],
            [-96.20003, 45.412310000000026],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ABY" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-82.62738999999996, 31.672640000000023],
            [-82.62741999999997, 31.666419999999988],
            [-82.78967999999998, 31.508339999999972],
            [-82.62899000000002, 31.363840000000025],
            [-82.67162999999996, 31.183790000000037],
            [-82.95365000000001, 31.18408999999999],
            [-82.96981000000002, 31.088019999999965],
            [-82.76289, 30.948579999999996],
            [-82.75887, 30.73259000000003],
            [-82.89859999999999, 30.824009999999983],
            [-82.94885999999997, 30.613280000000024],
            [-83.05402999999995, 30.619339999999966],
            [-84.38079999999997, 30.69009000000004],
            [-84.24382999999997, 30.829999999999995],
            [-84.24647000000002, 31.04579999999996],
            [-84.73078999999998, 31.06910999999996],
            [-84.76896999999994, 30.836630000000024],
            [-84.9136, 30.752090000000003],
            [-85.00194000000002, 31.000669999999968],
            [-85.29856999999998, 30.999840000000038],
            [-85.57356999999996, 31.19538999999997],
            [-85.46666000000002, 31.479890000000037],
            [-85.21778, 31.48758000000002],
            [-85.06089999999998, 31.991819999999997],
            [-84.91729999999998, 31.924759999999967],
            [-84.36240999999998, 31.91521000000001],
            [-84.19916999999998, 32.12092000000001],
            [-84.02794000000003, 32.14845000000003],
            [-83.89958999999999, 32.030349999999956],
            [-83.60991999999999, 32.02791000000004],
            [-83.57135999999994, 31.853369999999963],
            [-83.18316999999999, 31.851979999999973],
            [-82.86279999999996, 31.782830000000033],
            [-82.62738999999996, 31.672640000000023],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ACT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-96.78403999999995, 32.22833000000004],
            [-96.45985999999999, 32.16257000000002],
            [-96.23418999999996, 32.25040999999997],
            [-95.94805, 31.928939999999965],
            [-95.68831, 32.22293],
            [-95.57667000000001, 32.22009000000003],
            [-95.62409999999997, 32.06815],
            [-95.42031000000003, 31.92656000000004],
            [-95.40238999999997, 31.761830000000028],
            [-95.25957000000002, 31.576900000000034],
            [-95.11833999999999, 31.531559999999985],
            [-95.67258999999999, 31.36608],
            [-95.78055999999998, 31.094099999999962],
            [-95.98875999999996, 31.086200000000012],
            [-96.01792, 30.94326],
            [-96.20764000000003, 30.943800000000003],
            [-96.39090999999999, 30.879619999999967],
            [-96.62396000000001, 30.973450000000017],
            [-96.61070999999998, 30.755400000000048],
            [-97.17375000000001, 30.740779999999994],
            [-97.33544999999995, 30.970640000000042],
            [-97.52439000000001, 31.028669999999973],
            [-97.82851000000002, 30.90618999999996],
            [-98.10646999999996, 31.358230000000013],
            [-98.40205, 31.07458999999996],
            [-98.73037999999997, 31.42947000000004],
            [-98.38153000000001, 31.726170000000035],
            [-98.49989000000002, 32.02676000000001],
            [-98.47515000000001, 32.386050000000026],
            [-98.21452000000001, 32.06392000000004],
            [-98.07301999999994, 32.17366000000003],
            [-97.71127999999999, 32.10153],
            [-97.00061999999997, 32.28046999999998],
            [-96.78403999999995, 32.22833000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ACY" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-74.73072000000002, 39.15731000000004],
              [-74.71698000000004, 39.347110000000015],
              [-74.61478999999997, 39.28188999999999],
              [-74.73072000000002, 39.15731000000004],
            ],
          ],
          [
            [
              [-74.72299000000001, 39.36624000000001],
              [-74.85826, 39.46684999999998],
              [-74.67043999999999, 39.604380000000006],
              [-74.68683000000004, 39.74655],
              [-74.38952999999995, 39.74991],
              [-74.32837999999998, 39.93080999999998],
              [-74.16579000000002, 39.86909],
              [-74.15878999999993, 39.71092],
              [-74.36918, 39.56694],
              [-74.56948999999994, 39.303419999999974],
              [-74.72299000000001, 39.36624000000001],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "AHN" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-83.60226, 34.91403000000001],
            [-83.31602999999998, 34.79527000000004],
            [-83.34125, 34.67975],
            [-83.10239999999996, 34.53226000000002],
            [-82.95793999999995, 34.54063000000004],
            [-82.83416999999997, 34.36431999999998],
            [-82.62631999999999, 34.242729999999966],
            [-82.4513, 34.00297999999999],
            [-82.59567000000001, 33.82874999999998],
            [-82.50613999999996, 33.65977000000004],
            [-82.61724000000001, 33.632660000000044],
            [-82.65898000000001, 33.447470000000024],
            [-82.77899999999997, 33.37646999999996],
            [-83.01291999999995, 33.46917999999998],
            [-83.27402999999995, 33.19976000000001],
            [-83.54586999999995, 33.171980000000005],
            [-83.54101, 33.40779999999998],
            [-83.83325000000002, 33.39897],
            [-83.74556999999999, 33.71060000000003],
            [-84.01131000000004, 34.05947000000004],
            [-84.01166999999998, 34.29618999999997],
            [-84.25811999999999, 34.33520999999996],
            [-84.30393999999998, 34.54791000000003],
            [-84.18881999999999, 34.60299999999998],
            [-84.14259999999996, 34.821339999999964],
            [-83.9402, 34.74082000000002],
            [-83.66669999999996, 34.80670000000003],
            [-83.60226, 34.91403000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ALB" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.84915999999998, 42.465560000000025],
            [-74.94980999999996, 42.803169999999994],
            [-75.04590999999999, 42.885120000000036],
            [-74.87623999999997, 42.91109000000004],
            [-74.96060000000003, 43.135770000000036],
            [-74.86780000000002, 43.144419999999954],
            [-74.78267999999997, 43.54006999999997],
            [-74.50627999999998, 43.68135999999998],
            [-74.39339999999999, 43.601899999999986],
            [-74.20066000000003, 43.63811000000001],
            [-73.85882000000001, 43.76381],
            [-73.75779999999995, 43.647059999999975],
            [-73.58427999999998, 43.673400000000036],
            [-73.48256, 43.50627999999998],
            [-73.37174999999993, 43.624590000000026],
            [-73.25074999999998, 43.57943000000004],
            [-73.10405, 43.55859000000004],
            [-73.04952000000003, 43.39956000000002],
            [-72.75025000000002, 43.33277000000004],
            [-72.66889999999998, 43.224610000000034],
            [-72.77033999999998, 43.04057999999999],
            [-72.64130999999998, 42.947009999999956],
            [-72.78394, 42.91115000000003],
            [-72.82341999999997, 42.628169999999955],
            [-73.10810000000001, 42.48491000000003],
            [-73.75000999999995, 41.951930000000004],
            [-73.81838000000002, 41.86595000000003],
            [-74.08775000000003, 41.82545999999999],
            [-74.28405000000001, 41.69621000000001],
            [-74.37888000000001, 41.87776999999996],
            [-74.37222, 41.979020000000034],
            [-74.66481000000002, 42.06979000000003],
            [-74.76891, 42.25105999999998],
            [-74.73854, 42.43560999999997],
            [-74.84915999999998, 42.465560000000025],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ALO" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-91.38769999999997, 43.12985999999998],
            [-91.54250999999996, 42.892099999999985],
            [-91.37375000000003, 42.74782999999997],
            [-91.54959000000002, 42.54174999999999],
            [-91.54011, 42.39135000000002],
            [-91.87031999999999, 42.42170999999998],
            [-92.05532, 42.212389999999985],
            [-92.22170000000003, 42.21181999999998],
            [-92.20973000000004, 42.07276000000002],
            [-92.40515999999997, 42.036069999999974],
            [-92.49300000000002, 41.86234999999998],
            [-92.61038000000002, 41.84798],
            [-92.88314000000003, 41.790980000000026],
            [-93.09899999999999, 42.14928000000002],
            [-93.48272999999998, 42.209270000000025],
            [-93.52106999999992, 42.39822000000001],
            [-93.69894000000002, 42.441209999999955],
            [-93.70879000000002, 42.557540000000046],
            [-93.90733, 42.52267999999998],
            [-94.19809000000004, 42.774830000000016],
            [-94.2073, 42.980190000000015],
            [-94.29835, 42.97345999999997],
            [-94.52095999999995, 43.053179999999976],
            [-94.45574000000002, 43.16212999999997],
            [-93.93802, 43.162210000000016],
            [-93.86206000000004, 43.255260000000014],
            [-93.66762999999997, 43.183810000000015],
            [-93.49756, 43.24871000000003],
            [-93.13368, 43.25511000000004],
            [-92.65858999999995, 43.21251000000003],
            [-91.90337999999997, 43.24113],
            [-91.82409000000001, 43.16208000000001],
            [-91.65468999999996, 43.233000000000025],
            [-91.38769999999997, 43.12985999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ALS" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-105.24809000000003, 38.25897000000004],
              [-105.13594999999997, 37.96600999999997],
              [-104.97454000000003, 37.77525999999999],
              [-105.12622999999998, 37.61600000000004],
              [-104.89311999999997, 37.52909000000004],
              [-105.03890999999997, 37.32671999999998],
              [-104.75885999999996, 37.27279],
              [-104.72926, 36.9936],
              [-104.00776999999998, 36.996110000000016],
              [-104.00868999999999, 36.29766000000005],
              [-103.83938999999994, 36.33693000000004],
              [-103.63428000000002, 36.121279999999956],
              [-103.71438000000003, 36.08548000000002],
              [-104.00867000000001, 36.21810999999998],
              [-104.86536999999994, 36.217819999999975],
              [-104.86536999999994, 36.26130999999998],
              [-105.36446999999998, 36.26221999999996],
              [-105.47844000000003, 36.18584],
              [-105.70967999999995, 36.304659999999956],
              [-105.84602999999996, 36.218739999999976],
              [-105.99060999999995, 36.27472999999996],
              [-106.09966999999999, 36.176559999999995],
              [-106.37054999999997, 36.20837000000003],
              [-106.71137999999999, 36.34678999999998],
              [-106.71861000000001, 36.51198000000004],
              [-107.15898999999996, 36.53234000000002],
              [-107.21769, 36.27992000000003],
              [-107.31033, 36.216600000000014],
              [-107.62423, 36.219819999999984],
              [-107.61823999999999, 36.804620000000014],
              [-107.45707000000002, 36.89812000000003],
              [-107.48215, 36.99982000000003],
              [-107.48207999999998, 37.768210000000025],
              [-107.56891000000003, 37.96492000000002],
              [-107.56884999999996, 38.14709],
              [-107.42804999999998, 38.14704000000003],
              [-107.25901999999999, 38.404440000000044],
              [-107.13653999999998, 38.321580000000026],
              [-107.00055999999995, 38.425509999999974],
              [-106.24709999999999, 38.422840000000036],
              [-106.10836000000002, 38.51149000000004],
              [-105.79729999999999, 38.26496999999999],
              [-105.24809000000003, 38.25897000000004],
            ],
          ],
          [
            [
              [-106.59918999999996, 38.99787999999997],
              [-106.41598, 38.82409999999997],
              [-106.3832, 38.62335999999996],
              [-106.64806999999999, 38.46990999999997],
              [-106.74492, 38.52354],
              [-106.65821000000001, 38.68375999999997],
              [-106.84920999999997, 38.652219999999986],
              [-106.87238000000002, 38.78675000000004],
              [-106.59918999999996, 38.99787999999997],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "AMA" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-102.04222, 36.99289999999999],
            [-101.36645000000003, 36.99621999999997],
            [-101.45991000000002, 36.89236999999998],
            [-101.22880999999995, 36.68729999999999],
            [-100.95386999999997, 36.652090000000015],
            [-100.95414999999996, 36.49991999999997],
            [-100.70236999999999, 36.50026000000003],
            [-100.54593999999997, 36.22383999999998],
            [-100.36650999999995, 36.31770000000002],
            [-100.28070000000001, 36.23561000000004],
            [-100.00034000000001, 36.27264000000005],
            [-100.00032999999998, 35.8797],
            [-99.80879999999995, 35.99772999999996],
            [-99.60963, 35.84868999999999],
            [-99.53227999999997, 35.543869999999956],
            [-99.69388000000001, 35.55805000000002],
            [-99.81956000000002, 35.30929],
            [-99.73639000000001, 35.27328],
            [-99.78276000000002, 35.029749999999986],
            [-100.00025999999997, 35.03015000000004],
            [-99.99771000000001, 34.311830000000036],
            [-100.16041999999995, 34.231239999999985],
            [-100.36948999999996, 34.162520000000015],
            [-100.51745999999996, 34.285389999999964],
            [-100.51796999999996, 34.01785999999997],
            [-100.64354999999998, 33.95789000000002],
            [-100.80471999999995, 34.03907999999997],
            [-100.80792999999998, 34.31321],
            [-100.94600000000001, 34.313959999999966],
            [-100.94546000000001, 34.46129999999998],
            [-101.10611999999998, 34.451790000000045],
            [-101.16492999999997, 34.312279999999966],
            [-101.47159, 34.312319999999985],
            [-101.47879999999996, 34.41812000000003],
            [-101.99007999999998, 34.40111000000003],
            [-102.26761999999997, 34.51004999999999],
            [-102.29222999999998, 34.31312000000001],
            [-102.44417, 34.32019999999997],
            [-102.93668999999997, 34.46584000000001],
            [-103.10836999999994, 34.72692999999997],
            [-103.36617, 34.70206000000004],
            [-103.44187000000001, 34.86542999999997],
            [-103.72483000000003, 34.823179999999965],
            [-104.12931000000002, 34.89346999999999],
            [-104.12497000000002, 35.14198000000003],
            [-103.85735999999997, 35.24204999999999],
            [-103.63723999999998, 35.240939999999995],
            [-103.63698999999998, 35.38974],
            [-103.38002000000003, 35.398249999999976],
            [-103.36500000000001, 36.08630000000001],
            [-103.71438000000003, 36.08548000000002],
            [-103.63428000000002, 36.121279999999956],
            [-103.46375, 36.270420000000044],
            [-103.30658999999999, 36.53475000000003],
            [-103.33909, 36.73687],
            [-103.18616999999998, 36.827910000000045],
            [-103.00214000000003, 36.63743000000003],
            [-102.80476000000002, 36.71945],
            [-102.73807999999998, 36.84788],
            [-102.80841999999998, 36.999980000000036],
            [-102.04222, 36.99289999999999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "AOO" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-78.04793000000001, 41.28167000000004],
            [-77.87246999999999, 41.07088],
            [-77.60339000000002, 40.949650000000034],
            [-77.6483, 40.74600000000003],
            [-77.35724000000002, 40.844310000000036],
            [-77.45073000000002, 40.63324000000001],
            [-77.61251999999996, 40.51413000000003],
            [-77.51449000000002, 40.412680000000016],
            [-77.67101000000002, 40.25853000000001],
            [-77.60484, 40.206109999999995],
            [-77.81517, 39.99560999999997],
            [-77.85521, 39.72211999999996],
            [-78.04035999999999, 39.722340000000045],
            [-78.22860999999997, 39.39098000000003],
            [-78.47002, 39.51633],
            [-78.58038000000005, 39.492909999999966],
            [-78.95534000000004, 39.57176000000001],
            [-79.03365, 39.72249000000002],
            [-79.21765000000005, 39.721909999999994],
            [-79.36267999999995, 39.94873999999999],
            [-79.25990999999996, 40.07940999999997],
            [-79.35165000000003, 40.390249999999995],
            [-79.35963000000001, 40.90474000000003],
            [-79.22122000000002, 40.94961000000001],
            [-79.33156, 41.1219],
            [-79.2228, 41.305279999999996],
            [-79.20887999999997, 41.308849999999964],
            [-79.06349, 41.453200000000024],
            [-78.92876000000001, 41.34866999999999],
            [-78.63320999999996, 41.28059000000003],
            [-78.54120999999998, 41.377630000000025],
            [-78.37742999999995, 41.25858999999998],
            [-78.09324999999998, 41.21703999999998],
            [-78.04793000000001, 41.28167000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "APN" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-85.54398999999998, 45.75145999999996],
              [-85.49160999999998, 45.60764999999999],
              [-85.62047999999999, 45.581989999999976],
              [-85.54398999999998, 45.75145999999996],
            ],
          ],
          [
            [
              [-83.50166999999999, 44.27618000000004],
              [-83.77472999999995, 44.45189000000002],
              [-83.88813999999994, 44.68338999999996],
              [-84.04245999999998, 44.65858000000002],
              [-84.06473, 44.84211],
              [-84.37146999999999, 44.989230000000006],
              [-84.22051000000005, 45.10705000000001],
              [-84.36657999999994, 45.1988],
              [-84.45211, 45.0946],
              [-84.76023999999998, 45.17714000000001],
              [-84.73043999999999, 45.38010000000003],
              [-84.99364, 45.55810999999998],
              [-84.95453999999995, 45.701589999999996],
              [-84.72910999999999, 45.78818],
              [-84.47765999999999, 45.65638999999999],
              [-84.21553000000003, 45.634990000000016],
              [-84.08614, 45.49311999999998],
              [-83.49427999999997, 45.33936],
              [-83.31605999999996, 45.141860000000015],
              [-83.46390999999997, 44.996569999999984],
              [-83.31237999999996, 44.88275000000001],
              [-83.27045999999999, 44.708829999999985],
              [-83.33321000000001, 44.337810000000026],
              [-83.50166999999999, 44.27618000000004],
            ],
          ],
          [
            [
              [-83.79939000000002, 45.94250000000004],
              [-83.58215000000001, 46.090000000000046],
              [-83.55057, 45.91419999999999],
              [-83.79939000000002, 45.94250000000004],
            ],
          ],
          [
            [
              [-85.56928000000002, 46.05613000000001],
              [-85.41139999999996, 46.22878000000003],
              [-85.64498999999998, 46.245159999999956],
              [-85.63437999999996, 46.34628999999996],
              [-85.86475999999996, 46.48951999999999],
              [-85.86449000000002, 46.68992000000002],
              [-85.50642000000005, 46.67573999999996],
              [-85.25727, 46.75337999999999],
              [-84.95748999999998, 46.77231999999999],
              [-85.01952999999997, 46.48079999999996],
              [-84.63052999999994, 46.48491999999997],
              [-84.57454999999999, 46.413349999999994],
              [-84.30607999999992, 46.48890999999997],
              [-83.99661, 45.94665000000004],
              [-84.67397, 46.047469999999976],
              [-84.75198, 45.83890000000003],
              [-85.00805, 46.00857000000004],
              [-85.34106999999997, 46.09325000000001],
              [-85.56928000000002, 46.05613000000001],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "AST" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-123.06896999999996, 46.15545],
              [-123.08334000000002, 45.99969000000001],
              [-123.20669, 46.0223],
              [-123.36027, 45.90288000000004],
              [-123.29943, 45.60716999999998],
              [-123.46476000000001, 45.43314],
              [-123.97437999999998, 45.353659999999955],
              [-123.94193000000001, 45.65720000000004],
              [-123.99343999999996, 45.94681000000004],
              [-123.90925999999997, 46.18248000000004],
              [-123.48352999999997, 46.2282],
              [-123.38371000000001, 46.14167],
              [-123.06896999999996, 46.15545],
            ],
          ],
          [
            [
              [-124.02738999999995, 46.840469999999975],
              [-124.02877000000001, 46.79353999999999],
              [-123.37076999999995, 46.792450000000045],
              [-123.35861999999999, 46.384019999999985],
              [-123.21817000000003, 46.38524000000003],
              [-123.21310999999996, 46.17573999999997],
              [-123.70646999999998, 46.311649999999986],
              [-123.87523999999996, 46.24082999999998],
              [-124.08706999999998, 46.26371000000002],
              [-124.06485000000002, 46.64105000000002],
              [-124.01572, 46.37903000000003],
              [-123.88648999999998, 46.51323000000004],
              [-123.97151999999996, 46.703160000000025],
              [-124.09264999999999, 46.73617999999999],
              [-124.13643000000002, 46.905489999999965],
              [-124.02738999999995, 46.840469999999975],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ATL" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-84.30393999999998, 34.54791000000003],
            [-84.25811999999999, 34.33520999999996],
            [-84.01166999999998, 34.29618999999997],
            [-84.01131000000004, 34.05947000000004],
            [-83.74556999999999, 33.71060000000003],
            [-83.83325000000002, 33.39897],
            [-83.95318, 33.26409999999997],
            [-84.34536999999997, 33.04105000000001],
            [-84.61427, 33.076439999999955],
            [-84.99206000000001, 33.278030000000044],
            [-85.23653000000002, 33.12841000000003],
            [-85.26890999999995, 33.297899999999984],
            [-85.40896999999998, 33.28949000000003],
            [-85.60391999999999, 33.44769999999996],
            [-85.74227999999997, 33.599900000000005],
            [-85.62088999999997, 33.787919999999964],
            [-85.38705999999999, 33.90421999999997],
            [-85.41421, 34.04348999999999],
            [-85.34466999999995, 34.137709999999984],
            [-85.04567, 34.15129999999999],
            [-85.08045000000001, 34.297130000000024],
            [-84.58822999999998, 34.42391000000002],
            [-84.42875999999998, 34.55743],
            [-84.30393999999998, 34.54791000000003],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "AUS" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-96.20764000000003, 30.943800000000003],
            [-96.38570000000004, 30.85124999999999],
            [-96.54907999999998, 30.854229999999998],
            [-96.39057, 30.69477000000002],
            [-96.42174999999997, 30.55136000000002],
            [-96.27146999999997, 30.409320000000044],
            [-96.53664, 30.320600000000024],
            [-96.60366000000002, 29.843259999999987],
            [-96.88348000000002, 29.806639999999966],
            [-97.05730000000003, 29.659300000000048],
            [-97.29120000000003, 29.567060000000016],
            [-97.38736999999998, 29.629770000000015],
            [-97.69295999999994, 29.570789999999995],
            [-97.81691000000001, 29.790239999999983],
            [-97.92659, 29.738839999999993],
            [-98.29747, 30.037939999999967],
            [-98.24404000000001, 30.175049999999974],
            [-98.49143999999995, 30.166659999999982],
            [-98.59063000000002, 30.443140000000028],
            [-98.80071000000002, 30.37752999999998],
            [-98.74430999999996, 30.498869999999993],
            [-98.96407999999995, 30.498590000000007],
            [-98.96376999999997, 30.704340000000034],
            [-99.09035000000003, 30.702449999999974],
            [-99.09171999999997, 31.188410000000026],
            [-98.86854, 31.209180000000007],
            [-98.73037999999997, 31.42947000000004],
            [-98.40205, 31.07458999999996],
            [-98.10646999999996, 31.358230000000013],
            [-97.82851000000002, 30.90618999999996],
            [-97.52439000000001, 31.028669999999973],
            [-97.33544999999995, 30.970640000000042],
            [-97.17375000000001, 30.740779999999994],
            [-96.61070999999998, 30.755400000000048],
            [-96.62396000000001, 30.973450000000017],
            [-96.39090999999999, 30.879619999999967],
            [-96.20764000000003, 30.943800000000003],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "AUW" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-88.45122, 46.93893000000004],
            [-88.46260999999996, 46.786599999999986],
            [-88.23639, 46.868040000000015],
            [-88.11576999999997, 46.678290000000004],
            [-88.54301000000001, 46.41992999999997],
            [-88.47986999999995, 46.178179999999976],
            [-88.50105999999997, 45.87835],
            [-88.62210999999996, 45.708120000000015],
            [-88.42706000000001, 45.501180000000026],
            [-88.79337999999993, 45.498729999999995],
            [-88.67799, 45.37852000000004],
            [-88.70307, 45.06749000000001],
            [-88.65475, 44.856519999999996],
            [-88.79186999999996, 44.76257999999999],
            [-88.9039, 44.51372999999998],
            [-88.86632999999995, 44.29990999999997],
            [-88.73887999999997, 44.30483],
            [-88.90856, 44.12687000000001],
            [-88.81369999999998, 43.98714999999997],
            [-88.90610999999996, 43.89542000000004],
            [-89.36554999999998, 43.930290000000035],
            [-89.48461, 43.80788000000004],
            [-89.69748000000001, 43.861889999999974],
            [-89.77734999999998, 43.774509999999985],
            [-89.98184999999998, 43.91324],
            [-90.33849999999995, 43.75407999999998],
            [-90.52286999999998, 43.90431000000001],
            [-90.62165999999999, 43.74780999999998],
            [-90.76311999999993, 43.83534000000004],
            [-90.46977000000001, 44.524130000000014],
            [-90.50163, 44.66144999999999],
            [-90.34879999999998, 44.75223000000001],
            [-90.44681000000003, 44.86942999999996],
            [-90.43367000000003, 45.045700000000004],
            [-90.07277999999997, 45.12029000000001],
            [-90.29134000000005, 45.28711000000003],
            [-90.19125000000003, 45.381509999999984],
            [-90.58569999999995, 45.37746],
            [-90.22745000000003, 45.51078999999997],
            [-89.96788999999998, 46.13377999999999],
            [-89.92913000000001, 46.29986999999999],
            [-89.57739000000004, 46.23224999999999],
            [-89.36528999999996, 46.408270000000044],
            [-89.52466999999999, 46.50603000000002],
            [-89.44505999999993, 46.675909999999995],
            [-89.15907000000004, 46.710610000000045],
            [-88.99066000000002, 46.59911],
            [-88.86451, 46.67934999999996],
            [-88.74185000000003, 46.97202999999996],
            [-88.45122, 46.93893000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "AVL" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-81.73533, 35.90303999999999],
            [-81.53713000000002, 35.671739999999986],
            [-81.69793000000001, 35.57895000000001],
            [-81.75441999999998, 35.61206999999999],
            [-81.92652999999999, 35.39121999999998],
            [-81.87555000000003, 35.18382999999997],
            [-82.55528999999993, 35.159140000000015],
            [-82.61188000000001, 35.09643000000001],
            [-83.03490999999997, 35.02057],
            [-83.15687999999997, 34.74836000000003],
            [-83.31602999999998, 34.79527000000004],
            [-83.60226, 34.91403000000001],
            [-83.56604999999999, 35.29280000000003],
            [-83.31645, 35.332830000000016],
            [-83.15667000000002, 35.55476000000003],
            [-83.25699999999998, 35.705439999999996],
            [-83.09757000000002, 35.77611999999996],
            [-83.10030999999995, 35.969129999999964],
            [-82.82201999999998, 35.92237999999996],
            [-82.63257999999996, 36.06610000000003],
            [-82.10857999999999, 35.92801999999996],
            [-82.05762999999993, 35.98448000000002],
            [-81.73533, 35.90303999999999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "AVP" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.37888000000001, 41.87776999999996],
            [-74.50255999999993, 41.86053999999996],
            [-74.63501999999997, 41.57948999999998],
            [-74.8116, 41.60744999999996],
            [-74.86131999999998, 41.498870000000025],
            [-75.16112999999999, 41.57530000000004],
            [-75.23488000000003, 41.48331],
            [-75.47049999999999, 41.51205999999998],
            [-75.63073, 41.36081999999996],
            [-75.89213999999996, 41.412240000000004],
            [-76.28287000000003, 41.377259999999964],
            [-76.21990000000002, 41.54194000000001],
            [-76.30745999999999, 41.62695000000002],
            [-76.61035999999996, 41.61052999999998],
            [-76.66745, 41.95348],
            [-76.44743000000003, 42.037260000000025],
            [-76.2903, 41.998409999999964],
            [-75.94753999999998, 42.26650999999996],
            [-75.71810999999997, 42.300260000000016],
            [-75.43652, 42.23034999999999],
            [-75.36074000000002, 42.411279999999955],
            [-74.84915999999998, 42.465560000000025],
            [-74.73854, 42.43560999999997],
            [-74.76891, 42.25105999999998],
            [-74.66481000000002, 42.06979000000003],
            [-74.37222, 41.979020000000034],
            [-74.37888000000001, 41.87776999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BDL" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.09049999999996, 41.82924000000003],
            [-72.17695, 41.32240999999998],
            [-72.25449000000003, 41.31001000000002],
            [-72.27675000000002, 41.44062000000001],
            [-72.43102999999994, 41.423770000000005],
            [-72.43686999999997, 41.4003],
            [-72.97551999999999, 41.55382999999996],
            [-73.09560999999997, 41.65589],
            [-73.71051999999997, 41.84266],
            [-73.75000999999995, 41.951930000000004],
            [-73.10810000000001, 42.48491000000003],
            [-72.82341999999997, 42.628169999999955],
            [-72.63443999999998, 42.64017999999997],
            [-72.53292999999996, 42.51136999999997],
            [-72.45199, 42.22671],
            [-72.27453, 42.14356999999999],
            [-72.26953, 42.031710000000004],
            [-72.10249999999994, 42.02887000000003],
            [-72.09049999999996, 41.82924000000003],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BDR" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-73.48349999999996, 40.87465999999996],
              [-73.59341, 40.857140000000044],
              [-73.61603999999997, 40.89887],
              [-73.48349999999996, 40.87465999999996],
            ],
          ],
          [
            [
              [-72.23611, 41.033170000000034],
              [-72.02839999999998, 41.00022],
              [-72.42565999999997, 40.85916000000002],
              [-72.44325, 40.945479999999975],
              [-72.23611, 41.033170000000034],
            ],
          ],
          [
            [
              [-73.13596999999999, 40.717309999999955],
              [-73.46407000000002, 40.85859999999996],
              [-73.48441999999997, 40.947080000000014],
              [-73.23205999999999, 40.90897],
              [-72.63515000000001, 40.98196000000004],
              [-72.50368999999995, 40.89762999999999],
              [-73.13596999999999, 40.717309999999955],
            ],
          ],
          [
            [
              [-72.25449000000003, 41.31001000000002],
              [-72.43102999999994, 41.423770000000005],
              [-72.27675000000002, 41.44062000000001],
              [-72.25449000000003, 41.31001000000002],
            ],
          ],
          [
            [
              [-73.75000999999995, 41.951930000000004],
              [-73.71051999999997, 41.84266],
              [-73.09560999999997, 41.65589],
              [-72.97551999999999, 41.55382999999996],
              [-72.43686999999997, 41.4003],
              [-72.35033999999996, 41.31743999999999],
              [-72.54612999999995, 41.24919],
              [-72.75975000000003, 41.274259999999956],
              [-73.66364999999999, 40.98531000000003],
              [-73.85022999999998, 41.25699999999996],
              [-73.93861000000001, 41.27007999999996],
              [-73.98032, 41.331320000000005],
              [-74.28405000000001, 41.69621000000001],
              [-74.08775000000003, 41.82545999999999],
              [-73.81838000000002, 41.86595000000003],
              [-73.75000999999995, 41.951930000000004],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BFF" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-102.46667999999998, 42.99977999999997],
            [-102.34172999999997, 42.717850000000006],
            [-102.40466999999998, 42.65265000000004],
            [-102.20467000000001, 42.38746000000003],
            [-101.94184999999999, 42.41606000000004],
            [-101.79709000000003, 42.33152000000001],
            [-101.88770000000001, 42.094400000000036],
            [-101.75848000000002, 41.869550000000004],
            [-102.03498000000003, 41.69916000000002],
            [-102.19967999999996, 41.83398],
            [-102.28886999999996, 41.69540999999998],
            [-102.13408999999997, 41.270870000000045],
            [-102.27029, 41.00242000000004],
            [-102.42517000000001, 41.00238999999996],
            [-102.43918999999998, 40.74920000000003],
            [-102.41478000000001, 40.406419999999954],
            [-103.10795, 40.436840000000004],
            [-103.14742000000003, 40.43688999999996],
            [-103.24462999999996, 40.57836000000003],
            [-103.41064000000001, 40.55184],
            [-103.52346999999996, 40.70460000000001],
            [-103.57398999999997, 41.00174],
            [-104.05320999999995, 41.001720000000034],
            [-104.05259, 41.56418999999997],
            [-104.65339999999998, 41.56478999999997],
            [-104.65469999999998, 42.23672],
            [-104.92500000000001, 42.25674000000001],
            [-104.95151999999996, 42.337549999999965],
            [-105.28382999999998, 42.43149999999999],
            [-105.28657000000003, 42.60583000000001],
            [-104.89235999999997, 42.60932999999997],
            [-104.89815999999998, 42.93237000000003],
            [-104.72138000000001, 43.01515],
            [-104.56743999999996, 42.983830000000005],
            [-104.43247000000001, 43.23826000000003],
            [-104.61414999999995, 43.28444000000004],
            [-104.55362999999997, 43.50189000000002],
            [-104.05504000000002, 43.50316000000002],
            [-104.05304000000001, 43.00056000000003],
            [-102.46667999999998, 42.99977999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BFL" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-117.44445000000003, 36.025949999999966],
            [-117.40306999999999, 35.795550000000006],
            [-116.90710999999995, 35.795379999999966],
            [-116.86951999999997, 35.63597999999998],
            [-117.09985, 35.39035999999997],
            [-117.39707000000003, 35.43342999999996],
            [-117.53721, 35.232340000000036],
            [-117.42401, 35.14362000000001],
            [-117.43891999999997, 34.987350000000006],
            [-117.63210999999995, 34.822239999999994],
            [-118.60497000000002, 34.81826999999997],
            [-118.73344999999999, 34.84882999999996],
            [-118.80447999999996, 34.63320999999996],
            [-118.88130000000001, 34.79062999999999],
            [-119.16261, 34.81309],
            [-119.23656, 34.57731999999999],
            [-119.32923, 34.67450999999996],
            [-119.60988, 34.68621],
            [-119.76878, 34.91374],
            [-119.95574000000002, 35.055589999999974],
            [-120.4394, 35.23895],
            [-120.56999999999996, 35.355549999999965],
            [-120.62672999999998, 35.15024000000001],
            [-120.71704999999996, 35.17393000000001],
            [-120.85696, 35.20589999999996],
            [-120.90210000000003, 35.44619000000004],
            [-121.01839, 35.476829999999985],
            [-120.65334, 35.59482999999996],
            [-120.40836, 35.56875000000001],
            [-120.41600000000003, 35.78996999999998],
            [-119.53775999999999, 35.78988],
            [-119.34001000000002, 36.02202999999999],
            [-119.16569000000003, 36.112949999999955],
            [-118.93628, 36.08637999999996],
            [-118.79801000000002, 36.33744000000004],
            [-118.57219999999997, 36.300199999999975],
            [-118.16306999999999, 36.38962000000001],
            [-118.05930999999998, 36.17014000000002],
            [-117.75091000000003, 35.90898000000004],
            [-117.63296999999996, 35.94819999999998],
            [-117.56616999999996, 35.796359999999964],
            [-117.52921999999998, 36.01511999999997],
            [-117.71062999999997, 36.15203999999998],
            [-117.75464000000001, 36.362559999999974],
            [-117.6289, 36.494949999999974],
            [-117.46929999999999, 36.22737000000002],
            [-117.44445000000003, 36.025949999999966],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BFM" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-87.56635999999997, 31.66444999999997],
            [-87.38624000000004, 31.568880000000014],
            [-87.37982, 31.32951000000003],
            [-87.66193000000001, 31.252779999999973],
            [-87.60929999999993, 31.04025000000003],
            [-87.69108999999997, 30.603750000000034],
            [-87.82498999999996, 30.41289000000002],
            [-87.90455999999998, 30.40821999999998],
            [-87.9453, 30.82896000000001],
            [-88.04668999999996, 30.738570000000013],
            [-88.13169999999997, 30.346999999999984],
            [-88.35340999999997, 30.406110000000012],
            [-88.50292999999996, 30.319449999999996],
            [-88.59555, 30.42462999999999],
            [-88.67828, 30.734640000000006],
            [-88.88454999999999, 30.826389999999996],
            [-88.90072000000004, 31.089460000000006],
            [-89.14544000000001, 31.219369999999984],
            [-89.04134999999997, 31.43364000000001],
            [-88.86438000000001, 31.57414000000002],
            [-88.76905999999994, 31.441370000000017],
            [-88.15868000000003, 31.58418999999996],
            [-88.01220000000004, 31.759849999999982],
            [-87.90391000000002, 31.74774000000004],
            [-87.82774999999998, 31.56164999999999],
            [-87.56635999999997, 31.66444999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BGM" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.84915999999998, 42.465560000000025],
            [-75.36074000000002, 42.411279999999955],
            [-75.43652, 42.23034999999999],
            [-75.71810999999997, 42.300260000000016],
            [-75.94753999999998, 42.26650999999996],
            [-76.2903, 41.998409999999964],
            [-76.44743000000003, 42.037260000000025],
            [-76.66745, 41.95348],
            [-76.77116999999998, 41.881630000000044],
            [-77.02171000000004, 42.000590000000045],
            [-77.20933000000002, 42.05240000000003],
            [-77.10028, 42.286450000000016],
            [-77.15675999999993, 42.385960000000004],
            [-76.89565999999996, 42.541529999999995],
            [-76.66654000000003, 42.623449999999956],
            [-76.16634000000002, 42.61426000000003],
            [-75.85409000000001, 42.65778000000004],
            [-75.79841999999996, 42.72866999999997],
            [-75.54022999999995, 42.613870000000006],
            [-75.51857999999999, 42.740970000000004],
            [-75.28542000000002, 42.74241999999999],
            [-75.04590999999999, 42.885120000000036],
            [-74.94980999999996, 42.803169999999994],
            [-74.84915999999998, 42.465560000000025],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BGR" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-68.30492999999998, 44.440490000000025],
              [-68.17351999999997, 44.32852],
              [-68.36454999999992, 44.226360000000035],
              [-68.43103999999997, 44.31247999999996],
              [-68.30492999999998, 44.440490000000025],
            ],
          ],
          [
            [
              [-67.80576999999994, 45.68000999999997],
              [-67.43093999999996, 45.58407999999998],
              [-67.48929000000001, 45.281540000000035],
              [-67.35307, 45.12952999999999],
              [-67.16336000000001, 45.157969999999985],
              [-67.05882999999997, 44.96242999999999],
              [-67.15525999999994, 44.667849999999994],
              [-67.36562000000004, 44.68661000000002],
              [-67.56923, 44.53123000000003],
              [-67.75952000000001, 44.55001999999996],
              [-68.06034999999994, 44.33198000000002],
              [-68.10228999999998, 44.475100000000005],
              [-68.43733999999995, 44.483270000000005],
              [-68.56592000000003, 44.313640000000014],
              [-68.82706999999996, 44.31171000000002],
              [-68.8101, 44.467969999999994],
              [-68.94449, 44.428429999999956],
              [-69.10627000000002, 44.04978000000001],
              [-69.19037999999998, 44.06204999999996],
              [-69.28205999999994, 44.06292],
              [-69.45118999999997, 44.31400999999999],
              [-69.63979000000003, 44.277950000000025],
              [-69.76221999999999, 44.51194999999996],
              [-69.83399, 44.39109999999999],
              [-70.13403999999997, 44.48673000000002],
              [-70.13182999999998, 44.60275999999998],
              [-70.39203000000003, 44.771469999999965],
              [-70.76924000000002, 44.73231000000001],
              [-70.77441999999999, 44.84174000000002],
              [-70.81871999999996, 44.99078],
              [-70.83471999999998, 45.27695000000004],
              [-70.79639999999998, 45.42714999999999],
              [-70.41692000000003, 45.795459999999984],
              [-70.25983999999997, 45.88993999999999],
              [-70.29235999999995, 46.19147000000003],
              [-70.05668999999995, 46.415300000000045],
              [-70.02321000000003, 46.57350000000004],
              [-68.82144, 46.57244],
              [-68.82278000000002, 46.009369999999976],
              [-68.59744999999998, 46.03953],
              [-68.57827999999995, 45.937919999999984],
              [-68.16150000000002, 45.974100000000014],
              [-67.98224999999996, 45.88008999999999],
              [-67.80576999999994, 45.68000999999997],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BHM" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-85.78623999999996, 34.08030000000001],
            [-85.41421, 34.04348999999999],
            [-85.38705999999999, 33.90421999999997],
            [-85.62088999999997, 33.787919999999964],
            [-85.74227999999997, 33.599900000000005],
            [-85.60391999999999, 33.44769999999996],
            [-85.6532, 33.21107000000002],
            [-85.78484000000003, 33.07444000000003],
            [-85.89293, 33.104849999999956],
            [-86.06576000000001, 32.98398000000002],
            [-86.25578999999999, 33.03982000000002],
            [-86.43646999999999, 32.85825999999997],
            [-86.46226000000001, 33.01132999999997],
            [-86.60618000000002, 33.05506000000004],
            [-86.78072, 32.88105000000003],
            [-87.03835000000004, 32.90759000000003],
            [-87.01783999999998, 32.75728000000004],
            [-87.42111999999997, 32.87456999999998],
            [-87.78432000000004, 32.894790000000015],
            [-88.03434000000004, 33.081370000000014],
            [-87.99651, 33.34384000000003],
            [-87.66792999999996, 33.563779999999966],
            [-87.74506, 33.658519999999996],
            [-87.63616999999999, 34.04047999999999],
            [-87.48034999999999, 34.091879999999975],
            [-87.28598, 33.99507000000001],
            [-87.18933000000004, 34.18708999999999],
            [-87.01954999999998, 34.12540000000001],
            [-86.96569999999997, 33.97360000000002],
            [-86.83853000000002, 34.129699999999985],
            [-86.61287000000004, 34.11346000000001],
            [-86.54043000000001, 34.22551],
            [-86.28741999999997, 34.07778999999999],
            [-86.13444999999999, 34.080780000000026],
            [-85.96056999999999, 34.227589999999964],
            [-85.78623999999996, 34.08030000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BHX" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-122.89845999999999, 41.219770000000004],
            [-122.91747999999995, 40.99393999999998],
            [-123.31816999999998, 41.14089999999999],
            [-123.30776, 40.92526999999996],
            [-123.17218000000003, 40.86417000000004],
            [-123.19606000000002, 40.66201000000004],
            [-123.52741000000002, 40.71601000000004],
            [-123.52270999999999, 40.552269999999965],
            [-123.32177999999998, 40.36949999999999],
            [-123.21263999999998, 40.392420000000044],
            [-122.97670000000002, 40.23906999999997],
            [-122.90990000000001, 39.93635999999999],
            [-122.96007000000002, 39.844960000000015],
            [-122.88925999999995, 39.53034000000004],
            [-123.13239, 39.50953000000003],
            [-123.11156999999996, 39.27845999999997],
            [-123.26317000000002, 39.22832000000004],
            [-123.52061999999998, 39.27269000000004],
            [-123.56126, 39.16994000000002],
            [-123.31961999999996, 39.065390000000015],
            [-123.47829000000003, 38.90263999999996],
            [-123.65574999999994, 38.86811000000003],
            [-123.82757999999997, 39.34870999999997],
            [-123.76669000000001, 39.56032],
            [-123.84973000000001, 39.82837000000003],
            [-124.36279999999996, 40.258690000000016],
            [-124.40961999999999, 40.438249999999954],
            [-124.18627, 40.79778000000002],
            [-124.11343000000001, 41.03152000000003],
            [-124.16544999999996, 41.12979],
            [-124.07486000000003, 41.36458000000002],
            [-124.14179999999999, 41.690089999999984],
            [-123.92829999999998, 41.57485999999996],
            [-123.75847999999999, 41.582789999999996],
            [-123.66126999999997, 41.38232999999997],
            [-123.44883000000002, 41.30856999999998],
            [-123.28360999999995, 41.448929999999955],
            [-122.89845999999999, 41.219770000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BIL" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-107.62306999999994, 46.851060000000004],
            [-107.89776999999997, 46.84964000000002],
            [-107.80844999999995, 46.735759999999964],
            [-107.79683999999999, 46.49583000000001],
            [-107.48691999999997, 46.17757000000004],
            [-107.17548000000002, 46.110029999999995],
            [-107.08345999999999, 46.26628999999997],
            [-106.93906999999999, 46.13661000000002],
            [-106.93911999999996, 45.86966999999999],
            [-107.17640999999996, 45.91339999999997],
            [-107.33115999999997, 45.749400000000044],
            [-107.26420999999998, 45.548859999999976],
            [-107.63519000000001, 45.636179999999975],
            [-107.62332000000002, 45.45880000000002],
            [-107.79105000000001, 45.430319999999995],
            [-107.86286999999997, 45.25500000000004],
            [-107.75431, 45.13132999999998],
            [-107.91166999999996, 45.00101],
            [-107.79831000000003, 44.75677000000004],
            [-108.2062, 44.72987000000001],
            [-108.26527, 44.561690000000006],
            [-108.55682000000003, 44.72037000000002],
            [-108.57363999999995, 44.445829999999994],
            [-108.85206000000002, 44.469880000000025],
            [-108.97016, 44.25778000000004],
            [-109.22009000000003, 44.307080000000006],
            [-109.43195999999999, 44.16935000000004],
            [-109.51286000000002, 43.939549999999976],
            [-109.78758, 43.80167000000003],
            [-110.05353000000001, 44.00773000000004],
            [-110.05356999999995, 44.032599999999974],
            [-110.14460999999999, 44.283089999999966],
            [-110.3774, 44.583210000000044],
            [-110.66743000000002, 44.58324999999998],
            [-110.66746999999997, 44.66662000000001],
            [-111.05620000000002, 44.66657000000004],
            [-111.05465999999997, 45.00086999999996],
            [-110.34111999999995, 44.999180000000024],
            [-110.36268000000001, 45.369710000000026],
            [-110.21939, 45.45842000000002],
            [-110.22077999999999, 45.71914000000001],
            [-110.29257999999999, 45.78503000000004],
            [-110.28191, 46.18422000000004],
            [-110.27334999999998, 46.710519999999974],
            [-109.43787999999998, 46.80957000000001],
            [-109.14854000000001, 46.75118999999998],
            [-109.12815000000003, 46.94628999999998],
            [-108.94254, 47.21583999999996],
            [-109.18762999999994, 47.26455000000004],
            [-109.43964000000003, 47.21852000000001],
            [-109.59720000000002, 47.51890999999996],
            [-109.16944999999994, 47.54610000000001],
            [-109.03655999999997, 47.48089000000002],
            [-108.80832999999996, 47.55108999999997],
            [-108.80943000000002, 47.69687999999998],
            [-108.76601999999997, 47.643799999999985],
            [-108.34899999999998, 47.566850000000024],
            [-107.92977999999994, 47.568270000000005],
            [-107.96848999999996, 47.24966999999997],
            [-107.92186000000002, 47.02048000000003],
            [-107.69724999999995, 47.15604999999998],
            [-107.62306999999994, 46.851060000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BIS" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-99.79815999999995, 47.55188999999999],
            [-99.75626999999999, 47.36278],
            [-99.59470999999999, 47.212019999999995],
            [-99.7392, 46.93518],
            [-99.70259, 46.66130999999999],
            [-99.49688, 46.631510000000006],
            [-99.43281, 46.49041],
            [-99.64403, 46.456709999999994],
            [-99.73579999999997, 46.28975000000003],
            [-99.89576999999996, 46.297760000000025],
            [-99.74070000000003, 46.108909999999966],
            [-99.67437, 45.94092999999999],
            [-99.91286000000001, 45.90167999999996],
            [-99.88234999999997, 45.65159000000003],
            [-100.06113999999998, 45.61520999999997],
            [-100.22598000000004, 45.71854000000001],
            [-100.48585999999999, 45.54457000000002],
            [-100.34174999999998, 45.47258999999996],
            [-101.48057999999999, 45.47268999999998],
            [-101.79098000000003, 45.909180000000035],
            [-101.9988, 45.94450999999999],
            [-101.99652, 46.05623999999997],
            [-101.71253999999998, 46.068130000000004],
            [-101.73923000000003, 46.26716000000001],
            [-101.64367999999996, 46.34679999999997],
            [-101.71851999999996, 46.63120999999996],
            [-101.70926000000001, 46.95526],
            [-101.64276999999998, 47.14653000000001],
            [-101.74420999999997, 47.40697999999996],
            [-101.70964999999995, 47.537800000000004],
            [-101.42760999999994, 47.56182000000004],
            [-101.31605, 47.33251999999996],
            [-101.01847999999997, 47.48818000000003],
            [-100.68367999999998, 47.32767999999998],
            [-100.58137000000004, 47.66026999999999],
            [-100.29125999999997, 47.71777999999997],
            [-99.79815999999995, 47.55188999999999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BJI" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-93.24262999999999, 47.61345999999999],
            [-93.31413999999998, 47.327690000000004],
            [-93.22294999999994, 47.23154999999996],
            [-93.46469999999994, 47.01661000000001],
            [-93.44658000000001, 46.87090999999998],
            [-93.66388000000003, 46.85997000000003],
            [-93.77533000000003, 47.030279999999976],
            [-93.77786999999995, 46.68995000000002],
            [-93.44478999999998, 46.64676999999999],
            [-93.36648000000002, 46.45074999999998],
            [-93.37867, 46.35138999999997],
            [-93.79627000000002, 46.243130000000036],
            [-93.81126999999998, 46.47934999999998],
            [-93.93588999999997, 46.42397999999996],
            [-94.32865999999999, 46.45957999999996],
            [-94.44098000000002, 46.36294000000002],
            [-94.61005999999998, 46.585790000000046],
            [-94.77942000000002, 46.54135999999997],
            [-94.67452, 46.34165000000001],
            [-94.79693, 46.24360999999996],
            [-94.94578999999999, 46.296200000000006],
            [-95.23917, 46.256040000000006],
            [-95.42528000000001, 46.397400000000026],
            [-95.52195999999998, 46.542599999999986],
            [-95.35471000000001, 46.64409999999996],
            [-95.33016, 46.82583999999998],
            [-95.60020999999995, 46.99089],
            [-95.67317999999995, 47.34847000000001],
            [-95.88573999999997, 47.553749999999965],
            [-95.76952000000003, 47.65943000000003],
            [-95.80731999999998, 47.96449999999996],
            [-95.58228999999997, 47.93386000000001],
            [-95.58288999999996, 48.02065000000004],
            [-95.08791000000002, 47.98540999999998],
            [-94.93377000000004, 48.18202999999998],
            [-94.79492000000005, 48.12545999999997],
            [-94.38511000000003, 48.14042],
            [-94.22058999999996, 48.201900000000016],
            [-93.91941999999997, 47.94745000000002],
            [-93.67339000000004, 47.8974],
            [-93.60142999999997, 47.78840000000004],
            [-93.32935999999992, 47.766230000000036],
            [-93.24262999999999, 47.61345999999999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BKW" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-80.66894000000002, 38.48516000000001],
            [-80.35999000000004, 38.225759999999994],
            [-80.26449999999994, 38.04664999999997],
            [-79.95962999999995, 38.06418000000002],
            [-80.05679, 37.95188999999998],
            [-80.22837999999999, 37.96296999999997],
            [-80.43357999999998, 37.77721000000004],
            [-80.54284999999999, 37.54708000000004],
            [-80.67452999999998, 37.53745999999997],
            [-80.61006, 37.24417000000004],
            [-81.11431999999994, 37.02256999999997],
            [-80.91285000000002, 37.073059999999984],
            [-80.81445999999997, 36.88393000000002],
            [-81.09490000000002, 36.85201999999998],
            [-81.11085, 36.76772000000001],
            [-81.26162999999997, 36.76317999999998],
            [-81.50207999999995, 36.959220000000045],
            [-81.46159, 37.03681999999996],
            [-81.78053000000003, 36.95854],
            [-81.61793000000003, 37.08346000000002],
            [-81.88623999999999, 37.18621000000003],
            [-81.93269999999998, 37.369129999999984],
            [-82.15394999999995, 37.407569999999964],
            [-82.24025000000003, 37.568990000000014],
            [-81.9711, 37.54689000000003],
            [-82.10061999999996, 37.78255000000001],
            [-81.84480999999997, 37.84488],
            [-81.55965, 37.84073000000001],
            [-81.60463000000004, 37.961419999999976],
            [-81.47411999999997, 38.05449000000002],
            [-81.38086999999996, 37.96901999999997],
            [-81.33976999999999, 38.133149999999986],
            [-81.10576, 38.32276999999999],
            [-80.77995000000001, 38.49242000000003],
            [-80.66894000000002, 38.48516000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BLI" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-122.71658000000002, 47.98795],
              [-122.94883999999996, 47.867279999999994],
              [-124.21992999999998, 47.88141000000001],
              [-124.21000000000001, 48.00320999999998],
              [-124.39927000000002, 48.046059999999976],
              [-124.67454999999998, 47.9743],
              [-124.73678999999998, 48.17084000000004],
              [-124.62855999999996, 48.37172],
              [-123.98048000000003, 48.16447000000003],
              [-123.33257000000003, 48.11279999999999],
              [-123.12870999999998, 48.15434999999999],
              [-122.71658000000002, 47.98795],
            ],
          ],
          [
            [
              [-122.5959, 48.397290000000034],
              [-122.60596999999999, 48.20752999999999],
              [-122.37575, 48.03475999999999],
              [-122.43166999999997, 47.91427999999999],
              [-122.60738999999998, 48.03078000000002],
              [-122.6106, 48.15348999999997],
              [-122.77029, 48.224580000000024],
              [-122.5959, 48.397290000000034],
            ],
          ],
          [
            [
              [-122.60012999999995, 48.521150000000006],
              [-122.51062000000003, 48.37138000000002],
              [-122.67366999999994, 48.42389000000002],
              [-122.60012999999995, 48.521150000000006],
            ],
          ],
          [
            [
              [-122.89422999999994, 48.71483999999997],
              [-122.74182000000002, 48.660519999999956],
              [-122.94728000000003, 48.59714000000003],
              [-122.89422999999994, 48.71483999999997],
            ],
          ],
          [
            [
              [-119.54376000000003, 49.00010000000003],
              [-119.58416, 48.78954000000002],
              [-119.74691999999999, 48.55686999999999],
              [-119.90893999999996, 48.504880000000036],
              [-119.86909999999996, 48.32876999999999],
              [-119.98124999999996, 48.20957000000003],
              [-120.15290000000002, 48.06572999999998],
              [-120.65046000000001, 48.39769],
              [-120.65201, 48.53661000000002],
              [-121.05577999999996, 48.47814000000001],
              [-120.94727999999998, 48.11262999999996],
              [-121.17296999999998, 47.931230000000006],
              [-121.58264999999999, 48.020680000000034],
              [-122.22940999999996, 47.97142],
              [-122.36493999999998, 48.12612000000004],
              [-122.36543000000002, 48.30177999999998],
              [-122.50934, 48.37458999999997],
              [-122.42447999999996, 48.59947],
              [-122.48437999999999, 48.75300000000004],
              [-122.70049000000002, 48.80478000000003],
              [-122.75313000000003, 48.99335000000002],
              [-119.54376000000003, 49.00010000000003],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BNA" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-85.57419999999996, 36.05898000000005],
            [-85.72824999999995, 35.98366000000003],
            [-85.67273999999998, 35.85476999999999],
            [-85.96464000000003, 35.78245999999997],
            [-85.79519999999994, 35.51723999999997],
            [-86.01050000000001, 35.462669999999974],
            [-86.23353999999995, 35.245279999999994],
            [-86.50679, 35.32557],
            [-86.60911999999999, 35.43147999999999],
            [-86.78830000000002, 35.322720000000004],
            [-86.88898999999995, 35.42395000000002],
            [-87.12912999999998, 35.45616000000002],
            [-87.34242, 35.361029999999964],
            [-87.44863000000004, 35.42659999999999],
            [-87.35339999999997, 35.58963000000003],
            [-87.76489999999993, 35.67537999999998],
            [-87.68038999999999, 35.84285000000004],
            [-87.71211999999997, 36.00718],
            [-87.86232000000001, 35.97510000000001],
            [-87.81063, 35.83698000000001],
            [-87.96278000000001, 35.84088000000003],
            [-87.85361999999995, 36.045140000000046],
            [-88.04712, 36.49681999999998],
            [-88.15728000000001, 36.86712000000004],
            [-87.91490999999996, 36.94923],
            [-87.58686, 36.958],
            [-87.25289999999995, 37.01718000000004],
            [-87.31919000000005, 36.85884000000001],
            [-87.11309999999995, 36.716570000000004],
            [-86.75143000000003, 36.72617000000002],
            [-86.73521999999994, 36.648870000000045],
            [-86.39100000000002, 36.65034],
            [-86.21725999999995, 36.481519999999975],
            [-86.25444999999996, 36.37117999999998],
            [-86.05693000000002, 36.33455999999997],
            [-85.90651, 36.45987000000001],
            [-85.61900999999995, 36.24527000000003],
            [-85.47749000000002, 36.32007000000001],
            [-85.57419999999996, 36.05898000000005],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BNO" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-117.52996000000002, 44.56459999999999],
            [-117.69151, 44.44404000000004],
            [-117.66771999999997, 44.18031000000004],
            [-117.94486999999995, 44.28821000000002],
            [-118.05753999999999, 44.097689999999986],
            [-117.81865999999995, 44.015839999999955],
            [-117.81155, 43.521159999999966],
            [-117.86879999999996, 43.37816999999999],
            [-117.71902999999999, 43.280290000000036],
            [-117.56511, 43.41353999999997],
            [-117.25793999999995, 43.50218000000003],
            [-117.02663000000001, 43.41578999999997],
            [-117.02626999999998, 42.00021000000004],
            [-119.32417000000001, 41.99387999999996],
            [-119.99943999999999, 41.994889999999955],
            [-120.87975999999999, 41.99369999999999],
            [-120.88328000000001, 42.74389999999996],
            [-121.34965000000001, 42.74665000000004],
            [-121.34829999999995, 43.33888000000003],
            [-121.3328, 43.616629999999994],
            [-120.78162999999996, 43.61546],
            [-120.79976999999994, 43.92597],
            [-120.98653, 43.960829999999966],
            [-120.98733000000003, 44.13384000000002],
            [-121.10826999999999, 44.24894999999997],
            [-120.98878, 44.47640000000001],
            [-120.74643000000002, 44.562439999999974],
            [-120.38549999999994, 44.563910000000014],
            [-120.38004, 44.82677999999999],
            [-120.11417999999998, 44.933729999999976],
            [-120.06611, 44.70929000000003],
            [-119.87043999999999, 44.70081999999999],
            [-119.56684999999995, 44.48784000000003],
            [-118.85694, 44.560150000000036],
            [-118.89486000000002, 44.72715999999996],
            [-118.70636999999999, 44.79231999999999],
            [-118.84101, 44.998149999999974],
            [-118.64986999999999, 44.99726999999999],
            [-118.65900999999995, 44.75381],
            [-117.95081, 44.571860000000015],
            [-117.52996000000002, 44.56459999999999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BOI" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-114.69415, 45.19716000000002],
            [-114.72332, 44.89121000000002],
            [-114.82011, 44.747849999999985],
            [-114.56915000000002, 44.57623000000001],
            [-114.38665, 44.67097999999998],
            [-114.22124999999998, 44.87896000000004],
            [-113.8163, 44.49396999999999],
            [-113.45252, 44.455519999999986],
            [-113.32080000000002, 44.23316000000001],
            [-113.41636999999997, 44.059369999999994],
            [-113.71575000000001, 44.11873000000001],
            [-113.65674, 44.30509000000002],
            [-113.76386000000002, 44.39261999999999],
            [-114.16410000000003, 44.01051999999996],
            [-114.55652999999998, 43.97900999999997],
            [-114.17079999999999, 43.78197999999997],
            [-114.40823999999998, 43.67207999999997],
            [-114.57225999999996, 43.51019000000002],
            [-114.53447999999996, 43.33337999999997],
            [-114.26856999999998, 43.19988999999999],
            [-114.25617000000003, 42.98565999999999],
            [-114.37960999999999, 42.850739999999995],
            [-114.61742000000002, 42.85094000000002],
            [-114.69255999999999, 42.44754000000003],
            [-114.80302999999998, 42.37066],
            [-114.65420999999999, 42.186899999999994],
            [-114.75367999999996, 41.999600000000015],
            [-115.43414000000003, 41.99662000000001],
            [-115.52212000000002, 41.92796000000003],
            [-115.52305999999999, 41.99685000000004],
            [-117.02626999999998, 42.00021000000004],
            [-117.02663000000001, 43.41578999999997],
            [-117.25793999999995, 43.50218000000003],
            [-117.56511, 43.41353999999997],
            [-117.71902999999999, 43.280290000000036],
            [-117.86879999999996, 43.37816999999999],
            [-117.81155, 43.521159999999966],
            [-117.81865999999995, 44.015839999999955],
            [-118.05753999999999, 44.097689999999986],
            [-117.94486999999995, 44.28821000000002],
            [-117.66771999999997, 44.18031000000004],
            [-117.69151, 44.44404000000004],
            [-117.52996000000002, 44.56459999999999],
            [-117.34898, 44.738699999999994],
            [-117.26395000000002, 45.08115000000003],
            [-116.93311000000003, 45.07947999999997],
            [-116.91002999999996, 44.82797999999998],
            [-116.62551000000002, 44.838389999999954],
            [-116.52917999999998, 44.607769999999995],
            [-116.26248000000001, 44.65779000000003],
            [-116.23487000000003, 44.782559999999975],
            [-116.48412, 45.15991000000001],
            [-116.34268000000003, 45.26791000000001],
            [-116.14437, 45.107639999999975],
            [-115.97576999999995, 45.19526999999996],
            [-114.69415, 45.19716000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BOS" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-70.16086999999999, 41.683939999999964],
              [-70.26338000000004, 41.71059000000001],
              [-69.93794, 41.779170000000036],
              [-69.95827, 41.65638999999998],
              [-70.16086999999999, 41.683939999999964],
            ],
          ],
          [
            [
              [-70.53740000000002, 41.81078999999998],
              [-70.90678, 41.966690000000014],
              [-70.99868999999998, 41.92812000000003],
              [-71.38180999999994, 42.13493000000001],
              [-71.56025999999997, 42.47448],
              [-71.54621999999995, 42.70274],
              [-71.38585, 42.69889999999998],
              [-70.83240999999998, 42.89880999999997],
              [-70.83667000000003, 42.69708000000003],
              [-70.68451999999994, 42.58841000000001],
              [-70.97765999999999, 42.450619999999965],
              [-70.96214, 42.228850000000044],
              [-70.71664999999999, 42.20733],
              [-70.65044000000003, 41.950329999999965],
              [-70.53740000000002, 41.81078999999998],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BPT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-94.68662, 29.77176000000003],
            [-94.60650999999996, 30.069019999999995],
            [-94.68561, 30.10359999999998],
            [-94.73275999999998, 30.49011000000003],
            [-94.53783000000001, 30.491099999999964],
            [-94.68678, 30.919599999999996],
            [-94.56199999999993, 31.058770000000006],
            [-94.37412999999995, 31.26933999999996],
            [-94.12951999999993, 31.09929000000004],
            [-93.91086999999996, 31.15814999999999],
            [-93.87343999999999, 30.711599999999965],
            [-93.71349999999998, 30.582340000000034],
            [-93.72187999999997, 30.075219999999973],
            [-93.85961999999995, 29.973529999999997],
            [-93.93708000000001, 29.780310000000025],
            [-93.83736999999999, 29.67798000000003],
            [-94.06973999999997, 29.667449999999988],
            [-94.49904000000004, 29.50666000000001],
            [-94.77084000000002, 29.52623],
            [-94.68662, 29.77176000000003],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BRL" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-92.08333000000002, 40.07325000000001],
              [-92.00944000000004, 39.950189999999964],
              [-92.18680999999995, 39.95436999999997],
              [-92.08333000000002, 40.07325000000001],
            ],
          ],
          [
            [
              [-91.34940999999998, 41.30323000000001],
              [-90.92857000000001, 41.30764999999998],
              [-90.90358999999995, 41.156949999999966],
              [-90.75491999999994, 41.06845000000003],
              [-90.43940000000003, 41.063989999999954],
              [-90.44237999999996, 40.84808999999997],
              [-90.33625000000004, 40.84504999999997],
              [-90.28485999999998, 40.69941000000003],
              [-90.44672999999997, 40.555529999999955],
              [-90.52067000000002, 40.27779000000002],
              [-90.45051000000001, 40.262389999999996],
              [-90.65360000000004, 40.20869000000004],
              [-90.69581999999994, 40.103750000000005],
              [-90.91342, 40.104469999999985],
              [-90.96723, 40.19373000000001],
              [-91.50510999999997, 40.200390000000034],
              [-91.49714, 40.248820000000045],
              [-92.26984000000002, 40.303410000000014],
              [-92.39970000000002, 40.414580000000015],
              [-92.72972999999996, 40.38320000000003],
              [-92.81092000000001, 40.47206],
              [-92.63778999999997, 40.59080000000001],
              [-92.57241000000005, 40.84221000000001],
              [-92.63973999999993, 41.048630000000045],
              [-92.80237000000002, 41.125140000000016],
              [-92.75762999999995, 41.22010999999998],
              [-92.49985999999998, 41.16157000000004],
              [-92.28315000000003, 41.06816000000001],
              [-92.05488, 41.06823000000003],
              [-91.89105000000004, 41.18573000000002],
              [-91.48537000000005, 41.24940999999999],
              [-91.48403000000002, 41.423829999999995],
              [-91.34940999999998, 41.30323000000001],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BRO" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-97.27625000000003, 26.56314000000001],
              [-97.19735000000003, 26.25182999999999],
              [-97.33852999999999, 26.50991000000004],
              [-97.27625000000003, 26.56314000000001],
            ],
          ],
          [
            [
              [-97.37820000000002, 27.073899999999977],
              [-97.30942999999999, 26.56515999999999],
              [-97.39391000000003, 26.861430000000023],
              [-97.38925999999995, 27.073730000000033],
              [-97.37820000000002, 27.073899999999977],
            ],
          ],
          [
            [
              [-97.49177999999995, 27.093689999999963],
              [-97.55359999999993, 26.85059],
              [-97.47087000000002, 26.758419999999987],
              [-97.44984000000002, 26.40646000000001],
              [-97.37873999999994, 26.409449999999957],
              [-97.28293000000002, 26.117170000000016],
              [-97.15047999999993, 25.951759999999958],
              [-97.52024, 25.88603000000002],
              [-97.66271999999998, 26.038229999999977],
              [-98.17633000000002, 26.07524999999996],
              [-98.58642999999996, 26.257820000000002],
              [-98.32056999999995, 26.78301999999996],
              [-97.98545999999997, 26.78093999999999],
              [-97.98576000000003, 27.073079999999987],
              [-97.91183, 27.128670000000003],
              [-97.49177999999995, 27.093689999999963],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BTM" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-112.31431999999998, 47.005189999999956],
            [-112.18071000000002, 46.822389999999984],
            [-112.03033999999995, 46.92883999999999],
            [-111.89841, 46.86076000000003],
            [-111.60274999999999, 46.89152999999999],
            [-111.24718999999996, 46.43863000000001],
            [-111.05719999999998, 46.40330999999999],
            [-111.06202, 46.19280000000003],
            [-110.66141999999996, 46.312610000000014],
            [-110.69176999999998, 46.19265999999999],
            [-110.28191, 46.18422000000004],
            [-110.29257999999999, 45.78503000000004],
            [-110.22077999999999, 45.71914000000001],
            [-110.21939, 45.45842000000002],
            [-110.36268000000001, 45.369710000000026],
            [-110.34111999999995, 44.999180000000024],
            [-111.05465999999997, 45.00086999999996],
            [-111.05620000000002, 44.66657000000004],
            [-111.04901999999996, 44.47540999999999],
            [-111.3236, 44.72899000000003],
            [-111.48906999999996, 44.70499999999999],
            [-111.51890999999998, 44.583330000000025],
            [-111.82149000000003, 44.509289999999964],
            [-112.25676999999997, 44.571580000000026],
            [-112.38687999999998, 44.44726000000001],
            [-112.71853999999996, 44.50434000000003],
            [-112.81377999999997, 44.23021],
            [-113.32080000000002, 44.23316000000001],
            [-113.45252, 44.455519999999986],
            [-113.8163, 44.49396999999999],
            [-114.22124999999998, 44.87896000000004],
            [-114.38665, 44.67097999999998],
            [-114.56915000000002, 44.57623000000001],
            [-114.82011, 44.747849999999985],
            [-114.72332, 44.89121000000002],
            [-114.69415, 45.19716000000002],
            [-114.59332000000003, 45.29762000000001],
            [-114.79329000000001, 45.43650000000001],
            [-114.56497999999996, 45.557650000000024],
            [-114.33154999999994, 45.45934999999996],
            [-114.03022000000001, 45.648369999999964],
            [-114.04936999999998, 45.95583999999997],
            [-113.75316999999997, 46.11228],
            [-113.78299999999996, 46.36430000000002],
            [-113.87822, 46.497269999999965],
            [-113.77251999999997, 46.65803999999997],
            [-113.63986000000001, 46.48649999999996],
            [-113.52521000000002, 46.58119000000002],
            [-113.28891999999996, 46.427279999999975],
            [-113.03868999999999, 46.67140999999999],
            [-112.87489999999995, 46.73699999999998],
            [-112.72058, 46.592970000000015],
            [-112.44382999999999, 46.459000000000024],
            [-112.31431999999998, 47.005189999999956],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BTR" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-91.89773999999997, 29.632919999999967],
              [-91.74865000000003, 29.57365999999996],
              [-91.84597, 29.47971000000002],
              [-92.03076999999999, 29.573880000000045],
              [-91.89773999999997, 29.632919999999967],
            ],
          ],
          [
            [
              [-90.88106000000002, 31.61053000000002],
              [-90.69796, 31.396799999999995],
              [-90.03178000000003, 31.233890000000024],
              [-89.92949999999999, 31.098759999999974],
              [-89.93706999999998, 31.00154000000001],
              [-90.19549, 31.000829999999972],
              [-90.26064999999994, 30.826440000000048],
              [-90.24506000000002, 30.565050000000042],
              [-90.56694999999996, 30.53268000000004],
              [-90.49618999999996, 30.25773999999996],
              [-90.91537999999997, 30.112960000000026],
              [-90.97136000000003, 29.75899000000001],
              [-91.07964999999996, 29.62953999999999],
              [-91.18102999999994, 29.608879999999964],
              [-91.32266000000001, 29.48962000000001],
              [-91.52536, 29.550660000000033],
              [-91.60517999999993, 29.758349999999993],
              [-91.76819999999995, 29.745269999999994],
              [-91.93618999999995, 29.854200000000024],
              [-92.06277000000003, 29.77037000000004],
              [-92.07586999999998, 30.02111000000002],
              [-92.24821999999995, 30.085549999999987],
              [-92.16378999999998, 30.475880000000004],
              [-92.34488000000005, 30.561549999999997],
              [-92.52591999999996, 30.878489999999996],
              [-92.41237999999998, 30.982060000000004],
              [-92.46188999999998, 31.188799999999965],
              [-92.27424000000002, 31.084680000000013],
              [-92.11180000000002, 31.225949999999962],
              [-91.75274999999996, 31.315269999999977],
              [-91.72341000000003, 31.044080000000022],
              [-91.46779999999998, 31.306879999999985],
              [-91.17584999999997, 31.384420000000006],
              [-91.24561999999997, 31.501569999999994],
              [-91.12766000000002, 31.62802000000004],
              [-90.88106000000002, 31.61053000000002],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BTV" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-72.32153, 45.00444999999997],
            [-72.53697000000003, 44.87111999999999],
            [-72.70461000000003, 44.52715000000004],
            [-72.95248000000004, 44.161409999999975],
            [-72.88827, 44.054799999999965],
            [-73.03022999999993, 43.846659999999986],
            [-73.21937999999994, 43.837140000000026],
            [-73.25074999999998, 43.57943000000004],
            [-73.37174999999993, 43.624590000000026],
            [-73.48256, 43.50627999999998],
            [-73.58427999999998, 43.673400000000036],
            [-73.75779999999995, 43.647059999999975],
            [-73.85882000000001, 43.76381],
            [-74.20066000000003, 43.63811000000001],
            [-74.05789000000004, 43.74449],
            [-74.33682999999996, 43.925220000000024],
            [-74.28183000000001, 44.12029999999997],
            [-74.13114000000002, 44.13404999999999],
            [-74.25118999999995, 44.29463],
            [-74.36738999999994, 44.27162999999998],
            [-74.56032999999994, 44.397499999999994],
            [-74.64178000000001, 44.952820000000045],
            [-74.72385000000003, 44.97594999999998],
            [-74.66112999999999, 44.99969000000003],
            [-73.35218999999998, 45.01043000000004],
            [-73.44799999999998, 44.710020000000036],
            [-73.34948999999995, 44.27266000000002],
            [-73.25317999999996, 44.44160999999997],
            [-73.16106999999994, 44.92117000000002],
            [-73.09081999999995, 45.01530000000002],
            [-72.32153, 45.00444999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BUF" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-78.28034, 43.371769999999984],
            [-78.32327999999998, 43.20757999999997],
            [-78.13088999999994, 43.046369999999975],
            [-78.16282999999999, 42.86436],
            [-78.05024, 42.76517000000001],
            [-78.12195, 42.571739999999984],
            [-78.88845000000003, 42.44212000000002],
            [-79.15056000000001, 42.248689999999996],
            [-79.26500999999999, 42.40602000000004],
            [-79.43829, 42.42252999999997],
            [-79.14730999999995, 42.554659999999956],
            [-78.86621999999994, 42.77119999999996],
            [-78.94128999999998, 42.984600000000036],
            [-79.06938, 43.086080000000045],
            [-79.06460999999993, 43.26284999999998],
            [-78.63751999999997, 43.35722999999997],
            [-78.28034, 43.371769999999984],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BWG" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-85.37985000000003, 37.523899999999955],
            [-85.25490000000002, 37.50347000000004],
            [-85.17994000000002, 37.31103000000004],
            [-85.05680999999996, 37.25694999999999],
            [-84.86677000000003, 36.96701000000004],
            [-84.67904000000001, 36.98075999999996],
            [-84.57383999999996, 36.84466000000003],
            [-84.85686999999999, 36.52915999999999],
            [-85.04727999999997, 36.543599999999984],
            [-85.37091999999993, 36.089549999999974],
            [-85.57419999999996, 36.05898000000005],
            [-85.47749000000002, 36.32007000000001],
            [-85.61900999999995, 36.24527000000003],
            [-85.90651, 36.45987000000001],
            [-86.05693000000002, 36.33455999999997],
            [-86.25444999999996, 36.37117999999998],
            [-86.21725999999995, 36.481519999999975],
            [-86.39100000000002, 36.65034],
            [-86.73521999999994, 36.648870000000045],
            [-86.75143000000003, 36.72617000000002],
            [-87.11309999999995, 36.716570000000004],
            [-87.31919000000005, 36.85884000000001],
            [-87.25289999999995, 37.01718000000004],
            [-87.58686, 36.958],
            [-87.59999000000005, 37.08920999999998],
            [-87.40254000000002, 37.13202999999997],
            [-86.88939999999994, 37.61283999999998],
            [-86.65313999999998, 37.73157999999998],
            [-86.59061999999997, 37.91941000000003],
            [-86.4316, 37.870549999999966],
            [-86.43648000000002, 37.683230000000016],
            [-86.06701000000004, 37.65337999999997],
            [-85.78833999999998, 37.501370000000016],
            [-85.37985000000003, 37.523899999999955],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "BWI" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-76.00824999999998, 38.571510000000046],
              [-75.97685000000001, 38.36743],
              [-76.01970999999995, 38.353809999999996],
              [-76.03373999999994, 38.33498000000003],
              [-76.03360999999992, 38.33355999999996],
              [-76.03060000000002, 38.32728999999996],
              [-76.27827999999994, 38.381760000000035],
              [-76.27169000000004, 38.57746999999998],
              [-76.00824999999998, 38.571510000000046],
            ],
          ],
          [
            [
              [-76.06721999999996, 38.88579000000004],
              [-75.92574999999997, 38.83716000000001],
              [-76.02718000000002, 38.578530000000015],
              [-76.2656, 38.82929999999999],
              [-76.06721999999996, 38.88579000000004],
            ],
          ],
          [
            [
              [-76.04538, 39.13931000000001],
              [-75.88032999999996, 39.03587000000001],
              [-76.07588999999993, 38.89200999999999],
              [-76.14585999999994, 39.09251000000004],
              [-76.04538, 39.13931000000001],
            ],
          ],
          [
            [
              [-76.11355999999998, 39.36700000000001],
              [-75.98918999999998, 39.26300000000004],
              [-75.98673000000002, 39.24631999999998],
              [-76.11948999999998, 39.109149999999985],
              [-76.27460999999997, 39.16697999999998],
              [-76.11355999999998, 39.36700000000001],
            ],
          ],
          [
            [
              [-76.41455999999994, 39.72123000000005],
              [-76.28193999999999, 39.68860999999996],
              [-76.221, 39.474690000000024],
              [-76.38384999999997, 39.29814],
              [-76.53882999999999, 38.79004000000003],
              [-76.69461999999999, 38.957430000000045],
              [-77.10237000000001, 39.18135000000004],
              [-77.30739000000003, 39.641009999999966],
              [-77.10672999999997, 39.63036000000004],
              [-77.07286000000002, 39.72008000000002],
              [-76.41455999999994, 39.72123000000005],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CAE" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-80.69448999999997, 33.140969999999996],
            [-81.07169999999996, 33.19133],
            [-81.21909999999997, 33.282129999999995],
            [-81.29677999999996, 33.48015000000001],
            [-81.55535000000003, 33.60766000000001],
            [-81.63040000000001, 33.83136000000002],
            [-81.85493000000002, 33.87868000000002],
            [-81.97510999999997, 34.01024000000001],
            [-81.77987999999996, 34.433139999999966],
            [-81.52108000000004, 34.56980000000004],
            [-81.29575, 34.56631999999996],
            [-81.04324000000003, 34.627380000000045],
            [-80.89558, 34.493300000000005],
            [-80.48370999999997, 34.42256999999999],
            [-80.36417000000003, 34.539239999999964],
            [-80.26804000000001, 34.34952000000004],
            [-80.38210999999998, 34.15188000000002],
            [-80.28461999999996, 34.095329999999976],
            [-80.20970000000003, 33.85413000000001],
            [-80.39713, 33.767770000000034],
            [-80.36156, 33.66835000000003],
            [-80.49832999999992, 33.56162000000004],
            [-80.42716000000001, 33.47117999999999],
            [-80.52265999999995, 33.29503000000002],
            [-80.72219999999999, 33.23489999999997],
            [-80.69448999999997, 33.140969999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CAK" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-80.87451999999999, 40.81836],
            [-80.93292, 40.54884999999996],
            [-81.14950000000002, 40.26801999999998],
            [-81.05496999999997, 40.08554000000001],
            [-81.22811000000002, 40.11155000000004],
            [-81.23730000000003, 39.86783000000002],
            [-81.40198999999993, 39.75831999999996],
            [-81.76574999999997, 39.96963999999998],
            [-81.79792000000003, 40.14546],
            [-82.04046999999994, 40.22151000000002],
            [-81.90134999999998, 40.37078999999996],
            [-82.06363999999999, 40.58150000000004],
            [-81.96166000000002, 40.66774999999997],
            [-82.13908999999992, 40.849919999999955],
            [-81.97548999999998, 41.01552000000001],
            [-81.80399, 41.051419999999965],
            [-81.54344000000003, 41.274130000000035],
            [-81.21009000000001, 41.34745999999997],
            [-81.09835999999996, 41.08774999999997],
            [-80.93530999999996, 40.974230000000034],
            [-80.87451999999999, 40.81836],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CAR" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-67.80576999999994, 45.68000999999997],
            [-67.98224999999996, 45.88008999999999],
            [-68.16150000000002, 45.974100000000014],
            [-68.57827999999995, 45.937919999999984],
            [-68.59744999999998, 46.03953],
            [-68.82278000000002, 46.009369999999976],
            [-68.82144, 46.57244],
            [-70.02321000000003, 46.57350000000004],
            [-69.99720999999994, 46.69553000000003],
            [-69.22454999999997, 47.45983000000002],
            [-69.04306000000003, 47.42668999999999],
            [-69.05082999999996, 47.25650000000003],
            [-68.90053, 47.17791],
            [-68.36302, 47.35472000000004],
            [-68.15471, 47.32511999999999],
            [-67.79021, 47.067200000000035],
            [-67.78131000000002, 45.943470000000005],
            [-67.80576999999994, 45.68000999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CGI" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-89.03142, 38.29412999999997],
            [-88.84574000000003, 38.19995],
            [-88.79713999999998, 38.05322000000001],
            [-88.62321000000003, 37.993230000000004],
            [-88.40746999999996, 37.75263999999997],
            [-88.39875000000004, 37.447769999999984],
            [-88.18499, 37.33618000000004],
            [-88.18171999999998, 37.160450000000004],
            [-88.07243000000003, 37.176870000000044],
            [-87.91490999999996, 36.94923],
            [-88.15728000000001, 36.86712000000004],
            [-88.04712, 36.49681999999998],
            [-88.26561999999998, 36.500060000000005],
            [-88.34366, 36.352049999999984],
            [-88.48452000000003, 36.477740000000026],
            [-88.62064999999996, 36.35812999999998],
            [-88.70863000000003, 36.44362],
            [-88.76111000000003, 36.2864],
            [-89.14142000000001, 36.23965],
            [-89.59984999999995, 36.11960000000005],
            [-89.71317000000005, 36.026950000000014],
            [-89.81374, 36.18258],
            [-90.03559999999999, 36.14927999999996],
            [-90.31959999999998, 36.258999999999986],
            [-90.62724, 36.24375999999997],
            [-90.78522000000001, 36.35358000000001],
            [-90.85355999999999, 36.19998999999997],
            [-91.05227, 36.15284],
            [-91.23306999999994, 36.37595999999998],
            [-91.28713999999997, 36.49738999999998],
            [-91.12691999999998, 36.497669999999964],
            [-91.12037000000001, 36.747640000000004],
            [-91.22300999999999, 36.883840000000035],
            [-91.43843000000004, 36.943619999999996],
            [-91.28722000000002, 37.05876000000003],
            [-91.26401000000004, 37.20046000000003],
            [-91.15838999999997, 37.25499000000001],
            [-91.18299000000002, 37.41487000000001],
            [-90.90795000000003, 37.603170000000034],
            [-90.14669999999998, 37.64161000000001],
            [-90.25544, 37.71567000000004],
            [-89.94095999999996, 37.87649000000001],
            [-89.77188000000001, 38.03752000000004],
            [-89.49907999999999, 38.10454000000004],
            [-89.42684, 38.20845000000003],
            [-89.03142, 38.29412999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CHA" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-84.14259999999996, 34.821339999999964],
            [-84.18881999999999, 34.60299999999998],
            [-84.30393999999998, 34.54791000000003],
            [-84.42875999999998, 34.55743],
            [-84.58822999999998, 34.42391000000002],
            [-85.08045000000001, 34.297130000000024],
            [-85.04567, 34.15129999999999],
            [-85.34466999999995, 34.137709999999984],
            [-85.41421, 34.04348999999999],
            [-85.78623999999996, 34.08030000000001],
            [-85.75257000000005, 34.29662000000002],
            [-85.91213000000002, 34.49223000000003],
            [-85.83045000000004, 34.60244],
            [-85.92866999999995, 34.77009000000004],
            [-86.08201, 34.831620000000015],
            [-85.96159, 35.15575000000001],
            [-86.23353999999995, 35.245279999999994],
            [-86.01050000000001, 35.462669999999974],
            [-85.79519999999994, 35.51723999999997],
            [-85.96464000000003, 35.78245999999997],
            [-85.67273999999998, 35.85476999999999],
            [-85.72824999999995, 35.98366000000003],
            [-85.57419999999996, 36.05898000000005],
            [-85.37091999999993, 36.089549999999974],
            [-85.01284999999996, 35.891629999999964],
            [-85.05686000000003, 35.69693000000002],
            [-84.81165999999993, 35.57522000000003],
            [-84.72577999999999, 35.63714000000004],
            [-84.30314000000004, 35.13185999999999],
            [-84.32172999999995, 34.988110000000006],
            [-84.12130999999994, 34.98755000000004],
            [-84.14259999999996, 34.821339999999964],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CHS" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-80.14329999999998, 32.74992],
              [-79.99398999999994, 32.60592999999997],
              [-80.14535999999998, 32.57979999999998],
              [-80.14329999999998, 32.74992],
            ],
          ],
          [
            [
              [-80.14329999999998, 32.74992],
              [-80.41827999999998, 32.66761000000002],
              [-80.53789999999998, 32.764699999999976],
              [-80.60709999999997, 33.06262000000001],
              [-80.69448999999997, 33.140969999999996],
              [-80.72219999999999, 33.23489999999997],
              [-80.52265999999995, 33.29503000000002],
              [-80.42716000000001, 33.47117999999999],
              [-80.49832999999992, 33.56162000000004],
              [-80.36156, 33.66835000000003],
              [-80.20432000000002, 33.44181999999999],
              [-80.01415, 33.66027000000002],
              [-79.91275999999996, 33.619939999999986],
              [-79.74110999999999, 33.32211000000002],
              [-79.40248999999994, 33.182649999999995],
              [-79.32151999999999, 33.145580000000045],
              [-79.57081, 33.034199999999984],
              [-79.85934, 32.76611999999996],
              [-80.14329999999998, 32.74992],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CID" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-90.93703999999997, 41.90974],
            [-91.08262000000002, 41.56665999999997],
            [-91.34940999999998, 41.30323000000001],
            [-91.48403000000002, 41.423829999999995],
            [-91.48537000000005, 41.24940999999999],
            [-91.89105000000004, 41.18573000000002],
            [-92.05488, 41.06823000000003],
            [-92.28315000000003, 41.06816000000001],
            [-92.49985999999998, 41.16157000000004],
            [-92.47280000000003, 41.42929999999997],
            [-92.65649999999997, 41.559830000000005],
            [-92.61038000000002, 41.84798],
            [-92.49300000000002, 41.86234999999998],
            [-92.40515999999997, 42.036069999999974],
            [-92.20973000000004, 42.07276000000002],
            [-92.22170000000003, 42.21181999999998],
            [-92.05532, 42.212389999999985],
            [-91.87031999999999, 42.42170999999998],
            [-91.54011, 42.39135000000002],
            [-91.35633000000001, 42.30404999999999],
            [-91.24709000000001, 42.12696999999998],
            [-90.93703999999997, 41.90974],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CIN" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-83.46792999999997, 39.285890000000016],
            [-83.36143999999996, 39.16250000000002],
            [-83.50756000000001, 39.03692000000002],
            [-83.64196999999999, 38.525140000000036],
            [-84.03313000000003, 38.582789999999974],
            [-85.00774999999996, 38.550299999999986],
            [-85.21789999999999, 38.59320000000003],
            [-85.25874000000002, 38.737750000000034],
            [-85.54488999999992, 38.73739],
            [-85.53767000000002, 38.891879999999986],
            [-85.73932999999994, 38.90298000000003],
            [-85.77182000000002, 39.00620999999997],
            [-85.67845000000003, 39.07305],
            [-85.64935999999997, 39.40141999999999],
            [-85.26963999999995, 39.47919000000003],
            [-85.35838999999996, 39.61183999999997],
            [-85.27223000000004, 39.78796000000004],
            [-85.04750999999999, 39.695850000000014],
            [-84.98294000000001, 39.51615000000003],
            [-84.68899999999996, 39.56739000000002],
            [-84.24055000000001, 39.367510000000024],
            [-83.87942999999993, 39.365870000000044],
            [-83.83556999999996, 39.26822000000003],
            [-83.46792999999997, 39.285890000000016],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CLE" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-81.19735, 41.78093],
            [-81.12199999999999, 41.65007000000002],
            [-81.30546999999999, 41.56234999999997],
            [-81.21009000000001, 41.34745999999997],
            [-81.54344000000003, 41.274130000000035],
            [-81.80399, 41.051419999999965],
            [-81.97548999999998, 41.01552000000001],
            [-82.34071, 41.14471000000001],
            [-82.32462000000001, 41.329759999999986],
            [-82.50297999999998, 41.28515000000003],
            [-82.62256000000002, 41.42305000000003],
            [-82.48054999999994, 41.38147999999998],
            [-82.01230999999993, 41.515639999999976],
            [-81.74319999999994, 41.487889999999965],
            [-81.19735, 41.78093],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CLT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-79.68075999999996, 35.17717999999998],
            [-79.57886999999997, 35.09497],
            [-79.62180000000001, 35.017380000000024],
            [-79.89189999999999, 35.02477999999999],
            [-79.91376999999997, 34.81825],
            [-80.16776999999993, 34.81152999999998],
            [-80.17765000000003, 34.62209999999998],
            [-80.36417000000003, 34.539239999999964],
            [-80.48370999999997, 34.42256999999999],
            [-80.89558, 34.493300000000005],
            [-81.04324000000003, 34.627380000000045],
            [-81.29575, 34.56631999999996],
            [-81.44729999999998, 34.712389999999964],
            [-81.48854, 35.029670000000024],
            [-81.68465999999992, 35.29945000000002],
            [-81.69793000000001, 35.57895000000001],
            [-81.53713000000002, 35.671739999999986],
            [-81.73533, 35.90303999999999],
            [-81.72999000000004, 36.086989999999986],
            [-81.54550000000003, 36.11738999999997],
            [-81.38068999999999, 36.04405000000001],
            [-81.16271999999995, 36.28270000000002],
            [-80.90975999999998, 36.119910000000026],
            [-80.88289999999998, 35.932920000000024],
            [-80.72301999999996, 35.91866],
            [-80.60674000000003, 35.74029999999996],
            [-80.47920000000002, 35.77510999999997],
            [-80.05886999999998, 35.491790000000016],
            [-80.07481000000001, 35.39479999999999],
            [-79.86077, 35.27468000000002],
            [-79.88535000000002, 35.167429999999996],
            [-79.68075999999996, 35.17717999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CLX" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-80.62578999999997, 32.50292000000003],
              [-80.45686, 32.40946999999998],
              [-80.63097999999997, 32.25553999999997],
              [-80.62578999999997, 32.50292000000003],
            ],
          ],
          [
            [
              [-80.33428999999998, 32.63644000000001],
              [-80.21213, 32.550939999999954],
              [-80.33641, 32.47783000000001],
              [-80.33428999999998, 32.63644000000001],
            ],
          ],
          [
            [
              [-80.87510999999998, 32.161210000000025],
              [-80.97045, 32.30478999999997],
              [-81.38923999999997, 32.59546000000002],
              [-81.40629000000001, 32.883460000000035],
              [-81.07169999999996, 33.19133],
              [-80.69448999999997, 33.140969999999996],
              [-80.60709999999997, 33.06262000000001],
              [-80.53789999999998, 32.764699999999976],
              [-80.41827999999998, 32.66761000000002],
              [-80.39391999999998, 32.56826000000003],
              [-80.56132999999994, 32.502660000000006],
              [-80.85169999999997, 32.53430000000001],
              [-80.87510999999998, 32.161210000000025],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CMH" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-83.39615000000003, 40.68722000000004],
            [-83.28730999999999, 40.49551000000004],
            [-83.02264000000002, 40.51305000000002],
            [-82.91024000000004, 40.407490000000024],
            [-82.64201999999997, 40.403210000000016],
            [-82.59871000000001, 40.270529999999994],
            [-82.46515000000002, 40.30813000000001],
            [-82.08993999999996, 40.06863000000002],
            [-82.04046999999994, 40.22151000000002],
            [-81.79792000000003, 40.14546],
            [-81.76574999999997, 39.96963999999998],
            [-81.40198999999993, 39.75831999999996],
            [-81.43296000000001, 39.56467999999997],
            [-81.58157000000003, 39.586599999999976],
            [-81.63338000000002, 39.44863999999998],
            [-81.84479999999994, 39.449999999999974],
            [-82.06827000000001, 39.193009999999965],
            [-82.16874999999999, 39.262810000000044],
            [-82.43038999999996, 39.19405000000004],
            [-82.75573, 39.28628999999998],
            [-82.74690000000001, 39.14089],
            [-83.02755999999997, 39.22072999999999],
            [-83.36143999999996, 39.16250000000002],
            [-83.46792999999997, 39.285890000000016],
            [-83.67492999999996, 39.70482000000003],
            [-83.54282000000003, 39.99373000000003],
            [-83.80607999999995, 40.58755999999998],
            [-83.73015999999993, 40.70365999999996],
            [-83.64508000000001, 40.753860000000046],
            [-83.39615000000003, 40.68722000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CMI" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-87.34313999999998, 41.03288999999996],
            [-87.26807999999997, 40.881240000000034],
            [-86.93066999999996, 40.809690000000025],
            [-87.01596000000004, 40.68484999999997],
            [-87.09741999999994, 40.65659999999997],
            [-87.09215, 40.14226],
            [-87.16010999999997, 39.81773000000003],
            [-87.33293999999998, 39.777769999999975],
            [-87.40083999999996, 39.58178000000005],
            [-87.29099000000002, 39.60810999999999],
            [-87.24013999999997, 39.297240000000045],
            [-87.51872999999998, 39.28112999999999],
            [-87.52460999999994, 39.156700000000015],
            [-88.23715999999993, 39.04921999999996],
            [-88.4795, 38.91309000000004],
            [-88.65979000000002, 39.05057999999996],
            [-88.73998999999995, 39.28143000000003],
            [-88.62114, 39.40451999999998],
            [-88.79762000000002, 39.463670000000036],
            [-88.78669, 39.76258000000001],
            [-88.89118000000002, 40.017010000000035],
            [-89.14611000000002, 40.143809999999995],
            [-89.03659999999996, 40.26110000000002],
            [-88.88095999999996, 40.29701],
            [-88.89081999999999, 40.42066000000001],
            [-88.58385999999999, 40.66201000000004],
            [-88.58475000000001, 40.81586000000001],
            [-88.40958000000003, 40.999949999999956],
            [-87.82849000000002, 40.989810000000034],
            [-87.69325, 40.948950000000025],
            [-87.52657000000002, 41.072950000000034],
            [-87.34313999999998, 41.03288999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CNK" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-96.35500999999994, 39.896150000000034],
            [-96.58221, 39.669419999999974],
            [-96.50874999999996, 39.43598000000001],
            [-96.62219999999996, 39.277240000000006],
            [-96.75626000000003, 39.349490000000024],
            [-96.85096000000004, 39.10106999999998],
            [-96.58313999999993, 39.015499999999996],
            [-96.61278999999996, 38.870260000000016],
            [-96.89019999999994, 38.87008999999998],
            [-96.77133999999995, 38.59918000000002],
            [-96.98546999999994, 38.63669999999998],
            [-97.37189000000001, 38.609260000000035],
            [-97.37191999999999, 38.50787000000001],
            [-97.55610999999996, 38.536259999999956],
            [-97.72479999999999, 38.769080000000045],
            [-97.70594000000003, 38.609120000000004],
            [-98.11016999999994, 38.68881000000001],
            [-98.16451999999994, 38.594530000000034],
            [-98.48009999999995, 38.57264000000002],
            [-98.63272999999995, 38.44941000000003],
            [-98.57536999999995, 38.69685],
            [-99.06044, 38.69686999999996],
            [-99.16797000000001, 39.07261000000001],
            [-99.48365999999996, 39.07148999999998],
            [-99.60641999999996, 39.20678999999997],
            [-99.6281, 39.726920000000014],
            [-99.62724, 39.88227000000001],
            [-99.46509999999996, 40.00203000000003],
            [-98.60161, 40.00238999999998],
            [-98.56712, 40.20993999999999],
            [-98.29288000000001, 40.23460000000004],
            [-98.29687000000001, 40.37904],
            [-98.04834999999996, 40.27868999999997],
            [-97.63437000000005, 40.37931999999999],
            [-97.23685000000003, 40.32059000000005],
            [-97.01588999999998, 40.16077000000004],
            [-97.01834999999994, 40.00153999999999],
            [-96.65357, 40.001309999999975],
            [-96.35500999999994, 39.896150000000034],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CON" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-70.65528999999995, 43.10016],
            [-70.83240999999998, 42.89880999999997],
            [-71.38585, 42.69889999999998],
            [-71.54621999999995, 42.70274],
            [-71.72277, 42.79663000000004],
            [-72.31789999999995, 42.80015999999999],
            [-72.64130999999998, 42.947009999999956],
            [-72.77033999999998, 43.04057999999999],
            [-72.66889999999998, 43.224610000000034],
            [-72.75025000000002, 43.33277000000004],
            [-72.49678000000003, 43.56609000000002],
            [-72.38838999999999, 43.50941999999999],
            [-72.02122, 43.61442000000002],
            [-72.06072999999995, 43.75913000000002],
            [-71.57186000000002, 43.78660999999999],
            [-71.56457, 43.89317999999997],
            [-71.37085999999996, 43.959149999999966],
            [-70.9864, 43.638020000000026],
            [-70.98725999999999, 43.41346000000001],
            [-70.84862999999999, 43.363670000000006],
            [-70.65528999999995, 43.10016],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "COS" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-103.43633999999996, 39.56591999999998],
            [-103.35938999999999, 39.47760000000002],
            [-103.37893, 39.20352000000004],
            [-103.15556999999997, 39.14806000000003],
            [-103.16370000000002, 38.849360000000026],
            [-103.40346999999997, 38.8497],
            [-103.36893999999995, 38.952149999999975],
            [-103.55811999999996, 38.95293999999997],
            [-103.65667000000002, 38.665220000000026],
            [-103.87321999999996, 38.62421999999998],
            [-103.84959999999998, 38.52250000000001],
            [-104.94160000000002, 38.519050000000014],
            [-105.01850000000003, 38.651340000000005],
            [-105.17033999999995, 38.647640000000024],
            [-105.14338000000002, 38.40067000000004],
            [-105.24809000000003, 38.25897000000004],
            [-105.79729999999999, 38.26496999999999],
            [-106.10836000000002, 38.51149000000004],
            [-106.24709999999999, 38.422840000000036],
            [-106.3832, 38.62335999999996],
            [-106.41598, 38.82409999999997],
            [-106.59918999999996, 38.99787999999997],
            [-106.57827, 39.057880000000004],
            [-106.19089999999994, 39.05599000000004],
            [-106.12343000000001, 39.14828000000003],
            [-105.88065999999999, 39.05275],
            [-105.69684999999994, 39.08864000000003],
            [-105.66569999999999, 39.20419999999999],
            [-105.39767, 39.248849999999976],
            [-105.39783000000001, 39.12957999999999],
            [-105.00693, 39.129929999999995],
            [-105.01454999999996, 39.287839999999974],
            [-104.86195999999998, 39.21564000000001],
            [-104.35678000000003, 39.30826000000005],
            [-104.13602, 39.404739999999975],
            [-103.97795999999995, 39.388510000000025],
            [-104.04829999999995, 39.24171999999996],
            [-103.83496999999998, 39.28554000000001],
            [-103.70687000000002, 39.60065999999997],
            [-103.43633999999996, 39.56591999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "COU" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-92.85641999999999, 40.062610000000014],
            [-92.68458000000001, 39.86983999999997],
            [-92.36321000000001, 39.858810000000034],
            [-92.36353999999997, 39.663920000000005],
            [-92.18602999999999, 39.62422999999998],
            [-91.98313999999999, 39.062130000000025],
            [-91.92972000000003, 39.382360000000006],
            [-91.70558999999997, 39.149309999999986],
            [-91.63663000000003, 38.99081000000004],
            [-91.46829000000002, 39.08005],
            [-91.33961000000002, 38.96611999999999],
            [-91.41762999999997, 38.74560000000002],
            [-91.23239000000001, 38.65056000000004],
            [-91.38427999999996, 38.576890000000034],
            [-91.24966000000003, 38.481449999999995],
            [-91.36654999999999, 38.26217000000004],
            [-91.33563999999998, 38.10896000000001],
            [-91.52666000000002, 37.92803999999998],
            [-91.30838000000003, 37.78715999999997],
            [-91.32048999999998, 37.41722000000002],
            [-91.18299000000002, 37.41487000000001],
            [-91.15838999999997, 37.25499000000001],
            [-91.26401000000004, 37.20046000000003],
            [-91.31244000000004, 37.27954000000001],
            [-91.64135000000005, 37.279839999999965],
            [-91.78605999999994, 37.576620000000005],
            [-92.02932000000001, 37.6024],
            [-92.07249000000002, 37.70432000000001],
            [-92.33157000000003, 37.64013000000003],
            [-92.48533999999995, 37.68757000000002],
            [-92.53557000000004, 37.96143],
            [-92.85003, 37.913529999999966],
            [-92.82246000000004, 38.03564000000001],
            [-93.05109000000002, 38.270039999999995],
            [-93.39957000000001, 38.38017000000002],
            [-93.69429999999997, 38.41179000000005],
            [-93.70685, 38.488300000000024],
            [-93.59988000000004, 38.558510000000005],
            [-93.66571999999994, 38.81548999999999],
            [-93.35192999999998, 39.07617999999999],
            [-93.48424999999997, 39.17451999999999],
            [-93.21921999999998, 39.33336],
            [-93.28769999999997, 39.682580000000016],
            [-93.19807, 39.77833000000003],
            [-93.40827999999999, 39.77741000000003],
            [-93.29785000000004, 39.94692999999997],
            [-92.99776999999997, 39.93143000000003],
            [-92.92387999999997, 40.061969999999995],
            [-92.85641999999999, 40.062610000000014],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CPR" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-105.08064999999996, 43.49870999999998],
            [-104.55362999999997, 43.50189000000002],
            [-104.61414999999995, 43.28444000000004],
            [-104.43247000000001, 43.23826000000003],
            [-104.56743999999996, 42.983830000000005],
            [-104.72138000000001, 43.01515],
            [-104.89815999999998, 42.93237000000003],
            [-104.89235999999997, 42.60932999999997],
            [-105.28657000000003, 42.60583000000001],
            [-105.28382999999998, 42.43149999999999],
            [-105.37594, 42.29015],
            [-105.71347999999995, 42.35990999999996],
            [-105.79281999999995, 42.177540000000036],
            [-105.69912000000001, 42.05583999999999],
            [-105.76816, 41.802310000000006],
            [-106.11853000000004, 41.7402],
            [-106.20885000000001, 41.52079999999997],
            [-106.07431000000001, 41.394899999999964],
            [-106.41923999999999, 41.462269999999975],
            [-106.60662999999995, 41.402469999999965],
            [-106.55487000000002, 41.52193000000003],
            [-106.80425000000001, 41.74768000000002],
            [-107.26477999999999, 41.39198000000003],
            [-107.58405999999997, 41.27634000000002],
            [-107.70975999999996, 41.30261999999999],
            [-107.81906999999998, 41.279670000000024],
            [-107.91774000000002, 41.07310000000001],
            [-107.92975999999997, 41.65952999999999],
            [-107.50971999999996, 41.65735000000001],
            [-107.54348999999998, 42.761050000000004],
            [-107.74718, 42.68894999999996],
            [-107.90254999999996, 42.78950000000003],
            [-108.02086999999995, 43.090980000000016],
            [-107.95816000000003, 43.23705000000002],
            [-107.68783, 43.366059999999955],
            [-107.59517999999998, 43.501320000000014],
            [-107.11089, 43.50016999999999],
            [-107.12842000000003, 44.099369999999986],
            [-106.79520999999997, 43.88667000000001],
            [-106.50042999999995, 43.952559999999956],
            [-106.31454000000001, 44.143700000000045],
            [-106.17182, 44.02255000000003],
            [-106.00982, 44.08798000000002],
            [-106.01765999999996, 43.49500999999999],
            [-105.08064999999996, 43.49870999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CRP" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-96.79046999999994, 28.319220000000016],
            [-96.91158999999996, 28.125430000000044],
            [-97.15355999999997, 28.13613999999997],
            [-97.02534000000003, 28.03263999999998],
            [-97.19041999999993, 27.823159999999973],
            [-97.39278999999999, 27.813040000000015],
            [-97.24353999999997, 27.689659999999964],
            [-97.49177999999995, 27.093689999999963],
            [-97.91183, 27.128670000000003],
            [-97.98576000000003, 27.073079999999987],
            [-97.98545999999997, 26.78093999999999],
            [-98.32056999999995, 26.78301999999996],
            [-98.42242000000002, 26.78346999999998],
            [-98.41785, 27.055279999999986],
            [-98.49289000000002, 27.23439],
            [-98.23219, 27.26237000000004],
            [-98.23321000000001, 27.50586999999997],
            [-98.36699000000002, 27.60575000000002],
            [-98.50957, 27.57563999999996],
            [-98.62856, 27.357690000000005],
            [-98.79839, 27.353890000000007],
            [-98.80185000000003, 27.719249999999988],
            [-98.50866999999995, 27.954560000000043],
            [-98.34356999999997, 27.93159000000002],
            [-98.33427, 28.057860000000005],
            [-98.33443999999994, 28.303499999999985],
            [-98.46400999999994, 28.485869999999995],
            [-98.33539000000003, 28.64836999999997],
            [-98.24018999999996, 28.53609999999999],
            [-98.00524999999996, 28.690260000000027],
            [-97.78749000000002, 28.675549999999987],
            [-97.69669000000002, 28.541639999999983],
            [-97.40018000000003, 28.392589999999977],
            [-97.21610999999996, 28.510800000000007],
            [-97.07775000000001, 28.353560000000037],
            [-96.79046999999994, 28.319220000000016],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CRW" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-81.43296000000001, 39.56467999999997],
            [-81.22545000000002, 39.59216999999997],
            [-81.12141000000003, 39.457720000000045],
            [-81.01451, 39.40578999999999],
            [-80.93594999999996, 39.06879999999998],
            [-81.03786000000002, 39.00721999999996],
            [-80.93951999999993, 38.771049999999974],
            [-80.78493999999998, 38.830540000000006],
            [-80.66894000000002, 38.48516000000001],
            [-80.77995000000001, 38.49242000000003],
            [-81.10576, 38.32276999999999],
            [-81.33976999999999, 38.133149999999986],
            [-81.38086999999996, 37.96901999999997],
            [-81.47411999999997, 38.05449000000002],
            [-81.60463000000004, 37.961419999999976],
            [-81.55965, 37.84073000000001],
            [-81.84480999999997, 37.84488],
            [-82.10061999999996, 37.78255000000001],
            [-82.19077999999993, 37.97465000000004],
            [-82.04266999999999, 38.06121999999998],
            [-81.99217000000004, 38.25826000000001],
            [-82.11629000000002, 38.40723999999999],
            [-82.01937000000001, 38.97583000000004],
            [-82.23835999999997, 39.12814999999998],
            [-82.06827000000001, 39.193009999999965],
            [-81.84479999999994, 39.449999999999974],
            [-81.63338000000002, 39.44863999999998],
            [-81.58157000000003, 39.586599999999976],
            [-81.43296000000001, 39.56467999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CSG" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-84.34536999999997, 33.04105000000001],
            [-84.50599000000003, 32.88143999999997],
            [-84.33787000000001, 32.72066000000002],
            [-84.40829999999997, 32.58413999999998],
            [-84.25462000000005, 32.37202999999997],
            [-84.39127999999994, 32.382350000000045],
            [-84.43021000000005, 32.166310000000024],
            [-84.19916999999998, 32.12092000000001],
            [-84.36240999999998, 31.91521000000001],
            [-84.91729999999998, 31.924759999999967],
            [-85.06089999999998, 31.991819999999997],
            [-85.21778, 31.48758000000002],
            [-85.46666000000002, 31.479890000000037],
            [-85.54535999999999, 31.556419999999978],
            [-85.41576, 31.660950000000014],
            [-85.64668, 32.01306999999999],
            [-85.52756, 32.33693000000004],
            [-85.82430000000002, 32.57118999999999],
            [-85.61444, 32.91241000000004],
            [-85.78484000000003, 33.07444000000003],
            [-85.6532, 33.21107000000002],
            [-85.60391999999999, 33.44769999999996],
            [-85.40896999999998, 33.28949000000003],
            [-85.26890999999995, 33.297899999999984],
            [-85.23653000000002, 33.12841000000003],
            [-84.99206000000001, 33.278030000000044],
            [-84.61427, 33.076439999999955],
            [-84.34536999999997, 33.04105000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CXY" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-76.38517999999996, 40.70662],
            [-76.27196999999992, 40.51751],
            [-76.06123999999997, 40.49081],
            [-76.01308, 40.20799999999997],
            [-75.99759, 40.05470000000004],
            [-76.41455999999994, 39.72123000000005],
            [-77.07286000000002, 39.72008000000002],
            [-77.10672999999997, 39.63036000000004],
            [-77.30739000000003, 39.641009999999966],
            [-77.41431000000003, 39.71999999999997],
            [-77.85521, 39.72211999999996],
            [-77.81517, 39.99560999999997],
            [-77.60484, 40.206109999999995],
            [-77.67101000000002, 40.25853000000001],
            [-77.51449000000002, 40.412680000000016],
            [-77.61251999999996, 40.51413000000003],
            [-77.45073000000002, 40.63324000000001],
            [-77.01423999999994, 40.75525999999998],
            [-76.38517999999996, 40.70662],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "CYS" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-107.07105, 40.72975999999996],
            [-107.31753000000003, 40.9752],
            [-107.45853999999996, 40.885719999999985],
            [-107.54056000000001, 41.00225000000001],
            [-107.37331999999998, 41.00301000000001],
            [-107.46058, 41.154910000000015],
            [-107.70975999999996, 41.30261999999999],
            [-107.58405999999997, 41.27634000000002],
            [-107.26477999999999, 41.39198000000003],
            [-106.80425000000001, 41.74768000000002],
            [-106.55487000000002, 41.52193000000003],
            [-106.60662999999995, 41.402469999999965],
            [-106.41923999999999, 41.462269999999975],
            [-106.07431000000001, 41.394899999999964],
            [-106.20885000000001, 41.52079999999997],
            [-106.11853000000004, 41.7402],
            [-105.76816, 41.802310000000006],
            [-105.69912000000001, 42.05583999999999],
            [-105.79281999999995, 42.177540000000036],
            [-105.71347999999995, 42.35990999999996],
            [-105.37594, 42.29015],
            [-105.28382999999998, 42.43149999999999],
            [-104.95151999999996, 42.337549999999965],
            [-104.92500000000001, 42.25674000000001],
            [-104.65469999999998, 42.23672],
            [-104.65339999999998, 41.56478999999997],
            [-104.05259, 41.56418999999997],
            [-104.05320999999995, 41.001720000000034],
            [-103.57398999999997, 41.00174],
            [-103.52346999999996, 40.70460000000001],
            [-103.41064000000001, 40.55184],
            [-103.24462999999996, 40.57836000000003],
            [-103.14742000000003, 40.43688999999996],
            [-103.34029, 40.36878000000001],
            [-103.61515000000003, 40.522819999999975],
            [-104.14796000000001, 40.52436999999997],
            [-104.33663000000001, 40.39200999999996],
            [-104.57183000000002, 40.48600000000002],
            [-104.83873000000003, 40.50250000000001],
            [-104.88272000000002, 40.39912],
            [-105.16020999999996, 40.47628999999996],
            [-105.21255000000002, 40.59374],
            [-105.46247999999994, 40.48823999999999],
            [-105.73488999999995, 40.563730000000035],
            [-105.95943, 40.34827000000004],
            [-106.22982999999996, 40.32324000000002],
            [-106.61245000000002, 40.37962000000003],
            [-106.76668, 40.71930000000003],
            [-107.07105, 40.72975999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "DAB" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-80.85051999999993, 28.791200000000032],
            [-81.35828999999995, 28.84824000000003],
            [-81.35401999999996, 28.931370000000005],
            [-81.66095999999999, 28.956509999999984],
            [-81.75253999999995, 29.10675000000004],
            [-81.85214000000002, 29.000520000000034],
            [-82.27993000000001, 29.041120000000024],
            [-82.37860999999998, 29.220090000000003],
            [-82.58279000000005, 29.20822999999996],
            [-82.65541999999996, 29.30939999999999],
            [-82.54621999999998, 29.472859999999994],
            [-82.32596999999998, 29.58673999999996],
            [-82.20742999999999, 29.427379999999996],
            [-81.92705999999998, 29.521339999999967],
            [-81.94669999999999, 29.68625999999998],
            [-81.81263999999999, 29.83630000000001],
            [-81.59136999999998, 29.80567],
            [-81.70614999999998, 29.542140000000032],
            [-81.62470999999994, 29.208220000000022],
            [-81.53081999999998, 29.301740000000002],
            [-81.70247999999998, 29.543000000000045],
            [-81.52734000000001, 29.807469999999984],
            [-81.30771000000004, 29.966030000000014],
            [-81.27508999999995, 29.90215999999996],
            [-81.24699999999996, 29.719380000000044],
            [-80.78835000000004, 28.79127999999999],
            [-80.85051999999993, 28.791200000000032],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "DAY" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-83.73015999999993, 40.70365999999996],
            [-83.80607999999995, 40.58755999999998],
            [-83.54282000000003, 39.99373000000003],
            [-83.67492999999996, 39.70482000000003],
            [-83.46792999999997, 39.285890000000016],
            [-83.83556999999996, 39.26822000000003],
            [-83.87942999999993, 39.365870000000044],
            [-84.24055000000001, 39.367510000000024],
            [-84.68899999999996, 39.56739000000002],
            [-84.98294000000001, 39.51615000000003],
            [-85.04750999999999, 39.695850000000014],
            [-85.27223000000004, 39.78796000000004],
            [-85.28291999999999, 40.07659000000005],
            [-85.18645999999993, 40.30620000000002],
            [-84.86293, 40.309560000000026],
            [-84.75998999999999, 40.474660000000014],
            [-84.48014, 40.43105000000001],
            [-84.42859999999996, 40.64741999999998],
            [-84.15446, 40.70125000000004],
            [-83.96849000000003, 40.823950000000046],
            [-83.73015999999993, 40.70365999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "DCA" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-76.70635999999996, 38.059720000000034],
              [-76.93518999999995, 38.08058],
              [-77.24304999999998, 38.209870000000016],
              [-77.48777999999999, 38.14587999999998],
              [-77.46799999999993, 38.379049999999985],
              [-77.31670999999997, 38.35131],
              [-77.23971999999998, 38.33134000000004],
              [-77.04118, 38.40007000000004],
              [-76.96308999999997, 38.21190000000003],
              [-76.70635999999996, 38.059720000000034],
            ],
          ],
          [
            [
              [-76.53882999999999, 38.79004000000003],
              [-76.51261999999994, 38.520030000000006],
              [-76.38137999999998, 38.386229999999955],
              [-76.32001, 38.13792000000004],
              [-76.92486999999997, 38.291710000000016],
              [-77.02493999999993, 38.50056999999997],
              [-77.20766999999998, 38.35980000000001],
              [-77.27401000000003, 38.48175999999998],
              [-77.0961, 38.63551999999996],
              [-77.24733, 38.646240000000006],
              [-77.30046000000004, 38.50356000000001],
              [-77.44912999999997, 38.581049999999976],
              [-77.30249999999998, 38.650960000000005],
              [-77.28661000000002, 38.798490000000015],
              [-77.10237000000001, 39.18135000000004],
              [-76.69461999999999, 38.957430000000045],
              [-76.53882999999999, 38.79004000000003],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "DDC" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-99.60641999999996, 39.20678999999997],
            [-99.48365999999996, 39.07148999999998],
            [-99.16797000000001, 39.07261000000001],
            [-99.06044, 38.69686999999996],
            [-98.57536999999995, 38.69685],
            [-98.63272999999995, 38.44941000000003],
            [-98.70582000000002, 38.260849999999984],
            [-98.63770999999998, 38.05665000000004],
            [-98.72838999999999, 37.86836999999998],
            [-98.54920999999996, 37.57977000000005],
            [-98.75171999999995, 37.54359000000002],
            [-98.74468999999996, 37.32715999999998],
            [-98.83276000000002, 37.25908000000001],
            [-98.88959999999999, 36.99941999999997],
            [-99.11664000000003, 36.99938999999998],
            [-99.02488000000001, 36.75417999999996],
            [-98.86227, 36.76646999999997],
            [-98.68748999999995, 36.49817000000003],
            [-98.70165999999999, 36.417080000000006],
            [-98.96045, 36.50704000000004],
            [-98.95590000000001, 36.198219999999985],
            [-99.23923, 36.31881000000003],
            [-99.38097000000002, 36.012760000000014],
            [-99.60963, 35.84868999999999],
            [-99.80879999999995, 35.99772999999996],
            [-100.00032999999998, 35.8797],
            [-100.00034000000001, 36.27264000000005],
            [-100.28070000000001, 36.23561000000004],
            [-100.36650999999995, 36.31770000000002],
            [-100.54593999999997, 36.22383999999998],
            [-100.70236999999999, 36.50026000000003],
            [-100.95414999999996, 36.49991999999997],
            [-100.95386999999997, 36.652090000000015],
            [-101.22880999999995, 36.68729999999999],
            [-101.45991000000002, 36.89236999999998],
            [-101.36645000000003, 36.99621999999997],
            [-102.04222, 36.99289999999999],
            [-102.04204999999996, 37.07878999999998],
            [-102.45978, 37.16870999999999],
            [-102.40645, 37.31664999999999],
            [-102.47515999999996, 37.534780000000005],
            [-102.34825999999998, 37.64412000000003],
            [-102.04157999999998, 37.62002999999997],
            [-102.04210999999995, 37.73844000000003],
            [-101.72674, 37.737200000000016],
            [-101.58089, 37.957969999999975],
            [-101.65160999999999, 38.14688999999997],
            [-101.55154000000003, 38.26325999999999],
            [-101.04847999999998, 38.26476999999996],
            [-101.01736999999996, 38.43914000000001],
            [-101.12786999999996, 38.56276999999996],
            [-101.05802, 38.76211999999998],
            [-100.81881999999996, 38.699710000000024],
            [-100.16368999999997, 38.69747000000005],
            [-100.03312999999994, 39.16107000000001],
            [-99.81025000000002, 39.23370000000003],
            [-99.60641999999996, 39.20678999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "DEN" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-103.14742000000003, 40.43688999999996],
            [-103.10795, 40.436840000000004],
            [-103.09509, 40.01666999999997],
            [-102.80302000000002, 39.966400000000036],
            [-102.90066000000002, 39.78124999999996],
            [-103.20959999999995, 39.78562000000005],
            [-103.27433999999997, 39.566450000000046],
            [-103.43633999999996, 39.56591999999998],
            [-103.70687000000002, 39.60065999999997],
            [-103.83496999999998, 39.28554000000001],
            [-104.04829999999995, 39.24171999999996],
            [-103.97795999999995, 39.388510000000025],
            [-104.13602, 39.404739999999975],
            [-104.35678000000003, 39.30826000000005],
            [-104.86195999999998, 39.21564000000001],
            [-105.01454999999996, 39.287839999999974],
            [-105.00693, 39.129929999999995],
            [-105.39783000000001, 39.12957999999999],
            [-105.39767, 39.248849999999976],
            [-105.66569999999999, 39.20419999999999],
            [-105.69684999999994, 39.08864000000003],
            [-105.88065999999999, 39.05275],
            [-106.12343000000001, 39.14828000000003],
            [-106.19089999999994, 39.05599000000004],
            [-106.57827, 39.057880000000004],
            [-106.53194999999997, 39.20082000000002],
            [-106.67479999999999, 39.194089999999974],
            [-106.71469000000003, 39.36210000000004],
            [-106.55661000000002, 39.36209000000001],
            [-106.54321000000002, 39.48413999999997],
            [-106.76271999999999, 39.495210000000014],
            [-106.81761, 39.65681000000005],
            [-106.70665999999999, 39.669459999999994],
            [-107.03397999999996, 39.91893999999999],
            [-107.04888, 40.331209999999984],
            [-107.15162, 40.46951999999999],
            [-107.07105, 40.72975999999996],
            [-106.76668, 40.71930000000003],
            [-106.61245000000002, 40.37962000000003],
            [-106.22982999999996, 40.32324000000002],
            [-105.95943, 40.34827000000004],
            [-105.73488999999995, 40.563730000000035],
            [-105.46247999999994, 40.48823999999999],
            [-105.21255000000002, 40.59374],
            [-105.16020999999996, 40.47628999999996],
            [-104.88272000000002, 40.39912],
            [-104.83873000000003, 40.50250000000001],
            [-104.57183000000002, 40.48600000000002],
            [-104.33663000000001, 40.39200999999996],
            [-104.14796000000001, 40.52436999999997],
            [-103.61515000000003, 40.522819999999975],
            [-103.34029, 40.36878000000001],
            [-103.14742000000003, 40.43688999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "DFW" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-97.67249999999996, 33.55177999999998],
            [-97.55316000000005, 33.80324000000003],
            [-97.59562999999994, 33.91137000000003],
            [-97.30764999999997, 34.07109999999997],
            [-96.96801999999994, 34.07102000000001],
            [-96.93331999999998, 34.27307999999999],
            [-96.75410999999994, 34.233919999999955],
            [-96.76266999999999, 34.36149999999997],
            [-96.59682000000001, 34.43560999999997],
            [-96.53851, 34.31040999999996],
            [-96.40699999999998, 34.41840999999996],
            [-96.14538000000005, 34.41828999999998],
            [-96.00278999999995, 34.342209999999966],
            [-95.77890999999997, 34.45400999999996],
            [-95.77936, 34.15656],
            [-95.37854000000004, 34.15689000000003],
            [-95.34574999999992, 33.87419999999998],
            [-95.16186000000002, 33.93797000000002],
            [-95.25520000000003, 33.794650000000004],
            [-95.16088000000002, 33.704130000000006],
            [-95.20029999999997, 33.52289999999999],
            [-95.31046, 33.533580000000015],
            [-95.30787999999995, 33.166700000000034],
            [-95.40932999999998, 32.91702],
            [-95.22692999999995, 32.732679999999974],
            [-95.34218000000004, 32.60407],
            [-95.49049999999997, 32.61434999999996],
            [-95.59421, 32.47993000000004],
            [-95.47256000000002, 32.37149999999999],
            [-95.57667000000001, 32.22009000000003],
            [-95.68831, 32.22293],
            [-95.94805, 31.928939999999965],
            [-96.23418999999996, 32.25040999999997],
            [-96.45985999999999, 32.16257000000002],
            [-96.78403999999995, 32.22833000000004],
            [-96.71024999999997, 32.43511999999997],
            [-96.89858999999993, 32.49710999999999],
            [-96.90366999999998, 32.61905],
            [-97.07789999999997, 32.59050999999999],
            [-97.03712000000002, 32.75706000000004],
            [-97.25426999999993, 32.99754999999997],
            [-97.25740999999996, 33.150980000000004],
            [-97.39309999999998, 33.16895000000004],
            [-97.32797999999997, 33.428660000000036],
            [-97.63677999999996, 33.43363000000003],
            [-97.67249999999996, 33.55177999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "DIK" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-102.26095000000001, 47.61690999999998],
            [-101.83313999999996, 47.49461000000003],
            [-101.70964999999995, 47.537800000000004],
            [-101.74420999999997, 47.40697999999996],
            [-101.64276999999998, 47.14653000000001],
            [-101.70926000000001, 46.95526],
            [-101.71851999999996, 46.63120999999996],
            [-101.64367999999996, 46.34679999999997],
            [-101.73923000000003, 46.26716000000001],
            [-101.71253999999998, 46.068130000000004],
            [-101.99652, 46.05623999999997],
            [-101.9988, 45.94450999999999],
            [-101.79098000000003, 45.909180000000035],
            [-101.48057999999999, 45.47268999999998],
            [-101.99999999999999, 45.47235],
            [-102.00042000000002, 45.187780000000004],
            [-102.60182999999999, 45.21496000000002],
            [-102.61024999999998, 45.44303000000002],
            [-102.71444999999999, 45.523800000000044],
            [-102.70316999999997, 45.70920999999996],
            [-102.94244000000002, 45.878119999999974],
            [-103.12142999999998, 45.72718],
            [-103.26976999999994, 45.756810000000044],
            [-103.28931000000003, 45.59853],
            [-103.05127999999998, 45.645600000000016],
            [-102.95084999999999, 45.56520999999999],
            [-102.95758999999997, 45.21426000000001],
            [-103.84009999999998, 45.21297999999997],
            [-104.04031999999995, 45.36898000000002],
            [-104.04158000000002, 45.54968999999999],
            [-104.04427000000001, 45.88193],
            [-104.13530999999998, 45.968980000000045],
            [-104.39086999999996, 45.970229999999994],
            [-104.51621000000002, 46.05467],
            [-104.35811000000002, 46.45055999999998],
            [-104.60704, 46.68480999999999],
            [-104.60364999999999, 46.86089999999998],
            [-104.41201999999996, 46.90409999999998],
            [-104.30575, 47.042289999999994],
            [-104.42035999999997, 47.35465999999997],
            [-103.61977000000002, 47.37523000000001],
            [-103.61151999999997, 47.515429999999974],
            [-103.42286, 47.59707000000004],
            [-103.10966, 47.53256999999999],
            [-103.05338999999995, 47.67431000000001],
            [-102.92498, 47.67421],
            [-102.56421000000002, 47.516200000000005],
            [-102.26095000000001, 47.61690999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "DLH" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-88.49501999999998, 48.148239999999994],
              [-88.66113999999999, 48.01551000000001],
              [-89.11912000000001, 47.827770000000044],
              [-89.17943000000002, 47.935109999999966],
              [-88.49501999999998, 48.148239999999994],
            ],
          ],
          [
            [
              [-88.45122, 46.93893000000004],
              [-88.74185000000003, 46.97202999999996],
              [-88.86451, 46.67934999999996],
              [-88.99066000000002, 46.59911],
              [-89.15907000000004, 46.710610000000045],
              [-89.44505999999993, 46.675909999999995],
              [-89.52466999999999, 46.50603000000002],
              [-89.36528999999996, 46.408270000000044],
              [-89.57739000000004, 46.23224999999999],
              [-89.92913000000001, 46.29986999999999],
              [-89.96788999999998, 46.13377999999999],
              [-90.05088999999995, 46.06602000000004],
              [-90.30314999999993, 46.15432999999997],
              [-90.58173000000002, 46.102479999999964],
              [-90.83346999999995, 45.98050000000002],
              [-91.49068999999994, 45.87007999999999],
              [-91.68309999999997, 45.79781],
              [-92.06432000000001, 45.815200000000004],
              [-92.30404999999993, 45.72609999999999],
              [-92.50377999999995, 45.73568000000003],
              [-92.55783999999994, 45.95099000000004],
              [-92.61184000000003, 46.109980000000036],
              [-92.86609999999993, 46.06738000000003],
              [-93.19582, 46.11213999999996],
              [-93.26266999999996, 46.24924000000003],
              [-93.05392999999998, 46.278519999999986],
              [-93.31669999999994, 46.35382999999997],
              [-93.36648000000002, 46.45074999999998],
              [-93.44478999999998, 46.64676999999999],
              [-93.77786999999995, 46.68995000000002],
              [-93.77533000000003, 47.030279999999976],
              [-93.66388000000003, 46.85997000000003],
              [-93.44658000000001, 46.87090999999998],
              [-93.46469999999994, 47.01661000000001],
              [-93.22294999999994, 47.23154999999996],
              [-93.31413999999998, 47.327690000000004],
              [-93.24262999999999, 47.61345999999999],
              [-92.92912000000001, 47.70934000000002],
              [-92.60313999999997, 47.66871999999997],
              [-92.41987999999995, 47.94438999999996],
              [-92.21574000000001, 47.994089999999986],
              [-91.98882000000003, 48.25933999999998],
              [-91.71531999999999, 48.19930000000001],
              [-91.56742999999994, 48.04415999999998],
              [-91.26711999999995, 48.079069999999994],
              [-90.88502999999994, 48.24551000000001],
              [-90.75133, 48.09070000000001],
              [-90.14127000000002, 48.11246000000002],
              [-89.89820999999998, 47.98764000000001],
              [-89.62363000000002, 47.99462999999999],
              [-89.79396000000003, 47.89115999999999],
              [-90.52681000000001, 47.706330000000015],
              [-91.12847, 47.399310000000035],
              [-91.46563000000003, 47.13123000000001],
              [-92.08830000000003, 46.79381000000004],
              [-92.00401, 46.68171],
              [-91.78954000000002, 46.68884000000001],
              [-91.10480999999999, 46.85778999999996],
              [-90.85836000000003, 46.96262000000004],
              [-90.75144999999998, 46.886920000000025],
              [-90.94910000000004, 46.58594000000002],
              [-90.72495999999995, 46.66234000000004],
              [-90.43459999999999, 46.562160000000034],
              [-90.03428999999994, 46.67208],
              [-89.78823999999997, 46.81889999999997],
              [-89.41662999999997, 46.843500000000034],
              [-88.21879999999996, 47.44913000000003],
              [-87.93856999999997, 47.48013000000002],
              [-87.71179999999998, 47.401750000000035],
              [-88.22911999999994, 47.19886999999998],
              [-88.45122, 46.93893000000004],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "DNL" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-81.97510999999997, 34.01024000000001],
            [-81.85493000000002, 33.87868000000002],
            [-81.63040000000001, 33.83136000000002],
            [-81.55535000000003, 33.60766000000001],
            [-81.29677999999996, 33.48015000000001],
            [-81.21909999999997, 33.282129999999995],
            [-81.07169999999996, 33.19133],
            [-81.40629000000001, 32.883460000000035],
            [-81.38923999999997, 32.59546000000002],
            [-81.42983000000001, 32.496369999999956],
            [-81.68954000000002, 32.54616999999999],
            [-81.81088999999997, 32.64753000000002],
            [-82.14840000000001, 32.520500000000034],
            [-82.23999999999995, 32.36854000000004],
            [-82.35011, 32.41357000000002],
            [-82.59272000000001, 32.57228999999997],
            [-82.54874999999998, 32.79278000000002],
            [-82.64882999999998, 32.826489999999964],
            [-82.72699999999998, 33.07482000000003],
            [-82.83078999999998, 33.028749999999974],
            [-83.27402999999995, 33.19976000000001],
            [-83.01291999999995, 33.46917999999998],
            [-82.77899999999997, 33.37646999999996],
            [-82.65898000000001, 33.447470000000024],
            [-82.61724000000001, 33.632660000000044],
            [-82.50613999999996, 33.65977000000004],
            [-82.59567000000001, 33.82874999999998],
            [-82.4513, 34.00297999999999],
            [-82.23784, 34.091350000000006],
            [-81.97510999999997, 34.01024000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "DOV" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-76.03076999999996, 38.330659999999995],
              [-76.03060000000002, 38.32728999999996],
              [-76.03360999999992, 38.33355999999996],
              [-76.03076999999996, 38.330659999999995],
            ],
          ],
          [
            [
              [-76.03076999999996, 38.330659999999995],
              [-76.03373999999994, 38.33498000000003],
              [-76.01970999999995, 38.353809999999996],
              [-76.03076999999996, 38.330659999999995],
            ],
          ],
          [
            [
              [-75.47932000000003, 37.903119999999994],
              [-75.63727000000003, 37.94417],
              [-75.79236999999995, 37.964559999999985],
              [-76.01774999999995, 38.30941],
              [-75.97685000000001, 38.36743],
              [-76.00824999999998, 38.571510000000046],
              [-75.92574999999997, 38.83716000000001],
              [-76.06721999999996, 38.88579000000004],
              [-76.07588999999993, 38.89200999999999],
              [-75.88032999999996, 39.03587000000001],
              [-76.04538, 39.13931000000001],
              [-75.98673000000002, 39.24631999999998],
              [-75.98918999999998, 39.26300000000004],
              [-75.51105000000001, 39.36552000000003],
              [-75.40524999999997, 39.25872999999997],
              [-75.40090999999995, 39.06692000000004],
              [-75.18475999999998, 38.80308000000001],
              [-75.04924, 38.45121000000002],
              [-75.27558000000005, 38.20570000000005],
              [-75.47932000000003, 37.903119999999994],
            ],
          ],
          [
            [
              [-74.85826, 39.46684999999998],
              [-74.72299000000001, 39.36624000000001],
              [-74.71698000000004, 39.347110000000015],
              [-74.73072000000002, 39.15731000000004],
              [-74.89048999999997, 38.95235000000001],
              [-74.88669999999999, 39.156360000000035],
              [-75.11377000000005, 39.20956000000001],
              [-75.41652000000005, 39.38706999999998],
              [-75.32340999999997, 39.55337999999999],
              [-74.92091000000002, 39.42420000000001],
              [-74.85826, 39.46684999999998],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "DRT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-101.76874000000001, 30.653190000000034],
            [-101.64541999999996, 30.561110000000006],
            [-101.75794999999995, 30.28937000000002],
            [-99.75409999999995, 30.29063],
            [-99.75555999999996, 30.21333000000003],
            [-99.69117999999997, 29.90852000000003],
            [-99.60251000000001, 29.90763999999996],
            [-99.61030000000001, 29.564870000000003],
            [-99.74849000000002, 29.453900000000026],
            [-99.67323, 29.219440000000045],
            [-99.53603000000001, 29.222670000000043],
            [-99.50230999999995, 29.090859999999978],
            [-99.81797, 29.08894000000001],
            [-99.62832, 28.642970000000016],
            [-99.88661999999997, 28.39926000000003],
            [-99.82786999999996, 28.200330000000033],
            [-100.21229000000001, 28.19688000000004],
            [-100.39852999999995, 28.585249999999977],
            [-100.64088999999997, 28.91485000000004],
            [-100.67477999999997, 29.100730000000034],
            [-101.06484999999998, 29.46442999999998],
            [-101.25847, 29.523480000000017],
            [-101.45851999999994, 29.78975000000003],
            [-101.64529000000003, 29.754180000000023],
            [-102.07286000000003, 29.786439999999985],
            [-102.31541999999999, 29.880020000000044],
            [-102.38740999999999, 29.761220000000048],
            [-102.67493, 29.744149999999962],
            [-102.91162999999996, 29.21909999999998],
            [-103.15442999999996, 28.97156],
            [-103.38730000000001, 29.021849999999986],
            [-103.79235999999995, 29.26254999999997],
            [-103.80088999999998, 30.412480000000023],
            [-103.43985999999997, 30.665800000000047],
            [-102.56688999999997, 30.05269999999997],
            [-102.56682999999998, 30.283209999999976],
            [-102.34299999999998, 30.28405999999996],
            [-102.34286999999996, 30.598710000000022],
            [-102.13782000000003, 30.656109999999963],
            [-101.76874000000001, 30.653190000000034],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "DSM" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-92.61038000000002, 41.84798],
            [-92.65649999999997, 41.559830000000005],
            [-92.47280000000003, 41.42929999999997],
            [-92.49985999999998, 41.16157000000004],
            [-92.75762999999995, 41.22010999999998],
            [-92.80237000000002, 41.125140000000016],
            [-92.63973999999993, 41.048630000000045],
            [-92.57241000000005, 40.84221000000001],
            [-92.63778999999997, 40.59080000000001],
            [-92.81092000000001, 40.47206],
            [-92.72972999999996, 40.38320000000003],
            [-92.85559999999998, 40.342650000000006],
            [-92.85641999999999, 40.062610000000014],
            [-92.92387999999997, 40.061969999999995],
            [-93.26389, 40.08720000000005],
            [-93.36171999999999, 39.99703000000005],
            [-93.36699999999996, 40.43301000000001],
            [-93.48326999999998, 40.44237999999999],
            [-93.54593, 40.265090000000015],
            [-93.75119000000001, 40.43969],
            [-93.76351, 40.252529999999965],
            [-93.89799, 40.26445],
            [-94.15781999999999, 40.42712000000001],
            [-94.25412999999998, 40.57177999999996],
            [-94.59516000000002, 40.57104999999996],
            [-94.47155999999998, 40.67538999999999],
            [-94.69414000000003, 40.821220000000025],
            [-94.64209, 41.08631000000002],
            [-94.70035999999999, 41.316709999999986],
            [-94.89930999999996, 41.50458999999999],
            [-94.75086999999996, 41.50429999999997],
            [-94.74399999999997, 41.74682],
            [-95.03362000000001, 42.049949999999995],
            [-94.97429, 42.122750000000046],
            [-94.79232999999996, 42.235129999999984],
            [-94.80526, 42.413499999999964],
            [-94.65845999999999, 42.47354999999996],
            [-94.63833999999997, 42.67435999999999],
            [-94.29835, 42.97345999999997],
            [-94.2073, 42.980190000000015],
            [-94.19809000000004, 42.774830000000016],
            [-93.90733, 42.52267999999998],
            [-93.70879000000002, 42.557540000000046],
            [-93.69894000000002, 42.441209999999955],
            [-93.52106999999992, 42.39822000000001],
            [-93.48272999999998, 42.209270000000025],
            [-93.09899999999999, 42.14928000000002],
            [-92.88314000000003, 41.790980000000026],
            [-92.61038000000002, 41.84798],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "DTW" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-83.39462, 41.85493000000004],
            [-83.60197, 41.95641999999999],
            [-83.6003, 42.13557000000003],
            [-83.96153999999999, 42.21697000000003],
            [-83.81450999999996, 42.37146000000002],
            [-83.73683, 42.35088000000004],
            [-83.31978000000001, 42.50743000000003],
            [-82.86342000000002, 42.57106999999997],
            [-82.88224000000002, 42.40531],
            [-83.14772000000005, 42.23569000000004],
            [-83.20772, 42.000300000000024],
            [-83.39462, 41.85493000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "EAU" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-89.96788999999998, 46.13377999999999],
            [-90.22745000000003, 45.51078999999997],
            [-90.58569999999995, 45.37746],
            [-90.19125000000003, 45.381509999999984],
            [-90.29134000000005, 45.28711000000003],
            [-90.07277999999997, 45.12029000000001],
            [-90.43367000000003, 45.045700000000004],
            [-90.44681000000003, 44.86942999999996],
            [-90.34879999999998, 44.75223000000001],
            [-90.50163, 44.66144999999999],
            [-90.46977000000001, 44.524130000000014],
            [-90.76311999999993, 43.83534000000004],
            [-91.01880999999995, 43.772470000000034],
            [-91.19236000000001, 43.93244999999996],
            [-91.75705999999997, 44.26877999999998],
            [-91.83727000000002, 44.23010999999998],
            [-92.08365000000003, 44.40745000000001],
            [-92.04729000000003, 44.50713000000003],
            [-92.22569000000001, 44.55783000000002],
            [-92.29411999999999, 44.70777000000003],
            [-92.35931, 44.962899999999976],
            [-92.36027999999996, 45.28474000000004],
            [-92.23481999999996, 45.36592999999999],
            [-92.28396000000001, 45.58157999999998],
            [-92.52945, 45.61741000000001],
            [-92.50377999999995, 45.73568000000003],
            [-92.30404999999993, 45.72609999999999],
            [-92.06432000000001, 45.815200000000004],
            [-91.68309999999997, 45.79781],
            [-91.49068999999994, 45.87007999999999],
            [-90.83346999999995, 45.98050000000002],
            [-90.58173000000002, 46.102479999999964],
            [-90.30314999999993, 46.15432999999997],
            [-90.05088999999995, 46.06602000000004],
            [-89.96788999999998, 46.13377999999999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "EBQ" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-91.54011, 42.39135000000002],
            [-91.54959000000002, 42.54174999999999],
            [-91.37375000000003, 42.74782999999997],
            [-91.54250999999996, 42.892099999999985],
            [-91.38769999999997, 43.12985999999998],
            [-91.34486000000001, 43.27499000000001],
            [-91.44808, 43.41119000000004],
            [-91.03058000000001, 43.43329000000002],
            [-91.04342999999997, 43.55944000000002],
            [-90.78491999999997, 43.60751],
            [-90.73765999999995, 43.462099999999985],
            [-90.34973999999994, 43.24488000000004],
            [-90.33805999999996, 42.99397999999996],
            [-90.01839999999999, 42.92692000000002],
            [-89.96185999999997, 42.647540000000006],
            [-89.83792999999997, 42.60315999999999],
            [-89.96445000000003, 42.45184000000001],
            [-89.90069999999994, 42.06457999999999],
            [-89.96286, 41.99669000000003],
            [-90.19850000000002, 41.98893999999997],
            [-90.38533000000001, 41.86551000000004],
            [-90.55211, 41.91985999999996],
            [-90.93703999999997, 41.90974],
            [-91.24709000000001, 42.12696999999998],
            [-91.35633000000001, 42.30404999999999],
            [-91.54011, 42.39135000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ELK" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-79.21765000000005, 39.721909999999994],
            [-79.03365, 39.72249000000002],
            [-78.95534000000004, 39.57176000000001],
            [-78.58038000000005, 39.492909999999966],
            [-78.62691999999998, 39.218440000000044],
            [-78.82863999999998, 38.74745999999999],
            [-78.62368999999998, 38.71327000000004],
            [-78.71827000000002, 38.28225999999998],
            [-78.89620999999994, 38.22833],
            [-79.26417999999995, 38.22874],
            [-79.48242000000002, 38.08607999999997],
            [-79.60411999999997, 38.19204000000002],
            [-79.78100999999998, 38.037860000000016],
            [-80.05679, 37.95188999999998],
            [-79.95962999999995, 38.06418000000002],
            [-80.26449999999994, 38.04664999999997],
            [-80.35999000000004, 38.225759999999994],
            [-80.66894000000002, 38.48516000000001],
            [-80.78493999999998, 38.830540000000006],
            [-80.93951999999993, 38.771049999999974],
            [-81.03786000000002, 39.00721999999996],
            [-80.93594999999996, 39.06879999999998],
            [-81.01451, 39.40578999999999],
            [-81.12141000000003, 39.457720000000045],
            [-80.92552000000003, 39.46382000000001],
            [-80.77832999999998, 39.62020999999999],
            [-80.23865, 39.61095999999999],
            [-80.15732000000003, 39.721169999999965],
            [-79.69620999999995, 39.720789999999965],
            [-79.43478999999994, 39.80943999999997],
            [-79.21765000000005, 39.721909999999994],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ELP" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-104.02425999999994, 32.000199999999964],
            [-104.10220999999996, 31.10572999999998],
            [-103.97228000000001, 31.01960000000003],
            [-104.15218999999996, 30.762130000000003],
            [-104.20260000000002, 30.548760000000012],
            [-104.30328999999995, 30.494000000000014],
            [-103.80088999999998, 30.412480000000023],
            [-103.79235999999995, 29.26254999999997],
            [-104.03797999999996, 29.31999999999996],
            [-104.21292999999994, 29.48430000000001],
            [-104.50861000000002, 29.632799999999985],
            [-104.67998, 29.92090000000002],
            [-104.70647999999997, 30.235150000000026],
            [-104.85929999999998, 30.390129999999964],
            [-104.92279000000003, 30.60377],
            [-105.11817000000002, 30.74978000000001],
            [-105.39578999999998, 30.849309999999967],
            [-105.60348999999997, 31.08275000000002],
            [-105.77273000000001, 31.16653000000004],
            [-105.95355000000004, 31.364450000000048],
            [-106.20467000000001, 31.464799999999997],
            [-106.38051, 31.73162999999998],
            [-106.52852000000003, 31.783819999999967],
            [-107.29675000000002, 31.78391000000004],
            [-107.29815999999998, 32.45013999999999],
            [-106.98187000000003, 32.691910000000036],
            [-107.03732999999994, 32.77912],
            [-106.34051000000001, 33.05271000000002],
            [-106.12081999999997, 32.95587999999999],
            [-105.98303000000001, 33.027500000000025],
            [-105.86556000000002, 32.93125000000003],
            [-105.86106000000001, 32.61523000000003],
            [-105.74177999999999, 32.54659000000001],
            [-105.83009000000003, 32.25585000000004],
            [-105.81137000000001, 32.00162999999998],
            [-104.02425999999994, 32.000199999999964],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ELY" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-114.04188999999997, 40.99979999999998],
            [-114.0477, 39.54263000000004],
            [-113.31564999999996, 39.55245000000004],
            [-113.38624999999998, 39.12219999999999],
            [-113.28491, 38.994980000000005],
            [-113.08297, 39.02969],
            [-112.89633, 38.86580999999997],
            [-112.87933999999997, 38.71733999999999],
            [-112.82432999999997, 38.574619999999975],
            [-114.04999999999998, 38.572939999999974],
            [-114.04980000000003, 38.67738000000002],
            [-115.00089, 38.677369999999996],
            [-115.00083000000001, 38.05079999999998],
            [-115.07055000000003, 38.050810000000006],
            [-115.89379000000001, 38.05062000000001],
            [-115.89456999999997, 37.661030000000025],
            [-116.20693000000001, 37.47582999999998],
            [-116.83511000000001, 37.522210000000015],
            [-116.97071999999999, 37.697640000000014],
            [-117.16568999999998, 37.68710000000003],
            [-117.16571000000003, 38.00170000000004],
            [-117.64218999999997, 38.42958999999996],
            [-117.46615999999997, 38.58611999999998],
            [-117.32562999999998, 38.814539999999994],
            [-117.34057999999997, 38.95509999999999],
            [-117.17939000000003, 39.16313000000002],
            [-116.60094999999998, 39.16146999999998],
            [-116.59023999999997, 39.99326999999998],
            [-116.27810000000002, 39.95081000000002],
            [-116.12180000000002, 40.148869999999974],
            [-116.01238999999998, 40.168180000000035],
            [-116.13072, 40.571290000000005],
            [-116.10599, 40.68234999999997],
            [-115.80224999999999, 40.748310000000025],
            [-115.65129999999998, 40.90056999999997],
            [-115.45337000000004, 40.88785000000001],
            [-115.23030999999996, 41.07978],
            [-115.24772000000003, 41.40823000000004],
            [-115.47506000000003, 41.52241999999998],
            [-115.68957000000002, 41.52487000000002],
            [-115.71660999999999, 41.61131999999998],
            [-115.55335000000001, 41.79285000000003],
            [-115.41536999999997, 41.78120999999999],
            [-115.44417, 41.65220000000004],
            [-115.19587000000001, 41.645190000000014],
            [-115.05224000000003, 41.56023999999999],
            [-115.12902999999999, 41.43784999999997],
            [-114.84659999999995, 41.55082999999999],
            [-114.62229, 41.44794000000002],
            [-114.33823999999996, 41.63231999999998],
            [-114.20452999999999, 41.87349000000004],
            [-114.27347999999999, 41.99422999999997],
            [-114.04149000000001, 41.993940000000045],
            [-114.04188999999997, 40.99979999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ERI" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-79.15056000000001, 42.248689999999996],
            [-79.32058999999995, 42.199320000000014],
            [-79.21959999999999, 41.98833000000003],
            [-79.25408999999999, 41.83818999999999],
            [-79.20887999999997, 41.308849999999964],
            [-79.2228, 41.305279999999996],
            [-79.26413, 41.30039999999998],
            [-79.59952000000004, 41.321429999999985],
            [-80.02869999999993, 41.59148000000003],
            [-80.15917999999999, 41.53144999999999],
            [-80.44224000000003, 41.754620000000024],
            [-80.59230000000002, 41.70563000000004],
            [-80.67345999999998, 41.83405000000002],
            [-80.90382000000002, 41.86785999999997],
            [-80.32290999999998, 42.03869999999998],
            [-79.43829, 42.42252999999997],
            [-79.26500999999999, 42.40602000000004],
            [-79.15056000000001, 42.248689999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "EUG" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-121.10826999999999, 44.24894999999997],
            [-120.98733000000003, 44.13384000000002],
            [-120.98653, 43.960829999999966],
            [-120.79976999999994, 43.92597],
            [-120.78162999999996, 43.61546],
            [-121.3328, 43.616629999999994],
            [-121.34829999999995, 43.33888000000003],
            [-121.50741000000002, 43.393360000000044],
            [-121.73308999999998, 43.27281999999996],
            [-121.95392000000002, 43.30907000000001],
            [-122.09204999999996, 43.085649999999994],
            [-122.40059000000002, 42.995319999999985],
            [-122.51337000000001, 43.169949999999965],
            [-122.77451000000003, 43.074819999999995],
            [-123.06753999999995, 43.18879000000004],
            [-123.27135999999997, 43.09343999999999],
            [-123.70214000000001, 43.10599000000001],
            [-123.76447, 43.33746000000004],
            [-123.99520000000001, 43.29418],
            [-124.09703000000002, 43.10929000000003],
            [-124.26094999999998, 43.12645000000001],
            [-124.29948000000003, 42.95463000000001],
            [-124.48038000000001, 42.95432000000003],
            [-124.38483999999995, 43.331349999999965],
            [-124.24686, 43.52377],
            [-124.13852999999996, 44.016470000000034],
            [-124.07023000000001, 44.60670000000002],
            [-124.02051999999996, 44.60737999999997],
            [-123.98912000000001, 44.54134999999999],
            [-123.59725000000003, 44.43295999999996],
            [-123.53263, 44.711649999999985],
            [-123.32674999999996, 44.68231999999998],
            [-123.37758999999998, 44.56696000000004],
            [-123.19691, 44.58561999999996],
            [-122.87297999999994, 44.39432999999999],
            [-122.60750000000002, 44.463610000000024],
            [-122.56906999999998, 44.56414999999998],
            [-122.20672, 44.555370000000046],
            [-122.08089999999996, 44.675400000000025],
            [-121.79451, 44.68393999999999],
            [-121.80797, 44.515539999999994],
            [-121.58991, 44.39267000000004],
            [-121.61678999999998, 44.51555000000002],
            [-121.37880999999999, 44.50811000000003],
            [-121.32542000000001, 44.234530000000035],
            [-121.10826999999999, 44.24894999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "EVV" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-87.52460999999994, 39.156700000000015],
            [-87.24088, 39.12861000000002],
            [-87.24101000000002, 38.90788],
            [-86.95284999999998, 38.973200000000034],
            [-86.89330999999999, 38.83172000000003],
            [-86.68327999999994, 38.729800000000026],
            [-86.68008999999998, 38.293130000000005],
            [-86.59061999999997, 37.91941000000003],
            [-86.65313999999998, 37.73157999999998],
            [-86.88939999999994, 37.61283999999998],
            [-87.40254000000002, 37.13202999999997],
            [-87.59999000000005, 37.08920999999998],
            [-87.58686, 36.958],
            [-87.91490999999996, 36.94923],
            [-88.07243000000003, 37.176870000000044],
            [-88.18171999999998, 37.160450000000004],
            [-88.18499, 37.33618000000004],
            [-88.39875000000004, 37.447769999999984],
            [-88.40746999999996, 37.75263999999997],
            [-88.62321000000003, 37.993230000000004],
            [-88.79713999999998, 38.05322000000001],
            [-88.84574000000003, 38.19995],
            [-89.03142, 38.29412999999997],
            [-88.82268000000002, 38.67145],
            [-88.70082, 38.77472999999999],
            [-88.4795, 38.91309000000004],
            [-88.23715999999993, 39.04921999999996],
            [-87.52460999999994, 39.156700000000015],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "EWR" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-73.65197, 40.808019999999956],
              [-73.77579999999998, 40.627570000000006],
              [-74.04189999999997, 40.62419000000003],
              [-73.93554999999998, 40.77755999999998],
              [-73.65197, 40.808019999999956],
            ],
          ],
          [
            [
              [-73.61603999999997, 40.89887],
              [-73.59341, 40.857140000000044],
              [-73.64391999999998, 40.82365],
              [-73.61603999999997, 40.89887],
            ],
          ],
          [
            [
              [-73.93861000000001, 41.27007999999996],
              [-73.85022999999998, 41.25699999999996],
              [-73.66364999999999, 40.98531000000003],
              [-73.79073000000002, 40.80446000000001],
              [-73.92775000000003, 40.80260000000004],
              [-73.8649, 41.139889999999994],
              [-73.93861000000001, 41.27007999999996],
            ],
          ],
          [
            [
              [-74.37888000000001, 41.87776999999996],
              [-74.28405000000001, 41.69621000000001],
              [-73.98032, 41.331320000000005],
              [-73.90662000000003, 41.142180000000025],
              [-73.93244999999999, 40.903720000000014],
              [-74.07054, 40.66062999999999],
              [-74.26635999999996, 40.49978999999996],
              [-74.00274000000002, 40.41139999999998],
              [-74.05478999999997, 40.35894000000003],
              [-74.26214999999996, 40.05517000000002],
              [-74.4076, 40.06113999999998],
              [-74.48600000000005, 40.20039999999997],
              [-74.63491000000002, 40.21083],
              [-74.82499999999999, 40.37036],
              [-74.73673, 40.846639999999994],
              [-74.96782999999996, 41.09585999999997],
              [-74.84642999999997, 41.255099999999956],
              [-74.86131999999998, 41.498870000000025],
              [-74.8116, 41.60744999999996],
              [-74.63501999999997, 41.57948999999998],
              [-74.50255999999993, 41.86053999999996],
              [-74.37888000000001, 41.87776999999996],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "EYW" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-81.24978999999996, 25.80423999999998],
            [-80.87323000000004, 25.805520000000016],
            [-80.85828999999995, 25.17655999999996],
            [-81.08349999999993, 25.11648999999999],
            [-81.13122999999993, 25.330429999999986],
            [-81.02133999999998, 25.21855000000003],
            [-81.03507000000002, 25.51345000000004],
            [-81.22638999999998, 25.557720000000018],
            [-81.24978999999996, 25.80423999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "FAR" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-95.88573999999997, 47.553749999999965],
            [-95.67317999999995, 47.34847000000001],
            [-95.60020999999995, 46.99089],
            [-95.33016, 46.82583999999998],
            [-95.35471000000001, 46.64409999999996],
            [-95.52195999999998, 46.542599999999986],
            [-95.42528000000001, 46.397400000000026],
            [-95.58382, 46.37614000000001],
            [-95.52128000000002, 46.11261999999998],
            [-95.73832999999996, 45.904889999999995],
            [-95.91366999999997, 45.846069999999976],
            [-96.06141999999997, 45.63757999999999],
            [-96.23361000000003, 45.629429999999964],
            [-96.08757999999997, 45.411810000000045],
            [-96.20003, 45.412310000000026],
            [-96.26135000000002, 45.53843999999997],
            [-96.43136000000001, 45.485400000000006],
            [-96.61687000000003, 45.55889999999997],
            [-96.61753000000002, 45.70205000000004],
            [-96.79962999999998, 45.783389999999976],
            [-96.97122999999996, 45.69612000000002],
            [-97.09265999999997, 45.93533],
            [-97.30149000000003, 45.93509999999998],
            [-97.29420999999994, 46.17323999999998],
            [-97.48193999999998, 46.10947999999996],
            [-97.61099999999996, 46.26858],
            [-97.84637000000002, 46.31135999999997],
            [-97.88815999999997, 46.470979999999955],
            [-97.74484999999999, 46.709740000000004],
            [-97.41661999999994, 46.723689999999955],
            [-97.53554999999994, 46.846600000000024],
            [-97.73431, 46.83276999999996],
            [-97.72697000000002, 47.06587000000004],
            [-97.88270999999996, 47.18222],
            [-97.56816, 47.238959999999956],
            [-97.57304000000002, 47.41843000000001],
            [-97.31860999999998, 47.360299999999974],
            [-96.98424999999997, 47.49746999999997],
            [-96.81505999999999, 47.41197000000001],
            [-96.67936000000003, 47.49870999999998],
            [-96.44090000000003, 47.49935],
            [-96.33002000000002, 47.71893],
            [-96.17695000000003, 47.56561000000001],
            [-95.88573999999997, 47.553749999999965],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "FAT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-117.16568999999998, 37.68710000000003],
            [-117.16570000000002, 36.97078999999998],
            [-117.44106000000002, 37.17586999999999],
            [-117.49189999999996, 36.779600000000016],
            [-117.6289, 36.494949999999974],
            [-117.75464000000001, 36.362559999999974],
            [-117.71062999999997, 36.15203999999998],
            [-117.52921999999998, 36.01511999999997],
            [-117.56616999999996, 35.796359999999964],
            [-117.63296999999996, 35.94819999999998],
            [-117.75091000000003, 35.90898000000004],
            [-118.05930999999998, 36.17014000000002],
            [-118.16306999999999, 36.38962000000001],
            [-118.57219999999997, 36.300199999999975],
            [-118.79801000000002, 36.33744000000004],
            [-118.93628, 36.08637999999996],
            [-119.16569000000003, 36.112949999999955],
            [-119.34001000000002, 36.02202999999999],
            [-119.53775999999999, 35.78988],
            [-120.41600000000003, 35.78996999999998],
            [-120.40836, 35.56875000000001],
            [-120.65334, 35.59482999999996],
            [-121.01839, 35.476829999999985],
            [-121.34784, 35.79518000000003],
            [-121.18372999999995, 35.79388999999996],
            [-121.23241999999998, 35.90869000000002],
            [-121.55841999999998, 36.07927000000001],
            [-121.53287, 36.34626],
            [-121.27018, 36.66371000000001],
            [-121.04677999999994, 36.73828999999999],
            [-121.24589, 36.983040000000045],
            [-121.23662999999998, 37.15666999999998],
            [-121.45905999999997, 37.28230000000003],
            [-121.38517999999999, 37.356179999999995],
            [-121.05825999999999, 37.27067000000001],
            [-120.99436999999996, 37.50777999999996],
            [-120.49407999999997, 37.64716999999997],
            [-120.29638999999997, 37.87703000000002],
            [-120.09544, 37.90063999999997],
            [-120.02367, 38.07334999999998],
            [-119.61834000000002, 38.24861000000003],
            [-119.45900999999996, 38.095860000000044],
            [-119.20611999999998, 38.17354000000001],
            [-119.04448000000002, 38.13712000000002],
            [-118.88263999999994, 38.22071999999998],
            [-118.42824999999996, 37.89617999999999],
            [-118.35154999999999, 37.893769999999975],
            [-117.69152999999996, 38.473470000000006],
            [-117.64218999999997, 38.42958999999996],
            [-117.16571000000003, 38.00170000000004],
            [-117.16568999999998, 37.68710000000003],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "FCA" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-112.19370000000004, 48.99868000000004],
            [-112.18473000000002, 48.477230000000034],
            [-112.57722999999999, 48.48325999999998],
            [-112.57585000000003, 48.309419999999996],
            [-113.34921000000001, 48.310120000000005],
            [-113.23320000000002, 48.16846999999997],
            [-112.98451000000001, 48.11997999999997],
            [-112.87867999999997, 47.97703000000001],
            [-113.05863999999998, 47.870390000000015],
            [-113.14429000000001, 47.59631000000004],
            [-114.34092999999996, 47.58364000000003],
            [-114.41916999999998, 47.416670000000046],
            [-114.93822000000002, 47.83169000000002],
            [-115.07004999999997, 47.535120000000035],
            [-115.62947999999999, 47.47959000000001],
            [-115.72840000000001, 47.701979999999985],
            [-115.99375999999997, 47.92635],
            [-115.89996, 48.111010000000036],
            [-116.04902000000003, 48.20807],
            [-116.04911999999996, 48.626929999999994],
            [-116.19404999999995, 48.746229999999976],
            [-116.04945, 49.00085],
            [-112.19370000000004, 48.99868000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "FLG" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-109.55324000000002, 34.78712000000001],
            [-109.49440999999997, 34.46154000000003],
            [-109.67350999999995, 34.29318999999999],
            [-109.84878999999998, 34.26749000000004],
            [-109.85919999999994, 34.09360000000001],
            [-109.75414000000002, 34.021640000000005],
            [-109.73583000000002, 33.83254000000004],
            [-109.89162, 33.777629999999974],
            [-109.89170999999999, 33.56779999999996],
            [-110.00061999999997, 33.576940000000015],
            [-110.00064000000002, 34.00005000000003],
            [-110.25620000000002, 34.00004],
            [-110.32366000000002, 34.16471999999996],
            [-110.62657000000002, 34.286300000000026],
            [-110.86066000000002, 34.26967000000002],
            [-111.25069, 34.453370000000035],
            [-111.38506999999998, 34.43240000000002],
            [-111.69487999999998, 34.18817],
            [-111.65955000000002, 34.38639999999999],
            [-111.55421999999996, 34.43943999999996],
            [-111.55215999999996, 34.71906000000001],
            [-111.81760999999999, 34.60115000000003],
            [-111.86925000000002, 34.78748999999998],
            [-112.08788000000003, 34.80802],
            [-112.03866000000002, 34.97409999999998],
            [-112.33457999999996, 34.97307000000002],
            [-112.3358, 35.14825000000003],
            [-112.44068999999998, 35.26018999999997],
            [-112.94473000000002, 35.35253999999996],
            [-113.17441999999994, 35.50633000000002],
            [-113.33417999999996, 35.528039999999976],
            [-113.32609999999995, 35.84259999999996],
            [-113.31976000000003, 36.09714000000003],
            [-112.67727999999998, 36.34253999999996],
            [-112.58883000000002, 36.03408999999996],
            [-112.39994000000002, 35.947860000000006],
            [-112.44194999999996, 36.269129999999976],
            [-112.62491999999996, 36.408049999999996],
            [-112.65996, 36.54355000000002],
            [-112.59299999999998, 36.840549999999965],
            [-112.26389999999999, 36.69102000000004],
            [-112.17891999999998, 36.54663999999998],
            [-111.88306000000003, 36.486619999999974],
            [-111.71900000000002, 36.59324000000001],
            [-111.55025000000002, 36.473349999999975],
            [-111.37723000000003, 36.48630999999999],
            [-111.33054999999996, 36.660260000000015],
            [-111.15808, 36.71427000000004],
            [-111.22273000000001, 36.80846999999997],
            [-111.13877000000002, 37.00071000000004],
            [-110.47524999999995, 36.999150000000014],
            [-110.44551999999997, 36.78841000000003],
            [-110.50209, 36.561390000000046],
            [-110.75069, 36.46152000000002],
            [-110.75066999999996, 36.29354999999998],
            [-110.53083999999997, 36.46276999999997],
            [-110.49516000000001, 36.368809999999996],
            [-110.29971, 36.61006000000002],
            [-110.14906999999998, 36.45822],
            [-110.00064999999996, 36.433249999999965],
            [-110.00065999999998, 35.66261999999999],
            [-109.82692000000002, 35.66263000000002],
            [-109.85048, 34.661130000000014],
            [-109.63419, 34.660790000000034],
            [-109.55324000000002, 34.78712000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "FLO" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-78.81785999999997, 34.81633999999997],
            [-78.64748, 34.55685999999999],
            [-78.72556000000003, 34.466740000000044],
            [-78.50946000000002, 34.21526000000003],
            [-78.65097999999995, 33.945010000000046],
            [-78.57236999999995, 33.878080000000026],
            [-78.79398999999998, 33.76198999999999],
            [-79.03959999999998, 33.54404000000004],
            [-79.29142999999999, 33.173609999999954],
            [-79.40248999999994, 33.182649999999995],
            [-79.74110999999999, 33.32211000000002],
            [-79.91275999999996, 33.619939999999986],
            [-80.01415, 33.66027000000002],
            [-80.20432000000002, 33.44181999999999],
            [-80.36156, 33.66835000000003],
            [-80.39713, 33.767770000000034],
            [-80.20970000000003, 33.85413000000001],
            [-80.28461999999996, 34.095329999999976],
            [-80.38210999999998, 34.15188000000002],
            [-80.26804000000001, 34.34952000000004],
            [-80.36417000000003, 34.539239999999964],
            [-80.17765000000003, 34.62209999999998],
            [-80.16776999999993, 34.81152999999998],
            [-79.91376999999997, 34.81825],
            [-79.89189999999999, 35.02477999999999],
            [-79.62180000000001, 35.017380000000024],
            [-79.57886999999997, 35.09497],
            [-79.23294000000001, 35.08515],
            [-79.24660999999998, 35.21330000000002],
            [-79.09764999999996, 35.17421],
            [-79.05822999999998, 34.97833999999997],
            [-78.81785999999997, 34.81633999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "FMN" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-107.56891000000003, 37.96492000000002],
            [-107.48207999999998, 37.768210000000025],
            [-107.48215, 36.99982000000003],
            [-107.45707000000002, 36.89812000000003],
            [-107.61823999999999, 36.804620000000014],
            [-107.62423, 36.219819999999984],
            [-107.62645999999995, 36.000250000000015],
            [-107.30866000000002, 35.99851999999996],
            [-107.30613999999997, 35.30224999999997],
            [-108.46858000000003, 35.30664000000003],
            [-108.4693, 34.95907000000002],
            [-109.04592999999994, 34.95977000000003],
            [-109.04562999999999, 34.791289999999975],
            [-109.29856, 34.65167000000004],
            [-109.55324000000002, 34.78712000000001],
            [-109.63419, 34.660790000000034],
            [-109.85048, 34.661130000000014],
            [-109.82692000000002, 35.66263000000002],
            [-110.00065999999998, 35.66261999999999],
            [-110.00064999999996, 36.433249999999965],
            [-110.14906999999998, 36.45822],
            [-110.29971, 36.61006000000002],
            [-110.49516000000001, 36.368809999999996],
            [-110.53083999999997, 36.46276999999997],
            [-110.75066999999996, 36.29354999999998],
            [-110.75069, 36.46152000000002],
            [-110.50209, 36.561390000000046],
            [-110.44551999999997, 36.78841000000003],
            [-110.47524999999995, 36.999150000000014],
            [-111.13877000000002, 37.00071000000004],
            [-110.73622000000002, 37.345909999999975],
            [-110.60346999999999, 37.602799999999974],
            [-110.49812999999999, 37.65184000000001],
            [-110.40392000000003, 37.881039999999985],
            [-110.20577, 37.89591000000003],
            [-109.92784999999999, 38.15163999999997],
            [-109.88855999999996, 38.229939999999985],
            [-110.02519999999997, 38.49993999999998],
            [-109.58749999999999, 38.49995000000001],
            [-109.53595999999996, 38.166870000000046],
            [-109.39634000000001, 37.92822000000004],
            [-109.47836, 37.78195000000001],
            [-109.23285000000001, 37.75539999999999],
            [-109.0812, 37.82756000000002],
            [-109.04334999999999, 37.48423],
            [-108.88626000000001, 37.63193999999998],
            [-108.81687000000001, 37.89554999999999],
            [-108.25662, 37.89433000000004],
            [-107.84442999999996, 37.773440000000036],
            [-107.56891000000003, 37.96492000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "FNT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-82.86342000000002, 42.57106999999997],
            [-83.31978000000001, 42.50743000000003],
            [-83.73683, 42.35088000000004],
            [-83.81450999999996, 42.37146000000002],
            [-83.82663000000002, 42.592790000000036],
            [-83.99260999999998, 42.61715999999999],
            [-84.06442000000001, 42.90991000000001],
            [-83.97646, 43.04433999999996],
            [-84.25483, 43.20832000000001],
            [-84.16323, 43.35477],
            [-84.22938000000005, 43.51044000000001],
            [-84.11409999999998, 43.70412999999997],
            [-83.93556999999998, 43.70938999999998],
            [-83.68375, 43.58458],
            [-83.49201999999994, 43.69955],
            [-83.26214999999996, 43.97536999999998],
            [-82.96329000000003, 44.068619999999996],
            [-82.74495999999999, 43.99741999999999],
            [-82.61411999999999, 43.779720000000026],
            [-82.52233999999999, 43.223050000000015],
            [-82.42163000000002, 43.005829999999975],
            [-82.51379, 42.65192999999998],
            [-82.69746, 42.69005000000003],
            [-82.86342000000002, 42.57106999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "FSD" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-95.09975, 44.332580000000014],
            [-95.02048999999997, 44.137089999999986],
            [-94.75921, 44.18132000000003],
            [-94.74195, 43.84816000000002],
            [-94.56222999999997, 43.74295999999997],
            [-94.61420999999999, 43.58729999999999],
            [-94.49271000000005, 43.543519999999965],
            [-94.67756, 43.28054999999997],
            [-95.30379999999997, 43.255320000000005],
            [-95.3879, 43.3059],
            [-95.38826999999998, 43.05428000000004],
            [-95.57185999999993, 43.16404],
            [-95.88255999999993, 43.12968000000001],
            [-96.16210999999998, 43.003549999999976],
            [-96.31342999999995, 43.08389999999997],
            [-96.40154999999999, 42.909340000000014],
            [-96.54983999999999, 42.847689999999965],
            [-96.87915999999998, 42.959070000000025],
            [-97.40709000000004, 42.86545000000003],
            [-97.66936999999996, 42.83130000000001],
            [-97.77322999999998, 42.90802000000004],
            [-98.09496999999995, 42.965769999999985],
            [-98.09013999999999, 43.14873999999999],
            [-98.26771999999998, 43.22685000000001],
            [-98.22979000000002, 43.41325000000004],
            [-97.93006999999999, 43.43475999999997],
            [-97.78765000000001, 43.70228000000002],
            [-97.79975000000002, 43.849759999999975],
            [-97.67788999999996, 43.92905000000002],
            [-97.42266000000001, 43.92823999999997],
            [-97.45124999999999, 44.16752999999999],
            [-97.07985000000002, 44.19579000000002],
            [-97.01752000000002, 44.518370000000026],
            [-96.82759000000004, 44.529409999999984],
            [-96.60816000000003, 44.74688000000002],
            [-96.55868000000001, 44.947690000000044],
            [-96.30909999999997, 44.88504000000004],
            [-96.34591, 45.05933000000004],
            [-96.22920999999994, 45.21836999999999],
            [-95.90629999999999, 45.04479000000003],
            [-95.92086999999998, 44.94981000000004],
            [-95.73938999999999, 44.89140999999996],
            [-95.58599999999998, 44.73143999999997],
            [-95.60422, 44.54256],
            [-95.26932999999994, 44.52173999999997],
            [-95.09975, 44.332580000000014],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "FSM" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-92.94017, 36.00327999999999],
            [-92.95133999999996, 35.72455999999997],
            [-93.16445999999996, 35.72880999999998],
            [-93.22981000000001, 35.31355999999998],
            [-93.29456999999996, 35.21266],
            [-93.16925, 35.069070000000025],
            [-93.35695000000004, 35.054560000000016],
            [-93.34834999999998, 34.93406999999999],
            [-93.71002999999993, 34.74576000000002],
            [-93.39439999999999, 34.74336999999998],
            [-93.40823000000003, 34.33939999999999],
            [-93.64199000000002, 34.25032000000003],
            [-93.44312, 34.20858000000004],
            [-93.63610999999995, 33.973640000000046],
            [-93.87563, 33.872370000000004],
            [-94.03251000000003, 33.90972999999997],
            [-93.95916000000003, 33.75098999999996],
            [-94.30312999999998, 33.82129999999996],
            [-94.47728999999998, 33.940700000000035],
            [-94.48587999999998, 33.63633999999997],
            [-94.70902999999996, 33.685670000000016],
            [-95.16186000000002, 33.93797000000002],
            [-95.34574999999992, 33.87419999999998],
            [-95.37854000000004, 34.15689000000003],
            [-95.77936, 34.15656],
            [-95.77890999999997, 34.45400999999996],
            [-95.95553999999996, 34.73905999999997],
            [-96.08888999999999, 34.95140000000001],
            [-95.95177999999999, 35.151529999999994],
            [-95.79392999999999, 35.05735999999996],
            [-95.55789999999996, 35.10936000000004],
            [-95.16259999999994, 35.66754999999996],
            [-95.03137999999996, 36.04669000000004],
            [-94.79728, 36.16166000000004],
            [-94.79729999999995, 36.014019999999995],
            [-94.59718999999996, 36.08479000000004],
            [-94.90659000000002, 36.36895000000004],
            [-94.64162000000002, 36.32252000000004],
            [-94.61463, 36.49928000000004],
            [-94.23920999999996, 36.409670000000006],
            [-94.05768, 36.44093000000001],
            [-93.97724000000002, 36.34060999999997],
            [-93.65761999999995, 36.30298999999998],
            [-93.55116000000001, 36.126220000000046],
            [-93.37591999999992, 36.12277999999999],
            [-92.94017, 36.00327999999999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "FTW" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-96.78403999999995, 32.22833000000004],
            [-97.00061999999997, 32.28046999999998],
            [-97.71127999999999, 32.10153],
            [-98.07301999999994, 32.17366000000003],
            [-98.21452000000001, 32.06392000000004],
            [-98.47515000000001, 32.386050000000026],
            [-98.56266999999995, 32.38389000000001],
            [-98.57568999999997, 32.86892000000003],
            [-98.45738, 32.90173999999996],
            [-98.27007, 33.43585999999998],
            [-98.07173999999999, 33.33205000000001],
            [-97.67249999999996, 33.55177999999998],
            [-97.63677999999996, 33.43363000000003],
            [-97.32797999999997, 33.428660000000036],
            [-97.39309999999998, 33.16895000000004],
            [-97.25740999999996, 33.150980000000004],
            [-97.25426999999993, 32.99754999999997],
            [-97.03712000000002, 32.75706000000004],
            [-97.07789999999997, 32.59050999999999],
            [-96.90366999999998, 32.61905],
            [-96.89858999999993, 32.49710999999999],
            [-96.71024999999997, 32.43511999999997],
            [-96.78403999999995, 32.22833000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "FWA" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-84.8252, 41.83970999999999],
            [-84.67144999999994, 41.470420000000004],
            [-84.36112999999995, 41.187560000000005],
            [-84.34197999999998, 41.05531999999998],
            [-84.19950999999995, 41.04765999999999],
            [-84.19944999999996, 40.86474999999997],
            [-83.96849000000003, 40.823950000000046],
            [-84.15446, 40.70125000000004],
            [-84.42859999999996, 40.64741999999998],
            [-84.48014, 40.43105000000001],
            [-84.75998999999999, 40.474660000000014],
            [-84.86293, 40.309560000000026],
            [-85.18645999999993, 40.30620000000002],
            [-85.28291999999999, 40.07659000000005],
            [-85.577, 40.306129999999996],
            [-85.96828000000002, 40.42789000000003],
            [-86.01390999999998, 40.60056000000002],
            [-86.18524999999997, 40.67448000000002],
            [-86.32776999999996, 40.600840000000005],
            [-86.53314, 40.707819999999984],
            [-86.12575999999996, 40.99991000000002],
            [-85.98998999999998, 41.31188999999996],
            [-85.65355, 41.365220000000036],
            [-85.65495000000001, 41.533659999999976],
            [-85.46007, 41.52544999999996],
            [-85.52164999999994, 41.65533000000003],
            [-85.19498000000002, 41.66338999999998],
            [-85.29237, 41.906230000000015],
            [-85.17093, 41.988909999999976],
            [-85.03207999999998, 41.75968],
            [-84.8252, 41.83970999999999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "GEG" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-116.04945, 49.00085],
            [-116.19404999999995, 48.746229999999976],
            [-116.04911999999996, 48.626929999999994],
            [-116.04902000000003, 48.20807],
            [-115.89996, 48.111010000000036],
            [-115.99375999999997, 47.92635],
            [-115.72840000000001, 47.701979999999985],
            [-115.62947999999999, 47.47959000000001],
            [-115.74255, 47.42360000000003],
            [-116.09262, 47.21777999999998],
            [-116.39696999999995, 47.228600000000036],
            [-116.47102999999998, 47.036730000000034],
            [-117.06860000000003, 47.00570999999999],
            [-117.12561000000002, 47.07163000000003],
            [-117.46434999999997, 47.02469000000002],
            [-117.55280999999997, 46.869460000000004],
            [-117.72357999999996, 46.82155999999997],
            [-117.90382000000002, 46.91774999999998],
            [-118.10060999999997, 46.77274000000002],
            [-118.20368, 46.89848000000003],
            [-118.46383, 46.863900000000044],
            [-118.48804999999997, 46.73677999999998],
            [-118.77074999999996, 46.78624999999998],
            [-118.65340999999998, 46.94897999999998],
            [-118.96704999999996, 47.021770000000004],
            [-119.03339000000001, 47.20326999999997],
            [-119.16552, 47.27487999999997],
            [-119.29270999999999, 47.55057000000002],
            [-119.43869, 47.52480999999999],
            [-119.21243999999994, 47.80066999999998],
            [-119.20334999999994, 48.055909999999976],
            [-119.29569, 48.1154],
            [-119.53736999999997, 47.931179999999955],
            [-119.88296999999996, 47.97109999999999],
            [-119.98124999999996, 48.20957000000003],
            [-119.86909999999996, 48.32876999999999],
            [-119.90893999999996, 48.504880000000036],
            [-119.74691999999999, 48.55686999999999],
            [-119.58416, 48.78954000000002],
            [-119.54376000000003, 49.00010000000003],
            [-116.04945, 49.00085],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "GFK" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-95.41964000000002, 48.99908000000001],
            [-95.49410999999995, 48.77390999999997],
            [-95.34258, 48.54013000000003],
            [-95.21209000000002, 48.539919999999974],
            [-95.21054999999996, 48.365909999999964],
            [-94.90538000000001, 48.366449999999965],
            [-94.93377000000004, 48.18202999999998],
            [-95.08791000000002, 47.98540999999998],
            [-95.58288999999996, 48.02065000000004],
            [-95.58228999999997, 47.93386000000001],
            [-95.80731999999998, 47.96449999999996],
            [-95.76952000000003, 47.65943000000003],
            [-95.88573999999997, 47.553749999999965],
            [-96.17695000000003, 47.56561000000001],
            [-96.33002000000002, 47.71893],
            [-96.44090000000003, 47.49935],
            [-96.67936000000003, 47.49870999999998],
            [-96.81505999999999, 47.41197000000001],
            [-96.98424999999997, 47.49746999999997],
            [-97.31860999999998, 47.360299999999974],
            [-97.57304000000002, 47.41843000000001],
            [-97.56816, 47.238959999999956],
            [-97.88270999999996, 47.18222],
            [-97.98484000000002, 47.56318999999997],
            [-98.34808999999994, 47.701379999999986],
            [-98.66278000000003, 47.70310000000001],
            [-98.67206999999996, 48.00024],
            [-98.92832999999997, 47.9972],
            [-99.16766999999996, 48.19145000000002],
            [-98.99282, 48.39922000000003],
            [-99.03188000000002, 48.56603000000001],
            [-99.23209999999999, 48.64785000000004],
            [-99.06998999999995, 48.732769999999974],
            [-99.08116000000001, 48.87015999999997],
            [-99.24329999999996, 48.999680000000005],
            [-95.41964000000002, 48.99908000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "GGW" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-105.05780000000001, 48.99922999999999],
            [-105.03855000000003, 48.65031000000001],
            [-104.97337999999998, 48.56318000000001],
            [-105.0831, 48.34576999999997],
            [-105.00960999999997, 48.02724000000004],
            [-104.89454999999998, 47.97282000000002],
            [-105.02885999999995, 47.70345999999996],
            [-105.36296000000002, 47.79036999999997],
            [-105.36340999999994, 47.52944000000001],
            [-105.1892, 47.46816000000002],
            [-105.24128000000003, 47.29725],
            [-105.40194, 47.34176000000003],
            [-105.40635999999995, 47.181430000000006],
            [-105.59455999999997, 47.181379999999955],
            [-105.69448999999999, 47.37865000000001],
            [-106.07311000000003, 47.42595999999998],
            [-106.26251000000003, 47.22559999999997],
            [-106.58685, 47.26521000000003],
            [-106.88223000000002, 47.244210000000024],
            [-106.85275999999998, 47.02998999999996],
            [-107.01880000000003, 46.97108999999999],
            [-106.86199999999995, 46.85930999999996],
            [-107.62306999999994, 46.851060000000004],
            [-107.69724999999995, 47.15604999999998],
            [-107.92186000000002, 47.02048000000003],
            [-107.96848999999996, 47.24966999999997],
            [-107.92977999999994, 47.568270000000005],
            [-108.34899999999998, 47.566850000000024],
            [-108.76601999999997, 47.643799999999985],
            [-108.80943000000002, 47.69687999999998],
            [-108.98239999999996, 47.80284000000003],
            [-109.53852999999997, 47.738900000000044],
            [-109.55156999999994, 48.293539999999965],
            [-109.49724, 48.45174999999999],
            [-109.48955999999995, 49.00032000000002],
            [-105.05780000000001, 48.99922999999999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "GJT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-107.54056000000001, 41.00225000000001],
            [-107.45853999999996, 40.885719999999985],
            [-107.31753000000003, 40.9752],
            [-107.07105, 40.72975999999996],
            [-107.15162, 40.46951999999999],
            [-107.04888, 40.331209999999984],
            [-107.03397999999996, 39.91893999999999],
            [-106.70665999999999, 39.669459999999994],
            [-106.81761, 39.65681000000005],
            [-106.76271999999999, 39.495210000000014],
            [-106.54321000000002, 39.48413999999997],
            [-106.55661000000002, 39.36209000000001],
            [-106.71469000000003, 39.36210000000004],
            [-106.67479999999999, 39.194089999999974],
            [-106.53194999999997, 39.20082000000002],
            [-106.57827, 39.057880000000004],
            [-106.59918999999996, 38.99787999999997],
            [-106.87238000000002, 38.78675000000004],
            [-106.84920999999997, 38.652219999999986],
            [-106.65821000000001, 38.68375999999997],
            [-106.74492, 38.52354],
            [-106.64806999999999, 38.46990999999997],
            [-106.3832, 38.62335999999996],
            [-106.24709999999999, 38.422840000000036],
            [-107.00055999999995, 38.425509999999974],
            [-107.13653999999998, 38.321580000000026],
            [-107.25901999999999, 38.404440000000044],
            [-107.42804999999998, 38.14704000000003],
            [-107.56884999999996, 38.14709],
            [-107.56891000000003, 37.96492000000002],
            [-107.84442999999996, 37.773440000000036],
            [-108.25662, 37.89433000000004],
            [-108.81687000000001, 37.89554999999999],
            [-108.88626000000001, 37.63193999999998],
            [-109.04334999999999, 37.48423],
            [-109.0812, 37.82756000000002],
            [-109.23285000000001, 37.75539999999999],
            [-109.47836, 37.78195000000001],
            [-109.39634000000001, 37.92822000000004],
            [-109.53595999999996, 38.166870000000046],
            [-109.58749999999999, 38.49995000000001],
            [-110.02519999999997, 38.49993999999998],
            [-109.98186000000003, 38.585720000000016],
            [-109.73086999999997, 38.62241999999999],
            [-109.67718000000004, 38.77877999999998],
            [-109.49227, 38.69408999999999],
            [-109.23174000000002, 38.74703000000003],
            [-109.0539, 38.89548999999998],
            [-109.05140000000002, 39.49766000000005],
            [-109.43010999999994, 39.46237000000003],
            [-109.55027000000003, 39.667880000000004],
            [-109.43160999999998, 39.997250000000044],
            [-109.20916000000001, 39.879019999999954],
            [-109.05094999999999, 39.98768999999997],
            [-109.04998000000002, 41.000659999999996],
            [-107.54056000000001, 41.00225000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "GLD" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-99.6281, 39.726920000000014],
            [-99.60641999999996, 39.20678999999997],
            [-99.81025000000002, 39.23370000000003],
            [-100.03312999999994, 39.16107000000001],
            [-100.16368999999997, 38.69747000000005],
            [-100.81881999999996, 38.699710000000024],
            [-101.05802, 38.76211999999998],
            [-101.12786999999996, 38.56276999999996],
            [-101.01736999999996, 38.43914000000001],
            [-101.04847999999998, 38.26476999999996],
            [-101.55154000000003, 38.26325999999999],
            [-101.65160999999999, 38.14688999999997],
            [-101.58089, 37.957969999999975],
            [-101.72674, 37.737200000000016],
            [-102.04210999999995, 37.73844000000003],
            [-102.04157999999998, 37.62002999999997],
            [-102.34825999999998, 37.64412000000003],
            [-102.47515999999996, 37.534780000000005],
            [-102.49096000000003, 37.64380000000002],
            [-102.74753999999996, 37.64354],
            [-102.83292000000003, 37.72418000000001],
            [-102.74120000000003, 38.00533000000001],
            [-102.81885000000001, 38.26723999999996],
            [-103.14613999999999, 38.26597000000004],
            [-103.11547999999998, 38.43807999999997],
            [-102.92306999999997, 38.420689999999965],
            [-103.09935999999999, 38.61425],
            [-103.01766000000002, 38.65861999999999],
            [-103.16370000000002, 38.849360000000026],
            [-103.15556999999997, 39.14806000000003],
            [-103.37893, 39.20352000000004],
            [-103.35938999999999, 39.47760000000002],
            [-103.43633999999996, 39.56591999999998],
            [-103.27433999999997, 39.566450000000046],
            [-103.20959999999995, 39.78562000000005],
            [-102.90066000000002, 39.78124999999996],
            [-102.80302000000002, 39.966400000000036],
            [-103.09509, 40.01666999999997],
            [-103.10795, 40.436840000000004],
            [-102.41478000000001, 40.406419999999954],
            [-102.43918999999998, 40.74920000000003],
            [-102.23812999999996, 40.74895000000004],
            [-102.18587999999998, 40.60256000000004],
            [-102.05147, 40.653749999999974],
            [-102.05170000000003, 40.34912000000003],
            [-101.32334999999996, 40.35054000000002],
            [-101.32521000000003, 40.21480000000003],
            [-101.09802999999994, 40.26431999999999],
            [-100.85219999999995, 40.087269999999975],
            [-100.85862000000002, 40.002109999999995],
            [-100.17803999999998, 40.001610000000014],
            [-100.17941999999994, 39.83467999999996],
            [-99.81609999999999, 39.70438000000004],
            [-99.6281, 39.726920000000014],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "GPT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-89.63243000000003, 30.268959999999982],
            [-89.68320000000003, 30.451479999999968],
            [-89.85208000000003, 30.661350000000002],
            [-89.78712999999996, 30.84366000000002],
            [-90.01322999999996, 30.907559999999982],
            [-89.93706999999998, 31.00154000000001],
            [-89.92949999999999, 31.098759999999974],
            [-89.74225999999999, 31.003709999999966],
            [-89.65384000000003, 31.22401000000003],
            [-89.46844999999999, 31.24105000000003],
            [-89.3991, 31.43422000000004],
            [-89.29566999999994, 31.434199999999983],
            [-89.14544000000001, 31.219369999999984],
            [-88.90072000000004, 31.089460000000006],
            [-88.88454999999999, 30.826389999999996],
            [-88.67828, 30.734640000000006],
            [-88.59555, 30.42462999999999],
            [-88.72760000000002, 30.342810000000046],
            [-89.00702999999999, 30.386280000000003],
            [-89.57030999999998, 30.18182000000004],
            [-89.63243000000003, 30.268959999999982],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "GRB" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-87.01697999999996, 45.299349999999976],
              [-87.31304999999998, 44.794260000000016],
              [-87.40456, 44.91247999999998],
              [-87.23845999999998, 45.16688000000001],
              [-87.01697999999996, 45.299349999999976],
            ],
          ],
          [
            [
              [-86.81202000000002, 46.45197999999996],
              [-86.89782000000002, 46.34295000000001],
              [-86.75979000000001, 46.00565999999996],
              [-86.56700000000001, 45.899830000000016],
              [-86.77617999999998, 45.86448],
              [-86.94261999999998, 45.70207000000001],
              [-87.00611000000004, 45.832240000000006],
              [-87.32982000000001, 45.42264999999998],
              [-87.59966, 45.15096999999999],
              [-87.62985000000003, 44.98404000000002],
              [-87.82082, 44.89913999999997],
              [-87.98321999999996, 44.721019999999974],
              [-88.00615999999997, 44.540079999999975],
              [-87.75400999999994, 44.65079000000002],
              [-87.60958999999997, 44.83864999999997],
              [-87.31348999999997, 44.793940000000006],
              [-87.48381999999995, 44.511340000000025],
              [-87.51535000000001, 44.18680999999997],
              [-87.65038000000004, 44.10920000000002],
              [-87.73569999999995, 43.87286000000001],
              [-87.72810000000004, 43.64748],
              [-87.84089999999998, 43.84183999999997],
              [-87.89086000000003, 43.70330000000004],
              [-88.43955999999997, 43.631389999999996],
              [-88.73143999999996, 43.789519999999975],
              [-88.81369999999998, 43.98714999999997],
              [-88.90856, 44.12687000000001],
              [-88.73887999999997, 44.30483],
              [-88.86632999999995, 44.29990999999997],
              [-88.9039, 44.51372999999998],
              [-88.79186999999996, 44.76257999999999],
              [-88.65475, 44.856519999999996],
              [-88.70307, 45.06749000000001],
              [-88.67799, 45.37852000000004],
              [-88.79337999999993, 45.498729999999995],
              [-88.42706000000001, 45.501180000000026],
              [-88.62210999999996, 45.708120000000015],
              [-88.50105999999997, 45.87835],
              [-88.47986999999995, 46.178179999999976],
              [-88.54301000000001, 46.41992999999997],
              [-88.11576999999997, 46.678290000000004],
              [-88.23639, 46.868040000000015],
              [-88.08169999999998, 46.92056000000004],
              [-87.81674000000001, 46.890840000000004],
              [-87.59016, 46.78231999999997],
              [-87.35940999999994, 46.50344999999997],
              [-87.01972, 46.535450000000004],
              [-86.81202000000002, 46.45197999999996],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "GRI" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-97.47533999999993, 41.35017000000002],
            [-97.38644999999997, 41.11855000000001],
            [-97.37566999999996, 40.74938],
            [-97.70965999999999, 40.690969999999986],
            [-97.47449999999998, 40.44484999999999],
            [-97.63437000000005, 40.37931999999999],
            [-98.04834999999996, 40.27868999999997],
            [-98.29687000000001, 40.37904],
            [-98.29288000000001, 40.23460000000004],
            [-98.56712, 40.20993999999999],
            [-98.60161, 40.00238999999998],
            [-99.46509999999996, 40.00203000000003],
            [-99.62724, 39.88227000000001],
            [-99.76116999999996, 40.00165999999997],
            [-99.63023999999997, 40.237139999999975],
            [-99.52035999999994, 40.18857000000001],
            [-99.50202999999996, 40.35111000000002],
            [-99.75486999999997, 40.423619999999964],
            [-99.67147999999997, 40.674680000000045],
            [-99.45404999999997, 40.86761],
            [-99.42607000000002, 41.04653000000002],
            [-99.54515999999994, 41.13813000000003],
            [-99.5531, 41.30693],
            [-99.45420999999997, 41.49960000000003],
            [-99.68682000000001, 41.740210000000026],
            [-99.68689000000003, 42.08620999999998],
            [-99.27300000000002, 42.08756999999998],
            [-99.23464000000001, 42.13304000000004],
            [-98.87901999999998, 42.088410000000025],
            [-98.71846999999997, 41.84494],
            [-98.37334999999999, 41.793980000000005],
            [-98.17627999999998, 41.62525999999999],
            [-98.08011999999997, 41.63930000000002],
            [-97.91570999999996, 41.38032000000002],
            [-97.77216000000001, 41.308369999999954],
            [-97.62831999999995, 41.394980000000004],
            [-97.47533999999993, 41.35017000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "GRR" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-84.91298000000003, 43.50310999999997],
            [-84.97502999999995, 43.405789999999996],
            [-84.91596000000004, 43.20640999999998],
            [-84.98781999999994, 42.79229000000004],
            [-85.07529000000002, 42.61686999999998],
            [-84.95358000000002, 42.43114999999999],
            [-85.13095999999999, 42.25396000000003],
            [-85.18948999999998, 42.07239999999998],
            [-85.34029000000001, 42.150130000000004],
            [-85.73350000000002, 42.182839999999985],
            [-85.82795000000004, 42.323100000000025],
            [-86.13658999999996, 42.382649999999956],
            [-86.31249999999997, 42.328999999999965],
            [-86.22838999999999, 42.639970000000005],
            [-85.90814999999998, 42.78965000000001],
            [-85.79008999999999, 43.16864999999996],
            [-85.53207000000003, 43.46807999999997],
            [-85.56235999999998, 43.62083999999999],
            [-85.34292999999997, 43.60094999999999],
            [-85.23112999999995, 43.71391999999998],
            [-85.08689000000004, 43.67546000000004],
            [-84.91298000000003, 43.50310999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "GSO" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-79.61561999999998, 36.72697000000004],
            [-79.21279999999993, 36.565780000000004],
            [-79.14891, 36.530809999999995],
            [-79.38260999999997, 36.09397000000003],
            [-79.23674000000003, 35.85013999999997],
            [-79.48900999999992, 35.52872000000002],
            [-79.68075999999996, 35.17717999999998],
            [-79.88535000000002, 35.167429999999996],
            [-79.86077, 35.27468000000002],
            [-80.07481000000001, 35.39479999999999],
            [-80.05886999999998, 35.491790000000016],
            [-80.47920000000002, 35.77510999999997],
            [-80.60674000000003, 35.74029999999996],
            [-80.72301999999996, 35.91866],
            [-80.88289999999998, 35.932920000000024],
            [-80.90975999999998, 36.119910000000026],
            [-81.16271999999995, 36.28270000000002],
            [-81.20011000000002, 36.39293999999999],
            [-81.03723999999997, 36.41728999999997],
            [-81.02845000000002, 36.667399999999965],
            [-80.93208000000004, 36.77868000000001],
            [-80.80722, 36.630330000000015],
            [-80.66159999999994, 36.725540000000024],
            [-80.40503999999999, 36.63527000000001],
            [-80.17375999999996, 36.823160000000044],
            [-79.93226000000004, 36.69969000000001],
            [-79.81824999999998, 36.861040000000045],
            [-79.61561999999998, 36.72697000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "GSP" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-81.69793000000001, 35.57895000000001],
            [-81.68465999999992, 35.29945000000002],
            [-81.48854, 35.029670000000024],
            [-81.44729999999998, 34.712389999999964],
            [-81.29575, 34.56631999999996],
            [-81.52108000000004, 34.56980000000004],
            [-81.77987999999996, 34.433139999999966],
            [-81.97510999999997, 34.01024000000001],
            [-82.23784, 34.091350000000006],
            [-82.4513, 34.00297999999999],
            [-82.62631999999999, 34.242729999999966],
            [-82.83416999999997, 34.36431999999998],
            [-82.95793999999995, 34.54063000000004],
            [-83.10239999999996, 34.53226000000002],
            [-83.34125, 34.67975],
            [-83.31602999999998, 34.79527000000004],
            [-83.15687999999997, 34.74836000000003],
            [-83.03490999999997, 35.02057],
            [-82.61188000000001, 35.09643000000001],
            [-82.55528999999993, 35.159140000000015],
            [-81.87555000000003, 35.18382999999997],
            [-81.92652999999999, 35.39121999999998],
            [-81.75441999999998, 35.61206999999999],
            [-81.69793000000001, 35.57895000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "GTB" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.72385000000003, 44.97594999999998],
            [-74.64178000000001, 44.952820000000045],
            [-74.56032999999994, 44.397499999999994],
            [-74.36738999999994, 44.27162999999998],
            [-74.25118999999995, 44.29463],
            [-74.13114000000002, 44.13404999999999],
            [-74.28183000000001, 44.12029999999997],
            [-74.33682999999996, 43.925220000000024],
            [-74.05789000000004, 43.74449],
            [-74.20066000000003, 43.63811000000001],
            [-74.39339999999999, 43.601899999999986],
            [-74.50627999999998, 43.68135999999998],
            [-74.78267999999997, 43.54006999999997],
            [-75.08488000000003, 43.52048000000001],
            [-75.07699999999997, 43.330689999999976],
            [-75.37253999999999, 43.34544999999998],
            [-75.75543999999994, 43.470209999999994],
            [-75.77469000000002, 43.68895999999997],
            [-76.03690999999995, 43.577940000000034],
            [-76.18364999999997, 43.67935000000002],
            [-76.22380000000004, 43.82751999999996],
            [-76.12879999999998, 44.06343000000001],
            [-76.36338999999998, 44.11243999999996],
            [-76.01214999999996, 44.259450000000015],
            [-75.75440999999998, 44.51448000000004],
            [-75.29933000000003, 44.83722999999999],
            [-74.97039999999998, 44.95763000000003],
            [-74.72385000000003, 44.97594999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "GTF" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-109.48955999999995, 49.00032000000002],
            [-109.49724, 48.45174999999999],
            [-109.55156999999994, 48.293539999999965],
            [-109.53852999999997, 47.738900000000044],
            [-108.98239999999996, 47.80284000000003],
            [-108.80943000000002, 47.69687999999998],
            [-108.80832999999996, 47.55108999999997],
            [-109.03655999999997, 47.48089000000002],
            [-109.16944999999994, 47.54610000000001],
            [-109.59720000000002, 47.51890999999996],
            [-109.43964000000003, 47.21852000000001],
            [-109.18762999999994, 47.26455000000004],
            [-108.94254, 47.21583999999996],
            [-109.12815000000003, 46.94628999999998],
            [-109.14854000000001, 46.75118999999998],
            [-109.43787999999998, 46.80957000000001],
            [-110.27334999999998, 46.710519999999974],
            [-110.28191, 46.18422000000004],
            [-110.69176999999998, 46.19265999999999],
            [-110.66141999999996, 46.312610000000014],
            [-111.06202, 46.19280000000003],
            [-111.05719999999998, 46.40330999999999],
            [-111.24718999999996, 46.43863000000001],
            [-111.60274999999999, 46.89152999999999],
            [-111.89841, 46.86076000000003],
            [-112.03033999999995, 46.92883999999999],
            [-112.18071000000002, 46.822389999999984],
            [-112.31431999999998, 47.005189999999956],
            [-112.55567, 47.179639999999964],
            [-112.92471999999995, 47.315880000000014],
            [-113.05874, 47.200890000000044],
            [-113.05932999999996, 47.48783999999996],
            [-113.14429000000001, 47.59631000000004],
            [-113.05863999999998, 47.870390000000015],
            [-112.87867999999997, 47.97703000000001],
            [-112.98451000000001, 48.11997999999997],
            [-113.23320000000002, 48.16846999999997],
            [-113.34921000000001, 48.310120000000005],
            [-112.57585000000003, 48.309419999999996],
            [-112.57722999999999, 48.48325999999998],
            [-112.18473000000002, 48.477230000000034],
            [-112.19370000000004, 48.99868000000004],
            [-109.48955999999995, 49.00032000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "HON" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-96.34591, 45.05933000000004],
            [-96.30909999999997, 44.88504000000004],
            [-96.55868000000001, 44.947690000000044],
            [-96.60816000000003, 44.74688000000002],
            [-96.82759000000004, 44.529409999999984],
            [-97.01752000000002, 44.518370000000026],
            [-97.07985000000002, 44.19579000000002],
            [-97.45124999999999, 44.16752999999999],
            [-97.42266000000001, 43.92823999999997],
            [-97.67788999999996, 43.92905000000002],
            [-97.79975000000002, 43.849759999999975],
            [-97.78765000000001, 43.70228000000002],
            [-97.93006999999999, 43.43475999999997],
            [-98.22979000000002, 43.41325000000004],
            [-98.26771999999998, 43.22685000000001],
            [-98.45600999999998, 43.00055],
            [-98.71731, 43.09634000000004],
            [-98.85912999999998, 43.15626999999997],
            [-99.15642999999997, 43.42953000000004],
            [-99.30616000000002, 43.46186999999996],
            [-99.45465999999999, 43.68777000000001],
            [-99.30544999999998, 43.85691999999998],
            [-99.45341999999998, 44.12751999999997],
            [-99.29989000000002, 44.194910000000036],
            [-99.31198, 44.74366999999999],
            [-99.08914999999995, 44.77932000000004],
            [-98.86642999999994, 44.722210000000025],
            [-98.76548, 44.987810000000025],
            [-98.55325999999994, 44.93479000000002],
            [-98.31112, 45.01366000000004],
            [-97.98243999999995, 45.00855000000001],
            [-97.98167000000001, 45.15327999999998],
            [-97.38395, 44.971109999999996],
            [-97.21243000000004, 44.964419999999976],
            [-97.08645999999999, 45.10775000000002],
            [-96.73878999999997, 45.04837999999997],
            [-96.70945999999998, 44.980579999999996],
            [-96.43492000000003, 45.133470000000024],
            [-96.34591, 45.05933000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "HSE" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-76.51588999999998, 35.00256999999997],
              [-76.31431, 34.90351],
              [-76.68425999999997, 34.78339999999997],
              [-76.69080999999997, 34.87944],
              [-76.66265999999999, 34.90903999999996],
              [-76.65909999999994, 34.911220000000036],
              [-76.63481999999999, 34.94194000000003],
              [-76.51588999999998, 35.00256999999997],
            ],
          ],
          [
            [
              [-75.86039999999994, 35.60886999999998],
              [-76.15441999999999, 35.32552000000004],
              [-76.48386000000002, 35.373750000000015],
              [-76.58587999999995, 35.50924000000001],
              [-76.24170999999998, 35.58976999999998],
              [-76.10326999999998, 35.666180000000026],
              [-76.02167999999998, 35.652439999999956],
              [-75.98601999999997, 35.888809999999964],
              [-75.80962, 35.958950000000016],
              [-75.73431000000002, 35.63093999999997],
              [-75.86039999999994, 35.60886999999998],
            ],
          ],
          [
            [
              [-76.92058000000003, 35.05584999999999],
              [-76.89554999999999, 35.25347999999998],
              [-77.19045999999994, 35.418940000000006],
              [-77.14525, 35.73114000000003],
              [-77.02168999999998, 35.673919999999974],
              [-76.94941999999998, 35.80160000000001],
              [-76.76091, 35.86304],
              [-76.84505999999999, 35.70533999999998],
              [-76.63116999999997, 35.70516000000001],
              [-76.70020999999994, 35.92377000000003],
              [-76.06110999999996, 35.990129999999965],
              [-76.05965999999998, 35.70279000000002],
              [-76.24102999999994, 35.590930000000036],
              [-76.62188, 35.53481000000004],
              [-76.59759999999997, 35.074100000000016],
              [-76.80289999999997, 34.96424999999998],
              [-76.92058000000003, 35.05584999999999],
            ],
          ],
          [
            [
              [-75.77267999999998, 36.231680000000026],
              [-75.60391000000001, 35.913619999999995],
              [-75.73738000000003, 36.04140000000004],
              [-75.77580000000003, 36.23105999999997],
              [-75.77267999999998, 36.231680000000026],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "HSV" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-86.23353999999995, 35.245279999999994],
            [-85.96159, 35.15575000000001],
            [-86.08201, 34.831620000000015],
            [-85.92866999999995, 34.77009000000004],
            [-85.83045000000004, 34.60244],
            [-85.91213000000002, 34.49223000000003],
            [-85.75257000000005, 34.29662000000002],
            [-85.78623999999996, 34.08030000000001],
            [-85.96056999999999, 34.227589999999964],
            [-86.13444999999999, 34.080780000000026],
            [-86.28741999999997, 34.07778999999999],
            [-86.54043000000001, 34.22551],
            [-86.61287000000004, 34.11346000000001],
            [-86.83853000000002, 34.129699999999985],
            [-86.96569999999997, 33.97360000000002],
            [-87.01954999999998, 34.12540000000001],
            [-87.18933000000004, 34.18708999999999],
            [-87.28598, 33.99507000000001],
            [-87.48034999999999, 34.091879999999975],
            [-87.63616999999999, 34.04047999999999],
            [-87.77310999999995, 34.113759999999964],
            [-87.76575, 34.27442000000002],
            [-87.88173, 34.31192000000002],
            [-88.12222999999994, 34.70344],
            [-88.0976, 34.89171999999998],
            [-88.20254999999995, 35.00788999999997],
            [-87.74331999999998, 35.00431999999999],
            [-87.65851, 35.174920000000036],
            [-87.55263000000002, 35.09178000000003],
            [-87.45768999999996, 35.217789999999994],
            [-87.65233, 35.357669999999956],
            [-87.44863000000004, 35.42659999999999],
            [-87.34242, 35.361029999999964],
            [-87.12912999999998, 35.45616000000002],
            [-86.88898999999995, 35.42395000000002],
            [-86.78830000000002, 35.322720000000004],
            [-86.60911999999999, 35.43147999999999],
            [-86.50679, 35.32557],
            [-86.23353999999995, 35.245279999999994],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "HTL" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-83.50166999999999, 44.27618000000004],
            [-83.57769999999996, 44.04871999999997],
            [-83.83417000000003, 43.99674999999998],
            [-83.93556999999998, 43.70938999999998],
            [-84.11409999999998, 43.70412999999997],
            [-84.22938000000005, 43.51044000000001],
            [-84.49045999999998, 43.528090000000034],
            [-84.49719999999996, 43.63934],
            [-84.91298000000003, 43.50310999999997],
            [-85.08689000000004, 43.67546000000004],
            [-85.23112999999995, 43.71391999999998],
            [-85.11214999999999, 43.780879999999996],
            [-85.11811999999995, 43.99081999999996],
            [-85.28670000000002, 44.15300000000001],
            [-85.08357999999998, 44.21835999999998],
            [-84.85492000000002, 44.446760000000026],
            [-84.84819999999999, 44.91678999999999],
            [-84.98024999999996, 45.005239999999965],
            [-84.76023999999998, 45.17714000000001],
            [-84.45211, 45.0946],
            [-84.36657999999994, 45.1988],
            [-84.22051000000005, 45.10705000000001],
            [-84.37146999999999, 44.989230000000006],
            [-84.06473, 44.84211],
            [-84.04245999999998, 44.65858000000002],
            [-83.88813999999994, 44.68338999999996],
            [-83.77472999999995, 44.45189000000002],
            [-83.50166999999999, 44.27618000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "HTS" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-82.06827000000001, 39.193009999999965],
            [-82.23835999999997, 39.12814999999998],
            [-82.01937000000001, 38.97583000000004],
            [-82.11629000000002, 38.40723999999999],
            [-81.99217000000004, 38.25826000000001],
            [-82.04266999999999, 38.06121999999998],
            [-82.19077999999993, 37.97465000000004],
            [-82.10061999999996, 37.78255000000001],
            [-81.9711, 37.54689000000003],
            [-82.24025000000003, 37.568990000000014],
            [-82.64090999999996, 37.71912999999997],
            [-82.64563999999999, 37.83007999999998],
            [-82.82633999999993, 37.96490999999999],
            [-83.26709999999997, 38.17843000000005],
            [-83.41192999999996, 38.39636000000003],
            [-83.63518000000005, 38.355410000000035],
            [-83.64196999999999, 38.525140000000036],
            [-83.50756000000001, 39.03692000000002],
            [-83.36143999999996, 39.16250000000002],
            [-83.02755999999997, 39.22072999999999],
            [-82.74690000000001, 39.14089],
            [-82.75573, 39.28628999999998],
            [-82.43038999999996, 39.19405000000004],
            [-82.16874999999999, 39.262810000000044],
            [-82.06827000000001, 39.193009999999965],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "IAD" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-77.30739000000003, 39.641009999999966],
            [-77.10237000000001, 39.18135000000004],
            [-77.28661000000002, 38.798490000000015],
            [-77.30249999999998, 38.650960000000005],
            [-77.44912999999997, 38.581049999999976],
            [-77.30046000000004, 38.50356000000001],
            [-77.31670999999997, 38.35131],
            [-77.46799999999993, 38.379049999999985],
            [-77.48777999999999, 38.14587999999998],
            [-77.80247, 38.07882999999998],
            [-78.11625000000001, 38.197240000000036],
            [-78.40301999999994, 38.1895],
            [-78.57618, 38.32855999999997],
            [-78.71827000000002, 38.28225999999998],
            [-78.62368999999998, 38.71327000000004],
            [-78.82863999999998, 38.74745999999999],
            [-78.62691999999998, 39.218440000000044],
            [-78.58038000000005, 39.492909999999966],
            [-78.47002, 39.51633],
            [-78.22860999999997, 39.39098000000003],
            [-78.04035999999999, 39.722340000000045],
            [-77.85521, 39.72211999999996],
            [-77.41431000000003, 39.71999999999997],
            [-77.30739000000003, 39.641009999999966],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "IAH" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-94.56199999999993, 31.058770000000006],
            [-94.68678, 30.919599999999996],
            [-94.53783000000001, 30.491099999999964],
            [-94.73275999999998, 30.49011000000003],
            [-94.68561, 30.10359999999998],
            [-94.60650999999996, 30.069019999999995],
            [-94.68662, 29.77176000000003],
            [-95.01579000000001, 29.638350000000006],
            [-94.86801000000003, 29.290049999999994],
            [-94.96255000000002, 29.3279],
            [-95.29251000000002, 28.957179999999997],
            [-95.53544999999997, 28.83086999999999],
            [-95.77015999999995, 28.972050000000042],
            [-95.96380999999997, 29.305430000000047],
            [-96.23598000000001, 29.486789999999978],
            [-96.40997999999999, 29.772860000000005],
            [-96.60366000000002, 29.843259999999987],
            [-96.53664, 30.320600000000024],
            [-96.27146999999997, 30.409320000000044],
            [-96.42174999999997, 30.55136000000002],
            [-96.39057, 30.69477000000002],
            [-96.54907999999998, 30.854229999999998],
            [-96.38570000000004, 30.85124999999999],
            [-96.20764000000003, 30.943800000000003],
            [-96.01792, 30.94326],
            [-95.98875999999996, 31.086200000000012],
            [-95.78055999999998, 31.094099999999962],
            [-95.67258999999999, 31.36608],
            [-95.11833999999999, 31.531559999999985],
            [-94.86363, 31.23031000000002],
            [-94.77142000000003, 31.26940999999998],
            [-94.69344999999996, 31.095990000000022],
            [-94.56199999999993, 31.058770000000006],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ICT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-96.77133999999995, 38.59918000000002],
            [-96.81922999999995, 38.34846],
            [-96.48552000000001, 38.16364000000004],
            [-96.04041999999995, 37.98288999999996],
            [-96.01612000000003, 37.852249999999984],
            [-95.87891000000002, 37.91783999999997],
            [-95.85272999999995, 37.77625000000002],
            [-95.642, 37.65116999999999],
            [-95.82406000000003, 37.38577999999996],
            [-95.96439999999993, 37.29934999999997],
            [-96.24622999999997, 37.30080000000004],
            [-96.37892000000002, 37.098630000000014],
            [-96.31739999999999, 36.99912000000002],
            [-96.74999999999997, 36.999210000000005],
            [-96.93098999999992, 36.774790000000024],
            [-96.83277000000001, 36.610130000000034],
            [-97.29182, 36.59391000000002],
            [-97.31908999999999, 36.46409000000003],
            [-97.49741999999995, 36.56353],
            [-97.67553999999996, 36.47739000000003],
            [-98.27112000000001, 36.666199999999975],
            [-98.39924999999997, 36.53088000000001],
            [-98.68748999999995, 36.49817000000003],
            [-98.86227, 36.76646999999997],
            [-99.02488000000001, 36.75417999999996],
            [-99.11664000000003, 36.99938999999998],
            [-98.88959999999999, 36.99941999999997],
            [-98.83276000000002, 37.25908000000001],
            [-98.74468999999996, 37.32715999999998],
            [-98.75171999999995, 37.54359000000002],
            [-98.54920999999996, 37.57977000000005],
            [-98.72838999999999, 37.86836999999998],
            [-98.63770999999998, 38.05665000000004],
            [-98.70582000000002, 38.260849999999984],
            [-98.63272999999995, 38.44941000000003],
            [-98.48009999999995, 38.57264000000002],
            [-98.16451999999994, 38.594530000000034],
            [-98.11016999999994, 38.68881000000001],
            [-97.70594000000003, 38.609120000000004],
            [-97.72479999999999, 38.769080000000045],
            [-97.55610999999996, 38.536259999999956],
            [-97.37191999999999, 38.50787000000001],
            [-97.37189000000001, 38.609260000000035],
            [-96.98546999999994, 38.63669999999998],
            [-96.77133999999995, 38.59918000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ICX" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-109.92784999999999, 38.15163999999997],
            [-110.20577, 37.89591000000003],
            [-110.40392000000003, 37.881039999999985],
            [-110.49812999999999, 37.65184000000001],
            [-110.60346999999999, 37.602799999999974],
            [-110.73622000000002, 37.345909999999975],
            [-111.13877000000002, 37.00071000000004],
            [-111.22273000000001, 36.80846999999997],
            [-111.15808, 36.71427000000004],
            [-111.33054999999996, 36.660260000000015],
            [-111.37723000000003, 36.48630999999999],
            [-111.55025000000002, 36.473349999999975],
            [-111.71900000000002, 36.59324000000001],
            [-111.88306000000003, 36.486619999999974],
            [-112.17891999999998, 36.54663999999998],
            [-112.26389999999999, 36.69102000000004],
            [-112.59299999999998, 36.840549999999965],
            [-112.65996, 36.54355000000002],
            [-112.62491999999996, 36.408049999999996],
            [-112.44194999999996, 36.269129999999976],
            [-112.39994000000002, 35.947860000000006],
            [-112.58883000000002, 36.03408999999996],
            [-112.67727999999998, 36.34253999999996],
            [-113.31976000000003, 36.09714000000003],
            [-113.32609999999995, 35.84259999999996],
            [-113.45987000000001, 35.75863999999997],
            [-113.65330999999998, 35.89944000000002],
            [-113.82566999999999, 36.18174000000005],
            [-114.22712000000001, 36.26019000000004],
            [-114.20768000000002, 36.35403999999997],
            [-114.36623999999996, 36.674149999999976],
            [-114.51952000000003, 36.84346000000004],
            [-115.04917000000003, 36.85330000000002],
            [-115.08579999999999, 37.00365000000002],
            [-114.84511000000003, 37.21718000000002],
            [-114.68954999999998, 37.268699999999995],
            [-114.79776999999997, 37.561949999999996],
            [-114.72593000000003, 37.65261000000004],
            [-114.77803999999998, 37.84551],
            [-114.88989000000002, 37.84330000000001],
            [-115.07055000000003, 38.050810000000006],
            [-115.00083000000001, 38.05079999999998],
            [-115.00089, 38.677369999999996],
            [-114.04980000000003, 38.67738000000002],
            [-114.04999999999998, 38.572939999999974],
            [-112.82432999999997, 38.574619999999975],
            [-112.87933999999997, 38.71733999999999],
            [-112.73592000000002, 38.67137000000004],
            [-112.33920000000003, 38.836310000000026],
            [-112.17517000000002, 38.64087999999998],
            [-112.18154999999997, 38.51199999999996],
            [-111.76644999999995, 38.502240000000036],
            [-111.84910999999994, 38.423600000000036],
            [-111.84322999999998, 38.15128000000003],
            [-109.92784999999999, 38.15163999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ILG" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-75.51105000000001, 39.36552000000003],
              [-75.98918999999998, 39.26300000000004],
              [-76.11355999999998, 39.36700000000001],
              [-75.86356, 39.527919999999995],
              [-75.56476999999992, 39.55963000000001],
              [-75.60103000000001, 39.493329999999986],
              [-75.51105000000001, 39.36552000000003],
            ],
          ],
          [
            [
              [-75.32340999999997, 39.55337999999999],
              [-75.41652000000005, 39.38706999999998],
              [-75.54434, 39.479980000000026],
              [-75.57129999999995, 39.626419999999996],
              [-75.42890999999997, 39.78343000000004],
              [-75.23776999999995, 39.66305999999999],
              [-75.32340999999997, 39.55337999999999],
            ],
          ],
          [
            [
              [-75.6797, 40.152180000000016],
              [-75.64337, 39.99864000000004],
              [-75.50617, 39.97035000000001],
              [-75.42724999999993, 39.80886999999997],
              [-75.61434999999997, 39.620000000000026],
              [-75.59907000000001, 39.556820000000045],
              [-76.07634999999999, 39.55254999999997],
              [-76.221, 39.474690000000024],
              [-76.28193999999999, 39.68860999999996],
              [-76.41455999999994, 39.72123000000005],
              [-75.99759, 40.05470000000004],
              [-76.01308, 40.20799999999997],
              [-75.6797, 40.152180000000016],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ILM" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-78.57236999999995, 33.878080000000026],
            [-78.65097999999995, 33.945010000000046],
            [-78.50946000000002, 34.21526000000003],
            [-78.72556000000003, 34.466740000000044],
            [-78.64748, 34.55685999999999],
            [-78.81785999999997, 34.81633999999997],
            [-78.44951000000003, 34.83926999999997],
            [-78.45433999999997, 35.150710000000004],
            [-78.29051999999996, 35.171009999999995],
            [-78.29657999999998, 35.299860000000024],
            [-77.72961999999998, 35.215620000000044],
            [-77.48437999999996, 35.44529],
            [-77.36718999999994, 35.37287999999998],
            [-77.19045999999994, 35.418940000000006],
            [-76.89554999999999, 35.25347999999998],
            [-76.92058000000003, 35.05584999999999],
            [-76.96185999999997, 34.97725999999996],
            [-76.65795, 34.93437000000003],
            [-76.69064000000003, 34.83245000000003],
            [-76.69489999999996, 34.71593000000003],
            [-77.11674, 34.68767000000001],
            [-77.65476000000001, 34.34277000000003],
            [-77.86628999999999, 34.15227999999998],
            [-78.01468, 33.917860000000026],
            [-78.57236999999995, 33.878080000000026],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "IND" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-86.53314, 40.707819999999984],
            [-86.32776999999996, 40.600840000000005],
            [-86.18524999999997, 40.67448000000002],
            [-86.01390999999998, 40.60056000000002],
            [-85.96828000000002, 40.42789000000003],
            [-85.577, 40.306129999999996],
            [-85.28291999999999, 40.07659000000005],
            [-85.27223000000004, 39.78796000000004],
            [-85.35838999999996, 39.61183999999997],
            [-85.26963999999995, 39.47919000000003],
            [-85.64935999999997, 39.40141999999999],
            [-85.67845000000003, 39.07305],
            [-85.77182000000002, 39.00620999999997],
            [-86.08863, 39.093800000000016],
            [-86.27528999999998, 38.76308000000001],
            [-86.45232000000001, 38.81170999999996],
            [-86.68327999999994, 38.729800000000026],
            [-86.89330999999999, 38.83172000000003],
            [-86.95284999999998, 38.973200000000034],
            [-87.24101000000002, 38.90788],
            [-87.24088, 39.12861000000002],
            [-87.52460999999994, 39.156700000000015],
            [-87.51872999999998, 39.28112999999999],
            [-87.24013999999997, 39.297240000000045],
            [-87.29099000000002, 39.60810999999999],
            [-87.40083999999996, 39.58178000000005],
            [-87.33293999999998, 39.777769999999975],
            [-87.16010999999997, 39.81773000000003],
            [-87.09215, 40.14226],
            [-87.09741999999994, 40.65659999999997],
            [-87.01596000000004, 40.68484999999997],
            [-86.76469, 40.649110000000015],
            [-86.53314, 40.707819999999984],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "INL" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-91.98882000000003, 48.25933999999998],
            [-92.21574000000001, 47.994089999999986],
            [-92.41987999999995, 47.94438999999996],
            [-92.60313999999997, 47.66871999999997],
            [-92.92912000000001, 47.70934000000002],
            [-93.24262999999999, 47.61345999999999],
            [-93.32935999999992, 47.766230000000036],
            [-93.60142999999997, 47.78840000000004],
            [-93.67339000000004, 47.8974],
            [-93.91941999999997, 47.94745000000002],
            [-94.22058999999996, 48.201900000000016],
            [-94.38511000000003, 48.14042],
            [-94.79492000000005, 48.12545999999997],
            [-94.93377000000004, 48.18202999999998],
            [-94.90538000000001, 48.366449999999965],
            [-95.21054999999996, 48.365909999999964],
            [-95.21209000000002, 48.539919999999974],
            [-95.34258, 48.54013000000003],
            [-95.49410999999995, 48.77390999999997],
            [-95.41964000000002, 48.99908000000001],
            [-95.15318999999994, 48.998869999999954],
            [-95.15338999999997, 49.38447000000003],
            [-94.81585999999996, 49.321180000000005],
            [-94.69118, 48.778919999999985],
            [-94.22417999999999, 48.64949000000002],
            [-93.84166000000005, 48.629229999999964],
            [-93.79311999999999, 48.51634000000002],
            [-93.46929999999998, 48.545520000000046],
            [-93.25490000000002, 48.642610000000005],
            [-92.95443999999995, 48.63144999999997],
            [-92.50719999999995, 48.44768999999997],
            [-92.36964000000003, 48.220440000000046],
            [-92.26250999999996, 48.35481000000001],
            [-92.05587999999997, 48.35903999999997],
            [-91.98882000000003, 48.25933999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "IPT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-76.66745, 41.95348],
            [-76.61035999999996, 41.61052999999998],
            [-76.30745999999999, 41.62695000000002],
            [-76.21990000000002, 41.54194000000001],
            [-76.28287000000003, 41.377259999999964],
            [-75.89213999999996, 41.412240000000004],
            [-76.00884999999997, 41.10076000000004],
            [-76.21541999999997, 41.00533000000003],
            [-76.38517999999996, 40.70662],
            [-77.01423999999994, 40.75525999999998],
            [-77.45073000000002, 40.63324000000001],
            [-77.35724000000002, 40.844310000000036],
            [-77.6483, 40.74600000000003],
            [-77.60339000000002, 40.949650000000034],
            [-77.87246999999999, 41.07088],
            [-78.04793000000001, 41.28167000000004],
            [-77.98919999999995, 41.474819999999994],
            [-77.76147000000003, 41.38241000000002],
            [-77.59952999999993, 41.54233000000004],
            [-77.44453000000004, 41.543370000000024],
            [-77.50217999999995, 41.75579000000002],
            [-77.26784999999998, 41.99967000000004],
            [-77.02171000000004, 42.000590000000045],
            [-76.77116999999998, 41.881630000000044],
            [-76.66745, 41.95348],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ISN" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-102.19587999999996, 48.99883000000002],
            [-102.26210000000003, 48.86540000000003],
            [-102.55985999999999, 48.76491000000004],
            [-102.44190000000003, 48.54636000000001],
            [-102.62231999999999, 48.54631000000004],
            [-102.46138999999998, 48.29841999999997],
            [-102.45843999999997, 48.123969999999964],
            [-102.15869000000004, 48.07300999999997],
            [-102.38565999999997, 47.84774],
            [-102.26070000000001, 47.78023000000004],
            [-102.26095000000001, 47.61690999999998],
            [-102.56421000000002, 47.516200000000005],
            [-102.92498, 47.67421],
            [-103.05338999999995, 47.67431000000001],
            [-103.10966, 47.53256999999999],
            [-103.42286, 47.59707000000004],
            [-103.61151999999997, 47.515429999999974],
            [-103.61977000000002, 47.37523000000001],
            [-104.42035999999997, 47.35465999999997],
            [-104.69591, 47.471240000000044],
            [-104.75642999999998, 47.35182],
            [-104.96025999999995, 47.25384000000003],
            [-105.1892, 47.46816000000002],
            [-105.36340999999994, 47.52944000000001],
            [-105.36296000000002, 47.79036999999997],
            [-105.02885999999995, 47.70345999999996],
            [-104.89454999999998, 47.97282000000002],
            [-105.00960999999997, 48.02724000000004],
            [-105.0831, 48.34576999999997],
            [-104.97337999999998, 48.56318000000001],
            [-105.03855000000003, 48.65031000000001],
            [-105.05780000000001, 48.99922999999999],
            [-102.19587999999996, 48.99883000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "JAN" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-90.13680999999994, 33.72159000000003],
            [-89.87582999999992, 33.643179999999965],
            [-89.87006999999994, 33.49302999999998],
            [-89.54221999999999, 33.285709999999995],
            [-89.41465999999994, 33.21205000000002],
            [-89.31906000000001, 32.982789999999966],
            [-89.31761, 32.576340000000044],
            [-89.43251999999993, 32.31701999999998],
            [-89.32268000000002, 32.223939999999985],
            [-89.33196000000001, 31.801049999999968],
            [-89.3991, 31.43422000000004],
            [-89.46844999999999, 31.24105000000003],
            [-89.65384000000003, 31.22401000000003],
            [-89.74225999999999, 31.003709999999966],
            [-89.92949999999999, 31.098759999999974],
            [-90.03178000000003, 31.233890000000024],
            [-90.69796, 31.396799999999995],
            [-90.88106000000002, 31.61053000000002],
            [-90.91375999999997, 31.752759999999995],
            [-91.33977000000004, 31.85029999999997],
            [-91.08851000000001, 32.00000000000002],
            [-91.16497999999996, 32.19563],
            [-91.03774999999996, 32.24220000000004],
            [-90.96686000000003, 32.436049999999994],
            [-91.07739000000001, 32.447590000000034],
            [-91.15090000000001, 32.620249999999984],
            [-91.09004999999999, 33.05698000000001],
            [-91.11809, 33.45296999999999],
            [-91.23085000000003, 33.56130999999997],
            [-91.21248999999997, 33.658840000000005],
            [-90.92587, 33.72153000000004],
            [-90.83333999999996, 33.63472999999998],
            [-90.45175999999995, 33.686059999999955],
            [-90.45155, 33.811209999999996],
            [-90.18289999999996, 33.80926999999997],
            [-90.13680999999994, 33.72159000000003],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "JAX" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-81.30771000000004, 29.966030000000014],
              [-81.52734000000001, 29.807469999999984],
              [-81.55396999999999, 29.968350000000036],
              [-81.66828999999993, 30.035919999999987],
              [-81.60811999999996, 30.13250000000002],
              [-81.66563999999997, 30.31569999999996],
              [-81.61191000000002, 30.319949999999977],
              [-81.62024000000002, 30.389879999999973],
              [-81.53226999999998, 30.355959999999975],
              [-81.39036000000002, 30.397310000000026],
              [-81.30771000000004, 29.966030000000014],
            ],
          ],
          [
            [
              [-81.5846, 31.40958000000004],
              [-81.38666, 31.275890000000032],
              [-81.50701000000001, 30.914369999999984],
              [-81.46403999999995, 30.39104000000003],
              [-81.63715000000002, 30.393839999999976],
              [-81.62679, 30.320920000000033],
              [-81.66859, 30.322850000000027],
              [-81.69897, 30.282090000000032],
              [-81.66071, 30.23126999999998],
              [-81.70921999999996, 30.04259999999998],
              [-81.59136999999998, 29.80567],
              [-81.81263999999999, 29.83630000000001],
              [-81.94669999999999, 29.68625999999998],
              [-81.92705999999998, 29.521339999999967],
              [-82.20742999999999, 29.427379999999996],
              [-82.32596999999998, 29.58673999999996],
              [-82.54621999999998, 29.472859999999994],
              [-82.65541999999996, 29.30939999999999],
              [-82.83308999999994, 29.335200000000043],
              [-83.08056999999994, 29.238259999999975],
              [-83.23006000000004, 29.438179999999996],
              [-83.09336999999996, 29.67481999999996],
              [-83.19886999999994, 29.823550000000047],
              [-83.07002000000003, 29.82447999999999],
              [-82.99870000000004, 30.005359999999996],
              [-83.22549999999993, 30.11318999999996],
              [-83.17149, 30.38534999999997],
              [-83.24608, 30.51266000000003],
              [-83.08123, 30.49125999999997],
              [-83.05402999999995, 30.619339999999966],
              [-82.94885999999997, 30.613280000000024],
              [-82.89859999999999, 30.824009999999983],
              [-82.75887, 30.73259000000003],
              [-82.76289, 30.948579999999996],
              [-82.96981000000002, 31.088019999999965],
              [-82.95365000000001, 31.18408999999999],
              [-82.67162999999996, 31.183790000000037],
              [-82.62899000000002, 31.363840000000025],
              [-82.78967999999998, 31.508339999999972],
              [-82.62741999999997, 31.666419999999988],
              [-82.39418999999998, 31.385139999999982],
              [-82.30245999999994, 31.586050000000025],
              [-82.04182, 31.384249999999973],
              [-81.85106000000002, 31.354030000000048],
              [-81.63909999999998, 31.487369999999963],
              [-81.5846, 31.40958000000004],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "JHW" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-77.15675999999993, 42.385960000000004],
            [-77.10028, 42.286450000000016],
            [-77.20933000000002, 42.05240000000003],
            [-77.02171000000004, 42.000590000000045],
            [-77.26784999999998, 41.99967000000004],
            [-77.50217999999995, 41.75579000000002],
            [-77.44453000000004, 41.543370000000024],
            [-77.59952999999993, 41.54233000000004],
            [-77.76147000000003, 41.38241000000002],
            [-77.98919999999995, 41.474819999999994],
            [-78.04793000000001, 41.28167000000004],
            [-78.09324999999998, 41.21703999999998],
            [-78.37742999999995, 41.25858999999998],
            [-78.54120999999998, 41.377630000000025],
            [-78.63320999999996, 41.28059000000003],
            [-78.92876000000001, 41.34866999999999],
            [-79.06349, 41.453200000000024],
            [-79.20887999999997, 41.308849999999964],
            [-79.25408999999999, 41.83818999999999],
            [-79.21959999999999, 41.98833000000003],
            [-79.32058999999995, 42.199320000000014],
            [-79.15056000000001, 42.248689999999996],
            [-78.88845000000003, 42.44212000000002],
            [-78.12195, 42.571739999999984],
            [-77.53049000000004, 42.44469000000004],
            [-77.34172999999996, 42.47173000000001],
            [-77.15675999999993, 42.385960000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "JKL" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-82.24025000000003, 37.568990000000014],
            [-82.15394999999995, 37.407569999999964],
            [-82.35166999999993, 37.265900000000045],
            [-82.92478999999997, 37.00996999999998],
            [-82.87805, 36.88994],
            [-83.0627, 36.91446000000002],
            [-83.27199000000002, 36.81489999999998],
            [-83.22585000000004, 36.729929999999996],
            [-83.52394000000001, 36.66612000000002],
            [-83.87759999999997, 36.687310000000025],
            [-84.07548999999997, 36.80611000000002],
            [-84.34206000000003, 36.83582999999996],
            [-84.35815999999997, 36.959449999999975],
            [-84.28477000000004, 37.31165],
            [-84.09033000000002, 37.56615999999998],
            [-84.08013999999994, 37.85300000000004],
            [-83.83363999999997, 38.01839999999998],
            [-83.90527999999995, 38.14194999999997],
            [-83.75837000000001, 38.337250000000004],
            [-83.63518000000005, 38.355410000000035],
            [-83.41192999999996, 38.39636000000003],
            [-83.26709999999997, 38.17843000000005],
            [-82.82633999999993, 37.96490999999999],
            [-82.64563999999999, 37.83007999999998],
            [-82.64090999999996, 37.71912999999997],
            [-82.24025000000003, 37.568990000000014],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "JMS" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-99.16766999999996, 48.19145000000002],
            [-98.92832999999997, 47.9972],
            [-98.67206999999996, 48.00024],
            [-98.66278000000003, 47.70310000000001],
            [-98.34808999999994, 47.701379999999986],
            [-97.98484000000002, 47.56318999999997],
            [-97.88270999999996, 47.18222],
            [-97.72697000000002, 47.06587000000004],
            [-97.73431, 46.83276999999996],
            [-97.53554999999994, 46.846600000000024],
            [-97.41661999999994, 46.723689999999955],
            [-97.74484999999999, 46.709740000000004],
            [-97.88815999999997, 46.470979999999955],
            [-97.84637000000002, 46.31135999999997],
            [-98.36959999999996, 46.262290000000036],
            [-98.61435999999996, 46.282810000000026],
            [-98.88818999999994, 46.10599999999997],
            [-99.29516, 46.08476000000001],
            [-99.45787000000003, 46.156069999999964],
            [-99.74070000000003, 46.108909999999966],
            [-99.89576999999996, 46.297760000000025],
            [-99.73579999999997, 46.28975000000003],
            [-99.64403, 46.456709999999994],
            [-99.43281, 46.49041],
            [-99.49688, 46.631510000000006],
            [-99.70259, 46.66130999999999],
            [-99.7392, 46.93518],
            [-99.59470999999999, 47.212019999999995],
            [-99.75626999999999, 47.36278],
            [-99.79815999999995, 47.55188999999999],
            [-99.66177999999995, 47.759879999999995],
            [-99.29730999999998, 47.846779999999974],
            [-99.40574999999997, 48.079340000000045],
            [-99.32975, 48.195070000000044],
            [-99.16766999999996, 48.19145000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "LAN" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-84.22938000000005, 43.51044000000001],
            [-84.16323, 43.35477],
            [-84.25483, 43.20832000000001],
            [-83.97646, 43.04433999999996],
            [-84.06442000000001, 42.90991000000001],
            [-83.99260999999998, 42.61715999999999],
            [-83.82663000000002, 42.592790000000036],
            [-83.81450999999996, 42.37146000000002],
            [-83.96153999999999, 42.21697000000003],
            [-84.68805999999998, 42.07058000000003],
            [-84.8252, 41.83970999999999],
            [-85.03207999999998, 41.75968],
            [-85.17093, 41.988909999999976],
            [-85.18948999999998, 42.07239999999998],
            [-85.13095999999999, 42.25396000000003],
            [-84.95358000000002, 42.43114999999999],
            [-85.07529000000002, 42.61686999999998],
            [-84.98781999999994, 42.79229000000004],
            [-84.91596000000004, 43.20640999999998],
            [-84.97502999999995, 43.405789999999996],
            [-84.91298000000003, 43.50310999999997],
            [-84.49719999999996, 43.63934],
            [-84.49045999999998, 43.528090000000034],
            [-84.22938000000005, 43.51044000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "LAS" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-113.65330999999998, 35.89944000000002],
            [-113.64496999999994, 35.71490999999999],
            [-113.82435000000001, 35.62187999999996],
            [-113.69874000000002, 35.54824999999998],
            [-113.77801, 35.26550999999997],
            [-113.51023999999995, 35.256370000000004],
            [-113.57326000000002, 35.42079000000004],
            [-113.33296000000001, 35.42031000000003],
            [-113.33315, 34.63640000000002],
            [-113.46443000000001, 34.73864000000003],
            [-113.84779000000002, 34.733720000000005],
            [-113.98857999999996, 34.963199999999965],
            [-114.44341999999996, 34.645129999999995],
            [-114.29253000000003, 34.41798],
            [-114.34790999999998, 34.33232999999997],
            [-114.82620999999996, 34.45616000000004],
            [-114.95027999999999, 34.25183],
            [-115.25671999999994, 34.172859999999964],
            [-115.29361999999996, 34.28214],
            [-115.52861, 34.22800999999999],
            [-115.70404, 34.28798000000003],
            [-115.68954999999995, 34.41695000000004],
            [-116.30030000000002, 34.56625999999997],
            [-116.06783000000001, 34.928480000000036],
            [-116.23309, 35.079740000000015],
            [-116.38421999999998, 35.53088999999997],
            [-116.69133999999998, 35.52207000000002],
            [-116.86951999999997, 35.63597999999998],
            [-116.90710999999995, 35.795379999999966],
            [-117.40306999999999, 35.795550000000006],
            [-117.44445000000003, 36.025949999999966],
            [-117.46929999999999, 36.22737000000002],
            [-117.6289, 36.494949999999974],
            [-117.49189999999996, 36.779600000000016],
            [-117.44106000000002, 37.17586999999999],
            [-117.16570000000002, 36.97078999999998],
            [-117.16568999999998, 37.68710000000003],
            [-116.97071999999999, 37.697640000000014],
            [-116.83511000000001, 37.522210000000015],
            [-116.20693000000001, 37.47582999999998],
            [-115.89456999999997, 37.661030000000025],
            [-115.89379000000001, 38.05062000000001],
            [-115.07055000000003, 38.050810000000006],
            [-114.88989000000002, 37.84330000000001],
            [-114.77803999999998, 37.84551],
            [-114.72593000000003, 37.65261000000004],
            [-114.79776999999997, 37.561949999999996],
            [-114.68954999999998, 37.268699999999995],
            [-114.84511000000003, 37.21718000000002],
            [-115.08579999999999, 37.00365000000002],
            [-115.04917000000003, 36.85330000000002],
            [-114.51952000000003, 36.84346000000004],
            [-114.36623999999996, 36.674149999999976],
            [-114.20768000000002, 36.35403999999997],
            [-114.22712000000001, 36.26019000000004],
            [-113.82566999999999, 36.18174000000005],
            [-113.65330999999998, 35.89944000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "LAX" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-118.59261999999994, 33.03453000000002],
              [-118.34853999999999, 32.82043000000003],
              [-118.49997999999994, 32.85149],
              [-118.59261999999994, 33.03453000000002],
            ],
          ],
          [
            [
              [-118.60591, 33.47853],
              [-118.37237999999996, 33.409789999999965],
              [-118.46472, 33.32578000000001],
              [-118.60591, 33.47853],
            ],
          ],
          [
            [
              [-116.30030000000002, 34.56625999999997],
              [-116.25581999999999, 34.294419999999974],
              [-116.58519999999996, 34.242409999999964],
              [-116.71840999999995, 34.03381999999996],
              [-116.92950000000003, 34.034090000000006],
              [-116.96079999999996, 33.86104999999996],
              [-117.10763999999999, 33.90651],
              [-117.30260999999999, 33.69249999999998],
              [-117.37245, 33.505050000000026],
              [-117.64532999999999, 33.44050000000002],
              [-118.12780999999995, 33.767839999999964],
              [-118.41151, 33.74110000000003],
              [-118.52732999999999, 34.03084999999999],
              [-118.80684000000001, 34.000149999999955],
              [-119.07346000000003, 34.09186000000001],
              [-118.86041999999998, 34.177169999999975],
              [-118.833, 34.358969999999985],
              [-118.68375999999999, 34.387699999999995],
              [-118.80447999999996, 34.63320999999996],
              [-118.73344999999999, 34.84882999999996],
              [-118.60497000000002, 34.81826999999997],
              [-117.63210999999995, 34.822239999999994],
              [-117.43891999999997, 34.987350000000006],
              [-117.42401, 35.14362000000001],
              [-117.53721, 35.232340000000036],
              [-117.39707000000003, 35.43342999999996],
              [-117.09985, 35.39035999999997],
              [-116.86951999999997, 35.63597999999998],
              [-116.69133999999998, 35.52207000000002],
              [-116.38421999999998, 35.53088999999997],
              [-116.23309, 35.079740000000015],
              [-116.06783000000001, 34.928480000000036],
              [-116.30030000000002, 34.56625999999997],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "LBB" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-100.16041999999995, 34.231239999999985],
            [-100.01026999999996, 34.241740000000036],
            [-99.87518999999998, 34.10953000000001],
            [-100.00057999999997, 33.99112999999997],
            [-99.99262000000003, 33.540499999999966],
            [-99.99094999999997, 33.39718999999998],
            [-100.33563999999998, 33.397520000000014],
            [-100.51757, 33.13576999999998],
            [-100.52663000000001, 32.96337999999998],
            [-100.78825999999998, 33.02009999999997],
            [-100.59463000000001, 33.12930999999998],
            [-100.65326000000002, 33.199079999999974],
            [-101.03876, 33.24904000000001],
            [-101.03877999999996, 32.97018000000004],
            [-101.17411999999997, 32.76571999999999],
            [-101.31663999999996, 32.72618999999998],
            [-101.48296999999994, 32.61047000000001],
            [-101.68902000000001, 32.59762999999997],
            [-101.69067000000001, 32.81888999999997],
            [-101.86804999999998, 32.96093999999998],
            [-102.12641, 32.95944000000003],
            [-102.20562000000001, 32.79769000000003],
            [-102.20258999999994, 32.52316999999997],
            [-102.46965999999999, 32.523079999999986],
            [-102.36468000000002, 32.79611999999997],
            [-102.66714, 32.895719999999955],
            [-102.66610999999996, 32.95874999999997],
            [-103.06464999999999, 32.95909000000003],
            [-103.04991999999999, 33.70851000000003],
            [-103.21858, 33.78823999999997],
            [-103.04924999999997, 33.90724],
            [-103.15712999999998, 34.03176999999999],
            [-103.40855, 34.01094000000002],
            [-103.57204999999995, 34.23490999999998],
            [-103.44206999999996, 34.31081999999996],
            [-103.45718999999998, 34.585210000000004],
            [-103.36617, 34.70206000000004],
            [-103.10836999999994, 34.72692999999997],
            [-102.93668999999997, 34.46584000000001],
            [-102.44417, 34.32019999999997],
            [-102.29222999999998, 34.31312000000001],
            [-102.26761999999997, 34.51004999999999],
            [-101.99007999999998, 34.40111000000003],
            [-101.47879999999996, 34.41812000000003],
            [-101.47159, 34.312319999999985],
            [-101.16492999999997, 34.312279999999966],
            [-101.10611999999998, 34.451790000000045],
            [-100.94546000000001, 34.46129999999998],
            [-100.94600000000001, 34.313959999999966],
            [-100.80792999999998, 34.31321],
            [-100.80471999999995, 34.03907999999997],
            [-100.64354999999998, 33.95789000000002],
            [-100.51796999999996, 34.01785999999997],
            [-100.51745999999996, 34.285389999999964],
            [-100.36948999999996, 34.162520000000015],
            [-100.16041999999995, 34.231239999999985],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "LBF" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-99.68689000000003, 42.08620999999998],
            [-99.68682000000001, 41.740210000000026],
            [-99.45420999999997, 41.49960000000003],
            [-99.5531, 41.30693],
            [-99.54515999999994, 41.13813000000003],
            [-99.42607000000002, 41.04653000000002],
            [-99.45404999999997, 40.86761],
            [-99.67147999999997, 40.674680000000045],
            [-99.75486999999997, 40.423619999999964],
            [-99.50202999999996, 40.35111000000002],
            [-99.52035999999994, 40.18857000000001],
            [-99.63023999999997, 40.237139999999975],
            [-99.76116999999996, 40.00165999999997],
            [-99.62724, 39.88227000000001],
            [-99.6281, 39.726920000000014],
            [-99.81609999999999, 39.70438000000004],
            [-100.17941999999994, 39.83467999999996],
            [-100.17803999999998, 40.001610000000014],
            [-100.85862000000002, 40.002109999999995],
            [-100.85219999999995, 40.087269999999975],
            [-101.09802999999994, 40.26431999999999],
            [-101.32521000000003, 40.21480000000003],
            [-101.32334999999996, 40.35054000000002],
            [-102.05170000000003, 40.34912000000003],
            [-102.05147, 40.653749999999974],
            [-102.18587999999998, 40.60256000000004],
            [-102.23812999999996, 40.74895000000004],
            [-102.43918999999998, 40.74920000000003],
            [-102.42517000000001, 41.00238999999996],
            [-102.27029, 41.00242000000004],
            [-102.13408999999997, 41.270870000000045],
            [-102.28886999999996, 41.69540999999998],
            [-102.19967999999996, 41.83398],
            [-102.03498000000003, 41.69916000000002],
            [-101.75848000000002, 41.869550000000004],
            [-101.88770000000001, 42.094400000000036],
            [-101.79709000000003, 42.33152000000001],
            [-101.94184999999999, 42.41606000000004],
            [-101.63331000000001, 42.447340000000004],
            [-101.37751999999999, 42.29877000000001],
            [-101.60690000000002, 42.02539999999998],
            [-101.66996999999996, 41.74262000000003],
            [-100.84272999999996, 41.74043000000002],
            [-100.73064999999998, 41.911770000000004],
            [-100.70903000000001, 42.18096000000004],
            [-100.46962999999994, 42.28158999999997],
            [-100.29670999999996, 42.184790000000035],
            [-100.26665999999999, 41.95552999999998],
            [-100.02273999999994, 42.085419999999985],
            [-99.68689000000003, 42.08620999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "LCH" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-93.40043, 30.096240000000034],
              [-93.32750000000004, 30.080880000000036],
              [-93.34522999999993, 29.759600000000034],
              [-93.83380000000002, 29.69371],
              [-93.72574000000003, 30.049379999999985],
              [-93.40043, 30.096240000000034],
            ],
          ],
          [
            [
              [-93.40043, 30.096240000000034],
              [-93.72187999999997, 30.075219999999973],
              [-93.71349999999998, 30.582340000000034],
              [-93.87343999999999, 30.711599999999965],
              [-93.91086999999996, 31.15814999999999],
              [-93.37621999999999, 31.24590000000004],
              [-93.30478999999994, 31.364079999999987],
              [-92.99658, 31.36014999999998],
              [-92.81888999999998, 31.226999999999975],
              [-92.46188999999998, 31.188799999999965],
              [-92.41237999999998, 30.982060000000004],
              [-92.52591999999996, 30.878489999999996],
              [-92.34488000000005, 30.561549999999997],
              [-92.16378999999998, 30.475880000000004],
              [-92.24821999999995, 30.085549999999987],
              [-92.07586999999998, 30.02111000000002],
              [-92.06277000000003, 29.77037000000004],
              [-92.21058999999994, 29.74461000000001],
              [-92.10818, 29.612839999999967],
              [-92.30449000000002, 29.532820000000008],
              [-92.64617999999996, 29.585710000000002],
              [-93.23200999999995, 29.77813999999998],
              [-93.33091000000002, 30.152559999999966],
              [-93.40043, 30.096240000000034],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "LEX" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-83.64196999999999, 38.525140000000036],
            [-83.63518000000005, 38.355410000000035],
            [-83.75837000000001, 38.337250000000004],
            [-83.90527999999995, 38.14194999999997],
            [-83.83363999999997, 38.01839999999998],
            [-84.08013999999994, 37.85300000000004],
            [-84.09033000000002, 37.56615999999998],
            [-84.28477000000004, 37.31165],
            [-84.35815999999997, 36.959449999999975],
            [-84.57383999999996, 36.84466000000003],
            [-84.67904000000001, 36.98075999999996],
            [-84.86677000000003, 36.96701000000004],
            [-85.05680999999996, 37.25694999999999],
            [-85.17994000000002, 37.31103000000004],
            [-85.25490000000002, 37.50347000000004],
            [-85.37985000000003, 37.523899999999955],
            [-85.33576000000002, 37.621470000000016],
            [-85.04255999999998, 37.647320000000036],
            [-85.22299999999998, 37.82766999999997],
            [-85.16777000000002, 37.97173000000002],
            [-85.28280000000001, 38.02602000000003],
            [-85.03693999999993, 38.19064],
            [-85.00774999999996, 38.550299999999986],
            [-84.03313000000003, 38.582789999999974],
            [-83.64196999999999, 38.525140000000036],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "LGA" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-74.16579000000002, 39.86909],
              [-74.32837999999998, 39.93080999999998],
              [-74.26214999999996, 40.05517000000002],
              [-74.05478999999997, 40.35894000000003],
              [-73.97190000000003, 40.362239999999964],
              [-74.03083999999993, 40.10176000000003],
              [-74.16579000000002, 39.86909],
            ],
          ],
          [
            [
              [-73.77579999999998, 40.627570000000006],
              [-73.65197, 40.808019999999956],
              [-73.64391999999998, 40.82365],
              [-73.59341, 40.857140000000044],
              [-73.48349999999996, 40.87465999999996],
              [-73.46407000000002, 40.85859999999996],
              [-73.13596999999999, 40.717309999999955],
              [-73.77579999999998, 40.627570000000006],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "LIT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-91.28713999999997, 36.49738999999998],
            [-91.23306999999994, 36.37595999999998],
            [-91.28887999999995, 36.11773000000004],
            [-91.16219999999998, 36.01030000000004],
            [-91.22141000000002, 35.814799999999984],
            [-91.39301000000003, 35.63188000000003],
            [-91.34876999999994, 35.44501000000001],
            [-91.13618999999997, 35.444980000000015],
            [-91.03958000000003, 35.354280000000045],
            [-91.02100999999999, 34.971740000000025],
            [-91.14465999999999, 34.814260000000004],
            [-91.05016000000003, 34.70401],
            [-91.08000999999999, 34.142179999999996],
            [-90.87134000000003, 34.08658999999997],
            [-91.09, 33.99254999999996],
            [-90.92587, 33.72153000000004],
            [-91.21248999999997, 33.658840000000005],
            [-91.23085000000003, 33.56130999999997],
            [-91.45340000000002, 33.56352000000004],
            [-91.45198999999997, 33.68755999999999],
            [-91.67773, 33.43101999999999],
            [-91.90745999999996, 33.45318999999999],
            [-91.87820000000005, 33.79159000000004],
            [-92.13657999999998, 33.45372999999999],
            [-92.16888999999998, 33.615969999999955],
            [-92.47878999999995, 33.71583999999998],
            [-92.66505999999998, 33.66001],
            [-92.92889, 33.82250000000003],
            [-93.10402999999997, 33.77696999999999],
            [-93.37341, 33.95707000000003],
            [-93.63610999999995, 33.973640000000046],
            [-93.44312, 34.20858000000004],
            [-93.64199000000002, 34.25032000000003],
            [-93.40823000000003, 34.33939999999999],
            [-93.39439999999999, 34.74336999999998],
            [-93.71002999999993, 34.74576000000002],
            [-93.34834999999998, 34.93406999999999],
            [-93.35695000000004, 35.054560000000016],
            [-93.16925, 35.069070000000025],
            [-93.29456999999996, 35.21266],
            [-93.22981000000001, 35.31355999999998],
            [-93.16445999999996, 35.72880999999998],
            [-92.95133999999996, 35.72455999999997],
            [-92.94017, 36.00327999999999],
            [-92.69566, 36.12052999999999],
            [-92.41153, 36.06269999999999],
            [-92.36831999999995, 36.20707999999996],
            [-92.09808000000001, 36.25978000000005],
            [-91.73902999999996, 36.49931000000004],
            [-91.67210999999998, 36.34082999999996],
            [-91.48749999999998, 36.36496000000004],
            [-91.28713999999997, 36.49738999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "LND" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-108.57363999999995, 44.445829999999994],
              [-108.55089000000001, 44.07933000000001],
              [-108.42959999999997, 43.90334000000004],
              [-108.17493999999999, 43.818969999999965],
              [-107.9565, 43.818629999999985],
              [-107.95647999999994, 43.73335999999996],
              [-107.71596999999996, 43.733250000000005],
              [-107.59517999999998, 43.501320000000014],
              [-107.68783, 43.366059999999955],
              [-107.95816000000003, 43.23705000000002],
              [-108.02086999999995, 43.090980000000016],
              [-107.90254999999996, 42.78950000000003],
              [-107.74718, 42.68894999999996],
              [-107.54348999999998, 42.761050000000004],
              [-107.50971999999996, 41.65735000000001],
              [-107.92975999999997, 41.65952999999999],
              [-107.91774000000002, 41.07310000000001],
              [-107.81906999999998, 41.279670000000024],
              [-107.70975999999996, 41.30261999999999],
              [-107.46058, 41.154910000000015],
              [-107.37331999999998, 41.00301000000001],
              [-107.54056000000001, 41.00225000000001],
              [-109.04998000000002, 41.000659999999996],
              [-109.59426000000002, 40.99833999999997],
              [-110.04866999999997, 40.99722000000003],
              [-110.04809000000003, 41.57738000000001],
              [-110.61849999999994, 41.57912],
              [-110.82854000000002, 41.713429999999974],
              [-110.81110999999999, 42.10422000000004],
              [-110.91349999999997, 42.40243000000001],
              [-110.59155999999999, 42.43382000000001],
              [-110.57849000000002, 43.29168000000001],
              [-110.34374999999996, 43.29114],
              [-110.31258000000003, 43.451380000000036],
              [-110.68086999999997, 43.60648000000004],
              [-110.62682000000001, 43.707570000000025],
              [-110.20673999999997, 43.76262999999997],
              [-110.22351999999995, 43.98109999999997],
              [-110.05353000000001, 44.00773000000004],
              [-109.78758, 43.80167000000003],
              [-109.51286000000002, 43.939549999999976],
              [-109.43195999999999, 44.16935000000004],
              [-109.22009000000003, 44.307080000000006],
              [-108.97016, 44.25778000000004],
              [-108.85206000000002, 44.469880000000025],
              [-108.57363999999995, 44.445829999999994],
            ],
          ],
          [
            [
              [-110.05356999999995, 44.032599999999974],
              [-110.24686999999997, 44.00840999999999],
              [-110.54743999999998, 43.831130000000044],
              [-110.69998, 43.68045],
              [-110.73884, 43.88369],
              [-110.83927, 43.839409999999994],
              [-111.04691, 43.92934999999997],
              [-111.04901999999996, 44.47540999999999],
              [-111.05620000000002, 44.66657000000004],
              [-110.66746999999997, 44.66662000000001],
              [-110.66743000000002, 44.58324999999998],
              [-110.3774, 44.583210000000044],
              [-110.14460999999999, 44.283089999999966],
              [-110.05356999999995, 44.032599999999974],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "LNK" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-96.80922999999999, 41.597059999999956],
            [-96.70703, 41.57409999999996],
            [-96.65924000000001, 41.35068000000003],
            [-96.45221999999995, 41.31356000000003],
            [-96.31911, 41.04429999999998],
            [-96.05493999999999, 40.832710000000006],
            [-95.98575999999997, 40.58989999999997],
            [-95.85130000000004, 40.42991000000002],
            [-95.55532000000002, 40.264309999999966],
            [-95.55292000000003, 40.26190000000004],
            [-95.64505000000003, 40.0951],
            [-95.80347, 40.00535000000002],
            [-96.26050000000004, 40.00086999999998],
            [-96.35500999999994, 39.896150000000034],
            [-96.65357, 40.001309999999975],
            [-97.01834999999994, 40.00153999999999],
            [-97.01588999999998, 40.16077000000004],
            [-97.23685000000003, 40.32059000000005],
            [-97.63437000000005, 40.37931999999999],
            [-97.47449999999998, 40.44484999999999],
            [-97.70965999999999, 40.690969999999986],
            [-97.37566999999996, 40.74938],
            [-97.38644999999997, 41.11855000000001],
            [-97.47533999999993, 41.35017000000002],
            [-96.94793000000001, 41.44474999999996],
            [-96.80922999999999, 41.597059999999956],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "LRD" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-98.33427, 28.057860000000005],
            [-98.34356999999997, 27.93159000000002],
            [-98.50866999999995, 27.954560000000043],
            [-98.80185000000003, 27.719249999999988],
            [-98.79839, 27.353890000000007],
            [-98.62856, 27.357690000000005],
            [-98.50957, 27.57563999999996],
            [-98.36699000000002, 27.60575000000002],
            [-98.23321000000001, 27.50586999999997],
            [-98.23219, 27.26237000000004],
            [-98.49289000000002, 27.23439],
            [-98.41785, 27.055279999999986],
            [-98.42242000000002, 26.78346999999998],
            [-98.32056999999995, 26.78301999999996],
            [-98.58642999999996, 26.257820000000002],
            [-98.80505999999997, 26.367969999999985],
            [-99.08123000000003, 26.39655000000002],
            [-99.20889000000001, 26.72455999999998],
            [-99.44580000000002, 27.021880000000024],
            [-99.47871000000002, 27.47915],
            [-99.59583000000002, 27.639659999999992],
            [-99.87619999999995, 27.797430000000027],
            [-99.93146000000003, 27.980819999999966],
            [-100.21229000000001, 28.19688000000004],
            [-99.82786999999996, 28.200330000000033],
            [-99.88661999999997, 28.39926000000003],
            [-99.62832, 28.642970000000016],
            [-98.96699999999997, 28.64592000000003],
            [-98.90583999999997, 28.465960000000027],
            [-98.80074999999997, 28.46077000000004],
            [-98.80333, 28.057460000000038],
            [-98.33427, 28.057860000000005],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "LWS" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-114.56497999999996, 45.557650000000024],
            [-114.79329000000001, 45.43650000000001],
            [-114.59332000000003, 45.29762000000001],
            [-114.69415, 45.19716000000002],
            [-115.97576999999995, 45.19526999999996],
            [-116.14437, 45.107639999999975],
            [-116.34268000000003, 45.26791000000001],
            [-116.48412, 45.15991000000001],
            [-116.23487000000003, 44.782559999999975],
            [-116.26248000000001, 44.65779000000003],
            [-116.52917999999998, 44.607769999999995],
            [-116.62551000000002, 44.838389999999954],
            [-116.91002999999996, 44.82797999999998],
            [-116.93311000000003, 45.07947999999997],
            [-117.26395000000002, 45.08115000000003],
            [-117.47704000000003, 45.16524000000003],
            [-117.66342, 45.36575000000002],
            [-117.78742000000001, 45.68950999999996],
            [-117.74736999999996, 45.86101999999998],
            [-117.97768999999997, 45.860549999999996],
            [-117.99149999999997, 46.20769999999998],
            [-118.11665000000002, 46.26231],
            [-118.11991, 46.41089000000002],
            [-118.24169000000002, 46.38797999999999],
            [-118.24939999999997, 46.73372000000002],
            [-118.48804999999997, 46.73677999999998],
            [-118.46383, 46.863900000000044],
            [-118.20368, 46.89848000000003],
            [-118.10060999999997, 46.77274000000002],
            [-117.90382000000002, 46.91774999999998],
            [-117.72357999999996, 46.82155999999997],
            [-117.55280999999997, 46.869460000000004],
            [-117.46434999999997, 47.02469000000002],
            [-117.12561000000002, 47.07163000000003],
            [-117.06860000000003, 47.00570999999999],
            [-116.47102999999998, 47.036730000000034],
            [-116.39696999999995, 47.228600000000036],
            [-116.09262, 47.21777999999998],
            [-115.74255, 47.42360000000003],
            [-115.31968000000003, 47.25650000000003],
            [-115.04901999999996, 46.97022999999997],
            [-114.92654000000003, 46.9195],
            [-114.76675999999996, 46.69692000000003],
            [-114.60516000000003, 46.63564999999998],
            [-114.32077, 46.64774999999998],
            [-114.50641999999996, 46.030580000000036],
            [-114.38878000000003, 45.88228],
            [-114.56284000000001, 45.7796],
            [-114.56497999999996, 45.557650000000024],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "LYH" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-78.40301999999994, 38.1895],
            [-78.25859999999997, 38.04424999999999],
            [-78.35456999999997, 37.98731000000001],
            [-78.28883999999994, 37.54932000000001],
            [-78.40565999999998, 37.47392999999998],
            [-78.20759999999993, 37.426060000000035],
            [-78.22471999999999, 37.08982],
            [-78.09715, 37.02231000000004],
            [-78.27616, 36.819920000000025],
            [-78.53220999999996, 36.67324],
            [-78.77829999999994, 36.70546999999996],
            [-78.8313, 36.61551000000002],
            [-79.19931999999997, 36.621359999999996],
            [-79.21279999999993, 36.565780000000004],
            [-79.61561999999998, 36.72697000000004],
            [-79.56794999999997, 37.237689999999986],
            [-79.66707000000002, 37.30504000000003],
            [-79.49861999999996, 37.532820000000015],
            [-79.68367000000003, 37.66160000000002],
            [-79.65074999999999, 37.87156999999998],
            [-79.48242000000002, 38.08607999999997],
            [-79.26417999999995, 38.22874],
            [-78.89620999999994, 38.22833],
            [-78.71827000000002, 38.28225999999998],
            [-78.57618, 38.32855999999997],
            [-78.40301999999994, 38.1895],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MAF" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-101.31663999999996, 32.72618999999998],
            [-101.17452999999998, 32.584459999999986],
            [-101.01910000000002, 32.28419000000002],
            [-101.18157, 32.19931000000002],
            [-101.18358999999998, 32.08691000000003],
            [-101.26421000000002, 32.08713000000002],
            [-101.26681000000004, 31.65094000000001],
            [-101.53234999999995, 31.60642000000004],
            [-101.77569999999999, 31.651350000000004],
            [-101.77594999999998, 31.079750000000043],
            [-102.39018000000003, 31.085280000000008],
            [-101.88356999999998, 30.92576000000004],
            [-101.76874000000001, 30.653190000000034],
            [-102.13782000000003, 30.656109999999963],
            [-102.34286999999996, 30.598710000000022],
            [-102.34299999999998, 30.28405999999996],
            [-102.56682999999998, 30.283209999999976],
            [-102.56688999999997, 30.05269999999997],
            [-103.43985999999997, 30.665800000000047],
            [-103.80088999999998, 30.412480000000023],
            [-104.30328999999995, 30.494000000000014],
            [-104.20260000000002, 30.548760000000012],
            [-104.15218999999996, 30.762130000000003],
            [-103.97228000000001, 31.01960000000003],
            [-104.10220999999996, 31.10572999999998],
            [-104.02425999999994, 32.000199999999964],
            [-103.06450999999996, 32.000419999999956],
            [-103.06464999999999, 32.95909000000003],
            [-102.66610999999996, 32.95874999999997],
            [-102.66714, 32.895719999999955],
            [-102.36468000000002, 32.79611999999997],
            [-102.46965999999999, 32.523079999999986],
            [-102.20258999999994, 32.52316999999997],
            [-102.20562000000001, 32.79769000000003],
            [-102.12641, 32.95944000000003],
            [-101.86804999999998, 32.96093999999998],
            [-101.69067000000001, 32.81888999999997],
            [-101.68902000000001, 32.59762999999997],
            [-101.48296999999994, 32.61047000000001],
            [-101.31663999999996, 32.72618999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MBX" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-99.24329999999996, 48.999680000000005],
            [-99.08116000000001, 48.87015999999997],
            [-99.06998999999995, 48.732769999999974],
            [-99.23209999999999, 48.64785000000004],
            [-99.03188000000002, 48.56603000000001],
            [-98.99282, 48.39922000000003],
            [-99.16766999999996, 48.19145000000002],
            [-99.32975, 48.195070000000044],
            [-99.40574999999997, 48.079340000000045],
            [-99.29730999999998, 47.846779999999974],
            [-99.66177999999995, 47.759879999999995],
            [-99.79815999999995, 47.55188999999999],
            [-100.29125999999997, 47.71777999999997],
            [-100.58137000000004, 47.66026999999999],
            [-100.68367999999998, 47.32767999999998],
            [-101.01847999999997, 47.48818000000003],
            [-101.31605, 47.33251999999996],
            [-101.42760999999994, 47.56182000000004],
            [-101.70964999999995, 47.537800000000004],
            [-101.83313999999996, 47.49461000000003],
            [-102.26095000000001, 47.61690999999998],
            [-102.26070000000001, 47.78023000000004],
            [-102.38565999999997, 47.84774],
            [-102.15869000000004, 48.07300999999997],
            [-102.45843999999997, 48.123969999999964],
            [-102.46138999999998, 48.29841999999997],
            [-102.62231999999999, 48.54631000000004],
            [-102.44190000000003, 48.54636000000001],
            [-102.55985999999999, 48.76491000000004],
            [-102.26210000000003, 48.86540000000003],
            [-102.19587999999996, 48.99883000000002],
            [-99.24329999999996, 48.999680000000005],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MCI" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-92.92387999999997, 40.061969999999995],
            [-92.99776999999997, 39.93143000000003],
            [-93.29785000000004, 39.94692999999997],
            [-93.40827999999999, 39.77741000000003],
            [-93.19807, 39.77833000000003],
            [-93.28769999999997, 39.682580000000016],
            [-93.21921999999998, 39.33336],
            [-93.48424999999997, 39.17451999999999],
            [-93.35192999999998, 39.07617999999999],
            [-93.66571999999994, 38.81548999999999],
            [-93.59988000000004, 38.558510000000005],
            [-93.70685, 38.488300000000024],
            [-94.07080000000002, 38.321300000000036],
            [-94.14326, 38.15683000000004],
            [-94.50217999999995, 38.193190000000044],
            [-94.48444000000003, 37.99907999999998],
            [-94.61432999999997, 37.97253999999998],
            [-94.61290999999997, 38.315530000000024],
            [-94.91818, 38.294769999999986],
            [-94.89607000000001, 38.52551000000001],
            [-95.04696999999996, 38.57921999999999],
            [-94.94570999999996, 38.796570000000045],
            [-95.01915000000002, 38.961770000000044],
            [-95.18745000000001, 39.05897999999998],
            [-95.17970999999997, 39.397260000000045],
            [-95.30059999999997, 39.46306000000001],
            [-95.36839999999995, 39.99996],
            [-95.49204999999995, 40.02942999999996],
            [-95.55292000000003, 40.26190000000004],
            [-95.55532000000002, 40.264309999999966],
            [-95.18061999999995, 40.261730000000014],
            [-95.17846000000003, 40.348680000000044],
            [-94.59516000000002, 40.57104999999996],
            [-94.25412999999998, 40.57177999999996],
            [-94.15781999999999, 40.42712000000001],
            [-93.89799, 40.26445],
            [-93.76351, 40.252529999999965],
            [-93.75119000000001, 40.43969],
            [-93.54593, 40.265090000000015],
            [-93.48326999999998, 40.44237999999999],
            [-93.36699999999996, 40.43301000000001],
            [-93.36171999999999, 39.99703000000005],
            [-93.26389, 40.08720000000005],
            [-92.92387999999997, 40.061969999999995],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MCN" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-84.19916999999998, 32.12092000000001],
            [-84.43021000000005, 32.166310000000024],
            [-84.39127999999994, 32.382350000000045],
            [-84.25462000000005, 32.37202999999997],
            [-84.40829999999997, 32.58413999999998],
            [-84.33787000000001, 32.72066000000002],
            [-84.50599000000003, 32.88143999999997],
            [-84.34536999999997, 33.04105000000001],
            [-83.95318, 33.26409999999997],
            [-83.83325000000002, 33.39897],
            [-83.54101, 33.40779999999998],
            [-83.54586999999995, 33.171980000000005],
            [-83.27402999999995, 33.19976000000001],
            [-82.83078999999998, 33.028749999999974],
            [-82.72699999999998, 33.07482000000003],
            [-82.64882999999998, 32.826489999999964],
            [-82.54874999999998, 32.79278000000002],
            [-82.59272000000001, 32.57228999999997],
            [-82.35011, 32.41357000000002],
            [-82.47633000000002, 32.28267999999996],
            [-82.43107999999995, 31.965999999999976],
            [-82.52140000000003, 31.67252000000004],
            [-82.62738999999996, 31.672640000000023],
            [-82.86279999999996, 31.782830000000033],
            [-83.18316999999999, 31.851979999999973],
            [-83.57135999999994, 31.853369999999963],
            [-83.60991999999999, 32.02791000000004],
            [-83.89958999999999, 32.030349999999956],
            [-84.02794000000003, 32.14845000000003],
            [-84.19916999999998, 32.12092000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MCO" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-80.73787000000004, 28.791360000000036],
              [-80.57604999999992, 28.586449999999967],
              [-80.71889999999996, 28.406480000000027],
              [-80.70534000000004, 28.585590000000042],
              [-80.80413999999999, 28.65064000000003],
              [-80.73787000000004, 28.791360000000036],
            ],
          ],
          [
            [
              [-80.85051999999993, 28.791200000000032],
              [-80.74578999999997, 28.398680000000002],
              [-80.38307, 27.667299999999965],
              [-80.72323000000003, 27.701889999999977],
              [-80.88118000000003, 27.82229999999996],
              [-81.02358000000004, 27.73368999999998],
              [-81.20818, 27.82096999999996],
              [-81.13129999999995, 27.659919999999964],
              [-81.20527999999993, 27.489930000000033],
              [-81.12156999999993, 27.38981000000002],
              [-81.16819999999996, 27.12162000000004],
              [-81.34481, 27.20801000000001],
              [-81.56267999999997, 27.128170000000022],
              [-81.56317999999996, 27.64661999999997],
              [-81.68942999999999, 27.901199999999974],
              [-81.82716000000005, 27.947099999999995],
              [-81.83723000000003, 28.138060000000024],
              [-81.95777999999996, 28.30889],
              [-81.95428000000001, 28.58511000000003],
              [-82.27392999999998, 28.65437000000001],
              [-82.16927999999996, 28.792319999999975],
              [-82.27993000000001, 29.041120000000024],
              [-81.85214000000002, 29.000520000000034],
              [-81.75253999999995, 29.10675000000004],
              [-81.66095999999999, 28.956509999999984],
              [-81.35401999999996, 28.931370000000005],
              [-81.35828999999995, 28.84824000000003],
              [-80.85051999999993, 28.791200000000032],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MEI" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-87.99651, 33.34384000000003],
            [-88.03434000000004, 33.081370000000014],
            [-87.78432000000004, 32.894790000000015],
            [-87.42111999999997, 32.87456999999998],
            [-87.66020999999998, 32.50967000000004],
            [-87.52441999999994, 32.48185000000001],
            [-87.52195999999998, 32.13325999999998],
            [-87.41129999999998, 32.08355000000002],
            [-87.62003999999996, 31.82723999999996],
            [-87.50073000000003, 31.82920999999998],
            [-87.56635999999997, 31.66444999999997],
            [-87.82774999999998, 31.56164999999999],
            [-87.90391000000002, 31.74774000000004],
            [-88.01220000000004, 31.759849999999982],
            [-88.15868000000003, 31.58418999999996],
            [-88.76905999999994, 31.441370000000017],
            [-88.86438000000001, 31.57414000000002],
            [-89.04134999999997, 31.43364000000001],
            [-89.14544000000001, 31.219369999999984],
            [-89.29566999999994, 31.434199999999983],
            [-89.3991, 31.43422000000004],
            [-89.33196000000001, 31.801049999999968],
            [-89.32268000000002, 32.223939999999985],
            [-89.43251999999993, 32.31701999999998],
            [-89.31761, 32.576340000000044],
            [-89.31906000000001, 32.982789999999966],
            [-89.41465999999994, 33.21205000000002],
            [-89.54221999999999, 33.285709999999995],
            [-89.36474999999996, 33.47075999999997],
            [-89.18912000000003, 33.197559999999974],
            [-88.87551999999997, 33.28629000000002],
            [-88.27003999999994, 33.280259999999984],
            [-87.99651, 33.34384000000003],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MEM" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-89.71317000000005, 36.026950000000014],
            [-89.76811999999995, 35.86071000000003],
            [-89.66131000000001, 35.79264000000001],
            [-89.52672999999999, 35.90071000000003],
            [-89.41139999999996, 35.75185000000002],
            [-89.47028999999998, 35.53065000000001],
            [-89.27286999999995, 35.53240999999997],
            [-89.18715, 35.31132000000001],
            [-89.27933999999999, 35.10241],
            [-89.07247000000001, 34.923850000000016],
            [-89.29918999999995, 34.83517000000002],
            [-89.40731999999997, 34.522049999999986],
            [-89.53538, 34.55487000000001],
            [-89.72112999999999, 34.458699999999965],
            [-89.81404999999998, 34.026319999999984],
            [-90.07032000000001, 34.00093000000001],
            [-90.13680999999994, 33.72159000000003],
            [-90.18289999999996, 33.80926999999997],
            [-90.45155, 33.811209999999996],
            [-90.45175999999995, 33.686059999999955],
            [-90.83333999999996, 33.63472999999998],
            [-90.92587, 33.72153000000004],
            [-91.09, 33.99254999999996],
            [-90.87134000000003, 34.08658999999997],
            [-91.08000999999999, 34.142179999999996],
            [-91.05016000000003, 34.70401],
            [-91.14465999999999, 34.814260000000004],
            [-91.02100999999999, 34.971740000000025],
            [-91.03958000000003, 35.354280000000045],
            [-91.13618999999997, 35.444980000000015],
            [-91.34876999999994, 35.44501000000001],
            [-91.39301000000003, 35.63188000000003],
            [-91.22141000000002, 35.814799999999984],
            [-91.16219999999998, 36.01030000000004],
            [-91.28887999999995, 36.11773000000004],
            [-91.23306999999994, 36.37595999999998],
            [-91.05227, 36.15284],
            [-90.85355999999999, 36.19998999999997],
            [-90.78522000000001, 36.35358000000001],
            [-90.62724, 36.24375999999997],
            [-90.31959999999998, 36.258999999999986],
            [-90.03559999999999, 36.14927999999996],
            [-89.81374, 36.18258],
            [-89.71317000000005, 36.026950000000014],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MFD" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-82.62256000000002, 41.42305000000003],
            [-82.50297999999998, 41.28515000000003],
            [-82.32462000000001, 41.329759999999986],
            [-82.34071, 41.14471000000001],
            [-81.97548999999998, 41.01552000000001],
            [-82.13908999999992, 40.849919999999955],
            [-81.96166000000002, 40.66774999999997],
            [-82.06363999999999, 40.58150000000004],
            [-81.90134999999998, 40.37078999999996],
            [-82.04046999999994, 40.22151000000002],
            [-82.08993999999996, 40.06863000000002],
            [-82.46515000000002, 40.30813000000001],
            [-82.59871000000001, 40.270529999999994],
            [-82.64201999999997, 40.403210000000016],
            [-82.91024000000004, 40.407490000000024],
            [-83.02264000000002, 40.51305000000002],
            [-83.28730999999999, 40.49551000000004],
            [-83.39615000000003, 40.68722000000004],
            [-83.51538, 40.85501000000002],
            [-83.22132999999997, 41.25322000000001],
            [-83.02590999999995, 41.28271000000002],
            [-82.99603000000002, 41.44318],
            [-82.62256000000002, 41.42305000000003],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MFR" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-121.05447000000002, 41.57612000000003],
              [-120.99231999999999, 41.43980000000002],
              [-121.18318999999994, 41.36357999999997],
              [-121.05447000000002, 41.57612000000003],
            ],
          ],
          [
            [
              [-121.34829999999995, 43.33888000000003],
              [-121.34965000000001, 42.74665000000004],
              [-120.88328000000001, 42.74389999999996],
              [-120.87975999999999, 41.99369999999999],
              [-121.05823, 41.971090000000004],
              [-121.14313999999999, 41.69350999999998],
              [-121.30107999999997, 41.610649999999964],
              [-121.26126999999997, 41.45590999999999],
              [-121.71021000000003, 41.61982000000001],
              [-121.93777000000003, 41.396730000000034],
              [-122.03576999999996, 41.51381],
              [-122.68117999999996, 41.27786000000002],
              [-122.82512999999996, 41.395039999999995],
              [-122.89845999999999, 41.219770000000004],
              [-123.28360999999995, 41.448929999999955],
              [-123.44883000000002, 41.30856999999998],
              [-123.66126999999997, 41.38232999999997],
              [-123.75847999999999, 41.582789999999996],
              [-123.92829999999998, 41.57485999999996],
              [-124.14179999999999, 41.690089999999984],
              [-124.25434999999995, 41.770780000000045],
              [-124.21152999999995, 41.99849000000002],
              [-124.35395999999996, 42.103650000000044],
              [-124.43332000000002, 42.420240000000035],
              [-124.39104999999996, 42.57283999999996],
              [-124.56641999999997, 42.836259999999974],
              [-124.48038000000001, 42.95432000000003],
              [-124.29948000000003, 42.95463000000001],
              [-124.26094999999998, 43.12645000000001],
              [-124.09703000000002, 43.10929000000003],
              [-123.99520000000001, 43.29418],
              [-123.76447, 43.33746000000004],
              [-123.70214000000001, 43.10599000000001],
              [-123.27135999999997, 43.09343999999999],
              [-123.06753999999995, 43.18879000000004],
              [-122.77451000000003, 43.074819999999995],
              [-122.51337000000001, 43.169949999999965],
              [-122.40059000000002, 42.995319999999985],
              [-122.09204999999996, 43.085649999999994],
              [-121.95392000000002, 43.30907000000001],
              [-121.73308999999998, 43.27281999999996],
              [-121.50741000000002, 43.393360000000044],
              [-121.34829999999995, 43.33888000000003],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MGM" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-85.78484000000003, 33.07444000000003],
            [-85.61444, 32.91241000000004],
            [-85.82430000000002, 32.57118999999999],
            [-85.52756, 32.33693000000004],
            [-85.64668, 32.01306999999999],
            [-85.41576, 31.660950000000014],
            [-85.54535999999999, 31.556419999999978],
            [-85.46666000000002, 31.479890000000037],
            [-85.57356999999996, 31.19538999999997],
            [-85.62582999999998, 30.99579999999999],
            [-85.83121999999997, 30.994130000000013],
            [-86.18688999999995, 30.993790000000036],
            [-86.26670999999999, 31.16501000000004],
            [-86.42562000000001, 31.185650000000013],
            [-86.54076999999998, 31.00464],
            [-86.79892999999998, 31.1471],
            [-86.81108999999998, 31.330689999999965],
            [-87.37982, 31.32951000000003],
            [-87.38624000000004, 31.568880000000014],
            [-87.56635999999997, 31.66444999999997],
            [-87.50073000000003, 31.82920999999998],
            [-87.62003999999996, 31.82723999999996],
            [-87.41129999999998, 32.08355000000002],
            [-87.52195999999998, 32.13325999999998],
            [-87.52441999999994, 32.48185000000001],
            [-87.66020999999998, 32.50967000000004],
            [-87.42111999999997, 32.87456999999998],
            [-87.01783999999998, 32.75728000000004],
            [-87.03835000000004, 32.90759000000003],
            [-86.78072, 32.88105000000003],
            [-86.60618000000002, 33.05506000000004],
            [-86.46226000000001, 33.01132999999997],
            [-86.43646999999999, 32.85825999999997],
            [-86.25578999999999, 33.03982000000002],
            [-86.06576000000001, 32.98398000000002],
            [-85.89293, 33.104849999999956],
            [-85.78484000000003, 33.07444000000003],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MIA" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-80.85828999999995, 25.17655999999996],
            [-80.87323000000004, 25.805520000000016],
            [-81.24978999999996, 25.80423999999998],
            [-81.70708999999994, 25.967059999999968],
            [-81.80068999999997, 26.093640000000022],
            [-81.85168999999999, 26.449260000000045],
            [-81.78588999999994, 26.451120000000017],
            [-81.27173000000005, 26.51703000000002],
            [-81.06951999999998, 26.256460000000004],
            [-80.88136, 26.333889999999982],
            [-80.39641999999998, 26.334600000000023],
            [-80.37588, 26.261389999999977],
            [-80.09257, 26.204500000000046],
            [-80.18911, 25.75783000000004],
            [-80.31026999999995, 25.6107],
            [-80.30573999999996, 25.38540999999998],
            [-80.39777000000001, 25.253809999999966],
            [-80.70353999999995, 25.14032999999997],
            [-80.85828999999995, 25.17655999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MKE" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-87.72810000000004, 43.64748],
            [-87.91170000000002, 43.24582000000001],
            [-87.82530999999997, 42.838659999999955],
            [-87.75753999999998, 42.78186000000001],
            [-87.79790999999994, 42.47243000000002],
            [-88.36793000000003, 42.43714],
            [-88.53221000000002, 42.49494],
            [-88.66203000000002, 42.752299999999984],
            [-88.58676999999997, 42.93605999999998],
            [-88.65795000000003, 43.04149999999999],
            [-88.51961000000003, 43.22493000000004],
            [-88.58650999999998, 43.26927000000004],
            [-88.45006999999998, 43.45708999999997],
            [-88.43955999999997, 43.631389999999996],
            [-87.89086000000003, 43.70330000000004],
            [-87.84089999999998, 43.84183999999997],
            [-87.72810000000004, 43.64748],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MKG" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-85.56235999999998, 43.62083999999999],
            [-85.53207000000003, 43.46807999999997],
            [-85.79008999999999, 43.16864999999996],
            [-85.90814999999998, 42.78965000000001],
            [-86.22838999999999, 42.639970000000005],
            [-86.25089999999997, 43.05862000000004],
            [-86.53648999999999, 43.61084000000001],
            [-86.43019000000004, 43.82779000000001],
            [-86.50588000000002, 44.07098000000004],
            [-86.20050999999995, 44.005239999999986],
            [-86.15360999999999, 43.85544000000001],
            [-85.70287999999996, 43.81256000000002],
            [-85.72339999999994, 43.69158000000004],
            [-85.56235999999998, 43.62083999999999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MKL" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-88.04712, 36.49681999999998],
            [-87.85361999999995, 36.045140000000046],
            [-87.96278000000001, 35.84088000000003],
            [-87.81063, 35.83698000000001],
            [-87.86232000000001, 35.97510000000001],
            [-87.71211999999997, 36.00718],
            [-87.68038999999999, 35.84285000000004],
            [-87.76489999999993, 35.67537999999998],
            [-87.35339999999997, 35.58963000000003],
            [-87.44863000000004, 35.42659999999999],
            [-87.65233, 35.357669999999956],
            [-87.45768999999996, 35.217789999999994],
            [-87.55263000000002, 35.09178000000003],
            [-87.65851, 35.174920000000036],
            [-87.74331999999998, 35.00431999999999],
            [-88.20254999999995, 35.00788999999997],
            [-88.0976, 34.89171999999998],
            [-88.12222999999994, 34.70344],
            [-88.31947000000002, 34.71071999999999],
            [-88.59508999999994, 34.84791999999998],
            [-89.01531999999997, 34.807940000000045],
            [-89.07247000000001, 34.923850000000016],
            [-89.27933999999999, 35.10241],
            [-89.18715, 35.31132000000001],
            [-89.27286999999995, 35.53240999999997],
            [-89.47028999999998, 35.53065000000001],
            [-89.41139999999996, 35.75185000000002],
            [-89.52672999999999, 35.90071000000003],
            [-89.66131000000001, 35.79264000000001],
            [-89.76811999999995, 35.86071000000003],
            [-89.71317000000005, 36.026950000000014],
            [-89.59984999999995, 36.11960000000005],
            [-89.14142000000001, 36.23965],
            [-88.76111000000003, 36.2864],
            [-88.70863000000003, 36.44362],
            [-88.62064999999996, 36.35812999999998],
            [-88.48452000000003, 36.477740000000026],
            [-88.34366, 36.352049999999984],
            [-88.26561999999998, 36.500060000000005],
            [-88.04712, 36.49681999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MLI" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-89.96286, 41.99669000000003],
            [-89.78670999999994, 41.685830000000024],
            [-89.51626999999996, 41.58525999999999],
            [-89.50035, 41.494519999999994],
            [-89.66012999999998, 41.46805000000002],
            [-89.64453999999995, 41.263149999999975],
            [-89.86776999999998, 41.23444000000002],
            [-90.00385000000003, 41.06218999999997],
            [-90.11680999999999, 41.07681000000002],
            [-90.33625000000004, 40.84504999999997],
            [-90.44237999999996, 40.84808999999997],
            [-90.43940000000003, 41.063989999999954],
            [-90.75491999999994, 41.06845000000003],
            [-90.90358999999995, 41.156949999999966],
            [-90.92857000000001, 41.30764999999998],
            [-91.34940999999998, 41.30323000000001],
            [-91.08262000000002, 41.56665999999997],
            [-90.93703999999997, 41.90974],
            [-90.55211, 41.91985999999996],
            [-90.38533000000001, 41.86551000000004],
            [-90.19850000000002, 41.98893999999997],
            [-89.96286, 41.99669000000003],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MLS" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-104.42035999999997, 47.35465999999997],
            [-104.30575, 47.042289999999994],
            [-104.41201999999996, 46.90409999999998],
            [-104.60364999999999, 46.86089999999998],
            [-104.60704, 46.68480999999999],
            [-104.35811000000002, 46.45055999999998],
            [-104.51621000000002, 46.05467],
            [-104.39086999999996, 45.970229999999994],
            [-104.13530999999998, 45.968980000000045],
            [-104.04427000000001, 45.88193],
            [-104.04158000000002, 45.54968999999999],
            [-104.24320999999995, 45.606180000000045],
            [-104.51926999999998, 45.34694000000003],
            [-104.40458999999998, 45.14906999999999],
            [-104.58333999999996, 45.23374000000002],
            [-105.03836999999997, 45.18443999999997],
            [-105.13036999999996, 45.322969999999955],
            [-105.46410999999999, 45.25822000000001],
            [-105.47670999999997, 45.37423],
            [-105.67571, 45.145419999999966],
            [-105.84698999999999, 45.18439],
            [-105.96844999999998, 45.38283999999999],
            [-106.10335999999995, 45.40031000000004],
            [-106.06285999999997, 45.53957999999997],
            [-106.23302000000002, 45.689160000000044],
            [-106.23574999999995, 45.35184],
            [-106.58223999999996, 45.33449999999996],
            [-106.72960000000002, 45.42577999999997],
            [-106.72947, 45.57289000000004],
            [-106.47448, 45.655110000000036],
            [-106.53564999999995, 45.712799999999994],
            [-106.91315999999999, 45.68392000000001],
            [-106.93911999999996, 45.86966999999999],
            [-106.93906999999999, 46.13661000000002],
            [-107.08345999999999, 46.26628999999997],
            [-107.17548000000002, 46.110029999999995],
            [-107.48691999999997, 46.17757000000004],
            [-107.79683999999999, 46.49583000000001],
            [-107.80844999999995, 46.735759999999964],
            [-107.89776999999997, 46.84964000000002],
            [-107.62306999999994, 46.851060000000004],
            [-106.86199999999995, 46.85930999999996],
            [-107.01880000000003, 46.97108999999999],
            [-106.85275999999998, 47.02998999999996],
            [-106.88223000000002, 47.244210000000024],
            [-106.58685, 47.26521000000003],
            [-106.26251000000003, 47.22559999999997],
            [-106.07311000000003, 47.42595999999998],
            [-105.69448999999999, 47.37865000000001],
            [-105.59455999999997, 47.181379999999955],
            [-105.40635999999995, 47.181430000000006],
            [-105.40194, 47.34176000000003],
            [-105.24128000000003, 47.29725],
            [-105.1892, 47.46816000000002],
            [-104.96025999999995, 47.25384000000003],
            [-104.75642999999998, 47.35182],
            [-104.69591, 47.471240000000044],
            [-104.42035999999997, 47.35465999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MLU" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-91.23085000000003, 33.56130999999997],
            [-91.11809, 33.45296999999999],
            [-91.09004999999999, 33.05698000000001],
            [-91.15090000000001, 32.620249999999984],
            [-91.07739000000001, 32.447590000000034],
            [-90.96686000000003, 32.436049999999994],
            [-91.03774999999996, 32.24220000000004],
            [-91.16497999999996, 32.19563],
            [-91.08851000000001, 32.00000000000002],
            [-91.33977000000004, 31.85029999999997],
            [-90.91375999999997, 31.752759999999995],
            [-90.88106000000002, 31.61053000000002],
            [-91.12766000000002, 31.62802000000004],
            [-91.24561999999997, 31.501569999999994],
            [-91.17584999999997, 31.384420000000006],
            [-91.46779999999998, 31.306879999999985],
            [-91.72341000000003, 31.044080000000022],
            [-91.75274999999996, 31.315269999999977],
            [-92.11180000000002, 31.225949999999962],
            [-92.27424000000002, 31.084680000000013],
            [-92.46188999999998, 31.188799999999965],
            [-92.81888999999998, 31.226999999999975],
            [-92.99658, 31.36014999999998],
            [-93.04156000000003, 31.675669999999993],
            [-92.88289999999998, 31.83822999999996],
            [-93.00957000000002, 31.93388999999999],
            [-92.81482000000003, 32.14712000000003],
            [-92.89340000000001, 32.54149000000001],
            [-92.79839000000004, 32.607470000000035],
            [-92.91479999999999, 32.858750000000015],
            [-92.81618999999995, 32.99606999999999],
            [-92.98883999999998, 33.01752000000002],
            [-92.98535999999999, 33.132180000000034],
            [-92.82059000000004, 33.30068999999999],
            [-92.77583000000001, 33.550289999999976],
            [-92.66505999999998, 33.66001],
            [-92.47878999999995, 33.71583999999998],
            [-92.16888999999998, 33.615969999999955],
            [-92.13657999999998, 33.45372999999999],
            [-91.87820000000005, 33.79159000000004],
            [-91.90745999999996, 33.45318999999999],
            [-91.67773, 33.43101999999999],
            [-91.45198999999997, 33.68755999999999],
            [-91.45340000000002, 33.56352000000004],
            [-91.23085000000003, 33.56130999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MON" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-71.08434000000003, 45.30519000000001],
            [-71.05837000000002, 44.99132000000001],
            [-70.81871999999996, 44.99078],
            [-70.77441999999999, 44.84174000000002],
            [-71.04070999999996, 44.796649999999964],
            [-71.01029999999994, 44.28499999999999],
            [-71.25201000000001, 44.24413999999998],
            [-71.21082999999999, 44.08639],
            [-71.37085999999996, 43.959149999999966],
            [-71.56457, 43.89317999999997],
            [-71.57186000000002, 43.78660999999999],
            [-72.06072999999995, 43.75913000000002],
            [-72.02122, 43.61442000000002],
            [-72.38838999999999, 43.50941999999999],
            [-72.49678000000003, 43.56609000000002],
            [-72.75025000000002, 43.33277000000004],
            [-73.04952000000003, 43.39956000000002],
            [-73.10405, 43.55859000000004],
            [-73.25074999999998, 43.57943000000004],
            [-73.21937999999994, 43.837140000000026],
            [-73.03022999999993, 43.846659999999986],
            [-72.88827, 44.054799999999965],
            [-72.95248000000004, 44.161409999999975],
            [-72.70461000000003, 44.52715000000004],
            [-72.53697000000003, 44.87111999999999],
            [-72.32153, 45.00444999999997],
            [-71.50178999999997, 45.01340000000002],
            [-71.38442999999992, 45.233179999999955],
            [-71.08434000000003, 45.30519000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MSN" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-88.43955999999997, 43.631389999999996],
            [-88.45006999999998, 43.45708999999997],
            [-88.58650999999998, 43.26927000000004],
            [-88.51961000000003, 43.22493000000004],
            [-88.65795000000003, 43.04149999999999],
            [-88.58676999999997, 42.93605999999998],
            [-88.66203000000002, 42.752299999999984],
            [-89.05053000000004, 42.666049999999956],
            [-89.63632000000001, 42.722849999999994],
            [-89.83792999999997, 42.60315999999999],
            [-89.96185999999997, 42.647540000000006],
            [-90.01839999999999, 42.92692000000002],
            [-90.33805999999996, 42.99397999999996],
            [-90.34973999999994, 43.24488000000004],
            [-90.73765999999995, 43.462099999999985],
            [-90.78491999999997, 43.60751],
            [-90.62165999999999, 43.74780999999998],
            [-90.52286999999998, 43.90431000000001],
            [-90.33849999999995, 43.75407999999998],
            [-89.98184999999998, 43.91324],
            [-89.77734999999998, 43.774509999999985],
            [-89.69748000000001, 43.861889999999974],
            [-89.48461, 43.80788000000004],
            [-89.36554999999998, 43.930290000000035],
            [-88.90610999999996, 43.89542000000004],
            [-88.81369999999998, 43.98714999999997],
            [-88.73143999999996, 43.789519999999975],
            [-88.43955999999997, 43.631389999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MSO" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-113.14429000000001, 47.59631000000004],
            [-113.05932999999996, 47.48783999999996],
            [-113.05874, 47.200890000000044],
            [-112.92471999999995, 47.315880000000014],
            [-112.55567, 47.179639999999964],
            [-112.31431999999998, 47.005189999999956],
            [-112.44382999999999, 46.459000000000024],
            [-112.72058, 46.592970000000015],
            [-112.87489999999995, 46.73699999999998],
            [-113.03868999999999, 46.67140999999999],
            [-113.28891999999996, 46.427279999999975],
            [-113.52521000000002, 46.58119000000002],
            [-113.63986000000001, 46.48649999999996],
            [-113.77251999999997, 46.65803999999997],
            [-113.87822, 46.497269999999965],
            [-113.78299999999996, 46.36430000000002],
            [-113.75316999999997, 46.11228],
            [-114.04936999999998, 45.95583999999997],
            [-114.03022000000001, 45.648369999999964],
            [-114.33154999999994, 45.45934999999996],
            [-114.56497999999996, 45.557650000000024],
            [-114.56284000000001, 45.7796],
            [-114.38878000000003, 45.88228],
            [-114.50641999999996, 46.030580000000036],
            [-114.32077, 46.64774999999998],
            [-114.60516000000003, 46.63564999999998],
            [-114.76675999999996, 46.69692000000003],
            [-114.92654000000003, 46.9195],
            [-115.04901999999996, 46.97022999999997],
            [-115.31968000000003, 47.25650000000003],
            [-115.74255, 47.42360000000003],
            [-115.62947999999999, 47.47959000000001],
            [-115.07004999999997, 47.535120000000035],
            [-114.93822000000002, 47.83169000000002],
            [-114.41916999999998, 47.416670000000046],
            [-114.34092999999996, 47.58364000000003],
            [-113.14429000000001, 47.59631000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MSP" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-92.55783999999994, 45.95099000000004],
            [-92.50377999999995, 45.73568000000003],
            [-92.52945, 45.61741000000001],
            [-92.28396000000001, 45.58157999999998],
            [-92.23481999999996, 45.36592999999999],
            [-92.36027999999996, 45.28474000000004],
            [-92.35931, 44.962899999999976],
            [-92.29411999999999, 44.70777000000003],
            [-92.38633000000002, 44.47622000000004],
            [-92.73225000000002, 44.47779],
            [-93.11923999999999, 44.196650000000034],
            [-93.52538000000001, 44.20298000000002],
            [-93.70481999999998, 43.956790000000005],
            [-93.81821, 44.07972000000004],
            [-94.05824999999999, 43.93517999999998],
            [-94.34200000000001, 43.927639999999975],
            [-94.31489999999994, 43.78222999999996],
            [-94.56222999999997, 43.74295999999997],
            [-94.74195, 43.84816000000002],
            [-94.75921, 44.18132000000003],
            [-95.02048999999997, 44.137089999999986],
            [-95.09975, 44.332580000000014],
            [-94.90650999999997, 44.311439999999976],
            [-94.62408000000002, 44.456],
            [-94.62921999999998, 44.62204999999999],
            [-94.39627999999999, 44.63039000000001],
            [-94.42682000000002, 44.761399999999966],
            [-94.00055, 44.97849],
            [-93.27305999999996, 45.42133000000001],
            [-93.15254000000002, 45.42859999999997],
            [-93.14202999999995, 45.60933],
            [-92.88793999999999, 45.628289999999964],
            [-92.7211, 45.883669999999995],
            [-92.55783999999994, 45.95099000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "MSY" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-91.07964999999996, 29.62953999999999],
            [-90.97136000000003, 29.75899000000001],
            [-90.91537999999997, 30.112960000000026],
            [-90.49618999999996, 30.25773999999996],
            [-90.56694999999996, 30.53268000000004],
            [-90.24506000000002, 30.565050000000042],
            [-90.26064999999994, 30.826440000000048],
            [-90.19549, 31.000829999999972],
            [-89.93706999999998, 31.00154000000001],
            [-90.01322999999996, 30.907559999999982],
            [-89.78712999999996, 30.84366000000002],
            [-89.85208000000003, 30.661350000000002],
            [-89.68320000000003, 30.451479999999968],
            [-89.63243000000003, 30.268959999999982],
            [-89.75345000000002, 30.177670000000038],
            [-90.20908999999995, 30.385880000000036],
            [-90.40589999999997, 30.21631999999998],
            [-90.37192999999999, 30.05520999999999],
            [-90.14500000000001, 30.018950000000004],
            [-89.85574, 30.077029999999986],
            [-89.93205000000003, 29.95575999999999],
            [-89.57659000000001, 29.760840000000048],
            [-89.81664000000004, 29.61768999999998],
            [-89.52187999999998, 29.45628000000004],
            [-89.84225, 29.419109999999986],
            [-89.89404999999996, 29.55275000000003],
            [-90.09683000000001, 29.641970000000033],
            [-90.22780999999998, 29.53590000000003],
            [-90.24185, 29.336180000000038],
            [-90.36376000000001, 29.59671999999997],
            [-90.60146, 29.36870000000002],
            [-91.06685000000002, 29.395300000000006],
            [-91.13197000000002, 29.34632999999999],
            [-91.25827999999996, 29.444479999999988],
            [-91.26392999999999, 29.535439999999983],
            [-91.07964999999996, 29.62953999999999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "OFK" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-97.47533999999993, 41.35017000000002],
            [-97.62831999999995, 41.394980000000004],
            [-97.77216000000001, 41.308369999999954],
            [-97.91570999999996, 41.38032000000002],
            [-98.08011999999997, 41.63930000000002],
            [-98.17627999999998, 41.62525999999999],
            [-98.37334999999999, 41.793980000000005],
            [-98.71846999999997, 41.84494],
            [-98.87901999999998, 42.088410000000025],
            [-99.23464000000001, 42.13304000000004],
            [-99.11803000000002, 42.25891999999999],
            [-98.95387999999996, 42.21495999999999],
            [-98.94415000000002, 42.37292000000003],
            [-98.75598, 42.50800999999997],
            [-98.84043999999997, 42.857379999999964],
            [-98.71731, 43.09634000000004],
            [-98.45600999999998, 43.00055],
            [-98.26771999999998, 43.22685000000001],
            [-98.09013999999999, 43.14873999999999],
            [-98.09496999999995, 42.965769999999985],
            [-97.77322999999998, 42.90802000000004],
            [-97.66936999999996, 42.83130000000001],
            [-97.40709000000004, 42.86545000000003],
            [-97.07414, 42.68423999999999],
            [-97.19714000000005, 42.415550000000025],
            [-97.01777999999996, 42.351359999999964],
            [-96.90296999999995, 42.075960000000016],
            [-96.60591000000002, 41.923259999999985],
            [-96.56686999999997, 41.74202999999998],
            [-96.79040000000003, 41.74230999999996],
            [-96.80922999999999, 41.597059999999956],
            [-96.94793000000001, 41.44474999999996],
            [-97.47533999999993, 41.35017000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "OKC" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-97.31908999999999, 36.46409000000003],
            [-97.06797999999995, 36.362119999999976],
            [-97.10344999999995, 36.261179999999975],
            [-96.85489999999999, 36.10883999999998],
            [-96.91142999999997, 35.957759999999965],
            [-96.71604999999997, 35.63971999999999],
            [-96.49807999999996, 35.63885999999998],
            [-96.44135999999997, 35.290110000000034],
            [-96.27301000000003, 35.21806999999998],
            [-96.14208999999997, 35.02904000000004],
            [-96.21929999999995, 34.78510999999997],
            [-95.95553999999996, 34.73905999999997],
            [-95.77890999999997, 34.45400999999996],
            [-96.00278999999995, 34.342209999999966],
            [-96.14538000000005, 34.41828999999998],
            [-96.40699999999998, 34.41840999999996],
            [-96.53851, 34.31040999999996],
            [-96.59682000000001, 34.43560999999997],
            [-96.76266999999999, 34.36149999999997],
            [-96.75410999999994, 34.233919999999955],
            [-96.93331999999998, 34.27307999999999],
            [-97.20549000000003, 34.27005999999996],
            [-97.56243, 34.42696999999998],
            [-97.56277, 34.680999999999955],
            [-97.95092999999996, 34.747090000000014],
            [-98.13298999999999, 34.68116999999999],
            [-98.28284999999995, 34.81138000000001],
            [-98.77312000000002, 34.85545999999999],
            [-98.91236999999998, 34.90653000000003],
            [-98.98158999999994, 35.11652999999998],
            [-99.36022000000001, 35.116740000000036],
            [-99.36457999999998, 35.21925],
            [-99.56685000000002, 35.31228000000003],
            [-99.53227999999997, 35.543869999999956],
            [-99.60963, 35.84868999999999],
            [-99.38097000000002, 36.012760000000014],
            [-99.23923, 36.31881000000003],
            [-98.95590000000001, 36.198219999999985],
            [-98.96045, 36.50704000000004],
            [-98.70165999999999, 36.417080000000006],
            [-98.68748999999995, 36.49817000000003],
            [-98.39924999999997, 36.53088000000001],
            [-98.27112000000001, 36.666199999999975],
            [-97.67553999999996, 36.47739000000003],
            [-97.49741999999995, 36.56353],
            [-97.31908999999999, 36.46409000000003],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "OLM" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-123.05249999999995, 47.37004999999996],
              [-123.02289999999999, 47.520230000000026],
              [-122.91016999999997, 47.45648000000004],
              [-123.05249999999995, 47.37004999999996],
            ],
          ],
          [
            [
              [-123.11307, 47.46078000000002],
              [-123.13217, 47.33448000000004],
              [-122.97344999999997, 47.37935000000002],
              [-122.83243, 47.330200000000026],
              [-122.90068, 47.14460999999996],
              [-122.70446999999999, 47.09336999999997],
              [-122.58251000000001, 47.19315000000001],
              [-122.38450999999996, 47.07670999999997],
              [-122.19919999999996, 47.06784999999999],
              [-122.22731000000002, 46.923169999999985],
              [-121.83245, 46.85360000000002],
              [-121.81234, 46.74728000000003],
              [-121.83505000000001, 46.637549999999976],
              [-121.61513999999997, 46.605979999999995],
              [-121.42301999999998, 46.49254000000002],
              [-121.52362000000001, 46.388090000000034],
              [-122.24147000000002, 46.385970000000036],
              [-122.24127, 46.22875999999997],
              [-122.89128999999996, 46.25088000000001],
              [-122.91207999999999, 46.20193999999999],
              [-123.21817000000003, 46.38524000000003],
              [-123.35861999999999, 46.384019999999985],
              [-123.37076999999995, 46.792450000000045],
              [-124.02877000000001, 46.79353999999999],
              [-124.02738999999995, 46.840469999999975],
              [-123.94973999999998, 46.96914999999996],
              [-124.12392000000003, 47.041209999999985],
              [-124.17519, 46.92749000000002],
              [-124.21926999999998, 47.24532000000003],
              [-124.35442999999994, 47.53369000000002],
              [-123.50597000000002, 47.51773999999997],
              [-123.50438999999994, 47.607010000000024],
              [-123.12885000000001, 47.58579999999996],
              [-123.11307, 47.46078000000002],
            ],
          ],
          [
            [
              [-124.21992999999998, 47.88141000000001],
              [-124.61138999999996, 47.880729999999964],
              [-124.67454999999998, 47.9743],
              [-124.39927000000002, 48.046059999999976],
              [-124.21000000000001, 48.00320999999998],
              [-124.21992999999998, 47.88141000000001],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "OMA" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-94.97429, 42.122750000000046],
            [-95.03362000000001, 42.049949999999995],
            [-94.74399999999997, 41.74682],
            [-94.75086999999996, 41.50429999999997],
            [-94.89930999999996, 41.50458999999999],
            [-94.70035999999999, 41.316709999999986],
            [-94.64209, 41.08631000000002],
            [-94.69414000000003, 40.821220000000025],
            [-94.47155999999998, 40.67538999999999],
            [-94.59516000000002, 40.57104999999996],
            [-95.17846000000003, 40.348680000000044],
            [-95.18061999999995, 40.261730000000014],
            [-95.55532000000002, 40.264309999999966],
            [-95.85130000000004, 40.42991000000002],
            [-95.98575999999997, 40.58989999999997],
            [-96.05493999999999, 40.832710000000006],
            [-96.31911, 41.04429999999998],
            [-96.45221999999995, 41.31356000000003],
            [-96.65924000000001, 41.35068000000003],
            [-96.70703, 41.57409999999996],
            [-96.80922999999999, 41.597059999999956],
            [-96.79040000000003, 41.74230999999996],
            [-96.56686999999997, 41.74202999999998],
            [-96.46320000000003, 41.7275],
            [-96.25125999999997, 41.92371000000001],
            [-96.09396999999993, 41.85189000000004],
            [-95.74722, 41.86328],
            [-95.53699000000003, 42.008570000000034],
            [-95.42104999999998, 41.9283],
            [-95.22052999999997, 41.95878999999997],
            [-95.24585999999994, 42.13895],
            [-94.97429, 42.122750000000046],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ORD" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-87.79790999999994, 42.47243000000002],
            [-87.82773, 42.26805000000002],
            [-87.66954000000004, 42.05955],
            [-87.58336000000003, 41.78163000000001],
            [-87.32416000000003, 41.60883000000001],
            [-87.20225000000002, 41.62729],
            [-87.20649999999995, 41.39594000000004],
            [-87.34361999999999, 41.24613999999997],
            [-87.34313999999998, 41.03288999999996],
            [-87.52657000000002, 41.072950000000034],
            [-87.69325, 40.948950000000025],
            [-87.82849000000002, 40.989810000000034],
            [-88.40958000000003, 40.999949999999956],
            [-88.60643000000005, 41.19552999999998],
            [-88.78825000000003, 41.27387000000002],
            [-88.70082, 41.44972000000004],
            [-88.65671, 41.84248999999997],
            [-88.5837, 42.005390000000006],
            [-88.40994999999998, 42.04154999999997],
            [-88.48902000000004, 42.23841999999997],
            [-88.34880000000001, 42.277180000000044],
            [-88.36793000000003, 42.43714],
            [-87.79790999999994, 42.47243000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ORF" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-75.77267999999998, 36.231680000000026],
              [-75.77580000000003, 36.23105999999997],
              [-75.94312000000002, 36.72349999999999],
              [-76.04200999999995, 36.50308000000004],
              [-75.95389999999995, 36.20349999999996],
              [-76.57935999999998, 36.010649999999956],
              [-76.75522999999995, 36.151700000000005],
              [-76.70020999999994, 35.92377000000003],
              [-76.63116999999997, 35.70516000000001],
              [-76.84505999999999, 35.70533999999998],
              [-76.76091, 35.86304],
              [-76.94941999999998, 35.80160000000001],
              [-77.02168999999998, 35.673919999999974],
              [-77.14525, 35.73114000000003],
              [-77.13025999999996, 35.94008000000004],
              [-77.32740000000001, 36.07493000000001],
              [-77.26297, 36.15889],
              [-77.54972999999998, 36.412729999999975],
              [-77.33529000000001, 36.427730000000025],
              [-77.16953999999998, 36.70724000000004],
              [-77.20424999999997, 36.863839999999996],
              [-77.01207, 36.855729999999994],
              [-76.85192000000004, 36.994919999999965],
              [-76.79972000000004, 37.19383],
              [-76.48636000000002, 36.95687999999996],
              [-75.99530999999999, 36.92102000000003],
              [-75.77267999999998, 36.231680000000026],
            ],
          ],
          [
            [
              [-76.87725, 37.277029999999996],
              [-76.62660000000002, 37.31454000000002],
              [-76.47438, 37.20157999999997],
              [-76.29256999999996, 37.12717000000002],
              [-76.41108999999997, 36.95878999999999],
              [-76.64060999999995, 37.21570999999999],
              [-76.87725, 37.277029999999996],
            ],
          ],
          [
            [
              [-76.70410999999996, 37.449340000000035],
              [-76.55145999999999, 37.56408000000002],
              [-76.36000999999999, 37.52164000000002],
              [-76.27562999999998, 37.30881000000003],
              [-76.40346, 37.41839000000002],
              [-76.38362999999998, 37.27520000000001],
              [-76.50400999999997, 37.24517],
              [-76.70410999999996, 37.449340000000035],
            ],
          ],
          [
            [
              [-75.63727000000003, 37.94417],
              [-75.47932000000003, 37.903119999999994],
              [-75.58016999999995, 37.694420000000044],
              [-75.82426999999996, 37.47582999999998],
              [-76.01357999999999, 37.2071],
              [-75.90537999999995, 37.626450000000034],
              [-75.63727000000003, 37.94417],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ORN" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-71.54621999999995, 42.70274],
            [-71.56025999999997, 42.47448],
            [-71.38180999999994, 42.13493000000001],
            [-71.55777, 42.01439000000002],
            [-71.79912999999999, 42.00803000000003],
            [-71.79663, 41.89749999999996],
            [-72.09049999999996, 41.82924000000003],
            [-72.10249999999994, 42.02887000000003],
            [-72.26953, 42.031710000000004],
            [-72.27453, 42.14356999999999],
            [-72.45199, 42.22671],
            [-72.53292999999996, 42.51136999999997],
            [-72.63443999999998, 42.64017999999997],
            [-72.82341999999997, 42.628169999999955],
            [-72.78394, 42.91115000000003],
            [-72.64130999999998, 42.947009999999956],
            [-72.31789999999995, 42.80015999999999],
            [-71.72277, 42.79663000000004],
            [-71.54621999999995, 42.70274],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "PBI" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-80.09257, 26.204500000000046],
            [-80.37588, 26.261389999999977],
            [-80.39641999999998, 26.334600000000023],
            [-80.88136, 26.333889999999982],
            [-81.06951999999998, 26.256460000000004],
            [-81.27173000000005, 26.51703000000002],
            [-81.78588999999994, 26.451120000000017],
            [-81.73804999999999, 26.769400000000047],
            [-81.56573, 26.76952000000003],
            [-81.56267999999997, 27.128170000000022],
            [-81.34481, 27.20801000000001],
            [-81.16819999999996, 27.12162000000004],
            [-81.12156999999993, 27.38981000000002],
            [-81.20527999999993, 27.489930000000033],
            [-81.13129999999995, 27.659919999999964],
            [-81.20818, 27.82096999999996],
            [-81.02358000000004, 27.73368999999998],
            [-80.88118000000003, 27.82229999999996],
            [-80.72323000000003, 27.701889999999977],
            [-80.38307, 27.667299999999965],
            [-80.31671, 27.42915000000003],
            [-80.15799999999999, 27.163499999999978],
            [-80.05737000000005, 26.842849999999967],
            [-80.04258999999999, 26.54512000000001],
            [-80.09257, 26.204500000000046],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "PDT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-118.48804999999997, 46.73677999999998],
            [-118.24939999999997, 46.73372000000002],
            [-118.24169000000002, 46.38797999999999],
            [-118.11991, 46.41089000000002],
            [-118.11665000000002, 46.26231],
            [-117.99149999999997, 46.20769999999998],
            [-117.97768999999997, 45.860549999999996],
            [-117.74736999999996, 45.86101999999998],
            [-117.78742000000001, 45.68950999999996],
            [-117.66342, 45.36575000000002],
            [-117.47704000000003, 45.16524000000003],
            [-117.26395000000002, 45.08115000000003],
            [-117.34898, 44.738699999999994],
            [-117.52996000000002, 44.56459999999999],
            [-117.95081, 44.571860000000015],
            [-118.65900999999995, 44.75381],
            [-118.64986999999999, 44.99726999999999],
            [-118.84101, 44.998149999999974],
            [-118.70636999999999, 44.79231999999999],
            [-118.89486000000002, 44.72715999999996],
            [-118.85694, 44.560150000000036],
            [-119.56684999999995, 44.48784000000003],
            [-119.87043999999999, 44.70081999999999],
            [-120.06611, 44.70929000000003],
            [-120.11417999999998, 44.933729999999976],
            [-120.38004, 44.82677999999999],
            [-120.50351000000003, 45.083099999999995],
            [-120.52891999999997, 45.40047000000004],
            [-120.36583999999996, 45.496370000000034],
            [-120.4826, 45.69437],
            [-120.21061000000003, 45.72583999999997],
            [-119.96575999999996, 45.824369999999966],
            [-119.48159999999999, 45.90822000000001],
            [-119.34534999999998, 46.05031000000003],
            [-119.87412999999995, 46.62848999999997],
            [-119.22627, 46.690859999999994],
            [-118.77074999999996, 46.78624999999998],
            [-118.48804999999997, 46.73677999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "PDX" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-122.91207999999999, 46.20193999999999],
              [-122.91750999999995, 46.09807000000003],
              [-123.11478, 46.19011000000003],
              [-123.21310999999996, 46.17573999999997],
              [-123.21817000000003, 46.38524000000003],
              [-122.91207999999999, 46.20193999999999],
            ],
          ],
          [
            [
              [-121.52362000000001, 46.388090000000034],
              [-121.52392999999998, 46.04410000000003],
              [-121.33135000000003, 45.93894],
              [-121.40377, 45.69299000000004],
              [-120.91611999999999, 45.641349999999996],
              [-120.82552999999997, 45.513630000000035],
              [-121.02448000000003, 45.21907],
              [-120.72983999999995, 45.08377000000001],
              [-120.50351000000003, 45.083099999999995],
              [-120.38004, 44.82677999999999],
              [-120.38549999999994, 44.563910000000014],
              [-120.74643000000002, 44.562439999999974],
              [-120.92246000000002, 44.721059999999994],
              [-120.90932000000002, 44.82290000000004],
              [-121.75999999999995, 44.825430000000026],
              [-121.73446, 44.88580999999998],
              [-122.24242999999996, 44.88571999999999],
              [-122.25639999999997, 45.07984],
              [-122.58628999999996, 45.20137000000001],
              [-122.76332999999994, 45.210810000000016],
              [-123.26970000000003, 45.43376999999999],
              [-123.46476000000001, 45.43314],
              [-123.29943, 45.60716999999998],
              [-123.36027, 45.90288000000004],
              [-123.20669, 46.0223],
              [-123.08334000000002, 45.99969000000001],
              [-123.06896999999996, 46.15545],
              [-122.90563999999996, 46.078840000000014],
              [-122.89128999999996, 46.25088000000001],
              [-122.24127, 46.22875999999997],
              [-122.24147000000002, 46.385970000000036],
              [-121.52362000000001, 46.388090000000034],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "PHL" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.26214999999996, 40.05517000000002],
            [-74.32837999999998, 39.93080999999998],
            [-74.38952999999995, 39.74991],
            [-74.68683000000004, 39.74655],
            [-74.67043999999999, 39.604380000000006],
            [-74.85826, 39.46684999999998],
            [-74.92091000000002, 39.42420000000001],
            [-75.32340999999997, 39.55337999999999],
            [-75.23776999999995, 39.66305999999999],
            [-75.42890999999997, 39.78343000000004],
            [-75.42724999999993, 39.80886999999997],
            [-75.50617, 39.97035000000001],
            [-75.64337, 39.99864000000004],
            [-75.6797, 40.152180000000016],
            [-75.64332999999996, 40.30756000000001],
            [-75.37228999999999, 40.21375000000002],
            [-75.26361999999997, 40.286109999999994],
            [-74.93593999999999, 40.29990999999997],
            [-74.82499999999999, 40.37036],
            [-74.63491000000002, 40.21083],
            [-74.48600000000005, 40.20039999999997],
            [-74.4076, 40.06113999999998],
            [-74.26214999999996, 40.05517000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "PHX" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-110.25620000000002, 34.00004],
            [-110.75069999999995, 34.01442],
            [-110.80080999999997, 33.9353],
            [-110.5261, 33.70430999999998],
            [-110.64433, 33.55901],
            [-110.65448999999998, 33.352800000000016],
            [-110.80057000000001, 33.24474999999997],
            [-111.04240999999999, 33.25215000000003],
            [-111.08322000000003, 33.104620000000025],
            [-110.88898999999998, 33.006920000000044],
            [-110.83793999999999, 32.857249999999986],
            [-110.97607000000002, 32.71512000000003],
            [-111.23851999999998, 32.68668999999997],
            [-111.34147000000003, 32.83927000000001],
            [-111.49787000000003, 32.547610000000034],
            [-111.66861999999996, 32.50665000000001],
            [-112.57215999999998, 32.50520999999996],
            [-112.71729999999995, 32.344219999999964],
            [-112.63039999999997, 32.14972999999998],
            [-112.78004999999997, 32.166090000000025],
            [-112.98916, 32.04032999999997],
            [-113.20840000000003, 31.99886999999996],
            [-113.33410999999995, 32.03864999999996],
            [-113.33405999999998, 32.505170000000035],
            [-113.05311000000002, 32.72377999999998],
            [-113.11303999999994, 33.068480000000015],
            [-113.22873999999996, 33.11111000000001],
            [-112.99496000000002, 33.19463000000002],
            [-112.97944999999996, 33.30754999999996],
            [-113.33395000000003, 33.26185999999999],
            [-113.33376000000003, 33.78113000000002],
            [-112.92814999999997, 33.615580000000016],
            [-112.74232999999997, 33.767559999999975],
            [-112.62887999999997, 33.97116000000001],
            [-112.27601000000001, 33.88261999999997],
            [-112.16496, 34.04816999999997],
            [-111.49512999999999, 33.99996999999998],
            [-111.47778000000001, 34.15106000000003],
            [-111.69487999999998, 34.18817],
            [-111.38506999999998, 34.43240000000002],
            [-111.25069, 34.453370000000035],
            [-110.86066000000002, 34.26967000000002],
            [-110.62657000000002, 34.286300000000026],
            [-110.32366000000002, 34.16471999999996],
            [-110.25620000000002, 34.00004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "PIA" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-88.78825000000003, 41.27387000000002],
            [-88.60643000000005, 41.19552999999998],
            [-88.40958000000003, 40.999949999999956],
            [-88.58475000000001, 40.81586000000001],
            [-88.58385999999999, 40.66201000000004],
            [-88.89081999999999, 40.42066000000001],
            [-88.88095999999996, 40.29701],
            [-89.03659999999996, 40.26110000000002],
            [-89.37399999999997, 40.27270000000004],
            [-89.62730999999997, 40.22540000000001],
            [-89.86734000000001, 40.30941999999999],
            [-90.17747999999995, 40.19884000000004],
            [-90.24931000000004, 40.287529999999975],
            [-90.45051000000001, 40.262389999999996],
            [-90.52067000000002, 40.27779000000002],
            [-90.44672999999997, 40.555529999999955],
            [-90.28485999999998, 40.69941000000003],
            [-90.33625000000004, 40.84504999999997],
            [-90.11680999999999, 41.07681000000002],
            [-90.00385000000003, 41.06218999999997],
            [-89.86776999999998, 41.23444000000002],
            [-89.64453999999995, 41.263149999999975],
            [-89.66012999999998, 41.46805000000002],
            [-89.50035, 41.494519999999994],
            [-89.16651999999996, 41.37209000000003],
            [-89.05873999999997, 41.43290999999997],
            [-88.92685999999998, 41.24337000000001],
            [-88.78825000000003, 41.27387000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "PIH" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-111.04901999999996, 44.47540999999999],
            [-111.04691, 43.92934999999997],
            [-110.83927, 43.839409999999994],
            [-110.73884, 43.88369],
            [-110.69998, 43.68045],
            [-110.54743999999998, 43.831130000000044],
            [-110.24686999999997, 44.00840999999999],
            [-110.05356999999995, 44.032599999999974],
            [-110.05353000000001, 44.00773000000004],
            [-110.22351999999995, 43.98109999999997],
            [-110.20673999999997, 43.76262999999997],
            [-110.62682000000001, 43.707570000000025],
            [-110.68086999999997, 43.60648000000004],
            [-110.31258000000003, 43.451380000000036],
            [-110.34374999999996, 43.29114],
            [-110.57849000000002, 43.29168000000001],
            [-110.59155999999999, 42.43382000000001],
            [-110.91349999999997, 42.40243000000001],
            [-110.81110999999999, 42.10422000000004],
            [-110.82854000000002, 41.713429999999974],
            [-110.61849999999994, 41.57912],
            [-111.04581999999995, 41.57979000000002],
            [-111.04677999999998, 42.00167999999999],
            [-111.66446999999997, 41.99947000000001],
            [-111.93826999999996, 41.870380000000026],
            [-112.12262000000001, 41.92932000000002],
            [-112.46285999999998, 41.939719999999966],
            [-112.92900999999999, 41.531900000000014],
            [-112.81155999999996, 41.22818999999999],
            [-112.81624999999997, 40.999840000000006],
            [-114.04188999999997, 40.99979999999998],
            [-114.04149000000001, 41.993940000000045],
            [-114.27347999999999, 41.99422999999997],
            [-114.20452999999999, 41.87349000000004],
            [-114.33823999999996, 41.63231999999998],
            [-114.62229, 41.44794000000002],
            [-114.84659999999995, 41.55082999999999],
            [-115.12902999999999, 41.43784999999997],
            [-115.05224000000003, 41.56023999999999],
            [-115.19587000000001, 41.645190000000014],
            [-115.44417, 41.65220000000004],
            [-115.41536999999997, 41.78120999999999],
            [-115.55335000000001, 41.79285000000003],
            [-115.52212000000002, 41.92796000000003],
            [-115.43414000000003, 41.99662000000001],
            [-114.75367999999996, 41.999600000000015],
            [-114.65420999999999, 42.186899999999994],
            [-114.80302999999998, 42.37066],
            [-114.69255999999999, 42.44754000000003],
            [-114.61742000000002, 42.85094000000002],
            [-114.37960999999999, 42.850739999999995],
            [-114.25617000000003, 42.98565999999999],
            [-114.26856999999998, 43.19988999999999],
            [-114.53447999999996, 43.33337999999997],
            [-114.57225999999996, 43.51019000000002],
            [-114.40823999999998, 43.67207999999997],
            [-114.17079999999999, 43.78197999999997],
            [-114.55652999999998, 43.97900999999997],
            [-114.16410000000003, 44.01051999999996],
            [-113.76386000000002, 44.39261999999999],
            [-113.65674, 44.30509000000002],
            [-113.71575000000001, 44.11873000000001],
            [-113.41636999999997, 44.059369999999994],
            [-113.32080000000002, 44.23316000000001],
            [-112.81377999999997, 44.23021],
            [-112.71853999999996, 44.50434000000003],
            [-112.38687999999998, 44.44726000000001],
            [-112.25676999999997, 44.571580000000026],
            [-111.82149000000003, 44.509289999999964],
            [-111.51890999999998, 44.583330000000025],
            [-111.48906999999996, 44.70499999999999],
            [-111.3236, 44.72899000000003],
            [-111.04901999999996, 44.47540999999999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "PIR" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-100.06113999999998, 45.61520999999997],
            [-99.95579999999998, 45.593739999999976],
            [-99.93497999999995, 45.31910000000003],
            [-99.72715999999998, 45.371839999999956],
            [-99.67513, 44.90669],
            [-99.31174999999998, 44.89720999999997],
            [-99.31198, 44.74366999999999],
            [-99.29989000000002, 44.194910000000036],
            [-99.45341999999998, 44.12751999999997],
            [-99.30544999999998, 43.85691999999998],
            [-99.45465999999999, 43.68777000000001],
            [-99.58082000000003, 43.392980000000044],
            [-99.81507999999998, 43.507150000000024],
            [-99.89884000000004, 43.700880000000005],
            [-100.28524999999998, 43.696529999999974],
            [-100.59074000000003, 43.769059999999975],
            [-100.79037999999997, 43.72576999999999],
            [-101.03132000000001, 43.85778],
            [-101.16745000000002, 43.810670000000044],
            [-101.05275999999999, 43.69354000000003],
            [-101.09208999999998, 43.53487999999998],
            [-101.29323999999998, 43.635620000000046],
            [-101.71307999999998, 43.684010000000036],
            [-101.70370999999999, 43.758829999999975],
            [-102.01927999999997, 43.81386999999996],
            [-102.01912999999999, 43.994550000000025],
            [-101.32936999999997, 43.99502000000001],
            [-101.54092, 44.120869999999975],
            [-101.55708999999996, 44.325469999999974],
            [-101.71275000000003, 44.31222000000003],
            [-101.84958999999999, 44.51457999999997],
            [-102.00046999999998, 44.51051000000001],
            [-102.00042000000002, 45.187780000000004],
            [-101.99999999999999, 45.47235],
            [-101.48057999999999, 45.47268999999998],
            [-100.34174999999998, 45.47258999999996],
            [-100.48585999999999, 45.54457000000002],
            [-100.22598000000004, 45.71854000000001],
            [-100.06113999999998, 45.61520999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "PIT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-79.26413, 41.30039999999998],
            [-79.2228, 41.305279999999996],
            [-79.33156, 41.1219],
            [-79.22122000000002, 40.94961000000001],
            [-79.35963000000001, 40.90474000000003],
            [-79.35165000000003, 40.390249999999995],
            [-79.25990999999996, 40.07940999999997],
            [-79.36267999999995, 39.94873999999999],
            [-79.21765000000005, 39.721909999999994],
            [-79.43478999999994, 39.80943999999997],
            [-79.69620999999995, 39.720789999999965],
            [-80.15732000000003, 39.721169999999965],
            [-80.23865, 39.61095999999999],
            [-80.77832999999998, 39.62020999999999],
            [-80.92552000000003, 39.46382000000001],
            [-81.12141000000003, 39.457720000000045],
            [-81.22545000000002, 39.59216999999997],
            [-81.43296000000001, 39.56467999999997],
            [-81.40198999999993, 39.75831999999996],
            [-81.23730000000003, 39.86783000000002],
            [-81.22811000000002, 40.11155000000004],
            [-81.05496999999997, 40.08554000000001],
            [-81.14950000000002, 40.26801999999998],
            [-80.93292, 40.54884999999996],
            [-80.87451999999999, 40.81836],
            [-80.63736, 40.792770000000004],
            [-80.52306000000002, 40.89277000000004],
            [-80.21474999999995, 40.97603999999996],
            [-79.97749000000005, 40.97352],
            [-79.80442, 41.091190000000026],
            [-79.57279999999997, 41.02050000000003],
            [-79.54184999999995, 41.16315999999997],
            [-79.26413, 41.30039999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "PNS" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-85.84678, 30.23075999999997],
              [-86.32960999999997, 30.38199999999999],
              [-86.24829000000003, 30.428830000000044],
              [-85.84678, 30.23075999999997],
            ],
          ],
          [
            [
              [-85.83121999999997, 30.994130000000013],
              [-85.82242, 30.735400000000006],
              [-85.91596000000001, 30.636900000000004],
              [-85.87951000000004, 30.413090000000047],
              [-85.77778999999998, 30.28817000000003],
              [-85.99454999999998, 30.31204],
              [-86.09937000000002, 30.408260000000002],
              [-86.22222999999994, 30.47558999999999],
              [-86.60127, 30.40146000000003],
              [-86.94963000000001, 30.3954],
              [-87.10698999999997, 30.548749999999984],
              [-87.26685999999992, 30.343889999999966],
              [-87.57196999999996, 30.355199999999975],
              [-87.72874999999999, 30.280039999999968],
              [-87.82498999999996, 30.41289000000002],
              [-87.69108999999997, 30.603750000000034],
              [-87.60929999999993, 31.04025000000003],
              [-87.66193000000001, 31.252779999999973],
              [-87.37982, 31.32951000000003],
              [-86.81108999999998, 31.330689999999965],
              [-86.79892999999998, 31.1471],
              [-86.54076999999998, 31.00464],
              [-86.42562000000001, 31.185650000000013],
              [-86.26670999999999, 31.16501000000004],
              [-86.18688999999995, 30.993790000000036],
              [-85.83121999999997, 30.994130000000013],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "PRC" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-113.32609999999995, 35.84259999999996],
            [-113.33417999999996, 35.528039999999976],
            [-113.17441999999994, 35.50633000000002],
            [-112.94473000000002, 35.35253999999996],
            [-112.44068999999998, 35.26018999999997],
            [-112.3358, 35.14825000000003],
            [-112.33457999999996, 34.97307000000002],
            [-112.03866000000002, 34.97409999999998],
            [-112.08788000000003, 34.80802],
            [-111.86925000000002, 34.78748999999998],
            [-111.81760999999999, 34.60115000000003],
            [-111.55215999999996, 34.71906000000001],
            [-111.55421999999996, 34.43943999999996],
            [-111.65955000000002, 34.38639999999999],
            [-111.69487999999998, 34.18817],
            [-111.47778000000001, 34.15106000000003],
            [-111.49512999999999, 33.99996999999998],
            [-112.16496, 34.04816999999997],
            [-112.27601000000001, 33.88261999999997],
            [-112.62887999999997, 33.97116000000001],
            [-112.74232999999997, 33.767559999999975],
            [-112.92814999999997, 33.615580000000016],
            [-113.33376000000003, 33.78113000000002],
            [-113.33338000000003, 34.31772000000004],
            [-113.53107999999996, 34.30989000000001],
            [-113.66406999999995, 34.21206999999997],
            [-114.00598, 34.25377999999996],
            [-114.29253000000003, 34.41798],
            [-114.44341999999996, 34.645129999999995],
            [-113.98857999999996, 34.963199999999965],
            [-113.84779000000002, 34.733720000000005],
            [-113.46443000000001, 34.73864000000003],
            [-113.33315, 34.63640000000002],
            [-113.33296000000001, 35.42031000000003],
            [-113.57326000000002, 35.42079000000004],
            [-113.51023999999995, 35.256370000000004],
            [-113.77801, 35.26550999999997],
            [-113.69874000000002, 35.54824999999998],
            [-113.82435000000001, 35.62187999999996],
            [-113.64496999999994, 35.71490999999999],
            [-113.65330999999998, 35.89944000000002],
            [-113.45987000000001, 35.75863999999997],
            [-113.32609999999995, 35.84259999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "PUB" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-103.16370000000002, 38.849360000000026],
            [-103.01766000000002, 38.65861999999999],
            [-103.09935999999999, 38.61425],
            [-102.92306999999997, 38.420689999999965],
            [-103.11547999999998, 38.43807999999997],
            [-103.14613999999999, 38.26597000000004],
            [-102.81885000000001, 38.26723999999996],
            [-102.74120000000003, 38.00533000000001],
            [-102.83292000000003, 37.72418000000001],
            [-102.74753999999996, 37.64354],
            [-102.49096000000003, 37.64380000000002],
            [-102.47515999999996, 37.534780000000005],
            [-102.40645, 37.31664999999999],
            [-102.45978, 37.16870999999999],
            [-102.04204999999996, 37.07878999999998],
            [-102.04222, 36.99289999999999],
            [-102.80841999999998, 36.999980000000036],
            [-102.73807999999998, 36.84788],
            [-102.80476000000002, 36.71945],
            [-103.00214000000003, 36.63743000000003],
            [-103.18616999999998, 36.827910000000045],
            [-103.33909, 36.73687],
            [-103.30658999999999, 36.53475000000003],
            [-103.46375, 36.270420000000044],
            [-103.63428000000002, 36.121279999999956],
            [-103.83938999999994, 36.33693000000004],
            [-104.00868999999999, 36.29766000000005],
            [-104.00776999999998, 36.996110000000016],
            [-104.72926, 36.9936],
            [-104.75885999999996, 37.27279],
            [-105.03890999999997, 37.32671999999998],
            [-104.89311999999997, 37.52909000000004],
            [-105.12622999999998, 37.61600000000004],
            [-104.97454000000003, 37.77525999999999],
            [-105.13594999999997, 37.96600999999997],
            [-105.24809000000003, 38.25897000000004],
            [-105.14338000000002, 38.40067000000004],
            [-105.17033999999995, 38.647640000000024],
            [-105.01850000000003, 38.651340000000005],
            [-104.94160000000002, 38.519050000000014],
            [-103.84959999999998, 38.52250000000001],
            [-103.87321999999996, 38.62421999999998],
            [-103.65667000000002, 38.665220000000026],
            [-103.55811999999996, 38.95293999999997],
            [-103.36893999999995, 38.952149999999975],
            [-103.40346999999997, 38.8497],
            [-103.16370000000002, 38.849360000000026],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "PUC" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-109.04998000000002, 41.000659999999996],
            [-109.05094999999999, 39.98768999999997],
            [-109.20916000000001, 39.879019999999954],
            [-109.43160999999998, 39.997250000000044],
            [-109.55027000000003, 39.667880000000004],
            [-109.43010999999994, 39.46237000000003],
            [-109.05140000000002, 39.49766000000005],
            [-109.0539, 38.89548999999998],
            [-109.23174000000002, 38.74703000000003],
            [-109.49227, 38.69408999999999],
            [-109.67718000000004, 38.77877999999998],
            [-109.73086999999997, 38.62241999999999],
            [-109.98186000000003, 38.585720000000016],
            [-110.02519999999997, 38.49993999999998],
            [-109.88855999999996, 38.229939999999985],
            [-109.92784999999999, 38.15163999999997],
            [-111.84322999999998, 38.15128000000003],
            [-111.84910999999994, 38.423600000000036],
            [-111.76644999999995, 38.502240000000036],
            [-112.18154999999997, 38.51199999999996],
            [-112.17517000000002, 38.64087999999998],
            [-112.33920000000003, 38.836310000000026],
            [-112.73592000000002, 38.67137000000004],
            [-112.87933999999997, 38.71733999999999],
            [-112.89633, 38.86580999999997],
            [-112.77574999999999, 38.897419999999975],
            [-112.73778, 39.119059999999976],
            [-112.49533, 39.247410000000016],
            [-112.39101000000002, 39.180099999999996],
            [-112.29289999999996, 39.48641999999997],
            [-112.07423000000003, 39.32963000000002],
            [-111.95914000000003, 39.56474000000004],
            [-111.71542000000002, 39.589790000000036],
            [-111.64219000000001, 39.813019999999966],
            [-110.85771000000001, 39.813179999999974],
            [-110.89663, 40.30741000000003],
            [-110.64827000000002, 40.51527999999997],
            [-110.63360000000002, 40.76548999999997],
            [-110.26069, 40.83553000000001],
            [-109.86562, 40.76431000000004],
            [-109.80938999999998, 40.872449999999986],
            [-109.60699999999996, 40.872769999999996],
            [-109.59426000000002, 40.99833999999997],
            [-109.04998000000002, 41.000659999999996],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "PVD" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-70.26338000000004, 41.71059000000001],
              [-70.16086999999999, 41.683939999999964],
              [-70.63380000000001, 41.57339000000002],
              [-70.55694999999997, 41.772749999999974],
              [-70.26338000000004, 41.71059000000001],
            ],
          ],
          [
            [
              [-71.38180999999994, 42.13493000000001],
              [-70.99868999999998, 41.92812000000003],
              [-70.90678, 41.966690000000014],
              [-70.53740000000002, 41.81078999999998],
              [-70.91949000000002, 41.654739999999975],
              [-70.95387, 41.51430000000004],
              [-71.19532000000004, 41.45425999999998],
              [-71.17888999999997, 41.709080000000036],
              [-71.26151999999996, 41.642590000000006],
              [-71.37906999999998, 41.786960000000036],
              [-71.41436999999996, 41.51290999999996],
              [-71.51529, 41.374210000000026],
              [-71.85834999999997, 41.30337999999999],
              [-72.17695, 41.32240999999998],
              [-72.09049999999996, 41.82924000000003],
              [-71.79663, 41.89749999999996],
              [-71.79912999999999, 42.00803000000003],
              [-71.55777, 42.01439000000002],
              [-71.38180999999994, 42.13493000000001],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "PWM" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-69.19037999999998, 44.06204999999996],
              [-69.30707000000001, 43.95332999999999],
              [-69.43326999999996, 43.99126000000004],
              [-69.51477, 43.83116000000004],
              [-69.64112000000003, 43.954130000000006],
              [-70.01924, 43.86235999999996],
              [-70.19542999999999, 43.76946000000003],
              [-70.19689, 43.56540000000004],
              [-70.55896000000001, 43.321979999999975],
              [-70.65528999999995, 43.10016],
              [-70.84862999999999, 43.363670000000006],
              [-70.98725999999999, 43.41346000000001],
              [-70.9864, 43.638020000000026],
              [-71.37085999999996, 43.959149999999966],
              [-71.21082999999999, 44.08639],
              [-71.25201000000001, 44.24413999999998],
              [-71.01029999999994, 44.28499999999999],
              [-71.04070999999996, 44.796649999999964],
              [-70.77441999999999, 44.84174000000002],
              [-70.76924000000002, 44.73231000000001],
              [-70.39203000000003, 44.771469999999965],
              [-70.13182999999998, 44.60275999999998],
              [-70.13403999999997, 44.48673000000002],
              [-69.83399, 44.39109999999999],
              [-69.76221999999999, 44.51194999999996],
              [-69.63979000000003, 44.277950000000025],
              [-69.45118999999997, 44.31400999999999],
              [-69.28205999999994, 44.06292],
              [-69.19037999999998, 44.06204999999996],
            ],
          ],
          [
            [
              [-70.83471999999998, 45.27695000000004],
              [-70.81871999999996, 44.99078],
              [-71.05837000000002, 44.99132000000001],
              [-71.08434000000003, 45.30519000000001],
              [-70.83471999999998, 45.27695000000004],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "RAP" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-102.00042000000002, 45.187780000000004],
            [-102.00046999999998, 44.51051000000001],
            [-101.84958999999999, 44.51457999999997],
            [-101.71275000000003, 44.31222000000003],
            [-101.55708999999996, 44.325469999999974],
            [-101.54092, 44.120869999999975],
            [-101.32936999999997, 43.99502000000001],
            [-102.01912999999999, 43.994550000000025],
            [-102.01927999999997, 43.81386999999996],
            [-101.70370999999999, 43.758829999999975],
            [-101.71307999999998, 43.684010000000036],
            [-101.90158999999997, 43.41509999999999],
            [-102.11070999999995, 43.38986],
            [-102.08201999999996, 42.99971000000004],
            [-102.46667999999998, 42.99977999999997],
            [-104.05304000000001, 43.00056000000003],
            [-104.05504000000002, 43.50316000000002],
            [-104.55362999999997, 43.50189000000002],
            [-105.08064999999996, 43.49870999999998],
            [-105.07943, 44.17616000000004],
            [-104.62969999999994, 44.180229999999995],
            [-104.66293999999999, 44.44781000000004],
            [-104.82223999999997, 44.682219999999965],
            [-104.99978999999996, 44.73356999999999],
            [-105.03836999999997, 45.18443999999997],
            [-104.58333999999996, 45.23374000000002],
            [-104.40458999999998, 45.14906999999999],
            [-104.51926999999998, 45.34694000000003],
            [-104.24320999999995, 45.606180000000045],
            [-104.04158000000002, 45.54968999999999],
            [-104.04031999999995, 45.36898000000002],
            [-103.84009999999998, 45.21297999999997],
            [-102.95758999999997, 45.21426000000001],
            [-102.95084999999999, 45.56520999999999],
            [-103.05127999999998, 45.645600000000016],
            [-103.28931000000003, 45.59853],
            [-103.26976999999994, 45.756810000000044],
            [-103.12142999999998, 45.72718],
            [-102.94244000000002, 45.878119999999974],
            [-102.70316999999997, 45.70920999999996],
            [-102.71444999999999, 45.523800000000044],
            [-102.61024999999998, 45.44303000000002],
            [-102.60182999999999, 45.21496000000002],
            [-102.00042000000002, 45.187780000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "RDD" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-119.99943999999999, 41.994889999999955],
            [-119.99976999999994, 41.1842],
            [-120.42582999999998, 41.18409999999999],
            [-120.31037999999995, 40.94145999999998],
            [-120.36489999999999, 40.80829000000001],
            [-120.71629999999999, 40.875609999999966],
            [-120.95220000000002, 40.73881999999997],
            [-120.96665999999998, 40.49313000000002],
            [-120.84354000000003, 40.25588999999998],
            [-120.61170999999996, 40.285770000000014],
            [-120.69893999999998, 40.08111999999996],
            [-120.92008, 40.10671999999999],
            [-121.16678999999996, 39.98030000000003],
            [-121.30496999999995, 40.026880000000006],
            [-121.42985999999998, 39.911880000000004],
            [-121.76556, 39.547139999999985],
            [-121.98739, 39.53195000000002],
            [-122.13601999999999, 39.38550000000002],
            [-122.78509999999997, 39.38315],
            [-123.11156999999996, 39.27845999999997],
            [-123.13239, 39.50953000000003],
            [-122.88925999999995, 39.53034000000004],
            [-122.96007000000002, 39.844960000000015],
            [-122.90990000000001, 39.93635999999999],
            [-122.97670000000002, 40.23906999999997],
            [-123.21263999999998, 40.392420000000044],
            [-123.32177999999998, 40.36949999999999],
            [-123.52270999999999, 40.552269999999965],
            [-123.52741000000002, 40.71601000000004],
            [-123.19606000000002, 40.66201000000004],
            [-123.17218000000003, 40.86417000000004],
            [-123.30776, 40.92526999999996],
            [-123.31816999999998, 41.14089999999999],
            [-122.91747999999995, 40.99393999999998],
            [-122.89845999999999, 41.219770000000004],
            [-122.82512999999996, 41.395039999999995],
            [-122.68117999999996, 41.27786000000002],
            [-122.03576999999996, 41.51381],
            [-121.93777000000003, 41.396730000000034],
            [-121.71021000000003, 41.61982000000001],
            [-121.26126999999997, 41.45590999999999],
            [-121.30107999999997, 41.610649999999964],
            [-121.14313999999999, 41.69350999999998],
            [-121.05823, 41.971090000000004],
            [-120.87975999999999, 41.99369999999999],
            [-119.99943999999999, 41.994889999999955],
          ],
          [
            [-121.05447000000002, 41.57612000000003],
            [-121.18318999999994, 41.36357999999997],
            [-120.99231999999999, 41.43980000000002],
            [-121.05447000000002, 41.57612000000003],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "RDU" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-77.54972999999998, 36.412729999999975],
            [-77.26297, 36.15889],
            [-77.32740000000001, 36.07493000000001],
            [-77.13025999999996, 35.94008000000004],
            [-77.14525, 35.73114000000003],
            [-77.19045999999994, 35.418940000000006],
            [-77.36718999999994, 35.37287999999998],
            [-77.48437999999996, 35.44529],
            [-77.72961999999998, 35.215620000000044],
            [-78.29657999999998, 35.299860000000024],
            [-78.29051999999996, 35.171009999999995],
            [-78.45433999999997, 35.150710000000004],
            [-78.44951000000003, 34.83926999999997],
            [-78.81785999999997, 34.81633999999997],
            [-79.05822999999998, 34.97833999999997],
            [-79.09764999999996, 35.17421],
            [-79.24660999999998, 35.21330000000002],
            [-79.23294000000001, 35.08515],
            [-79.57886999999997, 35.09497],
            [-79.68075999999996, 35.17717999999998],
            [-79.48900999999992, 35.52872000000002],
            [-79.23674000000003, 35.85013999999997],
            [-79.38260999999997, 36.09397000000003],
            [-79.14891, 36.530809999999995],
            [-79.21279999999993, 36.565780000000004],
            [-79.19931999999997, 36.621359999999996],
            [-78.8313, 36.61551000000002],
            [-78.77829999999994, 36.70546999999996],
            [-78.53220999999996, 36.67324],
            [-78.27616, 36.819920000000025],
            [-78.12012999999996, 36.88732999999996],
            [-77.97170999999994, 36.54448999999999],
            [-77.78596999999999, 36.60391],
            [-77.80033999999998, 36.4948],
            [-77.54972999999998, 36.412729999999975],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "RFD" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-88.66203000000002, 42.752299999999984],
            [-88.53221000000002, 42.49494],
            [-88.36793000000003, 42.43714],
            [-88.34880000000001, 42.277180000000044],
            [-88.48902000000004, 42.23841999999997],
            [-88.40994999999998, 42.04154999999997],
            [-88.5837, 42.005390000000006],
            [-88.65671, 41.84248999999997],
            [-88.70082, 41.44972000000004],
            [-88.78825000000003, 41.27387000000002],
            [-88.92685999999998, 41.24337000000001],
            [-89.05873999999997, 41.43290999999997],
            [-89.16651999999996, 41.37209000000003],
            [-89.50035, 41.494519999999994],
            [-89.51626999999996, 41.58525999999999],
            [-89.78670999999994, 41.685830000000024],
            [-89.96286, 41.99669000000003],
            [-89.90069999999994, 42.06457999999999],
            [-89.96445000000003, 42.45184000000001],
            [-89.83792999999997, 42.60315999999999],
            [-89.63632000000001, 42.722849999999994],
            [-89.05053000000004, 42.666049999999956],
            [-88.66203000000002, 42.752299999999984],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "RIC" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-76.93518999999995, 38.08058],
              [-76.70635999999996, 38.059720000000034],
              [-76.237, 37.88892999999999],
              [-76.35986999999997, 37.60861000000001],
              [-76.72637999999998, 37.83606999999999],
              [-76.93518999999995, 38.08058],
            ],
          ],
          [
            [
              [-77.48777999999999, 38.14587999999998],
              [-77.24304999999998, 38.209870000000016],
              [-76.92866999999998, 38.07216000000001],
              [-76.89831000000001, 37.950809999999976],
              [-76.55145999999999, 37.56408000000002],
              [-76.70410999999996, 37.449340000000035],
              [-76.62660000000002, 37.31454000000002],
              [-76.87725, 37.277029999999996],
              [-76.79972000000004, 37.19383],
              [-76.85192000000004, 36.994919999999965],
              [-77.01207, 36.855729999999994],
              [-77.20424999999997, 36.863839999999996],
              [-77.16953999999998, 36.70724000000004],
              [-77.33529000000001, 36.427730000000025],
              [-77.54972999999998, 36.412729999999975],
              [-77.80033999999998, 36.4948],
              [-77.78596999999999, 36.60391],
              [-77.97170999999994, 36.54448999999999],
              [-78.12012999999996, 36.88732999999996],
              [-78.27616, 36.819920000000025],
              [-78.09715, 37.02231000000004],
              [-78.22471999999999, 37.08982],
              [-78.20759999999993, 37.426060000000035],
              [-78.40565999999998, 37.47392999999998],
              [-78.28883999999994, 37.54932000000001],
              [-78.35456999999997, 37.98731000000001],
              [-78.25859999999997, 38.04424999999999],
              [-78.40301999999994, 38.1895],
              [-78.11625000000001, 38.197240000000036],
              [-77.80247, 38.07882999999998],
              [-77.48777999999999, 38.14587999999998],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "RNO" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-117.17939000000003, 39.16313000000002],
            [-117.34057999999997, 38.95509999999999],
            [-117.32562999999998, 38.814539999999994],
            [-117.46615999999997, 38.58611999999998],
            [-117.64218999999997, 38.42958999999996],
            [-117.69152999999996, 38.473470000000006],
            [-118.35154999999999, 37.893769999999975],
            [-118.42824999999996, 37.89617999999999],
            [-118.88263999999994, 38.22071999999998],
            [-119.04448000000002, 38.13712000000002],
            [-119.20611999999998, 38.17354000000001],
            [-119.45900999999996, 38.095860000000044],
            [-119.61834000000002, 38.24861000000003],
            [-119.71285000000002, 38.41866999999998],
            [-119.88477000000003, 38.35620000000003],
            [-120.07257, 38.44715],
            [-120.07058999999995, 38.70275999999996],
            [-120.27480999999995, 38.559190000000044],
            [-120.39240000000001, 38.643509999999985],
            [-120.30009999999999, 38.77734000000003],
            [-120.09194999999998, 38.85678999999999],
            [-120.19486999999995, 39.16984000000001],
            [-120.65475999999998, 39.52682999999996],
            [-120.89130000000003, 39.42535999999998],
            [-120.83245999999995, 39.55074999999998],
            [-120.87077000000001, 39.77687999999996],
            [-121.07661000000002, 39.59733999999999],
            [-121.42985999999998, 39.911880000000004],
            [-121.30496999999995, 40.026880000000006],
            [-121.16678999999996, 39.98030000000003],
            [-120.92008, 40.10671999999999],
            [-120.69893999999998, 40.08111999999996],
            [-120.61170999999996, 40.285770000000014],
            [-120.84354000000003, 40.25588999999998],
            [-120.96665999999998, 40.49313000000002],
            [-120.95220000000002, 40.73881999999997],
            [-120.71629999999999, 40.875609999999966],
            [-120.36489999999999, 40.80829000000001],
            [-120.31037999999995, 40.94145999999998],
            [-120.42582999999998, 41.18409999999999],
            [-119.99976999999994, 41.1842],
            [-119.99943999999999, 41.994889999999955],
            [-119.32417000000001, 41.99387999999996],
            [-119.30409999999995, 41.304289999999966],
            [-119.33865999999996, 39.99841000000001],
            [-117.54171000000001, 40.00104000000002],
            [-117.46172999999999, 39.88791000000002],
            [-117.48220999999995, 39.55507999999996],
            [-117.75625, 39.37582999999999],
            [-117.77545999999995, 39.09333000000003],
            [-117.17939000000003, 39.16313000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ROA" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-79.48242000000002, 38.08607999999997],
            [-79.65074999999999, 37.87156999999998],
            [-79.68367000000003, 37.66160000000002],
            [-79.49861999999996, 37.532820000000015],
            [-79.66707000000002, 37.30504000000003],
            [-79.56794999999997, 37.237689999999986],
            [-79.61561999999998, 36.72697000000004],
            [-79.81824999999998, 36.861040000000045],
            [-79.93226000000004, 36.69969000000001],
            [-80.17375999999996, 36.823160000000044],
            [-80.40503999999999, 36.63527000000001],
            [-80.66159999999994, 36.725540000000024],
            [-80.80722, 36.630330000000015],
            [-80.93208000000004, 36.77868000000001],
            [-81.02845000000002, 36.667399999999965],
            [-81.11085, 36.76772000000001],
            [-81.09490000000002, 36.85201999999998],
            [-80.81445999999997, 36.88393000000002],
            [-80.91285000000002, 37.073059999999984],
            [-81.11431999999994, 37.02256999999997],
            [-80.61006, 37.24417000000004],
            [-80.67452999999998, 37.53745999999997],
            [-80.54284999999999, 37.54708000000004],
            [-80.43357999999998, 37.77721000000004],
            [-80.22837999999999, 37.96296999999997],
            [-80.05679, 37.95188999999998],
            [-79.78100999999998, 38.037860000000016],
            [-79.60411999999997, 38.19204000000002],
            [-79.48242000000002, 38.08607999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ROC" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-76.92768999999998, 43.236100000000015],
            [-76.87412000000003, 43.151540000000026],
            [-76.96337000000003, 42.896779999999964],
            [-76.89565999999996, 42.541529999999995],
            [-77.15675999999993, 42.385960000000004],
            [-77.34172999999996, 42.47173000000001],
            [-77.53049000000004, 42.44469000000004],
            [-78.12195, 42.571739999999984],
            [-78.05024, 42.76517000000001],
            [-78.16282999999999, 42.86436],
            [-78.13088999999994, 43.046369999999975],
            [-78.32327999999998, 43.20757999999997],
            [-78.28034, 43.371769999999984],
            [-77.76005999999998, 43.341190000000026],
            [-77.54916, 43.23563999999997],
            [-77.14633, 43.29014000000004],
            [-76.92768999999998, 43.236100000000015],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "ROW" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-103.36617, 34.70206000000004],
            [-103.45718999999998, 34.585210000000004],
            [-103.44206999999996, 34.31081999999996],
            [-103.57204999999995, 34.23490999999998],
            [-103.40855, 34.01094000000002],
            [-103.15712999999998, 34.03176999999999],
            [-103.04924999999997, 33.90724],
            [-103.21858, 33.78823999999997],
            [-103.04991999999999, 33.70851000000003],
            [-103.06464999999999, 32.95909000000003],
            [-103.06450999999996, 32.000419999999956],
            [-104.02425999999994, 32.000199999999964],
            [-105.81137000000001, 32.00162999999998],
            [-105.83009000000003, 32.25585000000004],
            [-105.74177999999999, 32.54659000000001],
            [-105.86106000000001, 32.61523000000003],
            [-105.86556000000002, 32.93125000000003],
            [-105.98303000000001, 33.027500000000025],
            [-106.12081999999997, 32.95587999999999],
            [-106.34051000000001, 33.05271000000002],
            [-106.34578999999998, 33.39065000000002],
            [-105.89821, 33.38990999999999],
            [-105.83022999999997, 33.63434999999998],
            [-105.72801000000001, 33.73027999999997],
            [-105.52326999999998, 33.656760000000034],
            [-105.61279000000002, 34.11749999999997],
            [-105.30323000000003, 33.976080000000046],
            [-104.89352999999996, 34.01861000000003],
            [-104.89197999999996, 34.60441999999996],
            [-104.44486000000003, 34.60495999999996],
            [-104.33994999999999, 34.77902999999997],
            [-104.12905999999994, 34.77934000000004],
            [-104.12931000000002, 34.89346999999999],
            [-103.72483000000003, 34.823179999999965],
            [-103.44187000000001, 34.86542999999997],
            [-103.36617, 34.70206000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "RST" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-90.76311999999993, 43.83534000000004],
            [-90.62165999999999, 43.74780999999998],
            [-90.78491999999997, 43.60751],
            [-91.04342999999997, 43.55944000000002],
            [-91.03058000000001, 43.43329000000002],
            [-91.44808, 43.41119000000004],
            [-91.34486000000001, 43.27499000000001],
            [-91.38769999999997, 43.12985999999998],
            [-91.65468999999996, 43.233000000000025],
            [-91.82409000000001, 43.16208000000001],
            [-91.90337999999997, 43.24113],
            [-92.65858999999995, 43.21251000000003],
            [-93.13368, 43.25511000000004],
            [-93.49756, 43.24871000000003],
            [-93.66762999999997, 43.183810000000015],
            [-93.86206000000004, 43.255260000000014],
            [-93.93802, 43.162210000000016],
            [-94.45574000000002, 43.16212999999997],
            [-94.67756, 43.28054999999997],
            [-94.49271000000005, 43.543519999999965],
            [-94.61420999999999, 43.58729999999999],
            [-94.56222999999997, 43.74295999999997],
            [-94.31489999999994, 43.78222999999996],
            [-94.34200000000001, 43.927639999999975],
            [-94.05824999999999, 43.93517999999998],
            [-93.81821, 44.07972000000004],
            [-93.70481999999998, 43.956790000000005],
            [-93.52538000000001, 44.20298000000002],
            [-93.11923999999999, 44.196650000000034],
            [-92.73225000000002, 44.47779],
            [-92.38633000000002, 44.47622000000004],
            [-92.29411999999999, 44.70777000000003],
            [-92.22569000000001, 44.55783000000002],
            [-92.04729000000003, 44.50713000000003],
            [-92.08365000000003, 44.40745000000001],
            [-91.83727000000002, 44.23010999999998],
            [-91.75705999999997, 44.26877999999998],
            [-91.19236000000001, 43.93244999999996],
            [-91.01880999999995, 43.772470000000034],
            [-90.76311999999993, 43.83534000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SAC" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-122.06068999999994, 38.14571000000004],
            [-122.28587999999995, 38.20446000000003],
            [-122.54488, 38.52054000000002],
            [-122.75936, 38.66487000000002],
            [-123.06924999999994, 38.61604999999999],
            [-123.32144, 38.85439000000001],
            [-123.47829000000003, 38.90263999999996],
            [-123.31961999999996, 39.065390000000015],
            [-123.56126, 39.16994000000002],
            [-123.52061999999998, 39.27269000000004],
            [-123.26317000000002, 39.22832000000004],
            [-123.11156999999996, 39.27845999999997],
            [-122.78509999999997, 39.38315],
            [-122.13601999999999, 39.38550000000002],
            [-121.98739, 39.53195000000002],
            [-121.76556, 39.547139999999985],
            [-121.42985999999998, 39.911880000000004],
            [-121.07661000000002, 39.59733999999999],
            [-120.87077000000001, 39.77687999999996],
            [-120.83245999999995, 39.55074999999998],
            [-120.89130000000003, 39.42535999999998],
            [-120.65475999999998, 39.52682999999996],
            [-120.19486999999995, 39.16984000000001],
            [-120.09194999999998, 38.85678999999999],
            [-120.30009999999999, 38.77734000000003],
            [-120.39240000000001, 38.643509999999985],
            [-120.27480999999995, 38.559190000000044],
            [-120.07058999999995, 38.70275999999996],
            [-120.07257, 38.44715],
            [-119.88477000000003, 38.35620000000003],
            [-119.71285000000002, 38.41866999999998],
            [-119.61834000000002, 38.24861000000003],
            [-120.02367, 38.07334999999998],
            [-120.09544, 37.90063999999997],
            [-120.29638999999997, 37.87703000000002],
            [-120.49407999999997, 37.64716999999997],
            [-120.99436999999996, 37.50777999999996],
            [-121.15430999999995, 37.55389999999998],
            [-121.35485000000003, 37.79779999999997],
            [-121.55010000000001, 37.832280000000026],
            [-121.56965999999997, 38.00356000000002],
            [-121.75234999999999, 38.017949999999956],
            [-122.06068999999994, 38.14571000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SAF" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-103.71438000000003, 36.08548000000002],
            [-103.36500000000001, 36.08630000000001],
            [-103.38002000000003, 35.398249999999976],
            [-103.63698999999998, 35.38974],
            [-103.63723999999998, 35.240939999999995],
            [-103.85735999999997, 35.24204999999999],
            [-104.12497000000002, 35.14198000000003],
            [-104.12931000000002, 34.89346999999999],
            [-104.12905999999994, 34.77934000000004],
            [-104.33994999999999, 34.77902999999997],
            [-104.44486000000003, 34.60495999999996],
            [-104.89197999999996, 34.60441999999996],
            [-104.89352999999996, 34.01861000000003],
            [-105.30323000000003, 33.976080000000046],
            [-105.61279000000002, 34.11749999999997],
            [-105.52326999999998, 33.656760000000034],
            [-105.72801000000001, 33.73027999999997],
            [-105.83022999999997, 33.63434999999998],
            [-105.89821, 33.38990999999999],
            [-106.34578999999998, 33.39065000000002],
            [-106.37266000000002, 33.47980000000001],
            [-106.37354, 33.66053000000004],
            [-106.05268000000002, 33.65026000000002],
            [-106.05272999999998, 33.82543],
            [-105.92469999999994, 33.82554999999998],
            [-105.9238, 34.259989999999966],
            [-106.41592999999995, 34.25973000000003],
            [-106.46954000000001, 34.52125999999999],
            [-106.4823, 34.94407999999999],
            [-106.32864999999997, 35.13885999999999],
            [-106.41459, 35.67917000000004],
            [-106.26596000000002, 35.77960000000004],
            [-106.39942, 35.96000000000003],
            [-106.24725999999998, 36.00158000000002],
            [-106.88521000000003, 35.999059999999965],
            [-106.88622999999995, 36.12146000000002],
            [-107.14675999999996, 35.992620000000024],
            [-107.30651000000003, 36.08017000000005],
            [-107.31033, 36.216600000000014],
            [-107.21769, 36.27992000000003],
            [-107.15898999999996, 36.53234000000002],
            [-106.71861000000001, 36.51198000000004],
            [-106.71137999999999, 36.34678999999998],
            [-106.37054999999997, 36.20837000000003],
            [-106.09966999999999, 36.176559999999995],
            [-105.99060999999995, 36.27472999999996],
            [-105.84602999999996, 36.218739999999976],
            [-105.70967999999995, 36.304659999999956],
            [-105.47844000000003, 36.18584],
            [-105.36446999999998, 36.26221999999996],
            [-104.86536999999994, 36.26130999999998],
            [-104.86536999999994, 36.217819999999975],
            [-104.00867000000001, 36.21810999999998],
            [-103.71438000000003, 36.08548000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SAN" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-117.64532999999999, 33.44050000000002],
            [-117.37245, 33.505050000000026],
            [-117.30260999999999, 33.69249999999998],
            [-117.10763999999999, 33.90651],
            [-116.96079999999996, 33.86104999999996],
            [-116.92950000000003, 34.034090000000006],
            [-116.71840999999995, 34.03381999999996],
            [-116.58519999999996, 34.242409999999964],
            [-116.25581999999999, 34.294419999999974],
            [-116.30030000000002, 34.56625999999997],
            [-115.68954999999995, 34.41695000000004],
            [-115.70404, 34.28798000000003],
            [-115.52861, 34.22800999999999],
            [-115.29361999999996, 34.28214],
            [-115.25671999999994, 34.172859999999964],
            [-115.31616000000001, 34.03410000000004],
            [-115.74892, 34.03527000000003],
            [-115.73249999999996, 33.74864000000004],
            [-115.57993000000003, 33.42723000000002],
            [-115.92012999999999, 33.42673000000004],
            [-115.73690999999998, 33.23578000000004],
            [-115.88534999999997, 33.01983000000001],
            [-115.88603999999995, 32.86712000000004],
            [-116.10311999999995, 32.954419999999985],
            [-116.10362000000002, 32.83396999999998],
            [-115.86605999999996, 32.76965],
            [-116.10622999999997, 32.61839000000001],
            [-117.12475999999995, 32.534289999999984],
            [-117.12653999999998, 32.68807999999996],
            [-117.28235999999995, 32.84004999999998],
            [-117.33683000000003, 33.14284],
            [-117.64532999999999, 33.44050000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SAT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-98.96407999999995, 30.498590000000007],
            [-98.74430999999996, 30.498869999999993],
            [-98.80071000000002, 30.37752999999998],
            [-98.59063000000002, 30.443140000000028],
            [-98.49143999999995, 30.166659999999982],
            [-98.24404000000001, 30.175049999999974],
            [-98.29747, 30.037939999999967],
            [-97.92659, 29.738839999999993],
            [-97.81691000000001, 29.790239999999983],
            [-97.69295999999994, 29.570789999999995],
            [-97.66686999999996, 29.071409999999968],
            [-97.77199999999999, 29.087100000000003],
            [-97.86180999999998, 28.848699999999987],
            [-98.06643000000003, 28.75345999999998],
            [-98.00524999999996, 28.690260000000027],
            [-98.24018999999996, 28.53609999999999],
            [-98.33539000000003, 28.64836999999997],
            [-98.46400999999994, 28.485869999999995],
            [-98.33443999999994, 28.303499999999985],
            [-98.33427, 28.057860000000005],
            [-98.80333, 28.057460000000038],
            [-98.80074999999997, 28.46077000000004],
            [-98.90583999999997, 28.465960000000027],
            [-98.96699999999997, 28.64592000000003],
            [-99.62832, 28.642970000000016],
            [-99.81797, 29.08894000000001],
            [-99.50230999999995, 29.090859999999978],
            [-99.53603000000001, 29.222670000000043],
            [-99.67323, 29.219440000000045],
            [-99.74849000000002, 29.453900000000026],
            [-99.61030000000001, 29.564870000000003],
            [-99.60251000000001, 29.90763999999996],
            [-99.69117999999997, 29.90852000000003],
            [-99.75555999999996, 30.21333000000003],
            [-99.53790999999995, 30.239810000000038],
            [-99.48460999999996, 30.49964999999996],
            [-98.96407999999995, 30.498590000000007],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SAV" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-81.5846, 31.40958000000004],
            [-81.63909999999998, 31.487369999999963],
            [-81.85106000000002, 31.354030000000048],
            [-82.04182, 31.384249999999973],
            [-82.30245999999994, 31.586050000000025],
            [-82.39418999999998, 31.385139999999982],
            [-82.62741999999997, 31.666419999999988],
            [-82.62738999999996, 31.672640000000023],
            [-82.52140000000003, 31.67252000000004],
            [-82.43107999999995, 31.965999999999976],
            [-82.47633000000002, 32.28267999999996],
            [-82.35011, 32.41357000000002],
            [-82.23999999999995, 32.36854000000004],
            [-82.14840000000001, 32.520500000000034],
            [-81.81088999999997, 32.64753000000002],
            [-81.68954000000002, 32.54616999999999],
            [-81.42983000000001, 32.496369999999956],
            [-81.38923999999997, 32.59546000000002],
            [-80.97045, 32.30478999999997],
            [-80.87510999999998, 32.161210000000025],
            [-81.03460999999996, 32.06334000000001],
            [-81.25563, 31.757550000000016],
            [-81.13055, 31.626159999999974],
            [-81.41622999999998, 31.347980000000046],
            [-81.5846, 31.40958000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SBA" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-120.05368999999999, 34.037149999999976],
              [-119.96782999999999, 33.942940000000014],
              [-120.11549999999994, 33.894080000000045],
              [-120.24886999999994, 34.001340000000006],
              [-120.05368999999999, 34.037149999999976],
            ],
          ],
          [
            [
              [-118.80447999999996, 34.63320999999996],
              [-118.68375999999999, 34.387699999999995],
              [-118.833, 34.358969999999985],
              [-118.86041999999998, 34.177169999999975],
              [-119.07346000000003, 34.09186000000001],
              [-119.26539999999996, 34.26077000000002],
              [-119.56199, 34.414259999999956],
              [-119.87830000000001, 34.40684999999996],
              [-120.13700000000001, 34.47325000000001],
              [-120.47203000000003, 34.448260000000005],
              [-120.6503, 34.57698000000002],
              [-120.63117, 35.09881000000003],
              [-120.71704999999996, 35.17393000000001],
              [-120.62672999999998, 35.15024000000001],
              [-120.56999999999996, 35.355549999999965],
              [-120.4394, 35.23895],
              [-119.95574000000002, 35.055589999999974],
              [-119.76878, 34.91374],
              [-119.60988, 34.68621],
              [-119.32923, 34.67450999999996],
              [-119.23656, 34.57731999999999],
              [-119.16261, 34.81309],
              [-118.88130000000001, 34.79062999999999],
              [-118.80447999999996, 34.63320999999996],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SBN" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-85.18948999999998, 42.07239999999998],
            [-85.17093, 41.988909999999976],
            [-85.29237, 41.906230000000015],
            [-85.19498000000002, 41.66338999999998],
            [-85.52164999999994, 41.65533000000003],
            [-85.46007, 41.52544999999996],
            [-85.65495000000001, 41.533659999999976],
            [-85.65355, 41.365220000000036],
            [-85.98998999999998, 41.31188999999996],
            [-86.12575999999996, 40.99991000000002],
            [-86.53314, 40.707819999999984],
            [-86.76469, 40.649110000000015],
            [-87.01596000000004, 40.68484999999997],
            [-86.93066999999996, 40.809690000000025],
            [-87.26807999999997, 40.881240000000034],
            [-87.34313999999998, 41.03288999999996],
            [-87.34361999999999, 41.24613999999997],
            [-87.20649999999995, 41.39594000000004],
            [-87.20225000000002, 41.62729],
            [-86.92290000000003, 41.71351999999996],
            [-86.59653999999998, 41.920320000000004],
            [-86.31249999999997, 42.328999999999965],
            [-86.13658999999996, 42.382649999999956],
            [-85.82795000000004, 42.323100000000025],
            [-85.73350000000002, 42.182839999999985],
            [-85.34029000000001, 42.150130000000004],
            [-85.18948999999998, 42.07239999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SDF" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-85.77182000000002, 39.00620999999997],
            [-85.73932999999994, 38.90298000000003],
            [-85.53767000000002, 38.891879999999986],
            [-85.54488999999992, 38.73739],
            [-85.25874000000002, 38.737750000000034],
            [-85.21789999999999, 38.59320000000003],
            [-85.00774999999996, 38.550299999999986],
            [-85.03693999999993, 38.19064],
            [-85.28280000000001, 38.02602000000003],
            [-85.16777000000002, 37.97173000000002],
            [-85.22299999999998, 37.82766999999997],
            [-85.04255999999998, 37.647320000000036],
            [-85.33576000000002, 37.621470000000016],
            [-85.37985000000003, 37.523899999999955],
            [-85.78833999999998, 37.501370000000016],
            [-86.06701000000004, 37.65337999999997],
            [-86.43648000000002, 37.683230000000016],
            [-86.4316, 37.870549999999966],
            [-86.59061999999997, 37.91941000000003],
            [-86.68008999999998, 38.293130000000005],
            [-86.68327999999994, 38.729800000000026],
            [-86.45232000000001, 38.81170999999996],
            [-86.27528999999998, 38.76308000000001],
            [-86.08863, 39.093800000000016],
            [-85.77182000000002, 39.00620999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SEA" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-122.83243, 47.330200000000026],
              [-122.97344999999997, 47.37935000000002],
              [-123.05249999999995, 47.37004999999996],
              [-122.91016999999997, 47.45648000000004],
              [-123.02289999999999, 47.520230000000026],
              [-122.52601999999996, 47.912290000000006],
              [-122.48211999999995, 47.81405999999996],
              [-122.61025999999994, 47.567670000000014],
              [-122.49538000000001, 47.51003999999996],
              [-122.60091000000001, 47.27202999999997],
              [-122.83243, 47.330200000000026],
            ],
          ],
          [
            [
              [-122.71658000000002, 47.98795],
              [-122.68726999999998, 47.83242999999997],
              [-122.85312000000003, 47.78079000000001],
              [-123.11307, 47.46078000000002],
              [-123.12885000000001, 47.58579999999996],
              [-123.50438999999994, 47.607010000000024],
              [-123.50597000000002, 47.51773999999997],
              [-124.35442999999994, 47.53369000000002],
              [-124.42721999999996, 47.74247999999996],
              [-124.61138999999996, 47.880729999999964],
              [-124.21992999999998, 47.88141000000001],
              [-122.94883999999996, 47.867279999999994],
              [-122.71658000000002, 47.98795],
            ],
          ],
          [
            [
              [-121.17296999999998, 47.931230000000006],
              [-121.06711000000003, 47.70618999999998],
              [-121.30073999999999, 47.49065000000003],
              [-121.11434999999999, 47.21885999999999],
              [-121.34164000000003, 47.28183000000001],
              [-121.29764, 47.14857999999999],
              [-121.52268999999997, 46.873430000000035],
              [-121.44286999999996, 46.792570000000026],
              [-121.81234, 46.74728000000003],
              [-121.83245, 46.85360000000002],
              [-122.22731000000002, 46.923169999999985],
              [-122.19919999999996, 47.06784999999999],
              [-122.38450999999996, 47.07670999999997],
              [-122.58251000000001, 47.19315000000001],
              [-122.32413999999996, 47.34937999999999],
              [-122.43613000000003, 47.66202000000001],
              [-122.30648, 47.948910000000026],
              [-122.22940999999996, 47.97142],
              [-121.58264999999999, 48.020680000000034],
              [-121.17296999999998, 47.931230000000006],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SFO" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-121.75234999999999, 38.017949999999956],
              [-121.56965999999997, 38.00356000000002],
              [-121.55010000000001, 37.832280000000026],
              [-121.35485000000003, 37.79779999999997],
              [-121.15430999999995, 37.55389999999998],
              [-120.99436999999996, 37.50777999999996],
              [-121.05825999999999, 37.27067000000001],
              [-121.38517999999999, 37.356179999999995],
              [-121.45905999999997, 37.28230000000003],
              [-121.23662999999998, 37.15666999999998],
              [-121.24589, 36.983040000000045],
              [-121.04677999999994, 36.73828999999999],
              [-121.27018, 36.66371000000001],
              [-121.53287, 36.34626],
              [-121.55841999999998, 36.07927000000001],
              [-121.23241999999998, 35.90869000000002],
              [-121.18372999999995, 35.79388999999996],
              [-121.34784, 35.79518000000003],
              [-121.67558, 36.163330000000016],
              [-121.90268000000003, 36.30696000000002],
              [-121.97859000000001, 36.581479999999985],
              [-121.84940999999995, 36.62146000000001],
              [-121.78961999999997, 36.80779999999996],
              [-121.90169999999995, 36.975449999999995],
              [-122.10579999999997, 36.95615000000005],
              [-122.40569000000002, 37.19774999999998],
              [-122.51986999999994, 37.53377000000002],
              [-122.51463, 37.78098000000004],
              [-122.38443000000001, 37.78741000000005],
              [-122.37794000000001, 37.60542000000004],
              [-122.10692, 37.50026000000001],
              [-122.16265999999999, 37.6703],
              [-122.39470000000003, 37.95479000000003],
              [-122.24413000000003, 38.058300000000045],
              [-122.14602999999998, 38.021900000000024],
              [-122.02451, 38.057940000000016],
              [-121.75234999999999, 38.017949999999956],
            ],
          ],
          [
            [
              [-123.47829000000003, 38.90263999999996],
              [-123.32144, 38.85439000000001],
              [-123.06924999999994, 38.61604999999999],
              [-122.75936, 38.66487000000002],
              [-122.54488, 38.52054000000002],
              [-122.28587999999995, 38.20446000000003],
              [-122.06068999999994, 38.14571000000004],
              [-122.13834, 38.03971999999999],
              [-122.40606, 38.155289999999994],
              [-122.48486, 38.099340000000026],
              [-122.52933, 37.81531000000004],
              [-122.90934999999998, 38.05158000000003],
              [-123.13079999999998, 38.45182999999998],
              [-123.33381999999999, 38.565809999999956],
              [-123.65574999999994, 38.86811000000003],
              [-123.47829000000003, 38.90263999999996],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SGF" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-93.70685, 38.488300000000024],
            [-93.69429999999997, 38.41179000000005],
            [-93.39957000000001, 38.38017000000002],
            [-93.05109000000002, 38.270039999999995],
            [-92.82246000000004, 38.03564000000001],
            [-92.85003, 37.913529999999966],
            [-92.53557000000004, 37.96143],
            [-92.48533999999995, 37.68757000000002],
            [-92.33157000000003, 37.64013000000003],
            [-92.07249000000002, 37.70432000000001],
            [-92.02932000000001, 37.6024],
            [-91.78605999999994, 37.576620000000005],
            [-91.64135000000005, 37.279839999999965],
            [-91.31244000000004, 37.27954000000001],
            [-91.26401000000004, 37.20046000000003],
            [-91.28722000000002, 37.05876000000003],
            [-91.43843000000004, 36.943619999999996],
            [-91.22300999999999, 36.883840000000035],
            [-91.12037000000001, 36.747640000000004],
            [-91.12691999999998, 36.497669999999964],
            [-91.28713999999997, 36.49738999999998],
            [-91.48749999999998, 36.36496000000004],
            [-91.67210999999998, 36.34082999999996],
            [-91.73902999999996, 36.49931000000004],
            [-92.09808000000001, 36.25978000000005],
            [-92.36831999999995, 36.20707999999996],
            [-92.41153, 36.06269999999999],
            [-92.69566, 36.12052999999999],
            [-92.94017, 36.00327999999999],
            [-93.37591999999992, 36.12277999999999],
            [-93.55116000000001, 36.126220000000046],
            [-93.65761999999995, 36.30298999999998],
            [-93.97724000000002, 36.34060999999997],
            [-94.05768, 36.44093000000001],
            [-94.23920999999996, 36.409670000000006],
            [-94.61463, 36.49928000000004],
            [-94.61793999999995, 36.91972000000003],
            [-94.70934999999997, 36.886840000000014],
            [-95.07435999999996, 37.14713999999998],
            [-94.97727999999992, 37.33272999999996],
            [-95.088, 37.38384999999997],
            [-95.15205999999998, 37.6468],
            [-94.95441999999994, 37.755239999999986],
            [-94.82365000000004, 37.99378000000004],
            [-94.61432999999997, 37.97253999999998],
            [-94.48444000000003, 37.99907999999998],
            [-94.50217999999995, 38.193190000000044],
            [-94.14326, 38.15683000000004],
            [-94.07080000000002, 38.321300000000036],
            [-93.70685, 38.488300000000024],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SHR" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-106.93911999999996, 45.86966999999999],
            [-106.91315999999999, 45.68392000000001],
            [-106.53564999999995, 45.712799999999994],
            [-106.47448, 45.655110000000036],
            [-106.72947, 45.57289000000004],
            [-106.72960000000002, 45.42577999999997],
            [-106.58223999999996, 45.33449999999996],
            [-106.23574999999995, 45.35184],
            [-106.23302000000002, 45.689160000000044],
            [-106.06285999999997, 45.53957999999997],
            [-106.10335999999995, 45.40031000000004],
            [-105.96844999999998, 45.38283999999999],
            [-105.84698999999999, 45.18439],
            [-105.67571, 45.145419999999966],
            [-105.47670999999997, 45.37423],
            [-105.46410999999999, 45.25822000000001],
            [-105.13036999999996, 45.322969999999955],
            [-105.03836999999997, 45.18443999999997],
            [-104.99978999999996, 44.73356999999999],
            [-104.82223999999997, 44.682219999999965],
            [-104.66293999999999, 44.44781000000004],
            [-104.62969999999994, 44.180229999999995],
            [-105.07943, 44.17616000000004],
            [-105.08064999999996, 43.49870999999998],
            [-106.01765999999996, 43.49500999999999],
            [-106.00982, 44.08798000000002],
            [-106.17182, 44.02255000000003],
            [-106.31454000000001, 44.143700000000045],
            [-106.50042999999995, 43.952559999999956],
            [-106.79520999999997, 43.88667000000001],
            [-107.12842000000003, 44.099369999999986],
            [-107.11089, 43.50016999999999],
            [-107.59517999999998, 43.501320000000014],
            [-107.71596999999996, 43.733250000000005],
            [-107.95647999999994, 43.73335999999996],
            [-107.9565, 43.818629999999985],
            [-108.17493999999999, 43.818969999999965],
            [-108.42959999999997, 43.90334000000004],
            [-108.55089000000001, 44.07933000000001],
            [-108.57363999999995, 44.445829999999994],
            [-108.55682000000003, 44.72037000000002],
            [-108.26527, 44.561690000000006],
            [-108.2062, 44.72987000000001],
            [-107.79831000000003, 44.75677000000004],
            [-107.91166999999996, 45.00101],
            [-107.75431, 45.13132999999998],
            [-107.86286999999997, 45.25500000000004],
            [-107.79105000000001, 45.430319999999995],
            [-107.62332000000002, 45.45880000000002],
            [-107.63519000000001, 45.636179999999975],
            [-107.26420999999998, 45.548859999999976],
            [-107.33115999999997, 45.749400000000044],
            [-107.17640999999996, 45.91339999999997],
            [-106.93911999999996, 45.86966999999999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SHV" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-93.63610999999995, 33.973640000000046],
            [-93.37341, 33.95707000000003],
            [-93.10402999999997, 33.77696999999999],
            [-92.92889, 33.82250000000003],
            [-92.66505999999998, 33.66001],
            [-92.77583000000001, 33.550289999999976],
            [-92.82059000000004, 33.30068999999999],
            [-92.98535999999999, 33.132180000000034],
            [-92.98883999999998, 33.01752000000002],
            [-92.81618999999995, 32.99606999999999],
            [-92.91479999999999, 32.858750000000015],
            [-92.79839000000004, 32.607470000000035],
            [-92.89340000000001, 32.54149000000001],
            [-92.81482000000003, 32.14712000000003],
            [-93.00957000000002, 31.93388999999999],
            [-92.88289999999998, 31.83822999999996],
            [-93.04156000000003, 31.675669999999993],
            [-92.99658, 31.36014999999998],
            [-93.30478999999994, 31.364079999999987],
            [-93.37621999999999, 31.24590000000004],
            [-93.91086999999996, 31.15814999999999],
            [-94.12951999999993, 31.09929000000004],
            [-94.37412999999995, 31.26933999999996],
            [-94.56199999999993, 31.058770000000006],
            [-94.69344999999996, 31.095990000000022],
            [-94.77142000000003, 31.26940999999998],
            [-94.86363, 31.23031000000002],
            [-95.11833999999999, 31.531559999999985],
            [-95.25957000000002, 31.576900000000034],
            [-95.40238999999997, 31.761830000000028],
            [-95.42031000000003, 31.92656000000004],
            [-95.62409999999997, 32.06815],
            [-95.57667000000001, 32.22009000000003],
            [-95.47256000000002, 32.37149999999999],
            [-95.59421, 32.47993000000004],
            [-95.49049999999997, 32.61434999999996],
            [-95.34218000000004, 32.60407],
            [-95.22692999999995, 32.732679999999974],
            [-95.40932999999998, 32.91702],
            [-95.30787999999995, 33.166700000000034],
            [-95.31046, 33.533580000000015],
            [-95.20029999999997, 33.52289999999999],
            [-95.16088000000002, 33.704130000000006],
            [-95.25520000000003, 33.794650000000004],
            [-95.16186000000002, 33.93797000000002],
            [-94.70902999999996, 33.685670000000016],
            [-94.48587999999998, 33.63633999999997],
            [-94.47728999999998, 33.940700000000035],
            [-94.30312999999998, 33.82129999999996],
            [-93.95916000000003, 33.75098999999996],
            [-94.03251000000003, 33.90972999999997],
            [-93.87563, 33.872370000000004],
            [-93.63610999999995, 33.973640000000046],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SJT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-99.09171999999997, 31.188410000000026],
            [-99.09035000000003, 30.702449999999974],
            [-98.96376999999997, 30.704340000000034],
            [-98.96407999999995, 30.498590000000007],
            [-99.48460999999996, 30.49964999999996],
            [-99.53790999999995, 30.239810000000038],
            [-99.75555999999996, 30.21333000000003],
            [-99.75409999999995, 30.29063],
            [-101.75794999999995, 30.28937000000002],
            [-101.64541999999996, 30.561110000000006],
            [-101.76874000000001, 30.653190000000034],
            [-101.88356999999998, 30.92576000000004],
            [-102.39018000000003, 31.085280000000008],
            [-101.77594999999998, 31.079750000000043],
            [-101.77569999999999, 31.651350000000004],
            [-101.53234999999995, 31.60642000000004],
            [-101.26681000000004, 31.65094000000001],
            [-101.26421000000002, 32.08713000000002],
            [-101.18358999999998, 32.08691000000003],
            [-100.42259000000001, 32.08232000000004],
            [-100.28973999999997, 32.000790000000016],
            [-100.16159000000003, 32.082530000000006],
            [-100.06186999999998, 31.849870000000006],
            [-99.89875999999998, 31.83417999999997],
            [-99.71944999999994, 31.70245999999998],
            [-99.72161999999999, 31.56271000000003],
            [-99.31336999999999, 31.409790000000008],
            [-99.23791999999997, 31.483050000000016],
            [-98.95720999999996, 31.443479999999983],
            [-99.09092000000003, 31.387850000000032],
            [-99.09171999999997, 31.188410000000026],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SLC" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-110.61849999999994, 41.57912],
            [-110.04809000000003, 41.57738000000001],
            [-110.04866999999997, 40.99722000000003],
            [-109.59426000000002, 40.99833999999997],
            [-109.60699999999996, 40.872769999999996],
            [-109.80938999999998, 40.872449999999986],
            [-109.86562, 40.76431000000004],
            [-110.26069, 40.83553000000001],
            [-110.63360000000002, 40.76548999999997],
            [-110.64827000000002, 40.51527999999997],
            [-110.89663, 40.30741000000003],
            [-110.85771000000001, 39.813179999999974],
            [-111.64219000000001, 39.813019999999966],
            [-111.71542000000002, 39.589790000000036],
            [-111.95914000000003, 39.56474000000004],
            [-112.07423000000003, 39.32963000000002],
            [-112.29289999999996, 39.48641999999997],
            [-112.39101000000002, 39.180099999999996],
            [-112.49533, 39.247410000000016],
            [-112.73778, 39.119059999999976],
            [-112.77574999999999, 38.897419999999975],
            [-112.89633, 38.86580999999997],
            [-113.08297, 39.02969],
            [-113.28491, 38.994980000000005],
            [-113.38624999999998, 39.12219999999999],
            [-113.31564999999996, 39.55245000000004],
            [-114.0477, 39.54263000000004],
            [-114.04188999999997, 40.99979999999998],
            [-112.81624999999997, 40.999840000000006],
            [-112.81155999999996, 41.22818999999999],
            [-112.92900999999999, 41.531900000000014],
            [-112.46285999999998, 41.939719999999966],
            [-112.12262000000001, 41.92932000000002],
            [-111.93826999999996, 41.870380000000026],
            [-111.66446999999997, 41.99947000000001],
            [-111.04677999999998, 42.00167999999999],
            [-111.04581999999995, 41.57979000000002],
            [-110.61849999999994, 41.57912],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SLE" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-120.74643000000002, 44.562439999999974],
            [-120.98878, 44.47640000000001],
            [-121.10826999999999, 44.24894999999997],
            [-121.32542000000001, 44.234530000000035],
            [-121.37880999999999, 44.50811000000003],
            [-121.61678999999998, 44.51555000000002],
            [-121.58991, 44.39267000000004],
            [-121.80797, 44.515539999999994],
            [-121.79451, 44.68393999999999],
            [-122.08089999999996, 44.675400000000025],
            [-122.20672, 44.555370000000046],
            [-122.56906999999998, 44.56414999999998],
            [-122.60750000000002, 44.463610000000024],
            [-122.87297999999994, 44.39432999999999],
            [-123.19691, 44.58561999999996],
            [-123.37758999999998, 44.56696000000004],
            [-123.32674999999996, 44.68231999999998],
            [-123.53263, 44.711649999999985],
            [-123.59725000000003, 44.43295999999996],
            [-123.98912000000001, 44.54134999999999],
            [-124.02051999999996, 44.60737999999997],
            [-124.08072999999996, 44.676220000000015],
            [-123.97437999999998, 45.353659999999955],
            [-123.46476000000001, 45.43314],
            [-123.26970000000003, 45.43376999999999],
            [-122.76332999999994, 45.210810000000016],
            [-122.58628999999996, 45.20137000000001],
            [-122.25639999999997, 45.07984],
            [-122.24242999999996, 44.88571999999999],
            [-121.73446, 44.88580999999998],
            [-121.75999999999995, 44.825430000000026],
            [-120.90932000000002, 44.82290000000004],
            [-120.92246000000002, 44.721059999999994],
            [-120.74643000000002, 44.562439999999974],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SPI" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-89.03659999999996, 40.26110000000002],
            [-89.14611000000002, 40.143809999999995],
            [-88.89118000000002, 40.017010000000035],
            [-88.78669, 39.76258000000001],
            [-88.79762000000002, 39.463670000000036],
            [-88.62114, 39.40451999999998],
            [-88.73998999999995, 39.28143000000003],
            [-88.65979000000002, 39.05057999999996],
            [-88.4795, 38.91309000000004],
            [-88.70082, 38.77472999999999],
            [-88.95804000000001, 38.82386000000001],
            [-88.99206000000004, 38.92660000000001],
            [-89.25437999999997, 38.771869999999964],
            [-89.25018999999995, 39.02815999999997],
            [-89.52965, 39.03930000000004],
            [-89.58926999999994, 39.10995000000001],
            [-90.02833000000001, 39.19912999999998],
            [-90.16458999999995, 39.490439999999964],
            [-90.23791999999997, 39.45842999999999],
            [-90.47892000000002, 39.48103999999998],
            [-90.29263000000003, 39.64617999999999],
            [-90.58375000000001, 39.87647],
            [-90.69581999999994, 40.103750000000005],
            [-90.65360000000004, 40.20869000000004],
            [-90.45051000000001, 40.262389999999996],
            [-90.24931000000004, 40.287529999999975],
            [-90.17747999999995, 40.19884000000004],
            [-89.86734000000001, 40.30941999999999],
            [-89.62730999999997, 40.22540000000001],
            [-89.37399999999997, 40.27270000000004],
            [-89.03659999999996, 40.26110000000002],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SPS" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-99.53227999999997, 35.543869999999956],
            [-99.56685000000002, 35.31228000000003],
            [-99.36457999999998, 35.21925],
            [-99.36022000000001, 35.116740000000036],
            [-98.98158999999994, 35.11652999999998],
            [-98.91236999999998, 34.90653000000003],
            [-98.77312000000002, 34.85545999999999],
            [-98.28284999999995, 34.81138000000001],
            [-98.13298999999999, 34.68116999999999],
            [-97.95092999999996, 34.747090000000014],
            [-97.56277, 34.680999999999955],
            [-97.56243, 34.42696999999998],
            [-97.20549000000003, 34.27005999999996],
            [-96.93331999999998, 34.27307999999999],
            [-96.96801999999994, 34.07102000000001],
            [-97.30764999999997, 34.07109999999997],
            [-97.59562999999994, 33.91137000000003],
            [-97.55316000000005, 33.80324000000003],
            [-97.67249999999996, 33.55177999999998],
            [-98.07173999999999, 33.33205000000001],
            [-98.27007, 33.43585999999998],
            [-98.45738, 32.90173999999996],
            [-98.57568999999997, 32.86892000000003],
            [-98.65498000000001, 32.95567999999997],
            [-98.95077000000002, 32.95691000000004],
            [-98.95296000000003, 33.217470000000034],
            [-99.07711000000002, 33.204249999999995],
            [-99.10609999999997, 33.39813000000004],
            [-99.53712999999999, 33.39882999999996],
            [-99.57831, 33.57839],
            [-99.83524999999996, 33.49305999999998],
            [-99.99262000000003, 33.540499999999966],
            [-100.00057999999997, 33.99112999999997],
            [-99.87518999999998, 34.10953000000001],
            [-100.01026999999996, 34.241740000000036],
            [-100.16041999999995, 34.231239999999985],
            [-99.99771000000001, 34.311830000000036],
            [-100.00025999999997, 35.03015000000004],
            [-99.78276000000002, 35.029749999999986],
            [-99.73639000000001, 35.27328],
            [-99.81956000000002, 35.30929],
            [-99.69388000000001, 35.55805000000002],
            [-99.53227999999997, 35.543869999999956],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "STC" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-93.36648000000002, 46.45074999999998],
            [-93.31669999999994, 46.35382999999997],
            [-93.05392999999998, 46.278519999999986],
            [-93.26266999999996, 46.24924000000003],
            [-93.19582, 46.11213999999996],
            [-92.86609999999993, 46.06738000000003],
            [-92.61184000000003, 46.109980000000036],
            [-92.55783999999994, 45.95099000000004],
            [-92.7211, 45.883669999999995],
            [-92.88793999999999, 45.628289999999964],
            [-93.14202999999995, 45.60933],
            [-93.15254000000002, 45.42859999999997],
            [-93.27305999999996, 45.42133000000001],
            [-94.00055, 44.97849],
            [-94.42682000000002, 44.761399999999966],
            [-94.39627999999999, 44.63039000000001],
            [-94.62921999999998, 44.62204999999999],
            [-94.62408000000002, 44.456],
            [-94.90650999999997, 44.311439999999976],
            [-95.09975, 44.332580000000014],
            [-95.26932999999994, 44.52173999999997],
            [-95.60422, 44.54256],
            [-95.58599999999998, 44.73143999999997],
            [-95.73938999999999, 44.89140999999996],
            [-95.92086999999998, 44.94981000000004],
            [-95.90629999999999, 45.04479000000003],
            [-96.22920999999994, 45.21836999999999],
            [-96.20003, 45.412310000000026],
            [-96.08757999999997, 45.411810000000045],
            [-96.23361000000003, 45.629429999999964],
            [-96.06141999999997, 45.63757999999999],
            [-95.91366999999997, 45.846069999999976],
            [-95.73832999999996, 45.904889999999995],
            [-95.52128000000002, 46.11261999999998],
            [-95.58382, 46.37614000000001],
            [-95.42528000000001, 46.397400000000026],
            [-95.23917, 46.256040000000006],
            [-94.94578999999999, 46.296200000000006],
            [-94.79693, 46.24360999999996],
            [-94.67452, 46.34165000000001],
            [-94.77942000000002, 46.54135999999997],
            [-94.61005999999998, 46.585790000000046],
            [-94.44098000000002, 46.36294000000002],
            [-94.32865999999999, 46.45957999999996],
            [-93.93588999999997, 46.42397999999996],
            [-93.81126999999998, 46.47934999999998],
            [-93.79627000000002, 46.243130000000036],
            [-93.37867, 46.35138999999997],
            [-93.36648000000002, 46.45074999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "STL" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-88.70082, 38.77472999999999],
            [-88.82268000000002, 38.67145],
            [-89.03142, 38.29412999999997],
            [-89.42684, 38.20845000000003],
            [-89.49907999999999, 38.10454000000004],
            [-89.77188000000001, 38.03752000000004],
            [-89.94095999999996, 37.87649000000001],
            [-90.25544, 37.71567000000004],
            [-90.14669999999998, 37.64161000000001],
            [-90.90795000000003, 37.603170000000034],
            [-91.18299000000002, 37.41487000000001],
            [-91.32048999999998, 37.41722000000002],
            [-91.30838000000003, 37.78715999999997],
            [-91.52666000000002, 37.92803999999998],
            [-91.33563999999998, 38.10896000000001],
            [-91.36654999999999, 38.26217000000004],
            [-91.24966000000003, 38.481449999999995],
            [-91.38427999999996, 38.576890000000034],
            [-91.23239000000001, 38.65056000000004],
            [-91.41762999999997, 38.74560000000002],
            [-91.07090999999994, 39.013920000000006],
            [-90.82658999999995, 39.256660000000025],
            [-90.60323, 39.248710000000024],
            [-90.61163000000002, 39.385099999999966],
            [-90.31939999999994, 39.33074000000002],
            [-90.23791999999997, 39.45842999999999],
            [-90.16458999999995, 39.490439999999964],
            [-90.02833000000001, 39.19912999999998],
            [-89.58926999999994, 39.10995000000001],
            [-89.52965, 39.03930000000004],
            [-89.25018999999995, 39.02815999999997],
            [-89.25437999999997, 38.771869999999964],
            [-88.99206000000004, 38.92660000000001],
            [-88.95804000000001, 38.82386000000001],
            [-88.70082, 38.77472999999999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SUX" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-94.67756, 43.28054999999997],
            [-94.45574000000002, 43.16212999999997],
            [-94.52095999999995, 43.053179999999976],
            [-94.29835, 42.97345999999997],
            [-94.63833999999997, 42.67435999999999],
            [-94.65845999999999, 42.47354999999996],
            [-94.80526, 42.413499999999964],
            [-94.79232999999996, 42.235129999999984],
            [-94.97429, 42.122750000000046],
            [-95.24585999999994, 42.13895],
            [-95.22052999999997, 41.95878999999997],
            [-95.42104999999998, 41.9283],
            [-95.53699000000003, 42.008570000000034],
            [-95.74722, 41.86328],
            [-96.09396999999993, 41.85189000000004],
            [-96.25125999999997, 41.92371000000001],
            [-96.46320000000003, 41.7275],
            [-96.56686999999997, 41.74202999999998],
            [-96.60591000000002, 41.923259999999985],
            [-96.90296999999995, 42.075960000000016],
            [-97.01777999999996, 42.351359999999964],
            [-97.19714000000005, 42.415550000000025],
            [-97.07414, 42.68423999999999],
            [-97.40709000000004, 42.86545000000003],
            [-96.87915999999998, 42.959070000000025],
            [-96.54983999999999, 42.847689999999965],
            [-96.40154999999999, 42.909340000000014],
            [-96.31342999999995, 43.08389999999997],
            [-96.16210999999998, 43.003549999999976],
            [-95.88255999999993, 43.12968000000001],
            [-95.57185999999993, 43.16404],
            [-95.38826999999998, 43.05428000000004],
            [-95.3879, 43.3059],
            [-95.30379999999997, 43.255320000000005],
            [-94.67756, 43.28054999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SVC" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-106.37266000000002, 33.47980000000001],
            [-106.34578999999998, 33.39065000000002],
            [-106.34051000000001, 33.05271000000002],
            [-107.03732999999994, 32.77912],
            [-106.98187000000003, 32.691910000000036],
            [-107.29815999999998, 32.45013999999999],
            [-107.29675000000002, 31.78391000000004],
            [-108.20836999999996, 31.783750000000037],
            [-108.20848, 31.333359999999992],
            [-109.11902, 31.33255000000003],
            [-109.14582999999996, 31.591379999999962],
            [-109.28602, 31.65737000000001],
            [-109.27536999999997, 32.06278999999998],
            [-109.48306000000002, 32.196400000000025],
            [-109.60518, 32.42672000000003],
            [-109.11399000000003, 32.42618000000003],
            [-109.22607, 32.52909999999999],
            [-109.24816999999999, 32.750219999999956],
            [-109.49567999999998, 33.077899999999964],
            [-109.49553, 33.65263],
            [-109.76652000000001, 33.47569000000003],
            [-109.89170999999999, 33.56779999999996],
            [-109.89162, 33.777629999999974],
            [-109.73583000000002, 33.83254000000004],
            [-109.75414000000002, 34.021640000000005],
            [-109.85919999999994, 34.09360000000001],
            [-109.84878999999998, 34.26749000000004],
            [-109.67350999999995, 34.29318999999999],
            [-109.49440999999997, 34.46154000000003],
            [-109.55324000000002, 34.78712000000001],
            [-109.29856, 34.65167000000004],
            [-109.04562999999999, 34.791289999999975],
            [-109.04681999999995, 34.066080000000014],
            [-108.91978000000003, 34.12835999999996],
            [-108.59137000000003, 33.94149000000003],
            [-108.35383000000002, 34.012659999999954],
            [-108.46122, 33.90427000000002],
            [-108.38360000000002, 33.61707000000002],
            [-108.00057999999999, 33.47804999999998],
            [-106.37266000000002, 33.47980000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "SYR" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-74.78267999999997, 43.54006999999997],
            [-74.86780000000002, 43.144419999999954],
            [-74.96060000000003, 43.135770000000036],
            [-74.87623999999997, 42.91109000000004],
            [-75.04590999999999, 42.885120000000036],
            [-75.28542000000002, 42.74241999999999],
            [-75.51857999999999, 42.740970000000004],
            [-75.54022999999995, 42.613870000000006],
            [-75.79841999999996, 42.72866999999997],
            [-75.85409000000001, 42.65778000000004],
            [-76.16634000000002, 42.61426000000003],
            [-76.66654000000003, 42.623449999999956],
            [-76.89565999999996, 42.541529999999995],
            [-76.96337000000003, 42.896779999999964],
            [-76.87412000000003, 43.151540000000026],
            [-76.92768999999998, 43.236100000000015],
            [-76.41209000000003, 43.523090000000046],
            [-76.22048999999998, 43.530889999999985],
            [-76.18364999999997, 43.67935000000002],
            [-76.03690999999995, 43.577940000000034],
            [-75.77469000000002, 43.68895999999997],
            [-75.75543999999994, 43.470209999999994],
            [-75.37253999999999, 43.34544999999998],
            [-75.07699999999997, 43.330689999999976],
            [-75.08488000000003, 43.52048000000001],
            [-74.78267999999997, 43.54006999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "TLH" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-85.77778999999998, 30.28817000000003],
            [-85.87951000000004, 30.413090000000047],
            [-85.91596000000001, 30.636900000000004],
            [-85.82242, 30.735400000000006],
            [-85.83121999999997, 30.994130000000013],
            [-85.62582999999998, 30.99579999999999],
            [-85.57356999999996, 31.19538999999997],
            [-85.29856999999998, 30.999840000000038],
            [-85.00194000000002, 31.000669999999968],
            [-84.9136, 30.752090000000003],
            [-84.76896999999994, 30.836630000000024],
            [-84.73078999999998, 31.06910999999996],
            [-84.24647000000002, 31.04579999999996],
            [-84.24382999999997, 30.829999999999995],
            [-84.38079999999997, 30.69009000000004],
            [-83.05402999999995, 30.619339999999966],
            [-83.08123, 30.49125999999997],
            [-83.24608, 30.51266000000003],
            [-83.17149, 30.38534999999997],
            [-83.22549999999993, 30.11318999999996],
            [-82.99870000000004, 30.005359999999996],
            [-83.07002000000003, 29.82447999999999],
            [-83.19886999999994, 29.823550000000047],
            [-83.09336999999996, 29.67481999999996],
            [-83.23006000000004, 29.438179999999996],
            [-83.40055999999996, 29.51360999999996],
            [-83.40854999999999, 29.666950000000007],
            [-83.58478999999994, 29.75963999999997],
            [-83.67942999999997, 29.924269999999968],
            [-83.99997000000002, 30.109380000000023],
            [-84.25734999999997, 30.10606000000004],
            [-84.56981000000002, 29.978480000000022],
            [-84.67446999999999, 29.83073000000002],
            [-84.89036999999996, 29.72238000000002],
            [-85.31052999999997, 29.689709999999973],
            [-85.43397999999993, 30.075590000000034],
            [-85.73275999999998, 30.175860000000025],
            [-85.77778999999998, 30.28817000000003],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "TOL" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-82.99603000000002, 41.44318],
            [-83.02590999999995, 41.28271000000002],
            [-83.22132999999997, 41.25322000000001],
            [-83.51538, 40.85501000000002],
            [-83.39615000000003, 40.68722000000004],
            [-83.64508000000001, 40.753860000000046],
            [-83.73015999999993, 40.70365999999996],
            [-83.96849000000003, 40.823950000000046],
            [-84.19944999999996, 40.86474999999997],
            [-84.19950999999995, 41.04765999999999],
            [-84.34197999999998, 41.05531999999998],
            [-84.36112999999995, 41.187560000000005],
            [-84.67144999999994, 41.470420000000004],
            [-84.8252, 41.83970999999999],
            [-84.68805999999998, 42.07058000000003],
            [-83.96153999999999, 42.21697000000003],
            [-83.6003, 42.13557000000003],
            [-83.60197, 41.95641999999999],
            [-83.39462, 41.85493000000004],
            [-83.46303, 41.70215999999999],
            [-83.07958999999994, 41.60352999999998],
            [-82.99603000000002, 41.44318],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "TOP" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-94.61432999999997, 37.97253999999998],
            [-94.82365000000004, 37.99378000000004],
            [-94.95441999999994, 37.755239999999986],
            [-95.15205999999998, 37.6468],
            [-95.30695999999995, 37.72162000000003],
            [-95.37901999999997, 37.54422000000001],
            [-95.61535999999998, 37.54436999999999],
            [-95.642, 37.65116999999999],
            [-95.85272999999995, 37.77625000000002],
            [-95.87891000000002, 37.91783999999997],
            [-96.01612000000003, 37.852249999999984],
            [-96.04041999999995, 37.98288999999996],
            [-96.48552000000001, 38.16364000000004],
            [-96.81922999999995, 38.34846],
            [-96.77133999999995, 38.59918000000002],
            [-96.89019999999994, 38.87008999999998],
            [-96.61278999999996, 38.870260000000016],
            [-96.58313999999993, 39.015499999999996],
            [-96.85096000000004, 39.10106999999998],
            [-96.75626000000003, 39.349490000000024],
            [-96.62219999999996, 39.277240000000006],
            [-96.50874999999996, 39.43598000000001],
            [-96.58221, 39.669419999999974],
            [-96.35500999999994, 39.896150000000034],
            [-96.26050000000004, 40.00086999999998],
            [-95.80347, 40.00535000000002],
            [-95.64505000000003, 40.0951],
            [-95.55292000000003, 40.26190000000004],
            [-95.49204999999995, 40.02942999999996],
            [-95.36839999999995, 39.99996],
            [-95.30059999999997, 39.46306000000001],
            [-95.17970999999997, 39.397260000000045],
            [-95.18745000000001, 39.05897999999998],
            [-95.01915000000002, 38.961770000000044],
            [-94.94570999999996, 38.796570000000045],
            [-95.04696999999996, 38.57921999999999],
            [-94.89607000000001, 38.52551000000001],
            [-94.91818, 38.294769999999986],
            [-94.61290999999997, 38.315530000000024],
            [-94.61432999999997, 37.97253999999998],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "TPA" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-82.42370999999997, 27.116849999999985],
              [-82.34191999999993, 27.113299999999978],
              [-82.24690999999996, 26.966749999999966],
              [-82.18393, 26.936520000000012],
              [-82.15112000000002, 26.784060000000036],
              [-82.30091999999999, 26.852889999999967],
              [-82.43788999999995, 27.052549999999968],
              [-82.44796999999997, 27.110030000000044],
              [-82.42370999999997, 27.116849999999985],
            ],
          ],
          [
            [
              [-83.08056999999994, 29.238259999999975],
              [-82.83308999999994, 29.335200000000043],
              [-82.65541999999996, 29.30939999999999],
              [-82.58279000000005, 29.20822999999996],
              [-82.37860999999998, 29.220090000000003],
              [-82.27993000000001, 29.041120000000024],
              [-82.16927999999996, 28.792319999999975],
              [-82.27392999999998, 28.65437000000001],
              [-81.95428000000001, 28.58511000000003],
              [-81.95777999999996, 28.30889],
              [-81.83723000000003, 28.138060000000024],
              [-81.82716000000005, 27.947099999999995],
              [-81.68942999999999, 27.901199999999974],
              [-81.56317999999996, 27.64661999999997],
              [-81.56267999999997, 27.128170000000022],
              [-81.56573, 26.76952000000003],
              [-81.73804999999999, 26.769400000000047],
              [-81.78588999999994, 26.451120000000017],
              [-81.85168999999999, 26.449260000000045],
              [-81.96220999999994, 26.472349999999956],
              [-82.08734000000004, 26.682589999999962],
              [-82.04512000000003, 26.84756999999997],
              [-82.34042, 27.113139999999973],
              [-82.46326000000005, 27.11436000000002],
              [-82.57383999999999, 27.413150000000012],
              [-82.65176000000002, 27.450940000000028],
              [-82.39889999999994, 27.887600000000027],
              [-82.64629999999997, 28.02984999999997],
              [-82.72546000000003, 27.93689999999999],
              [-82.63741999999993, 27.70432999999998],
              [-82.84880000000004, 27.87842999999998],
              [-82.65011000000001, 28.496910000000046],
              [-82.62338, 28.880049999999972],
              [-82.80854999999997, 29.16277000000002],
              [-83.08056999999994, 29.238259999999975],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "TRI" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-81.11085, 36.76772000000001],
            [-81.02845000000002, 36.667399999999965],
            [-81.03723999999997, 36.41728999999997],
            [-81.20011000000002, 36.39293999999999],
            [-81.16271999999995, 36.28270000000002],
            [-81.38068999999999, 36.04405000000001],
            [-81.54550000000003, 36.11738999999997],
            [-81.72999000000004, 36.086989999999986],
            [-81.73533, 35.90303999999999],
            [-82.05762999999993, 35.98448000000002],
            [-82.10857999999999, 35.92801999999996],
            [-82.63257999999996, 36.06610000000003],
            [-82.82201999999998, 35.92237999999996],
            [-83.10030999999995, 35.969129999999964],
            [-83.32394999999997, 36.42745000000004],
            [-83.52394000000001, 36.66612000000002],
            [-83.22585000000004, 36.729929999999996],
            [-83.27199000000002, 36.81489999999998],
            [-83.0627, 36.91446000000002],
            [-82.87805, 36.88994],
            [-82.92478999999997, 37.00996999999998],
            [-82.35166999999993, 37.265900000000045],
            [-82.15394999999995, 37.407569999999964],
            [-81.93269999999998, 37.369129999999984],
            [-81.88623999999999, 37.18621000000003],
            [-81.61793000000003, 37.08346000000002],
            [-81.78053000000003, 36.95854],
            [-81.46159, 37.03681999999996],
            [-81.50207999999995, 36.959220000000045],
            [-81.26162999999997, 36.76317999999998],
            [-81.11085, 36.76772000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "TUL" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-95.15205999999998, 37.6468],
            [-95.088, 37.38384999999997],
            [-94.97727999999992, 37.33272999999996],
            [-95.07435999999996, 37.14713999999998],
            [-94.70934999999997, 36.886840000000014],
            [-94.61793999999995, 36.91972000000003],
            [-94.61463, 36.49928000000004],
            [-94.64162000000002, 36.32252000000004],
            [-94.90659000000002, 36.36895000000004],
            [-94.59718999999996, 36.08479000000004],
            [-94.79729999999995, 36.014019999999995],
            [-94.79728, 36.16166000000004],
            [-95.03137999999996, 36.04669000000004],
            [-95.16259999999994, 35.66754999999996],
            [-95.55789999999996, 35.10936000000004],
            [-95.79392999999999, 35.05735999999996],
            [-95.95177999999999, 35.151529999999994],
            [-96.08888999999999, 34.95140000000001],
            [-95.95553999999996, 34.73905999999997],
            [-96.21929999999995, 34.78510999999997],
            [-96.14208999999997, 35.02904000000004],
            [-96.27301000000003, 35.21806999999998],
            [-96.44135999999997, 35.290110000000034],
            [-96.49807999999996, 35.63885999999998],
            [-96.71604999999997, 35.63971999999999],
            [-96.91142999999997, 35.957759999999965],
            [-96.85489999999999, 36.10883999999998],
            [-97.10344999999995, 36.261179999999975],
            [-97.06797999999995, 36.362119999999976],
            [-97.31908999999999, 36.46409000000003],
            [-97.29182, 36.59391000000002],
            [-96.83277000000001, 36.610130000000034],
            [-96.93098999999992, 36.774790000000024],
            [-96.74999999999997, 36.999210000000005],
            [-96.31739999999999, 36.99912000000002],
            [-96.37892000000002, 37.098630000000014],
            [-96.24622999999997, 37.30080000000004],
            [-95.96439999999993, 37.29934999999997],
            [-95.82406000000003, 37.38577999999996],
            [-95.642, 37.65116999999999],
            [-95.61535999999998, 37.54436999999999],
            [-95.37901999999997, 37.54422000000001],
            [-95.30695999999995, 37.72162000000003],
            [-95.15205999999998, 37.6468],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "TUP" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-89.07247000000001, 34.923850000000016],
            [-89.01531999999997, 34.807940000000045],
            [-88.59508999999994, 34.84791999999998],
            [-88.31947000000002, 34.71071999999999],
            [-88.12222999999994, 34.70344],
            [-87.88173, 34.31192000000002],
            [-87.76575, 34.27442000000002],
            [-87.77310999999995, 34.113759999999964],
            [-87.63616999999999, 34.04047999999999],
            [-87.74506, 33.658519999999996],
            [-87.66792999999996, 33.563779999999966],
            [-87.99651, 33.34384000000003],
            [-88.27003999999994, 33.280259999999984],
            [-88.87551999999997, 33.28629000000002],
            [-89.18912000000003, 33.197559999999974],
            [-89.36474999999996, 33.47075999999997],
            [-89.54221999999999, 33.285709999999995],
            [-89.87006999999994, 33.49302999999998],
            [-89.87582999999992, 33.643179999999965],
            [-90.13680999999994, 33.72159000000003],
            [-90.07032000000001, 34.00093000000001],
            [-89.81404999999998, 34.026319999999984],
            [-89.72112999999999, 34.458699999999965],
            [-89.53538, 34.55487000000001],
            [-89.40731999999997, 34.522049999999986],
            [-89.29918999999995, 34.83517000000002],
            [-89.07247000000001, 34.923850000000016],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "TUS" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-110.25620000000002, 34.00004],
            [-110.00064000000002, 34.00005000000003],
            [-110.00061999999997, 33.576940000000015],
            [-109.89170999999999, 33.56779999999996],
            [-109.76652000000001, 33.47569000000003],
            [-109.49553, 33.65263],
            [-109.49567999999998, 33.077899999999964],
            [-109.24816999999999, 32.750219999999956],
            [-109.22607, 32.52909999999999],
            [-109.11399000000003, 32.42618000000003],
            [-109.60518, 32.42672000000003],
            [-109.48306000000002, 32.196400000000025],
            [-109.27536999999997, 32.06278999999998],
            [-109.28602, 31.65737000000001],
            [-109.14582999999996, 31.591379999999962],
            [-109.11902, 31.33255000000003],
            [-111.0757, 31.332010000000025],
            [-113.20840000000003, 31.99886999999996],
            [-112.98916, 32.04032999999997],
            [-112.78004999999997, 32.166090000000025],
            [-112.63039999999997, 32.14972999999998],
            [-112.71729999999995, 32.344219999999964],
            [-112.57215999999998, 32.50520999999996],
            [-111.66861999999996, 32.50665000000001],
            [-111.49787000000003, 32.547610000000034],
            [-111.34147000000003, 32.83927000000001],
            [-111.23851999999998, 32.68668999999997],
            [-110.97607000000002, 32.71512000000003],
            [-110.83793999999999, 32.857249999999986],
            [-110.88898999999998, 33.006920000000044],
            [-111.08322000000003, 33.104620000000025],
            [-111.04240999999999, 33.25215000000003],
            [-110.80057000000001, 33.24474999999997],
            [-110.65448999999998, 33.352800000000016],
            [-110.64433, 33.55901],
            [-110.5261, 33.70430999999998],
            [-110.80080999999997, 33.9353],
            [-110.75069999999995, 34.01442],
            [-110.25620000000002, 34.00004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "TVC" },
      geometry: {
        type: "MultiPolygon",
        coordinates: [
          [
            [
              [-84.76023999999998, 45.17714000000001],
              [-84.98024999999996, 45.005239999999965],
              [-84.84819999999999, 44.91678999999999],
              [-84.85492000000002, 44.446760000000026],
              [-85.08357999999998, 44.21835999999998],
              [-85.28670000000002, 44.15300000000001],
              [-85.11811999999995, 43.99081999999996],
              [-85.11214999999999, 43.780879999999996],
              [-85.23112999999995, 43.71391999999998],
              [-85.34292999999997, 43.60094999999999],
              [-85.56235999999998, 43.62083999999999],
              [-85.72339999999994, 43.69158000000004],
              [-85.70287999999996, 43.81256000000002],
              [-86.15360999999999, 43.85544000000001],
              [-86.20050999999995, 44.005239999999986],
              [-86.50588000000002, 44.07098000000004],
              [-86.26451999999998, 44.360010000000024],
              [-86.25663999999998, 44.687289999999976],
              [-86.0898, 44.74156000000002],
              [-86.06460999999996, 44.907650000000025],
              [-85.81197, 44.947590000000034],
              [-85.61812000000003, 45.18706000000003],
              [-85.64105000000004, 44.77440000000001],
              [-85.52626000000001, 44.74796999999997],
              [-85.38338999999999, 44.96792999999996],
              [-85.37139999999994, 45.27162000000002],
              [-85.02909999999997, 45.361329999999974],
              [-85.12011999999996, 45.56943000000002],
              [-84.95453999999995, 45.701589999999996],
              [-84.99364, 45.55810999999998],
              [-84.73043999999999, 45.38010000000003],
              [-84.76023999999998, 45.17714000000001],
            ],
          ],
          [
            [
              [-85.86449000000002, 46.68992000000002],
              [-85.86475999999996, 46.48951999999999],
              [-85.63437999999996, 46.34628999999996],
              [-85.64498999999998, 46.245159999999956],
              [-85.41139999999996, 46.22878000000003],
              [-85.56928000000002, 46.05613000000001],
              [-85.65474999999998, 45.966760000000036],
              [-86.27610000000001, 45.94323000000004],
              [-86.35452000000004, 45.79066999999996],
              [-86.53762999999998, 45.74584000000001],
              [-86.56700000000001, 45.899830000000016],
              [-86.75979000000001, 46.00565999999996],
              [-86.89782000000002, 46.34295000000001],
              [-86.81202000000002, 46.45197999999996],
              [-86.64090999999996, 46.41033999999999],
              [-86.46946999999997, 46.551830000000024],
              [-86.16309000000001, 46.668839999999975],
              [-85.86449000000002, 46.68992000000002],
            ],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "TYS" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-85.37091999999993, 36.089549999999974],
            [-85.04727999999997, 36.543599999999984],
            [-84.85686999999999, 36.52915999999999],
            [-84.57383999999996, 36.84466000000003],
            [-84.35815999999997, 36.959449999999975],
            [-84.34206000000003, 36.83582999999996],
            [-84.07548999999997, 36.80611000000002],
            [-83.87759999999997, 36.687310000000025],
            [-83.52394000000001, 36.66612000000002],
            [-83.32394999999997, 36.42745000000004],
            [-83.10030999999995, 35.969129999999964],
            [-83.09757000000002, 35.77611999999996],
            [-83.25699999999998, 35.705439999999996],
            [-83.15667000000002, 35.55476000000003],
            [-83.31645, 35.332830000000016],
            [-83.56604999999999, 35.29280000000003],
            [-83.60226, 34.91403000000001],
            [-83.66669999999996, 34.80670000000003],
            [-83.9402, 34.74082000000002],
            [-84.14259999999996, 34.821339999999964],
            [-84.12130999999994, 34.98755000000004],
            [-84.32172999999995, 34.988110000000006],
            [-84.30314000000004, 35.13185999999999],
            [-84.72577999999999, 35.63714000000004],
            [-84.81165999999993, 35.57522000000003],
            [-85.05686000000003, 35.69693000000002],
            [-85.01284999999996, 35.891629999999964],
            [-85.37091999999993, 36.089549999999974],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "UIN" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-90.69581999999994, 40.103750000000005],
            [-90.58375000000001, 39.87647],
            [-90.29263000000003, 39.64617999999999],
            [-90.47892000000002, 39.48103999999998],
            [-90.23791999999997, 39.45842999999999],
            [-90.31939999999994, 39.33074000000002],
            [-90.61163000000002, 39.385099999999966],
            [-90.60323, 39.248710000000024],
            [-90.82658999999995, 39.256660000000025],
            [-91.07090999999994, 39.013920000000006],
            [-91.41762999999997, 38.74560000000002],
            [-91.33961000000002, 38.96611999999999],
            [-91.46829000000002, 39.08005],
            [-91.63663000000003, 38.99081000000004],
            [-91.70558999999997, 39.149309999999986],
            [-91.92972000000003, 39.382360000000006],
            [-91.98313999999999, 39.062130000000025],
            [-92.18602999999999, 39.62422999999998],
            [-92.36353999999997, 39.663920000000005],
            [-92.36321000000001, 39.858810000000034],
            [-92.68458000000001, 39.86983999999997],
            [-92.85641999999999, 40.062610000000014],
            [-92.85559999999998, 40.342650000000006],
            [-92.72972999999996, 40.38320000000003],
            [-92.39970000000002, 40.414580000000015],
            [-92.26984000000002, 40.303410000000014],
            [-91.49714, 40.248820000000045],
            [-91.50510999999997, 40.200390000000034],
            [-90.96723, 40.19373000000001],
            [-90.91342, 40.104469999999985],
            [-90.69581999999994, 40.103750000000005],
          ],
          [
            [-92.08333000000002, 40.07325000000001],
            [-92.18680999999995, 39.95436999999997],
            [-92.00944000000004, 39.950189999999964],
            [-92.08333000000002, 40.07325000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "VCT" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-95.53544999999997, 28.83086999999999],
            [-95.97674, 28.596550000000047],
            [-96.39609999999996, 28.68007999999999],
            [-96.56676999999993, 28.58359999999997],
            [-96.40247, 28.44290000000002],
            [-96.79046999999994, 28.319220000000016],
            [-97.07775000000001, 28.353560000000037],
            [-97.21610999999996, 28.510800000000007],
            [-97.40018000000003, 28.392589999999977],
            [-97.69669000000002, 28.541639999999983],
            [-97.78749000000002, 28.675549999999987],
            [-98.00524999999996, 28.690260000000027],
            [-98.06643000000003, 28.75345999999998],
            [-97.86180999999998, 28.848699999999987],
            [-97.77199999999999, 29.087100000000003],
            [-97.66686999999996, 29.071409999999968],
            [-97.69295999999994, 29.570789999999995],
            [-97.38736999999998, 29.629770000000015],
            [-97.29120000000003, 29.567060000000016],
            [-97.05730000000003, 29.659300000000048],
            [-96.88348000000002, 29.806639999999966],
            [-96.60366000000002, 29.843259999999987],
            [-96.40997999999999, 29.772860000000005],
            [-96.23598000000001, 29.486789999999978],
            [-95.96380999999997, 29.305430000000047],
            [-95.77015999999995, 28.972050000000042],
            [-95.53544999999997, 28.83086999999999],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "VTN" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-99.45465999999999, 43.68777000000001],
            [-99.30616000000002, 43.46186999999996],
            [-99.15642999999997, 43.42953000000004],
            [-98.85912999999998, 43.15626999999997],
            [-98.71731, 43.09634000000004],
            [-98.84043999999997, 42.857379999999964],
            [-98.75598, 42.50800999999997],
            [-98.94415000000002, 42.37292000000003],
            [-98.95387999999996, 42.21495999999999],
            [-99.11803000000002, 42.25891999999999],
            [-99.23464000000001, 42.13304000000004],
            [-99.27300000000002, 42.08756999999998],
            [-99.68689000000003, 42.08620999999998],
            [-100.02273999999994, 42.085419999999985],
            [-100.26665999999999, 41.95552999999998],
            [-100.29670999999996, 42.184790000000035],
            [-100.46962999999994, 42.28158999999997],
            [-100.70903000000001, 42.18096000000004],
            [-100.73064999999998, 41.911770000000004],
            [-100.84272999999996, 41.74043000000002],
            [-101.66996999999996, 41.74262000000003],
            [-101.60690000000002, 42.02539999999998],
            [-101.37751999999999, 42.29877000000001],
            [-101.63331000000001, 42.447340000000004],
            [-101.94184999999999, 42.41606000000004],
            [-102.20467000000001, 42.38746000000003],
            [-102.40466999999998, 42.65265000000004],
            [-102.34172999999997, 42.717850000000006],
            [-102.46667999999998, 42.99977999999997],
            [-102.08201999999996, 42.99971000000004],
            [-102.11070999999995, 43.38986],
            [-101.90158999999997, 43.41509999999999],
            [-101.71307999999998, 43.684010000000036],
            [-101.29323999999998, 43.635620000000046],
            [-101.09208999999998, 43.53487999999998],
            [-101.05275999999999, 43.69354000000003],
            [-101.16745000000002, 43.810670000000044],
            [-101.03132000000001, 43.85778],
            [-100.79037999999997, 43.72576999999999],
            [-100.59074000000003, 43.769059999999975],
            [-100.28524999999998, 43.696529999999974],
            [-99.89884000000004, 43.700880000000005],
            [-99.81507999999998, 43.507150000000024],
            [-99.58082000000003, 43.392980000000044],
            [-99.45465999999999, 43.68777000000001],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "WMC" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-117.02626999999998, 42.00021000000004],
            [-115.52305999999999, 41.99685000000004],
            [-115.52212000000002, 41.92796000000003],
            [-115.55335000000001, 41.79285000000003],
            [-115.71660999999999, 41.61131999999998],
            [-115.68957000000002, 41.52487000000002],
            [-115.47506000000003, 41.52241999999998],
            [-115.24772000000003, 41.40823000000004],
            [-115.23030999999996, 41.07978],
            [-115.45337000000004, 40.88785000000001],
            [-115.65129999999998, 40.90056999999997],
            [-115.80224999999999, 40.748310000000025],
            [-116.10599, 40.68234999999997],
            [-116.13072, 40.571290000000005],
            [-116.01238999999998, 40.168180000000035],
            [-116.12180000000002, 40.148869999999974],
            [-116.27810000000002, 39.95081000000002],
            [-116.59023999999997, 39.99326999999998],
            [-116.60094999999998, 39.16146999999998],
            [-117.17939000000003, 39.16313000000002],
            [-117.77545999999995, 39.09333000000003],
            [-117.75625, 39.37582999999999],
            [-117.48220999999995, 39.55507999999996],
            [-117.46172999999999, 39.88791000000002],
            [-117.54171000000001, 40.00104000000002],
            [-119.33865999999996, 39.99841000000001],
            [-119.30409999999995, 41.304289999999966],
            [-119.32417000000001, 41.99387999999996],
            [-117.02626999999998, 42.00021000000004],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "YKM" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-119.98124999999996, 48.20957000000003],
            [-119.88296999999996, 47.97109999999999],
            [-119.53736999999997, 47.931179999999955],
            [-119.29569, 48.1154],
            [-119.20334999999994, 48.055909999999976],
            [-119.21243999999994, 47.80066999999998],
            [-119.43869, 47.52480999999999],
            [-119.29270999999999, 47.55057000000002],
            [-119.16552, 47.27487999999997],
            [-119.03339000000001, 47.20326999999997],
            [-118.96704999999996, 47.021770000000004],
            [-118.65340999999998, 46.94897999999998],
            [-118.77074999999996, 46.78624999999998],
            [-119.22627, 46.690859999999994],
            [-119.87412999999995, 46.62848999999997],
            [-119.34534999999998, 46.05031000000003],
            [-119.48159999999999, 45.90822000000001],
            [-119.96575999999996, 45.824369999999966],
            [-120.21061000000003, 45.72583999999997],
            [-120.4826, 45.69437],
            [-120.36583999999996, 45.496370000000034],
            [-120.52891999999997, 45.40047000000004],
            [-120.50351000000003, 45.083099999999995],
            [-120.72983999999995, 45.08377000000001],
            [-121.02448000000003, 45.21907],
            [-120.82552999999997, 45.513630000000035],
            [-120.91611999999999, 45.641349999999996],
            [-121.40377, 45.69299000000004],
            [-121.33135000000003, 45.93894],
            [-121.52392999999998, 46.04410000000003],
            [-121.52362000000001, 46.388090000000034],
            [-121.42301999999998, 46.49254000000002],
            [-121.61513999999997, 46.605979999999995],
            [-121.83505000000001, 46.637549999999976],
            [-121.81234, 46.74728000000003],
            [-121.44286999999996, 46.792570000000026],
            [-121.52268999999997, 46.873430000000035],
            [-121.29764, 47.14857999999999],
            [-121.34164000000003, 47.28183000000001],
            [-121.11434999999999, 47.21885999999999],
            [-121.30073999999999, 47.49065000000003],
            [-121.06711000000003, 47.70618999999998],
            [-121.17296999999998, 47.931230000000006],
            [-120.94727999999998, 48.11262999999996],
            [-121.05577999999996, 48.47814000000001],
            [-120.65201, 48.53661000000002],
            [-120.65046000000001, 48.39769],
            [-120.15290000000002, 48.06572999999998],
            [-119.98124999999996, 48.20957000000003],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "YNG" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-80.90382000000002, 41.86785999999997],
            [-80.67345999999998, 41.83405000000002],
            [-80.59230000000002, 41.70563000000004],
            [-80.44224000000003, 41.754620000000024],
            [-80.15917999999999, 41.53144999999999],
            [-80.02869999999993, 41.59148000000003],
            [-79.59952000000004, 41.321429999999985],
            [-79.26413, 41.30039999999998],
            [-79.54184999999995, 41.16315999999997],
            [-79.57279999999997, 41.02050000000003],
            [-79.80442, 41.091190000000026],
            [-79.97749000000005, 40.97352],
            [-80.21474999999995, 40.97603999999996],
            [-80.52306000000002, 40.89277000000004],
            [-80.63736, 40.792770000000004],
            [-80.87451999999999, 40.81836],
            [-80.93530999999996, 40.974230000000034],
            [-81.09835999999996, 41.08774999999997],
            [-81.21009000000001, 41.34745999999997],
            [-81.30546999999999, 41.56234999999997],
            [-81.12199999999999, 41.65007000000002],
            [-81.19735, 41.78093],
            [-80.90382000000002, 41.86785999999997],
          ],
        ],
      },
    },
    {
      type: "Feature",
      properties: { market_to_: "YUM" },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [-114.29253000000003, 34.41798],
            [-114.00598, 34.25377999999996],
            [-113.66406999999995, 34.21206999999997],
            [-113.53107999999996, 34.30989000000001],
            [-113.33338000000003, 34.31772000000004],
            [-113.33376000000003, 33.78113000000002],
            [-113.33395000000003, 33.26185999999999],
            [-112.97944999999996, 33.30754999999996],
            [-112.99496000000002, 33.19463000000002],
            [-113.22873999999996, 33.11111000000001],
            [-113.11303999999994, 33.068480000000015],
            [-113.05311000000002, 32.72377999999998],
            [-113.33405999999998, 32.505170000000035],
            [-113.33410999999995, 32.03864999999996],
            [-114.81324000000001, 32.49398000000001],
            [-114.72000000000001, 32.71861000000004],
            [-116.10622999999997, 32.61839000000001],
            [-115.86605999999996, 32.76965],
            [-116.10362000000002, 32.83396999999998],
            [-116.10311999999995, 32.954419999999985],
            [-115.88603999999995, 32.86712000000004],
            [-115.88534999999997, 33.01983000000001],
            [-115.73690999999998, 33.23578000000004],
            [-115.92012999999999, 33.42673000000004],
            [-115.57993000000003, 33.42723000000002],
            [-115.73249999999996, 33.74864000000004],
            [-115.74892, 34.03527000000003],
            [-115.31616000000001, 34.03410000000004],
            [-115.25671999999994, 34.172859999999964],
            [-114.95027999999999, 34.25183],
            [-114.82620999999996, 34.45616000000004],
            [-114.34790999999998, 34.33232999999997],
            [-114.29253000000003, 34.41798],
          ],
        ],
      },
    },
  ],
};
